// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    en: {
        translation: {
            home: 'Home',
            aboutUs: 'About Us',
            sriLankanav: 'Sri Lanka',
            gallerynav: 'Gallery',
            bookATour: 'Book a Tour',
            thingsToDo: 'Things to Do',
            contactUs: 'Contact Us',
        },
        contactus: {
            heroTitle: 'Contact Us',
            heroSubtitle: 'Star Lanka Tours Sri Lanka - Your Gateway to Unforgettable Sri Lankan Adventures',

            feelFree: 'Feel Free To Contact Us',
            planDream: 'Plan Your Dream Sri Lankan Adventure',
            reachOutDesc: 'Reach out to Star Lanka Tours Sri Lanka for personalized tour packages, expert guidance, and unforgettable travel experiences across Sri Lanka.',

            callCenter: 'Call Center',
            phone: '+94 76 805 1224',                    // ← Change to your real WhatsApp/call number
            emailTitle: 'Email',
            email: 'info@starlankatours.com',            // ← Change to your real email
            locationTitle: 'Our Location',
            location: 'Beruwala / Bentota Area, Sri Lanka', // ← Update to your actual address (e.g. if in Negombo like your location)
            socialTitle: 'Social Network',

            getInTouch: 'Get In Touch',
            getInTouchDesc: 'Discover Sri Lanka with Star Lanka Tours Sri Lanka — we’re here 24/7 to make your journey unforgettable.',

            nameLabel: 'Name',
            namePlaceholder: 'Your full name',
            emailLabel: 'Email',
            emailPlaceholder: 'you@example.com',
            phoneLabel: 'Contact Number',
            phonePlaceholder: '+94 7X XXX XXXX',
            messageLabel: 'Message',
            messagePlaceholder: 'Tell us about your dream trip...',

            sendButton: 'Send Message',
            sendingButton: 'Sending...',
            successMsg: 'Your inquiry has been sent via WhatsApp!',
            errorMsg: 'Failed to open WhatsApp. Please try again.',

            findUsTitle: 'Find Us in Sri Lanka',
        },
        // Add this inside the resources object in i18n.js
        thingstodo: {
            heroTitle: 'Unforgettable Experiences in Sri Lanka',
            heroSubtitle: 'Adventure • Heritage • Nature • Wellness',

            sectionTitle: 'Top Things to Do & Must-Experience Activities',

            // Activity titles (used in cards)
            ayurveda: 'Authentic Ayurvedic Treatments & Wellness',
            diving: 'World-Class Scuba Diving',
            elephantRide: 'Ride with Gentle Giants',
            fishing: 'Traditional & Deep Sea Fishing',
            ballooning: 'Magical Hot Air Balloon Ride',
            jeepSafari: 'Exciting Jeep Safari Adventures',
            whiteWaterRafting: 'Adrenaline-Pumping Rafting',
            riverSafari: 'Beautiful River Safari Journey',
            snorkeling: 'Vibrant Snorkeling Experience',
            teaTasting: 'Ceylon Tea Journey & Tasting',
            templeVisit: 'Explore Ancient Temples & Sacred Sites',
            wildlifeSafari: 'Big Five & Wildlife Encounters',

            viewMore: 'View More',
        },
        // Add inside en, ru, ar objects in resources
        gallery: {
            heroTitle: 'Gallery',
            heroSubtitle: 'Moments Captured, Memories Cherished — our gallery showcases the adventures, smiles, and breathtaking views that make every journey in Sri Lanka unforgettable',

            tabPlaces: 'Places',
            tabEvents: 'Events',

            // Image labels (used in alt text and overlay)
            nuwaraEliya: 'Nuwara Eliya',
            sigiriya: 'Sigiriya',
            anuradhapura: 'Anuradhapura',
            rambodaFalls: 'Ramboda Falls',
            ella: 'Ella',
            yala: 'Yala National Park',
            kandy: 'Kandy',
            bodhiViharaya: 'Bodhi Viharaya',
            knuckles: 'Knuckles Mountain Range',
            udawalawe: 'Udawalawe National Park',
            bentota: 'Bentota Boat Safari',
            colombo: 'Colombo',
            galle: 'Galle Fort',
            mirissa: 'Mirissa Beach',
            jaffna: 'Jaffna',
            ambuluwawaTower: 'Ambuluwawa Tower',
            turtle: 'Turtle Hatchery',
            polonnaruwa: 'Polonnaruwa Ancient City',
            polgampala: 'Polgampala Water Pool',
            beach: 'Sri Lankan Beaches',
        },
        // Inside en, ru, ar → resources
        events: {
            heroTitle: 'Events',
            heroSubtitle: 'Celebrate the Spirit of Sri Lanka Through Its Festivals — from sacred Buddhist ceremonies to colorful cultural parades, every event is a chance to experience the heartbeat of the island.',

            tabPlaces: 'Places',
            tabEvents: 'Events',

            // Event names
            kandyPerahera: 'Kandy Esala Perahera (The Festival of the Tooth)',
            vesak: 'Vesak Festival',
            sinhalaNewYear: 'Sinhala and Tamil New Year',
            christmas: 'Christmas',
            thaiPongal: 'Thai Pongal',
            deepavali: 'Deepavali',
            holi: 'Holi',
            poson: 'Poson Festival',
        },
        // Inside en, ru, ar → resources
        srilanka: {
            heroTitle: 'Discover Sri Lanka',
            heroSubtitle: 'Pearl of the Indian Ocean',

            sectionPlaces: 'Attractive Places in Sri Lanka',
            sectionFamous: 'Famous Things in Sri Lanka',
            viewMore: 'View More',

            // Intro paragraphs
            intro1: 'Sri Lanka, known as the "Emerald Isle", is a tropical gem celebrated for its stunning landscapes, ancient heritage, and heartfelt hospitality.',
            intro2: 'With a legacy of over two millennia, Sri Lanka is home to UNESCO-listed sites like Sigiriya’s rock fortress and the sacred city of Anuradhapura. Its cultural richness blends Buddhist, Hindu, and colonial influences, seen in its vibrant festivals and intricate architecture.',
            intro3: 'The island’s diverse terrain captivates — from rolling tea plantations in Ella to the turquoise waters of Trincomalee. National parks like Wilpattu harbor leopards, crocodiles, and rare bird species, delighting nature lovers.',
            intro4: 'For thrill-seekers, Sri Lanka offers white-water rafting, surfing in Arugam Bay, and trekking through lush jungles. Its cuisine, infused with aromatic spices, fresh fish, and jackfruit, tells a story of tradition and flavor.',
            intro5: 'From sacred pilgrimages to serene beach escapes, Sri Lanka promises an enchanting experience steeped in beauty and culture.',

            // Place names & descriptions
            sigiriya: 'Sigiriya Rock Fortress',
            sigiriyaDesc: 'UNESCO site with ancient gardens, frescoes, and breathtaking summit views.',

            templeOfTooth: 'Temple of the Tooth',
            templeOfToothDesc: 'Sacred Buddhist site housing a relic of Buddha’s tooth.',

            ella: 'Ella',
            ellaDesc: 'Hill town surrounded by tea estates, famous for Nine Arch Bridge.',

            yala: 'Yala National Park',
            yalaDesc: 'Renowned for elephants, leopards, and wildlife safaris.',

            galleFort: 'Galle Fort',
            galleFortDesc: 'Colonial fort with cobblestone streets and Dutch architecture.',

            nuwaraEliya: 'Nuwara Eliya',
            nuwaraEliyaDesc: 'Known as "Little England" with cool climate and tea plantations.',

            adamsPeak: 'Adam’s Peak',
            adamsPeakDesc: 'Sacred mountain with a unique footprint, a pilgrimage site.',

            hortonPlains: 'Horton Plains',
            hortonPlainsDesc: 'Rolling hills, waterfalls, and World’s End viewpoint.',

            bentota: 'Bentota Beach',
            bentotaDesc: 'Pristine coast with golden sands and water sports.',

            jaffna: 'Jaffna',
            jaffnaDesc: 'Rich in Tamil culture, history, and cuisine.',

            anuradhapura: 'Anuradhapura',
            anuradhapuraDesc: 'Ancient city with sacred Buddhist sites and ruins.',

            polonnaruwa: 'Polonnaruwa',
            polonnaruwaDesc: 'UNESCO site with well-preserved temples and statues.',

            unawatuna: 'Unawatuna Beach',
            unawatunaDesc: 'Vibrant beach with snorkeling and nightlife.',

            colombo: 'Colombo',
            colomboDesc: 'Bustling capital with modern and colonial architecture.',

            udawalawe: 'Udawalawe National Park',
            udawalaweDesc: 'Famous for large elephant herds and stunning landscapes.',

            dambulla: 'Dambulla Cave Temple',
            dambullaDesc: 'UNESCO site with ancient Buddhist murals and statues.',

            // Famous Things
            ceylonTea: 'Ceylon Tea',
            ceylonTeaDesc: 'World-famous for its flavor, especially from Nuwara Eliya and Uva.',

            spices: 'Spices',
            spicesDesc: 'Cinnamon, cardamom, cloves — Sri Lankan cinnamon is the best.',

            gems: 'Gems',
            gemsDesc: 'Sapphires, rubies, moonstones — island of rare gems.',

            ayurveda: 'Ayurveda',
            ayurvedaDesc: 'Wellness treatments with massages and herbal therapies.',

            handicrafts: 'Handicrafts',
            handicraftsDesc: 'Masks, batik, wood carvings, lacquerware.',

            elephants: 'Elephants',
            elephantsDesc: 'Cultural symbol, featured in grand festival processions.',

            food: 'Traditional Food',
            foodDesc: 'Rice and curry, hoppers, kottu roti, wattalappam.',

            festivals: 'Festivals',
            festivalsDesc: 'Esala Perahera, Vesak, Sinhala-Tamil New Year.',

            coconut: 'Coconut Products',
            coconutDesc: 'Oil, milk, coir fiber for ropes and mats.',

            sarees: 'Kandyan Saree',
            sareesDesc: 'Elegant traditional attire for ceremonies.',

            dances: 'Traditional Dances',
            dancesDesc: 'Kandyan, devil, and low-country dances.',

            stiltFishing: 'Stilt Fishing',
            stiltFishingDesc: 'Iconic southern coast fishing technique.',

            moonstones: 'Moonstones',
            moonstonesDesc: 'Semi-precious gems, famous Meetiyagoda mines.',

            cricket: 'Cricket',
            cricketDesc: 'National passion — 1996 World Cup winners.',

            herbs: 'Ayurvedic Herbs',
            herbsDesc: 'Gotu kola, cinnamon, neem for remedies.',

            masks: 'Masks',
            masksDesc: 'Ambalangoda masks used in ritual performances.',
        },


        ayurveda: {
            title: "Ayurveda - The Ancient Science of Life",

            introParagraph1: "The word “Ayurveda” has existed for more than three thousand years. In Sanskrit, the word means “science of life.” The technique is based on the Ayurvedic healing view of disease rather than its consequences, which usually fights European medicine. It postulates the following principles:",

            corePrinciplesTitle: "Core Principles",
            principle1: "The body should be free of energy and maintain balance for normal metabolic and cardiac activity.",
            principle2: "The body should have normal muscle contraction with regular hormonal activity.",
            principle3: "The body needs a healthy immune system to function properly.",

            sriLankaDoctors: "According to recent data, in Sri Lanka, there are more than 6,000 graduates trained in Ayurveda. They undergo seven years of study and two years of practice in public hospitals. Ayurveda programs include:",

            benefit1: "Removing stress, fatigue, and anxiety",
            benefit2: "Oxygen saturation",
            benefit3: "Stimulation of muscular systems and elimination of toxins",
            benefit4: "Restoring the balance of the nervous system",
            benefit5: "Restoring blood flow to internal organs",
            benefit6: "Producing endorphins",

            mainImageAlt: "Ayurveda Wellness",

            faceTreatmentAlt: "Ayurveda Face Treatment",
            faceTreatmentCaption: "Ayurveda Face Treatment",

            massageTreatmentAlt: "Ayurveda Massage Treatment",
            massageTreatmentCaption: "Ayurveda Massage Treatment",

            treatmentDescription: "Standard treatments include body massages and scalp massages using special oils, herbal sauna treatments, and baths infused with herbs. The most popular technique is the “Shirodhara procedure,” where warm herbal oil is rhythmically dripped on the forehead. This helps restore balance to the nervous system and achieve relaxation.",

            tipsTitle: "Tips for Ayurvedic Treatment",
            tip1: "Forget about problems. Relax and clear your mind for the best results.",
            tip2: "Choose the correct location. Select a setting that aligns with your comfort and preferences for optimal healing.",
            tip3: "Select the correct program. Discuss your concerns with the doctor and try different therapies to find what suits you best.",
            tip4: "Take a warm bath before treatment to relax your muscles and prepare your body.",
            tip5: "Eat a light meal before the procedure. Avoid heavy meals to allow proper blood flow during the massage.",
            tip6: "Relaxation after procedures is essential. Proper relaxation enhances the effectiveness of Ayurvedic treatments."
        },
        // Inside resources → en, ru, ar
        ballooning: {
            title: "Ballooning in Sri Lanka",

            introParagraph1: "Hot air ballooning in Sri Lanka offers an unforgettable experience of floating gently above the stunning landscapes of the island. Starting at sunrise, balloon rides provide breathtaking aerial views of rolling hills, lush forests, ancient ruins, and serene villages.",
            introParagraph2: "The most popular ballooning destination in Sri Lanka is Dambulla, located in the heart of the cultural triangle. Balloon rides here often take you over the iconic Sigiriya Rock Fortress, offering a perspective like no other. Flights typically last 60-90 minutes, giving you ample time to soak in the beauty of Sri Lanka from above.",

            mainImageAlt: "Hot Air Ballooning in Sri Lanka",
            mainImageCaption: "Hot Air Ballooning in Sri Lanka",

            highlightsTitle: "Why Try Hot Air Ballooning in Sri Lanka?",
            highlightsIntro: "Hot air ballooning combines adventure with tranquility, allowing you to experience Sri Lanka’s beauty in a unique way. Some of the highlights of ballooning include:",

            highlight1: "Uninterrupted panoramic views of the island’s stunning landscapes.",
            highlight2: "Flying over iconic landmarks like Sigiriya Rock and nearby lakes.",
            highlight3: "A serene and peaceful ride above lush greenery and charming villages.",
            highlight4: "Witnessing a spectacular sunrise from the sky.",
            highlight5: "Perfect for photography enthusiasts looking to capture scenic beauty from above.",

            sunriseImageAlt: "Enjoy breathtaking views of the sunrise while floating gently in a hot air balloon.",
            sunriseImageCaption: "Enjoy breathtaking views of the sunrise while floating gently in a hot air balloon.",

            landscapeImageAlt: "Witness stunning landscapes of Sri Lanka from above, including rolling hills and lush forests.",
            landscapeImageCaption: "Witness stunning landscapes of Sri Lanka from above, including rolling hills and lush forests.",

            tipsTitle: "Tips for a Memorable Balloon Ride",
            tip1: "Book your ride early, as ballooning is weather-dependent and slots fill up quickly.",
            tip2: "Wear comfortable clothing and carry a light jacket, as early mornings can be cool.",
            tip3: "Carry a camera or smartphone to capture the stunning views.",
            tip4: "Listen carefully to the safety instructions provided by your pilot.",
            tip5: "Arrive on time to watch the preparation and inflation of the balloon, which is a fascinating process."
        },
        diving: {
            title: "Diving in Sri Lanka",

            introParagraph1: "A wide coral reef surrounds the coast of Sri Lanka at depths of 2 to 40 meters. The warm waters of the Indian Ocean, between 27°C and 30°C, and the high transparency of the water, from 15 to 35 meters, provide excellent conditions for diving and snorkeling. While diving in Sri Lanka, you can explore endless untouched coral reefs, old wrecks, and mesmerizing underwater caves.",
            introParagraph2: "The northeast of the island offers a variety of more than 130 species of colorful corals, which are home to marine life such as sea turtles, clownfish, lionfish, and seahorses. Visit shipwrecks near underwater rocks and reefs for an unforgettable experience. Floating in the clear waters, you'll find yourself immersed in the fascinating past of Ceylon.",

            mainImageAlt: "Diving in Sri Lanka",
            mainImageCaption: "Diving in Sri Lanka",

            facilitiesTitle: "Facilities and Best Dive Spots",
            facilitiesParagraph1: "Island dive centers are equipped with the latest diving equipment from renowned manufacturers. Certified instructors with PADI and CMAS qualifications ensure safe and enjoyable dives. Dive centers are located along the southwest coast of the island, operating between mid-October and the end of April. The northeast coast, including Nilaveli and Trincomalee, is ideal for diving from March to October.",
            facilitiesParagraph2: "The coral reefs near Kalpitiya in the west and the shipwreck diving sites in Hikkaduwa are among the most popular attractions for divers.",

            coralImageAlt: "Explore vibrant coral reefs that are home to diverse marine life.",
            coralImageCaption: "Explore vibrant coral reefs that are home to diverse marine life.",

            shipwreckImageAlt: "Discover historic shipwrecks that offer a glimpse into Sri Lanka's maritime past.",
            shipwreckImageCaption: "Discover historic shipwrecks that offer a glimpse into Sri Lanka's maritime past.",

            tipsTitle: "Tips for Divers",
            tip1: "Choose the best season for diving based on the location: southwest coast (October to April) or northeast coast (March to October).",
            tip2: "Ensure your dive center is certified and equipped with modern gear for a safe experience.",
            tip3: "Listen to your instructor's advice, especially if you are a beginner.",
            tip4: "Respect marine life by not touching corals or disturbing the underwater environment.",
            tip5: "Carry a waterproof camera to capture the mesmerizing beauty of Sri Lanka's underwater world."
        },
        elephantRide: {
            title: "Elephant Back Ride",

            introParagraph1: "Elephant trekking is a fascinating, exciting activity and a unique experience in Sri Lanka. If you are staying near the cultural triangle in areas like Habarana, Sigiriya, or Dambulla, you can participate in an elephant safari. These rides start at around $30 for an hour of unforgettable adventure.",
            introParagraph2: "Before the ride, elephants are saddled with a multi-basket designed for 4 to 6 people. These gentle giants take you through scenic jungle paths, cross areas flooded with water, and navigate through lush vegetation. Elephants usually walk slowly, allowing you to fully appreciate the beauty of the surrounding nature, even though they can reach speeds of up to 40 km/h.",

            mainImageAlt: "Elephant Back Ride",
            mainImageCaption: "Elephant Back Ride",

            highlightsTitle: "Highlights of an Elephant Ride",
            highlightsIntro: "Riding an elephant in Sri Lanka provides a unique way to connect with nature and explore the countryside. Some highlights of the experience include:",
            highlight1: "Walking through dense jungles filled with exotic vegetation and wildlife.",
            highlight2: "Crossing rivers and flooded areas, offering stunning views of the natural landscape.",
            highlight3: "Learning about the close relationship between elephants and Sri Lankan culture.",
            highlight4: "Relaxing on a comfortable saddle while the elephant gently carries you through various terrains.",

            jungleImageAlt: "Explore dense jungles and scenic paths while riding on an elephant.",
            jungleImageCaption: "Explore dense jungles and scenic paths while riding on an elephant.",

            waterImageAlt: "Cross rivers and enjoy the tranquil beauty of the water and vegetation.",
            waterImageCaption: "Cross rivers and enjoy the tranquil beauty of the water and vegetation.",

            tipsTitle: "Tips for a Safe and Enjoyable Elephant Ride",
            tip1: "Wear comfortable clothing and footwear suitable for outdoor activities.",
            tip2: "Follow the instructions of your guide for a safe and enjoyable ride.",
            tip3: "Ensure that the elephants are well-treated and the ride provider follows ethical practices.",
            tip4: "Bring a camera to capture the breathtaking scenery and moments.",
            tip5: "Respect the elephants and avoid actions that might stress or harm them."
        },
        fishing: {
            title: "Fishing in Sri Lanka",

            introParagraph1: "Sri Lanka, with its vast coastline and abundance of freshwater lakes and rivers, offers an unparalleled fishing experience. Whether you're a professional angler or a hobbyist, Sri Lanka has something to offer. From deep-sea fishing expeditions to the traditional stilt fishing practiced by local fishermen, you'll have an unforgettable adventure.",
            introParagraph2: "Popular fishing destinations include the southern coast around Galle and Mirissa, the Negombo lagoon, and the calm waters of Trincomalee. Depending on your preference, you can try different fishing techniques such as trolling, bottom fishing, or fly fishing.",

            mainImageAlt: "Fishing in Sri Lanka",
            mainImageCaption: "Fishing in Sri Lanka",

            experiencesTitle: "Fishing Experiences in Sri Lanka",
            experiencesIntro: "Fishing in Sri Lanka is not just about catching fish; it is an opportunity to immerse yourself in the culture and traditions of the island. Some unique fishing experiences include:",

            expStiltTitle: "Stilt Fishing",
            expStiltDesc: "A traditional method where fishermen perch on stilts to catch fish near the shore, a practice unique to Sri Lanka.",

            expDeepSeaTitle: "Deep-Sea Fishing",
            expDeepSeaDesc: "Venture into the Indian Ocean to catch marlins, tunas, barracudas, and other large fish species.",

            expLagoonTitle: "Lagoon and River Fishing",

            expLagoonDesc: "Relax while fishing in serene lagoons and rivers teeming with fish like tilapia and catfish.",

            expNightTitle: "Night Fishing",
            expNightDesc: "Experience the thrill of fishing under the stars, a common practice in coastal villages.",

            stiltImageAlt: "Stilt fishing, a traditional method and iconic part of Sri Lanka's fishing heritage.",
            stiltImageCaption: "Stilt fishing is a traditional method and an iconic image of Sri Lanka's fishing heritage.",

            deepSeaImageAlt: "Deep-sea fishing offers an adventurous experience, targeting large fish species in the Indian Ocean.",
            deepSeaImageCaption: "Deep-sea fishing offers an adventurous experience, targeting large fish species in the Indian Ocean.",

            tipsTitle: "Tips for an Enjoyable Fishing Trip",
            tip1: "Choose the right season for your fishing expedition; October to April is ideal for the southern coast, while March to October suits the eastern coast.",
            tip2: "Bring sunscreen, a hat, and protective clothing to stay comfortable during your trip.",
            tip3: "Book a fishing guide or charter to make the most of your experience and learn from the experts.",
            tip4: "Respect the local environment by avoiding littering and adhering to sustainable fishing practices.",
            tip5: "Stay hydrated and carry snacks for longer fishing trips."
        },
        jeepSafari: {
            title: "Jeep Safari in Sri Lanka",

            introParagraph1: "Sri Lanka's national parks offer a thrilling jeep safari experience, allowing you to explore the island's rich biodiversity and witness wildlife in their natural habitats. Yala National Park, Wilpattu National Park, and Udawalawe National Park are among the most popular destinations for jeep safaris.",
            introParagraph2: "These safaris provide a chance to see elephants, leopards, sloth bears, water buffalo, crocodiles, and a wide variety of bird species. Guided by experienced naturalists and trackers, jeep safaris are perfect for wildlife enthusiasts and photographers alike.",

            mainImageAlt: "Jeep Safari in Sri Lanka",
            mainImageCaption: "Jeep Safari in Sri Lanka",

            whyChooseTitle: "Why Choose a Jeep Safari?",
            whyChooseIntro: "Jeep safaris are one of the best ways to explore the diverse wildlife of Sri Lanka. Here are some highlights:",

            highlight1: "Close encounters with iconic species like elephants and leopards.",
            highlight2: "Access to remote and scenic areas within national parks.",
            highlight3: "Opportunities for wildlife photography in a natural setting.",
            highlight4: "Guidance from knowledgeable naturalists and park rangers.",
            highlight5: "An adventure suitable for all age groups, combining excitement with education.",

            wildlifeImageAlt: "Witness iconic wildlife like leopards, elephants, and crocodiles during your safari.",
            wildlifeImageCaption: "Witness iconic wildlife like leopards, elephants, and crocodiles during your safari.",

            landscapeImageAlt: "Explore the stunning landscapes of Sri Lanka's national parks, from dense forests to open plains.",
            landscapeImageCaption: "Explore the stunning landscapes of Sri Lanka's national parks, from dense forests to open plains.",

            tipsTitle: "Tips for an Enjoyable Jeep Safari",
            tip1: "Wear comfortable, neutral-colored clothing to blend in with the environment.",
            tip2: "Carry sunscreen, a hat, and insect repellent for protection.",
            tip3: "Bring binoculars and a camera to enhance your experience and capture wildlife.",
            tip4: "Follow the guide's instructions to ensure safety and respect for the animals.",
            tip5: "Book your safari early, especially during peak seasons, to secure a spot."
        },
        riverSafari: {
            title: "River Safari in Sri Lanka",

            introParagraph1: "A river safari in Sri Lanka offers a unique way to explore the island's rich biodiversity and scenic beauty. Glide along tranquil waterways surrounded by lush mangroves, spot exotic wildlife, and enjoy picturesque sunsets that will leave you mesmerized.",
            introParagraph2: "Popular river safari destinations include the Madu Ganga (Madu River) and Bentota River. These safaris provide a chance to witness various bird species, monitor lizards, crocodiles, and even monkeys in their natural habitats. The serene environment is perfect for nature lovers and photographers.",

            mainImageAlt: "River Safari in Sri Lanka",
            mainImageCaption: "River Safari in Sri Lanka",

            whyChooseTitle: "Why Choose a River Safari?",
            whyChooseIntro: "A river safari is a relaxing and immersive experience that combines nature, wildlife, and cultural exploration. Here are some highlights:",

            highlight1: "Explore lush mangroves teeming with life.",
            highlight2: "Spot exotic birds, crocodiles, and other wildlife.",
            highlight3: "Visit small islands and local villages along the river.",
            highlight4: "Enjoy the tranquility and picturesque beauty of Sri Lanka's waterways.",
            highlight5: "Perfect for families, couples, and solo travelers seeking a peaceful escape.",

            mangrovesImageAlt: "Discover the lush mangroves that line Sri Lanka's scenic waterways.",
            mangrovesImageCaption: "Discover the lush mangroves that line Sri Lanka's scenic waterways.",

            wildlifeImageAlt: "Spot exotic wildlife like crocodiles, monitor lizards, and colorful birds during your safari.",
            wildlifeImageCaption: "Spot exotic wildlife like crocodiles, monitor lizards, and colorful birds during your safari.",

            tipsTitle: "Tips for an Enjoyable River Safari",
            tip1: "Wear comfortable clothing and bring a hat and sunscreen for protection.",
            tip2: "Carry binoculars to spot distant wildlife and birds.",
            tip3: "Bring a camera or smartphone to capture the stunning scenery and wildlife.",
            tip4: "Follow the instructions of your guide for a safe and enjoyable experience.",
            tip5: "Respect the natural environment by avoiding littering and disturbing wildlife."
        },
        snorkeling: {
            title: "Snorkeling in Sri Lanka",

            introParagraph1: "Snorkeling in Sri Lanka offers an unforgettable underwater experience, where you can explore vibrant coral reefs and diverse marine life. With its crystal-clear natural waters and abundant aquatic ecosystems, Sri Lanka is a paradise for snorkelers of all skill levels.",
            introParagraph2: "Some of the most popular snorkeling spots include Hikkaduwa, known for its colorful coral gardens and turtles, Pigeon Island in Trincomalee, famous for its pristine reefs, and Mirissa, where you might even spot a whale or two during the snorkeling season.",

            mainImageAlt: "Snorkeling in Sri Lanka",
            mainImageCaption: "Snorkeling in Sri Lanka",

            whyChooseTitle: "Why Choose Snorkeling in Sri Lanka?",
            whyChooseIntro: "Snorkeling in Sri Lanka is a magical experience, combining adventure and natural beauty. Here are some highlights:",

            highlight1: "Explore vibrant coral reefs teeming with life.",
            highlight2: "Swim alongside colorful tropical fish, turtles, and even reef sharks.",
            highlight3: "Discover pristine underwater landscapes in clear, warm waters.",
            highlight4: "Suitable for both beginners and experienced snorkelers.",
            highlight5: "Accessible from some of the best beach destinations in Sri Lanka.",

            coralImageAlt: "Discover stunning coral reefs and their vibrant ecosystems.",
            coralImageCaption: "Discover stunning coral reefs and their vibrant ecosystems.",

            marineLifeImageAlt: "Encounter diverse marine life, including turtles, tropical fish, and more.",
            marineLifeImageCaption: "Encounter diverse marine life, including turtles, tropical fish, and more.",

            tipsTitle: "Tips for a Memorable Snorkeling Experience",
            tip1: "Wear a comfortable mask and snorkel to ensure a clear view underwater.",
            tip2: "Apply reef-safe sunscreen to protect both your skin and marine life.",
            tip3: "Swim gently to avoid disturbing coral reefs and aquatic creatures.",
            tip4: "Stay hydrated and take breaks between sessions.",
            tip5: "Join a guided tour for the best snorkeling spots and safety tips."
        },
        teaTasting: {
            title: "Tea Tasting Tour in Sri Lanka",

            introParagraph1: "Sri Lanka, often referred to as the 'Pearl of the Indian Ocean,' is famous for its world-class tea production. Embark on a tea tasting tour and explore the lush tea plantations in regions like Nuwara Eliya, Ella, and Kandy. Learn about the art of tea cultivation, the meticulous process of tea production, and savor the rich flavors of authentic Ceylon tea.",
            introParagraph2: "Whether you're a tea enthusiast or simply curious, a tea tasting tour offers a unique opportunity to delve into Sri Lanka’s tea heritage and experience the serene beauty of its highlands.",

            mainImageAlt: "Tea Tasting Tour in Sri Lanka",
            mainImageCaption: "Tea Tasting Tour in Sri Lanka",

            whyChooseTitle: "Why Choose a Tea Tasting Tour?",
            whyChooseIntro: "A tea tasting tour in Sri Lanka is not just about tasting tea—it's an immersive cultural experience. Here are some highlights:",

            highlight1: "Visit picturesque tea plantations nestled in the cool highlands.",
            highlight2: "Learn about the history and significance of Ceylon tea.",
            highlight3: "Participate in tea plucking and observe the production process in tea factories.",
            highlight4: "Savor different varieties of tea, from black to green to flavored blends.",
            highlight5: "Enjoy the breathtaking scenery of misty mountains and cascading waterfalls.",

            plantationImageAlt: "Explore lush tea plantations and learn about tea cultivation.",
            plantationImageCaption: "Explore lush tea plantations and learn about tea cultivation.",

            preparationImageAlt: "Discover the art of tea preparation and savor authentic Ceylon tea.",
            preparationImageCaption: "Discover the art of tea preparation and savor authentic Ceylon tea.",

            tipsTitle: "Tips for an Enjoyable Tea Tasting Tour",
            tip1: "Wear comfortable clothing and footwear for walking through plantations.",
            tip2: "Bring a light jacket, as highland regions can be cool and misty.",
            tip3: "Try different varieties of tea and take some favorites home as souvenirs.",
            tip4: "Ask questions during the tour to learn more about the tea-making process.",
            tip5: "Combine your tea tour with visits to nearby attractions like waterfalls and viewpoints."
        },
        templeVisit: {
            title: "Temple Visit in Sri Lanka",

            introParagraph1: "Sri Lanka, known as the Land of Buddha, is home to ancient temples that reflect its rich spiritual and cultural heritage. Embark on a journey to explore iconic temples such as the Temple of the Tooth in Kandy, the Dambulla Cave Temple, and Ruwanwelisaya in Anuradhapura.",
            introParagraph2: "These sacred sites, adorned with intricate carvings, murals, and statues, offer a glimpse into the island's spiritual traditions and architectural brilliance. A temple visit is not only a cultural experience but also an opportunity to find peace and tranquility.",

            mainImageAlt: "Temple Visit in Sri Lanka",
            mainImageCaption: "Temple Visit in Sri Lanka",

            whyVisitTitle: "Why Visit Temples in Sri Lanka?",
            whyVisitIntro: "Visiting temples in Sri Lanka offers a unique opportunity to connect with the island’s history, culture, and spirituality. Here are some highlights:",

            highlight1: "Admire the intricate architecture and centuries-old statues.",
            highlight2: "Learn about Buddhist traditions and rituals from knowledgeable guides.",
            highlight3: "Explore UNESCO World Heritage Sites like the Golden Temple of Dambulla.",
            highlight4: "Experience the serenity and spiritual ambiance of sacred spaces.",
            highlight5: "Witness vibrant festivals like Esala Perahera at the Temple of the Tooth.",

            interiorImageAlt: "Marvel at the stunning interiors adorned with intricate carvings and murals.",
            interiorImageCaption: "Marvel at the stunning interiors adorned with intricate carvings and murals.",

            sacredImageAlt: "Visit sacred temples like Ruwanwelisaya and immerse yourself in spiritual traditions.",
            sacredImageCaption: "Visit sacred temples like Ruwanwelisaya and immerse yourself in spiritual traditions.",

            tipsTitle: "Tips for Visiting Temples in Sri Lanka",
            tip1: "Dress modestly, covering your shoulders and knees, as a sign of respect.",
            tip2: "Remove your shoes before entering temple premises.",
            tip3: "Refrain from touching statues or sacred objects.",
            tip4: "Bring a small donation for the temple if you wish to contribute.",
            tip5: "Respect the silence and spiritual atmosphere during your visit."
        },
        whiteWaterRafting: {
            title: "White Water Rafting in Sri Lanka",

            introParagraph1: "White water rafting in Sri Lanka is an exhilarating experience, especially in Kitulgala, the adventure capital of the island. The Kelani River, with its roaring rapids and scenic surroundings, offers a perfect setting for both beginners and experienced rafters.",
            introParagraph2: "Rafting expeditions typically cover a 5-kilometer stretch with rapids ranging from Grade 2 to Grade 4. Participants can enjoy the thrill of navigating challenging currents while taking in the lush greenery and breathtaking views of the riverbanks.",

            mainImageAlt: "White Water Rafting in Sri Lanka",
            mainImageCaption: "White Water Rafting in Sri Lanka",

            whyChooseTitle: "Why Choose White Water Rafting in Sri Lanka?",
            whyChooseIntro: "White water rafting in Sri Lanka offers a unique combination of adventure and natural beauty. Here are some highlights of the experience:",

            highlight1: "Navigate through thrilling rapids under the guidance of experienced instructors.",
            highlight2: "Enjoy stunning views of the surrounding rainforest and mountainous terrain.",
            highlight3: "Combine rafting with other activities like trekking, birdwatching, and canyoning in Kitulgala.",
            highlight4: "Perfect for groups, families, or solo travelers looking for an adrenaline rush.",

            actionImageAlt: "Feel the adrenaline rush as you conquer challenging rapids on the Kelani River.",
            actionImageCaption: "Feel the adrenaline rush as you conquer challenging rapids on the Kelani River.",

            scenicImageAlt: "Enjoy the serene beauty of the lush surroundings during your rafting adventure.",
            scenicImageCaption: "Enjoy the serene beauty of the lush surroundings during your rafting adventure.",

            tipsTitle: "Tips for a Safe and Exciting Rafting Trip",
            tip1: "Wear a life jacket and helmet provided by your rafting guide for safety.",
            tip2: "Listen carefully to the safety instructions before starting your trip.",
            tip3: "Wear comfortable, quick-drying clothing and secure footwear like water shoes.",
            tip4: "Carry a change of clothes and a towel for after the trip.",
            tip5: "Book your rafting trip with a reputable operator to ensure a safe and enjoyable experience."
        },
        wildlifeSafari: {
            title: "Wildlife Safari in Sri Lanka",

            introParagraph1: "Sri Lanka, known for its rich biodiversity, offers incredible wildlife safaris in national parks like Yala, Wilpattu, Minneriya, and Udawalawe. These safaris provide a chance to witness elephants, leopards, sloth bears, and a variety of bird species in their natural habitats.",
            introParagraph2: "Explore diverse landscapes ranging from dense forests to open grasslands, and capture unforgettable moments of wildlife in action. With expert guides and well-maintained safari jeeps, a wildlife safari in Sri Lanka is a must for nature enthusiasts and adventure seekers.",

            mainImageAlt: "Wildlife Safari in Sri Lanka",
            mainImageCaption: "Wildlife Safari in Sri Lanka",

            whyChooseTitle: "Why Choose a Wildlife Safari?",
            whyChooseIntro: "A wildlife safari in Sri Lanka offers a unique opportunity to connect with nature and explore the island's remarkable biodiversity. Highlights include:",

            highlight1: "Witnessing iconic species like elephants, leopards, and crocodiles.",
            highlight2: "Exploring lush forests, wetlands, and open plains teeming with wildlife.",
            highlight3: "Capturing stunning wildlife photography in natural settings.",
            highlight4: "Experiencing the thrill of spotting elusive animals like the Sri Lankan leopard.",
            highlight5: "Learning about conservation efforts from experienced guides and naturalists.",

            elephantsImageAlt: "Witness majestic elephants roaming freely in Sri Lanka's national parks.",
            elephantsImageCaption: "Witness majestic elephants roaming freely in Sri Lanka's national parks.",

            leopardImageAlt: "Spot the elusive Sri Lankan leopard, a highlight of any wildlife safari.",
            leopardImageCaption: "Spot the elusive Sri Lankan leopard, a highlight of any wildlife safari.",

            tipsTitle: "Tips for an Exciting Wildlife Safari",
            tip1: "Wear neutral-colored clothing to blend into the environment.",
            tip2: "Carry sunscreen, a hat, and insect repellent for protection.",
            tip3: "Bring binoculars and a camera to spot and capture wildlife.",
            tip4: "Follow your guide's instructions for a safe and enjoyable experience.",
            tip5: "Book early, especially during peak seasons, to secure a spot in popular parks."
        },
        about: {
            hero: {
                discover: "DISCOVER",
                starLankaTours: "STAR LANKA TOURS",
                tagline1: "See old big ruins, green tea hills, and exciting animal safaris. Sri Lanka is full of life. This beautiful island is more than a place to visit — it is a big adventure.",
                tagline2: "Sunny beaches, cloudy mountains, and many surprises wait for you. Star Lanka Tours Sri Lanka makes every minute special."
            },
            slider: {
                sigiriya: "Sigiriya Rock Fortress",
                yala: "Yala National Park",
                tea: "Tea Country",
                beaches: "Clean Beaches",
                temples: "Holy Temples"
            },
            about: {
                title: "About Star Lanka Tours Sri Lanka",
                signature: "Special Sri Lanka Trips"
            },
            tours: {
                days4: "4 Days",
                classic: "BASIC TRIP",
                days5: "5 Days",
                safari: "ANIMAL TRIPS",
                days6: "6 Days",
                retreat: "Quiet Rest",
                desc1: "Star Lanka Tours Sri Lanka shows you every part of this beautiful island — busy cities, misty hills, and clean south beaches.",
                desc2: "Enjoy the best of Sri Lanka — holy Kandy, fun Colombo, and calm South Coast.",
                desc3: "Want adventure, old culture, animals, or peace? Star Lanka Tours Sri Lanka makes great trips any time of the year."
            },
            whoWeAre: {
                title: "Who We Are",
                description: "<p>Welcome to Star Lanka Tours Sri Lanka — your friend to travel all over this magic island. Our boss is tour guide Nethaj. Our friendly local team makes trips that show the real Sri Lanka, not just normal tourist places.</p><br /><p>We take you to old cities, green tea hills, sunny beaches, and parks full of animals. Every trip helps you feel the real culture, kind people, old ways, and beautiful nature of Sri Lanka.</p><br /><p>You want culture, adventure, rest, health, or special private trip? We plan everything carefully, give you personal help, and make sure you have happy memories.</p>",
                imageAlt: "Star Lanka Tours Team",
                item1: { title: "Travel All Over Sri Lanka", text: "We go from North to South — real local experiences everywhere." },
                item2: { title: "Trips Made for You", text: "We plan the trip for what you like — adventure, culture, nature, or rest." },
                item3: { title: "Good Local Guides", text: "Nethaj and his team know many secret places, old stories, and the true feeling of Sri Lanka." },
                item4: { title: "Help All the Time", text: "Star Lanka Tours helps you 24 hours a day during your whole trip." }
            },
            offers: {
                title: "What We Give to You",
                cultural: { title: "Culture Experience", text: "See local customs, festivals, and daily life.", alt: "Culture Experience" },
                adventure: { title: "Adventure Trips", text: "Walking, animal safaris, sea fun, and nature action.", alt: "Adventure" },
                luxury: { title: "Comfort & Luxury", text: "Nice hotels, private cars, and special service.", alt: "Luxury" },
                wellness: { title: "Health & Relax", text: "Yoga, Ayurveda, and calm places.", alt: "Relax" }
            },
            guides: {
                title: "Our Guides",
                text: "Nethaj is our main tour operator. Our trained and happy guides make your trip exciting. They show you secret places, old stories, and special things in Sri Lanka.",
                imageAlt: "Star Lanka Tours Guide - Nethaj"
            },
            expert: {
                name: "Nethaj",
                role: "(Main Guide & Tour Operator)",
                bio: "Nethaj is the heart of Star Lanka Tours Sri Lanka. He knows Sri Lanka very well. From beaches to high hills, animals to old places — he makes trips you will never forget.",
                imageAlt: "Nethaj - Star Lanka Tours"
            },
            vehicles: {
                title: "Tour Vehicles",
                text: "Star Lanka Tours Sri Lanka cares about your safety and comfort. With Nethaj watching, we use modern, air-conditioned, and clean cars for easy travel around the island.",
                bookButton: "Book Your Trip",
                car: { title: "Car", text: "Good for 2 or 3 people. Small, saves fuel, perfect for small trips." },
                van: { title: "Van", text: "Good for families or small groups (up to 6). Big and comfortable for long drives." },
                minibus: { title: "Minibus", text: "Good for bigger groups (8–12). Nice seats and space for bags." },
                luxury: { title: "Luxury Car", text: "Very nice cars with soft seats, Wi-Fi, and private driver." }
            },
            accommodations: {
                intro: "Rest in nice 3-star, 4-star, 5-star hotels and special places. We choose them for calm, beauty, and comfort on your Star Lanka Tours trip.",
                item1: "Private villas with big pools and relaxing sea views.",
                item2: "Old-style luxury hotels by the sea with good food.",
                item3: "Nature lodge with modern rooms and wild animal views.",
                item4: "Beautiful house in nature with great views and green design."
            },
            notices: {
                title: "Free Extras",
                intro: "Star Lanka Tours Sri Lanka gives you these free things on every trip:",
                bike: { title: "Free Bike for Each Guest", text: "Ride around freely — we give a bike to every person." },
                fruits: { title: "Fresh Fruits at the End", text: "Finish your trip with a nice pack of fresh fruits." },
                meals: { title: "Free Food for Special Events", text: "Join local traditions — we give free meals during money feeding ceremonies." }
            },
        },
        home: {
            common: { viewAll: "See All" },
            sections: {
                recommendations: { title: "Best Places", subtitle: "Not sure where to go? We help you choose." },
                excursions: { title: "Our Tours", desc: "Trips of many days — mix of old culture, nature, and happy memories." },
                packages: { title: "Special Packages" },
                reviews: { title: "What Guests Say", subtitle: "True words from people who traveled with us" },
                gallery: { title: "Our Photos", subtitle: "Beautiful pictures of Sri Lanka — full of wonder, fun, and nice moments." }
            },
            recommendations: {
                sigiriya: { label: "Sigiriya", name: "Big old rock fort high above the ground." },
                udawalawa: { label: "Udawalawe", name: "Big fields with many free elephants." },
                ella: { label: "Ella", name: "Cloudy hills, nice train ride, big views." },
                mirissa: { label: "Mirissa", name: "Yellow beaches, blue sea, good for whale watching." },
                nuwaraeliya: { label: "Nuwara Eliya", name: "Many tea fields and cool fresh air." },
                kandy: { label: "Kandy", name: "Holy city with Temple of the Tooth." },
                galle: { label: "Galle", name: "Old fort next to the sea." },
                yala: { label: "Yala", name: "Big park with leopards, elephants, and many animals." },
                anuradhapura: { label: "Anuradhapura", name: "Old place where Buddhism started, big stupas." },
                polonnaruwa: { label: "Polonnaruwa", name: "Old city ruins from long ago." }
            },
            excursions: {
                oneDay: { title: "1 Day – Sri Lanka in One Day", des: "One day full of magic — old places to sunny beaches." },
                twoDays: { title: "2 Days – Nature Call", des: "Two days in wild nature: safaris, tea hills, jungle sounds." },
                threeDays: { title: "3 Days – Soul & Sea", des: "Three days for your heart — morning temples, evening sea, real culture." },
                fourDays: { title: "4 Days – Old & Calm", des: "Four days of old wonders: big forts, old streets, real traditions." },
                fiveDays: { title: "5 Days – Heart of Sri Lanka", des: "Five days to love Sri Lanka — misty hills to blue sea." },
                sixDays: { title: "6 Days – Special Trip", des: "Six days of nice things — holy places, animal safaris, calm sunsets." }
            },
            packages: {
                one: { title: "1 Day / 0 Nights: Sri Lanka in One Day", duration: "1 Day", desc: "One big day — old stupas, golden beaches, real Sri Lanka feeling.", category: "Quick Trip" },
                two: { title: "2 Days / 1 Night: Nature Call", duration: "2 Days", desc: "Two days in nature — night safaris, tea smell, jungle life.", category: "Wild Trip" },
                three: { title: "3 Days / 2 Nights: Soul & Sea", duration: "3 Days", desc: "Three days for your soul — temples in morning, calm sea at night.", category: "Sea & Spirit" },
                four: { title: "4 Days / 3 Nights: Old & Calm", duration: "4 Days", desc: "Four days of old things — forts, old towns, real culture.", category: "Culture Trip" },
                five: { title: "5 Days / 4 Nights: Heart of Sri Lanka", duration: "5 Days", desc: "Five days to love the island — hills, blue sea, happy moments.", category: "Love Trip" },
                six: { title: "6 Days / 5 Nights: Special Trip", duration: "6 Days", desc: "Six days of best things — holy places, animals, nice sunsets.", category: "Best Trip" }
            },
            featured: {
                perahera: {
                    h2: "See This Big Show", h3: "Kandy Esala Perahera", h4: "(Festival of the Tooth)",
                    paragraph: `One of the biggest Buddhist festivals in Asia. Every year in Kandy people honor the Sacred Tooth. Elephants with nice clothes, loud drums, fire dancers, and lights make a beautiful night. Come see this with <strong style="color: #166880;">Star Lanka Tours Sri Lanka</strong> — culture is alive here.`,
                    button: "See More"
                },
                safari: {
                    h2: "Go to the Wild", h3: "Safari Trips",
                    paragraph: `Sri Lanka has some of the best animals in Asia. See big open areas in <span style="color: #D5A44F; font-weight: 600;">Yala</span> and <span style="color: #D5A44F; font-weight: 600;">Udawalawe</span>, or lakes in <span style="color: #D5A44F; font-weight: 600;">Wilpattu</span>. Find elephants, leopards, and many birds. Travel with <strong style="color: #166880;">Star Lanka Tours Sri Lanka</strong> — every safari is a new story.`,
                    button: "See Safaris"
                }
            },
            gallery: {
                title: "Our Photos", subtitle: "Nice pictures of Sri Lanka — full of wonder, fun, and beauty.",
                alt1: "Sunrise over Sigiriya Rock", alt2: "Elephants in Yala National Park", alt3: "Tea workers in misty Nuwara Eliya",
                alt4: "Sunset at Mirissa Beach", alt5: "Prayer at Kandy Temple", alt6: "Old ruins in Polonnaruwa",
                alt7: "Whales near south coast", alt8: "Train ride in Ella hills", alt9: "Galle Fort in evening light",
                alt10: "Fisherman working in Negombo", alt11: "Kandyan dance show", alt12: "Hot air balloon over Dambulla"
            },
            cta: {
                title: "Star Lanka Tours Sri Lanka — Making Happy Trips",
                desc: "Every trip is special — full of culture, fun, and calm times. Let us make your story in beautiful Sri Lanka.",
                button: "Start Now",
                alt: "Make Your Trip"
            },
        },
        hero: {
            title: {
                line1: "Discover Paradise with",
                line2: "Star Lanka Tours",
                line3: "Sri Lanka"
            },
            subtitle: "Dive into lush emerald jungles, sun-drenched golden shores, timeless ancient cities, and exhilarating wildlife adventures —",
            subtitle2: "tailored perfectly to your dreams.",

            cta: "Start Your Adventure",
            trust: "Loved by travelers from over 50 countries • Recognized by top travel experts worldwide"
        },
        footer: {
            brand: "Star Lanka Tours",

            nav: {
                home: "Home",
                about: "About Us",
                explore: "Explore Sri Lanka",
                tours: "Tour Packages",
                gallery: "Gallery",
                events: "Special Events",
                things: "Things to Do",
                contact: "Contact Us"
            },

            contact: {
                title: "Let’s Make Great Memories Together",
                address: "Beruwala Area,<br />Western Province, Sri Lanka",
                email: "info@starlankatours.com",          // ← change to your real email
                phone: "+94 76 805 1224"                   // ← change to your real phone/WhatsApp number
            },

            newsletter: {
                title: "Join Our Adventure",
                desc: "Get news first about special deals, secret places, and amazing trips in Sri Lanka.",
                placeholder: "Your email address",
                subscribe: "Subscribe"
            },

            tagline: "\"Not all who wander are lost...<br /><span class='text-[#96BA33] font-semibold'>some are traveling with Star Lanka Tours</span>\"",

            copyright: "All Rights Reserved.",
            developedBy: "Designed by"
        },

        tourpackages: {
            heroTitle: 'Our Tour Packages',
            heroSubtitle: 'Discover Sri Lanka in a single day — handcrafted adventures by <span class="text-[#009CE6] font-bold">Star Lanka Tours</span>',
            heroAlt: 'Star Lanka Tours Sri Lanka - One Day Adventures',
            chooseAdventure: 'Choose Your Adventure',
            packagesSubtitle: '25 handpicked experiences — from wildlife safaris to cultural immersions.',
            viewDetails: 'View Details',
            itineraryTitle: 'Itinerary',
            bookViaWhatsApp: 'Book via WhatsApp',
            whatsappMessage: 'Hi Star Lanka Tours! I\'d like to book: *{{title}}* ({{duration}})\n\nLet me know availability and pricing!',

            packages: {
                '1': {
                    title: 'Ella Adventure Day',
                    duration: '1 Day',
                    category: 'Nature & Adventure',
                    description: 'Journey through misty hills, cascading waterfalls, and iconic bridges — a perfect blend of thrill and serenity.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Swim in crystal pools</li>
                <li><strong>Nine Arch Bridge</strong> – Iconic train photo stop</li>
                <li><strong>Tea Plantation</strong> – Walk among emerald hills</li>
                <li><strong>Train Ride</strong> – Scenic Ella to Demodara</li>
                <li><strong>Little Adam’s Peak</strong> – Panoramic sunrise/sunset views</li>
                <li><strong>Udawalawe Elephant Milk Feeding</strong> – Heartwarming wildlife moment</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Learn ancient wellness secrets</li>
            </ul>`
                },
                '2': {
                    title: 'Ella & Yala Safari',
                    duration: '1 Day',
                    category: 'Wildlife & Scenic',
                    description: 'From misty highlands to wild savannah — experience the best of nature in one unforgettable day.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Refreshing natural pool</li>
                <li><strong>Nine Arch Bridge</strong> – Architectural wonder</li>
                <li><strong>Tea Plantation</strong> – Scenic hill walks</li>
                <li><strong>Little Adam’s Peak</strong> – Stunning hilltop views</li>
                <li><strong>Yala Safari</strong> – Jeep adventure with leopards & elephants</li>
            </ul>`
                },
                '3': {
                    title: 'Kandy Cultural Day',
                    duration: '1 Day',
                    category: 'Heritage & Nature',
                    description: 'Immerse in sacred temples, lush gardens, and local traditions in the heart of Sri Lanka.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Kandy City</strong> – Vibrant cultural hub</li>
                <li><strong>Royal Botanical Garden</strong> – Tropical paradise</li>
                <li><strong>Tea Factory & Plantation</strong> – Ceylon tea experience</li>
                <li><strong>Elephant Feeding, Bathing & Riding</strong> – Ethical interaction</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Natural healing tour</li>
                <li><strong>Ambuluwawa Tower</strong> – 360° panoramic views</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Silk Factory</strong> – Traditional weaving</li>
            </ul>`
                },
                '4': {
                    title: 'Kandy Sacred Journey',
                    duration: '1 Day',
                    category: 'Spiritual & Cultural',
                    description: 'A soulful day of devotion, heritage, and natural beauty in the sacred city of Kandy.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Temple of the Tooth Relic</strong> – Sacred Buddhist site</li>
                <li><strong>Tea Factory & Plantation</strong> – Fresh tea tasting</li>
                <li><strong>Elephant Feeding, Bathing & Riding</strong> – Gentle giants</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Wellness wisdom</li>
                <li><strong>Ambuluwawa Tower</strong> – Spiral climb to heaven</li>
                <li><strong>Jewellery & Gem Factory</strong> – Local gems</li>
                <li><strong>Silk Factory</strong> – Silk artistry</li>
            </ul>`
                },
                '5': {
                    title: 'Sigiriya Heritage Day',
                    duration: '1 Day',
                    category: 'History & Adventure',
                    description: 'Climb ancient rock fortresses, explore golden caves, and taste authentic village life.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Dambulla Golden Temple</strong> – Ancient cave art</li>
                <li><strong>Village Tour</strong> – Bullock cart, catamaran, traditional lunch</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Healing plants</li>
                <li><strong>Pidurangala Rock</strong> – Best view of Sigiriya</li>
            </ul>`
                },
                '6': {
                    title: 'Galle Coastal Heritage',
                    duration: '1 Day',
                    category: 'History & Nature',
                    description: 'Walk through colonial forts, cruise mangrove rivers, and witness sea turtle conservation.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Kande Viharaya Temple</strong> – Giant Buddha statue</li>
                <li><strong>Turtle Hatchery</strong> – Baby turtles release</li>
                <li><strong>Boat Safari</strong> – Madu River mangroves</li>
                <li><strong>Moonstone Mine</strong> – Gem mining experience</li>
                <li><strong>Dutch Fort Galle</strong> – UNESCO colonial town</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Natural remedies</li>
            </ul>`
                },
                '7': {
                    title: 'Colombo City Discovery',
                    duration: '1 Day',
                    category: 'Urban & Culture',
                    description: 'Explore modern landmarks, sacred sites, and vibrant shopping in Sri Lanka’s bustling capital.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Lotus Tower</strong> – 360° city views</li>
                <li><strong>Red Mosque</strong> – Stunning Islamic architecture</li>
                <li><strong>Shopping</strong> – Local markets & malls</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Wellness stop</li>
                <li><strong>Gangaramaya Temple</strong> – Sacred urban oasis</li>
            </ul>`
                },
                '8': {
                    title: 'Yala Wild Safari',
                    duration: '1 Day',
                    category: 'Wildlife',
                    description: 'Track leopards, elephants, and rare birds in one of Asia’s top national parks.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala Jeep Safari</strong> – 3-hour wildlife adventure</li>
                <li>Spot leopards, elephants, sloth bears, and 200+ bird species</li>
            </ul>`
                },
                '9': {
                    title: 'Mirissa Whale Odyssey',
                    duration: '1 Day',
                    category: 'Marine Adventure',
                    description: 'Sail with blue whales in high-comfort boats — the world’s largest creatures up close.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Blue Whale Watching</strong> – 4-hour ocean safari</li>
                <li><strong>Mirissa Beach</strong> – Relax on golden sands</li>
                <li><strong>Stilt Fishing</strong> – Iconic photo moment</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Coastal wellness</li>
            </ul>`
                },
                '10': {
                    title: 'Udawalawe Elephant Day',
                    duration: '1 Day',
                    category: 'Wildlife & Compassion',
                    description: 'Witness baby elephants being fed and roam with wild herds in their natural habitat.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Udawalawe National Park</strong> – Jeep safari</li>
                <li><strong>Elephant Milk Feeding</strong> – Orphanage visit</li>
            </ul>`
                },
                '11': {
                    title: 'Ella & Galle Express',
                    duration: '1 Day',
                    category: 'Scenic & Heritage',
                    description: 'From mountain trains to colonial forts — a fast-paced journey of beauty and history.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Train Ride</strong> – Ella to Galle</li>
                <li><strong>Little Adam’s Peak</strong> – Sunrise hike</li>
                <li><strong>Dutch Fort Galle</strong> – Sunset walk</li>
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Wellness stop</li>
            </ul>`
                },
                '12': {
                    title: 'Yala & Galle Safari',
                    duration: '1 Day',
                    category: 'Wild & Colonial',
                    description: 'Morning wildlife safari, afternoon heritage walk — the ultimate south coast combo.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
                <li><strong>Dutch Fort Galle</strong> – Afternoon colonial walk</li>
            </ul>`
                },
                '13': {
                    title: 'Kandy & Ella & Yala Express',
                    duration: '2 Days',
                    category: 'Cultural & Scenic',
                    description: 'From sacred temples to misty hills and wild safaris — a whirlwind tour of Sri Lanka’s highlights.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Quick Hike</li>
                <li><strong>Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Temple of the Tooth Relic</strong> – Sacred visit</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Kandy (Luxury Hotel)</h3>`
                },
                '14': {
                    title: 'Kandy Cultural',
                    duration: '2 Days',
                    category: 'Cultural',
                    description: 'Immerse in sacred temples, lush gardens, and local traditions in the heart of Sri Lanka.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Kandy City</strong> – Vibrant cultural hub</li>
                <li><strong>Royal Botanical Garden</strong> – Tropical paradise</li>
                <li><strong>Tea Factory & Plantation</strong> – Ceylon tea experience</li>
                <li><strong>Elephant Feeding, Bathing & Riding</strong> – Ethical interaction</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Natural healing tour</li>
                <li><strong>Ambuluwawa Tower</strong> – 360° panoramic views</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Silk Factory</strong> – Traditional weaving</li>
                <li><strong>Nelligala</strong> – Traditional Temple</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Kandy (Luxury Hotel)</h3>`
                },
                '15': {
                    title: 'Ella/Nuwara Eliya/Kandy Cultural',
                    duration: '2 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Pink Post Office</strong> – Cultural Beauty</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Ramboda Waterfall</strong></li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Herbal Garden</strong> – Tropical paradise</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Kandy (Luxury Hotel)</h3>`
                },
                '16': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy Cultural',
                    duration: '3 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Pink Post Office</strong> – Cultural Beauty</li>
                <li><strong>Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Temple of the Tooth Relic</strong> – Sacred visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Gem & Jewelry</strong> – Ceylon gem experience</li>
                <li><strong>Wood Carving</strong> – Traditional carving</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Nuwara Eliya & Kandy (Luxury Hotel)</h3>`
                },
                '17': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya Cultural',
                    duration: '3 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Pidurangala</strong> – Scenic hike</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Golden Temple</strong> – Sacred visit</li>
                <li><strong>Sigiriya Lion Rock</strong> – Ancient fortress</li>
                <li><strong>Village Tour with Boat Ride & Traditional Lunch</strong> – Cultural experience</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Nuwara Eliya & Sigiriya (Luxury Hotel)</h3>`
                },
                '18': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa Cultural',
                    duration: '3 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Kandy & Sigiriya (Luxury Hotel)</h3>`
                },
                '19': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Polonnaruwa Cultural',
                    duration: '4 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Ella,Nuwara Eliya & Kandy (Luxury Hotel)</h3>`
                },
                '20': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura Cultural',
                    duration: '5 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4">Day 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Anuradhapura Ancient City Tour</strong> – Historic exploration</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Sigiriya,Nuwara Eliya & Kandy (Luxury Hotel)</h3>`
                },
                '21': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Colombo Cultural',
                    duration: '5 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4">Day 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Colombo City Tour</strong> – Urban exploration</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Nuwara Eliya,Sigiriya,Polonnaruwa & Kandy (Luxury Hotel)</h3>`
                },
                '22': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Galle Cultural',
                    duration: '5 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4">Day 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Galle City</strong> – Colonial exploration</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Nuwara Eliya,Sigiriya,Polonnaruwa & Galle (Luxury Hotel)</h3>`
                },
                '23': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Colombo',
                    duration: '6 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4">Day 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Anuradhapura Ancient City Tour</strong> – Historic exploration</li>
            </ul>
            <h3 class="mt-4">Day 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Colombo City Tour</strong> – Urban exploration</li>
                <li><strong>Galle City</strong> – Colonial exploration</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Ella,Nuwara Eliya,Sigiriya (Luxury Hotel)</h3>`
                },
                '24': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Colombo',
                    duration: '6 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4">Day 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Anuradhapura Ancient City Tour</strong> – Historic exploration</li>
            </ul>
            <h3 class="mt-4">Day 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Colombo City Tour</strong> – Urban exploration</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Ella,Nuwara Eliya,Kandy,Sigiriya & Colombo (Luxury Hotel)</h3>`
                },
                '25': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Galle',
                    duration: '6 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4">Day 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Anuradhapura Ancient City Tour</strong> – Historic exploration</li>
            </ul>
            <h3 class="mt-4">Day 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Galle City</strong> – Colonial exploration</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Ella,Nuwara Eliya,Kandy,Sigiriya & Galle (Luxury Hotel)</h3>`
                },
            },
        },
    },

    de: {
        translation: {
            home: 'Home',
            aboutUs: 'Über uns',
            sriLankanav: 'Sri Lanka',
            gallerynav: 'Galerie',
            bookATour: 'Tour buchen',
            thingsToDo: 'Aktivitäten',
            contactUs: 'Kontakt',
        },
        // German (de)
        contactus: {
            heroTitle: 'Kontaktieren Sie uns',
            heroSubtitle: 'Star Lanka Tours Sri Lanka - Ihr Tor zu unvergesslichen Abenteuern in Sri Lanka',
            feelFree: 'Kontaktieren Sie uns gerne',
            planDream: 'Planen Sie Ihr Traum-Abenteuer in Sri Lanka',
            reachOutDesc: 'Kontaktieren Sie Star Lanka Tours Sri Lanka für personalisierte Tourenpakete, fachkundige Beratung und unvergessliche Reiseerlebnisse in ganz Sri Lanka.',
            callCenter: 'Call Center',
            phone: '+94 76 805 1224', // ← Change to your real WhatsApp/call number
            emailTitle: 'E-Mail',
            email: 'info@starlankatours.com', // ← Change to your real email
            locationTitle: 'Unser Standort',
            location: 'Beruwala / Bentota Area, Sri Lanka', // ← Update to your actual address (e.g. if in Negombo like your location)
            socialTitle: 'Soziale Netzwerke',
            getInTouch: 'Nehmen Sie Kontakt auf',
            getInTouchDesc: 'Entdecken Sie Sri Lanka mit Star Lanka Tours Sri Lanka — wir sind 24/7 für Sie da, um Ihre Reise unvergesslich zu machen.',
            nameLabel: 'Name',
            namePlaceholder: 'Ihr vollständiger Name',
            emailLabel: 'E-Mail',
            emailPlaceholder: 'sie@beispiel.de',
            phoneLabel: 'Telefonnummer',
            phonePlaceholder: '+94 7X XXX XXXX',
            messageLabel: 'Nachricht',
            messagePlaceholder: 'Erzählen Sie uns von Ihrem Traumurlaub...',
            sendButton: 'Nachricht senden',
            sendingButton: 'Wird gesendet...',
            successMsg: 'Ihre Anfrage wurde über WhatsApp gesendet!',
            errorMsg: 'WhatsApp konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.',
            findUsTitle: 'Finden Sie uns in Sri Lanka',
        },
        // German (de)
        thingstodo: {
            heroTitle: 'Unvergessliche Erlebnisse in Sri Lanka',
            heroSubtitle: 'Abenteuer • Erbe • Natur • Wellness',

            sectionTitle: 'Top-Aktivitäten & Must-Experience-Erlebnisse',

            // Activity titles (used in cards)
            ayurveda: 'Authentische Ayurvedische Behandlungen & Wellness',
            diving: 'Tauchen Weltklasse',
            elephantRide: 'Reiten mit sanften Riesen',
            fishing: 'Traditionelles & Tiefsee-Angeln',
            ballooning: 'Magische Heißluftballonfahrt',
            jeepSafari: 'Aufregende Jeep-Safari-Abenteuer',
            whiteWaterRafting: 'Adrenalin-geladene Rafting-Touren',
            riverSafari: 'Wunderschöne Fluss-Safari-Reise',
            snorkeling: 'Lebendiges Schnorchel-Erlebnis',
            teaTasting: 'Ceylon-Tee-Reise & Verkostung',
            templeVisit: 'Erkunden antiker Tempel & heiliger Stätten',
            wildlifeSafari: 'Big Five & Wildlife-Begegnungen',

            viewMore: 'Mehr anzeigen',
        },
        // German (de)
        gallery: {
            heroTitle: 'Galerie',
            heroSubtitle: 'Momente festgehalten, Erinnerungen bewahrt — unsere Galerie zeigt die Abenteuer, Lächeln und atemberaubenden Ausblicke, die jede Reise in Sri Lanka unvergesslich machen',

            tabPlaces: 'Orte',
            tabEvents: 'Veranstaltungen',

            // Image labels (used in alt text and overlay)
            nuwaraEliya: 'Nuwara Eliya',
            sigiriya: 'Sigiriya',
            anuradhapura: 'Anuradhapura',
            rambodaFalls: 'Ramboda Falls',
            ella: 'Ella',
            yala: 'Yala Nationalpark',
            kandy: 'Kandy',
            bodhiViharaya: 'Bodhi Viharaya',
            knuckles: 'Knuckles Gebirge',
            udawalawe: 'Udawalawe Nationalpark',
            bentota: 'Bentota Boots-Safari',
            colombo: 'Colombo',
            galle: 'Galle Fort',
            mirissa: 'Mirissa Beach',
            jaffna: 'Jaffna',
            ambuluwawaTower: 'Ambuluwawa Turm',
            turtle: 'Schildkrötenaufzuchtstation',
            polonnaruwa: 'Polonnaruwa Antike Stadt',
            polgampala: 'Polgampala Wasserbecken',
            beach: 'Sri-Lanka-Strände',
        },
        // German (de)
        events: {
            heroTitle: 'Veranstaltungen',
            heroSubtitle: 'Feiern Sie den Geist Sri Lankas durch seine Feste — von heiligen buddhistischen Zeremonien bis zu bunten kulturellen Paraden, jedes Ereignis ist eine Gelegenheit, den Herzschlag der Insel zu erleben.',

            tabPlaces: 'Orte',
            tabEvents: 'Veranstaltungen',

            // Event names
            kandyPerahera: 'Kandy Esala Perahera (Das Fest des Zahns)',
            vesak: 'Vesak-Fest',
            sinhalaNewYear: 'Singhalesisches und Tamilisches Neujahr',
            christmas: 'Weihnachten',
            thaiPongal: 'Thai Pongal',
            deepavali: 'Deepavali',
            holi: 'Holi',
            poson: 'Poson-Fest',
        },
        // German (de)
        srilanka: {
            heroTitle: 'Entdecken Sie Sri Lanka',
            heroSubtitle: 'Perle des Indischen Ozeans',

            sectionPlaces: 'Attraktive Orte in Sri Lanka',
            sectionFamous: 'Berühmte Dinge in Sri Lanka',
            viewMore: 'Mehr anzeigen',

            // Intro paragraphs
            intro1: 'Sri Lanka, bekannt als die "Smaragdinsel", ist ein tropisches Juwel, das für seine atemberaubenden Landschaften, antikes Erbe und herzliche Gastfreundschaft gefeiert wird.',
            intro2: 'Mit einem Erbe von über zwei Jahrtausenden beherbergt Sri Lanka UNESCO-Stätten wie die Felsenfestung Sigiriya und die heilige Stadt Anuradhapura. Seine kulturelle Vielfalt verbindet buddhistische, hinduistische und koloniale Einflüsse, sichtbar in lebendigen Festen und kunstvoller Architektur.',
            intro3: 'Das vielfältige Gelände der Insel fasziniert — von rollenden Teeplantagen in Ella bis zu den türkisfarbenen Gewässern von Trincomalee. Nationalparks wie Wilpattu beherbergen Leoparden, Krokodile und seltene Vogelarten und erfreuen Naturliebhaber.',
            intro4: 'Für Abenteuerlustige bietet Sri Lanka Wildwasser-Rafting, Surfen in Arugam Bay und Trekking durch üppige Dschungel. Die Küche, durchzogen von aromatischen Gewürzen, frischem Fisch und Jackfruit, erzählt eine Geschichte von Tradition und Geschmack.',
            intro5: 'Von heiligen Pilgerreisen bis zu ruhigen Strandurlauben verspricht Sri Lanka ein bezauberndes Erlebnis voller Schönheit und Kultur.',

            // Place names & descriptions
            sigiriya: 'Sigiriya Felsenfestung',
            sigiriyaDesc: 'UNESCO-Stätte mit antiken Gärten, Fresken und atemberaubenden Gipfelblicken.',

            templeOfTooth: 'Zahntempel',
            templeOfToothDesc: 'Heilige buddhistische Stätte, die eine Reliquie von Buddhas Zahn beherbergt.',

            ella: 'Ella',
            ellaDesc: 'Hügelstadt umgeben von Teeplantagen, berühmt für die Neun-Bogen-Brücke.',

            yala: 'Yala Nationalpark',
            yalaDesc: 'Bekannt für Elefanten, Leoparden und Wildtiersafaris.',

            galleFort: 'Galle Fort',
            galleFortDesc: 'Koloniales Fort mit Kopfsteinpflasterstraßen und niederländischer Architektur.',

            nuwaraEliya: 'Nuwara Eliya',
            nuwaraEliyaDesc: 'Bekannt als "Klein-England" mit kühlem Klima und Teeplantagen.',

            adamsPeak: 'Adams Peak',
            adamsPeakDesc: 'Heiliger Berg mit einzigartigem Fußabdruck, Pilgerstätte.',

            hortonPlains: 'Horton Plains',
            hortonPlainsDesc: 'Rollende Hügel, Wasserfälle und World’s End Aussichtspunkt.',

            bentota: 'Bentota Strand',
            bentotaDesc: 'Unberührte Küste mit goldenen Sandstränden und Wassersport.',

            jaffna: 'Jaffna',
            jaffnaDesc: 'Reich an tamilischer Kultur, Geschichte und Küche.',

            anuradhapura: 'Anuradhapura',
            anuradhapuraDesc: 'Antike Stadt mit heiligen buddhistischen Stätten und Ruinen.',

            polonnaruwa: 'Polonnaruwa',
            polonnaruwaDesc: 'UNESCO-Stätte mit gut erhaltenen Tempeln und Statuen.',

            unawatuna: 'Unawatuna Strand',
            unawatunaDesc: 'Lebhafter Strand mit Schnorcheln und Nachtleben.',

            colombo: 'Colombo',
            colomboDesc: 'Pulsierende Hauptstadt mit moderner und kolonialer Architektur.',

            udawalawe: 'Udawalawe Nationalpark',
            udawalaweDesc: 'Berühmt für große Elefantenherden und beeindruckende Landschaften.',

            dambulla: 'Dambulla Höhlentempel',
            dambullaDesc: 'UNESCO-Stätte mit antiken buddhistischen Wandmalereien und Statuen.',

            // Famous Things
            ceylonTea: 'Ceylon-Tee',
            ceylonTeaDesc: 'Weltberühmt für seinen Geschmack, besonders aus Nuwara Eliya und Uva.',

            spices: 'Gewürze',
            spicesDesc: 'Zimt, Kardamom, Nelken — Sri-Lanka-Zimt ist der beste.',

            gems: 'Edelsteine',
            gemsDesc: 'Saphire, Rubine, Mondsteine — Insel der seltenen Edelsteine.',

            ayurveda: 'Ayurveda',
            ayurvedaDesc: 'Wellness-Behandlungen mit Massagen und Kräutertherapien.',

            handicrafts: 'Handwerkskunst',
            handicraftsDesc: 'Masken, Batik, Holzschnitzereien, Lackwaren.',

            elephants: 'Elefanten',
            elephantsDesc: 'Kulturelles Symbol, prominent in großen Festumzügen.',

            food: 'Traditionelle Küche',
            foodDesc: 'Reis und Curry, Hoppers, Kottu Roti, Wattalappam.',

            festivals: 'Feste',
            festivalsDesc: 'Esala Perahera, Vesak, Singhalesisch-Tamilisches Neujahr.',

            coconut: 'Kokosprodukte',
            coconutDesc: 'Öl, Milch, Coir-Fasern für Seile und Matten.',

            sarees: 'Kandyan Sari',
            sareesDesc: 'Elegante traditionelle Kleidung für Zeremonien.',

            dances: 'Traditionelle Tänze',
            dancesDesc: 'Kandyan-, Teufel- und Tiefland-Tänze.',

            stiltFishing: 'Stelzenfischen',
            stiltFishingDesc: 'Ikonische Fischtechnik an der Südküste.',

            moonstones: 'Mondsteine',
            moonstonesDesc: 'Halb-edle Steine, berühmt aus den Minen von Meetiyagoda.',

            cricket: 'Cricket',
            cricketDesc: 'Nationale Leidenschaft — Weltmeister 1996.',

            herbs: 'Ayurvedische Kräuter',
            herbsDesc: 'Gotu Kola, Zimt, Neem für Heilmittel.',

            masks: 'Masken',
            masksDesc: 'Ambalangoda-Masken, verwendet in rituellen Aufführungen.',
        },
        // German (de)
        about: {
            hero: {
                discover: "ENTDECKEN",
                starLankaTours: "STAR LANKA TOURS",
                tagline1: "Sehen Sie alte große Ruinen, grüne Teehügel und spannende Tier-Safaris. Sri Lanka ist voller Leben. Diese wunderschöne Insel ist mehr als ein Reiseziel — sie ist ein großes Abenteuer.",
                tagline2: "Sonnige Strände, bewölkte Berge und viele Überraschungen warten auf Sie. Star Lanka Tours Sri Lanka macht jede Minute besonders."
            },
            slider: {
                sigiriya: "Sigiriya Felsenfestung",
                yala: "Yala Nationalpark",
                tea: "Tee-Land",
                beaches: "Saubere Strände",
                temples: "Heilige Tempel"
            },
            about: {
                title: "Über Star Lanka Tours Sri Lanka",
                signature: "Besondere Sri-Lanka-Reisen"
            },
            tours: {
                days4: "4 Tage",
                classic: "BASISREISE",
                days5: "5 Tage",
                safari: "TIERREISEN",
                days6: "6 Tage",
                retreat: "Ruhige Erholung",
                desc1: "Star Lanka Tours Sri Lanka zeigt Ihnen jeden Teil dieser wunderschönen Insel — belebte Städte, neblige Hügel und saubere Südstrände.",
                desc2: "Genießen Sie das Beste von Sri Lanka — heiliges Kandy, unterhaltsames Colombo und ruhige Südküste.",
                desc3: "Suchen Sie Abenteuer, alte Kultur, Tiere oder Ruhe? Star Lanka Tours Sri Lanka schafft tolle Reisen zu jeder Jahreszeit."
            },
            whoWeAre: {
                title: "Wer wir sind",
                description: "<p>Willkommen bei Star Lanka Tours Sri Lanka — Ihrem Freund für Reisen über diese magische Insel. Unser Chef ist der Reiseleiter Nethaj. Unser freundliches lokales Team erstellt Reisen, die das echte Sri Lanka zeigen, nicht nur die üblichen Touristenorte.</p><br /><p>Wir bringen Sie zu alten Städten, grünen Teehügeln, sonnigen Stränden und Parks voller Tiere. Jede Reise lässt Sie die echte Kultur, freundliche Menschen, alte Traditionen und die wunderschöne Natur Sri Lankas spüren.</p><br /><p>Sie wollen Kultur, Abenteuer, Erholung, Gesundheit oder eine besondere private Reise? Wir planen alles sorgfältig, geben persönliche Hilfe und sorgen für glückliche Erinnerungen.</p>",
                imageAlt: "Star Lanka Tours Team",
                item1: { title: "Reisen durch ganz Sri Lanka", text: "Wir gehen von Nord nach Süd — echte lokale Erlebnisse überall." },
                item2: { title: "Reisen maßgeschneidert für Sie", text: "Wir planen die Reise nach Ihren Wünschen — Abenteuer, Kultur, Natur oder Erholung." },
                item3: { title: "Gute lokale Guides", text: "Nethaj und sein Team kennen viele Geheimtipps, alte Geschichten und das wahre Gefühl Sri Lankas." },
                item4: { title: "Hilfe rund um die Uhr", text: "Star Lanka Tours hilft Ihnen 24 Stunden am Tag während Ihrer gesamten Reise." }
            },
            offers: {
                title: "Was wir Ihnen bieten",
                cultural: { title: "Kulturerlebnis", text: "Erleben Sie lokale Bräuche, Feste und Alltag.", alt: "Kulturerlebnis" },
                adventure: { title: "Abenteuerreisen", text: "Wandern, Tier-Safaris, Meeresspaß und Natur-Action.", alt: "Abenteuer" },
                luxury: { title: "Komfort & Luxus", text: "Schöne Hotels, private Autos und besonderer Service.", alt: "Luxus" },
                wellness: { title: "Gesundheit & Entspannung", text: "Yoga, Ayurveda und ruhige Orte.", alt: "Entspannung" }
            },
            guides: {
                title: "Unsere Guides",
                text: "Nethaj ist unser Haupt-Tour-Operator. Unsere ausgebildeten und fröhlichen Guides machen Ihre Reise spannend. Sie zeigen Ihnen Geheimtipps, alte Geschichten und besondere Dinge in Sri Lanka.",
                imageAlt: "Star Lanka Tours Guide - Nethaj"
            },
            expert: {
                name: "Nethaj",
                role: "(Haupt-Guide & Tour-Operator)",
                bio: "Nethaj ist das Herz von Star Lanka Tours Sri Lanka. Er kennt Sri Lanka sehr gut. Von Stränden bis zu hohen Hügeln, Tieren bis zu alten Orten — er schafft Reisen, die Sie nie vergessen.",
                imageAlt: "Nethaj - Star Lanka Tours"
            },
            vehicles: {
                title: "Tour-Fahrzeuge",
                text: "Star Lanka Tours Sri Lanka achtet auf Ihre Sicherheit und Ihren Komfort. Unter Aufsicht von Nethaj verwenden wir moderne, klimatisierte und saubere Autos für entspanntes Reisen über die Insel.",
                bookButton: "Ihre Reise buchen",
                car: { title: "Auto", text: "Gut für 2 oder 3 Personen. Klein, sparsam, perfekt für kleine Touren." },
                van: { title: "Van", text: "Gut für Familien oder kleine Gruppen (bis 6). Groß und bequem für lange Fahrten." },
                minibus: { title: "Minibus", text: "Gut für größere Gruppen (8–12). Schöne Sitze und Platz für Gepäck." },
                luxury: { title: "Luxusauto", text: "Sehr schöne Autos mit weichen Sitzen, Wi-Fi und privatem Fahrer." }
            },
            accommodations: {
                intro: "Übernachten Sie in schönen 3-Sterne-, 4-Sterne-, 5-Sterne-Hotels und besonderen Orten. Wir wählen sie für Ruhe, Schönheit und Komfort auf Ihrer Star Lanka Tours Reise.",
                item1: "Private Villen mit großen Pools und entspannenden Meerblicken.",
                item2: "Altmodische Luxushotels am Meer mit gutem Essen.",
                item3: "Natur-Lodge mit modernen Zimmern und Ausblicken auf wilde Tiere.",
                item4: "Schönes Haus in der Natur mit tollen Ausblicken und grünem Design."
            },
            notices: {
                title: "Kostenlose Extras",
                intro: "Star Lanka Tours Sri Lanka gibt Ihnen diese kostenlosen Dinge auf jeder Reise:",
                bike: { title: "Kostenloses Fahrrad für jeden Gast", text: "Fahren Sie frei herum — wir geben jedem eine Fahrrad." },
                fruits: { title: "Frische Früchte am Ende", text: "Beenden Sie Ihre Reise mit einem schönen Paket frischer Früchte." },
                meals: { title: "Kostenloses Essen bei besonderen Events", text: "Nehmen Sie an lokalen Traditionen teil — wir geben kostenlose Mahlzeiten bei Geld-Fütterungs-Zeremonien." }
            },
        },
        // German (de)
        home: {
            common: { viewAll: "Alle ansehen" },
            sections: {
                recommendations: { title: "Beste Orte", subtitle: "Nicht sicher, wohin? Wir helfen Ihnen bei der Wahl." },
                excursions: { title: "Unsere Touren", desc: "Mehrtägige Reisen — Mischung aus alter Kultur, Natur und glücklichen Erinnerungen." },
                packages: { title: "Spezialpakete" },
                reviews: { title: "Was Gäste sagen", subtitle: "Echte Worte von Menschen, die mit uns gereist sind" },
                gallery: { title: "Unsere Fotos", subtitle: "Wunderschöne Bilder aus Sri Lanka — voller Staunen, Spaß und schöner Momente." }
            },
            recommendations: {
                sigiriya: { label: "Sigiriya", name: "Große alte Felsenfestung hoch über dem Boden." },
                udawalawa: { label: "Udawalawe", name: "Große Flächen mit vielen freien Elefanten." },
                ella: { label: "Ella", name: "Wolkige Hügel, schöne Zugfahrt, tolle Ausblicke." },
                mirissa: { label: "Mirissa", name: "Gelbe Strände, blaues Meer, gut zum Walbeobachten." },
                nuwaraeliya: { label: "Nuwara Eliya", name: "Viele Teefelder und kühle frische Luft." },
                kandy: { label: "Kandy", name: "Heilige Stadt mit dem Zahntempel." },
                galle: { label: "Galle", name: "Altes Fort direkt am Meer." },
                yala: { label: "Yala", name: "Großer Park mit Leoparden, Elefanten und vielen Tieren." },
                anuradhapura: { label: "Anuradhapura", name: "Alter Ort, wo der Buddhismus begann, große Stupas." },
                polonnaruwa: { label: "Polonnaruwa", name: "Alte Stadtruinen aus längst vergangener Zeit." }
            },
            excursions: {
                oneDay: { title: "1 Tag – Sri Lanka an einem Tag", des: "Ein Tag voller Magie — von alten Orten bis zu sonnigen Stränden." },
                twoDays: { title: "2 Tage – Ruf der Natur", des: "Zwei Tage in wilder Natur: Safaris, Teehügel, Dschungelklänge." },
                threeDays: { title: "3 Tage – Seele & Meer", des: "Drei Tage für Ihr Herz — morgens Tempel, abends Meer, echte Kultur." },
                fourDays: { title: "4 Tage – Alt & Ruhig", des: "Vier Tage voller alter Wunder: große Festungen, alte Straßen, echte Traditionen." },
                fiveDays: { title: "5 Tage – Herz von Sri Lanka", des: "Fünf Tage, um Sri Lanka zu lieben — neblige Hügel bis blaues Meer." },
                sixDays: { title: "6 Tage – Besondere Reise", des: "Sechs Tage voller schöner Dinge — heilige Orte, Tier-Safaris, ruhige Sonnenuntergänge." }
            },
            packages: {
                one: { title: "1 Tag / 0 Nächte: Sri Lanka an einem Tag", duration: "1 Tag", desc: "Ein großer Tag — alte Stupas, goldene Strände, echtes Sri-Lanka-Gefühl.", category: "Kurztrip" },
                two: { title: "2 Tage / 1 Nacht: Ruf der Natur", duration: "2 Tage", desc: "Zwei Tage in der Natur — Nacht-Safaris, Teeduft, Dschungelleben.", category: "Wildtrip" },
                three: { title: "3 Tage / 2 Nächte: Seele & Meer", duration: "3 Tage", desc: "Drei Tage für die Seele — morgens Tempel, abends ruhiges Meer.", category: "Meer & Geist" },
                four: { title: "4 Tage / 3 Nächte: Alt & Ruhig", duration: "4 Tage", desc: "Vier Tage voller alter Dinge — Festungen, alte Städte, echte Kultur.", category: "Kulturtrip" },
                five: { title: "5 Tage / 4 Nächte: Herz von Sri Lanka", duration: "5 Tage", desc: "Fünf Tage, um die Insel zu lieben — Hügel, blaues Meer, glückliche Momente.", category: "Liebestrip" },
                six: { title: "6 Tage / 5 Nächte: Besondere Reise", duration: "6 Tage", desc: "Sechs Tage voller Highlights — heilige Orte, Tiere, schöne Sonnenuntergänge.", category: "Bester Trip" }
            },
            featured: {
                perahera: {
                    h2: "Sehen Sie diese große Show", h3: "Kandy Esala Perahera", h4: "(Fest des Zahns)",
                    paragraph: `Eines der größten buddhistischen Feste Asiens. Jedes Jahr in Kandy ehren die Menschen den Heiligen Zahn. Elefanten in prächtigen Kleidern, laute Trommeln, Feuertänzer und Lichter machen eine wunderschöne Nacht. Kommen Sie mit <strong style="color: #166880;">Star Lanka Tours Sri Lanka</strong> und erleben Sie es — hier lebt die Kultur.`,
                    button: "Mehr sehen"
                },
                safari: {
                    h2: "Gehen Sie in die Wildnis", h3: "Safari-Touren",
                    paragraph: `Sri Lanka hat einige der besten Tiere Asiens. Sehen Sie weite Flächen in <span style="color: #D5A44F; font-weight: 600;">Yala</span> und <span style="color: #D5A44F; font-weight: 600;">Udawalawe</span> oder Seen in <span style="color: #D5A44F; font-weight: 600;">Wilpattu</span>. Finden Sie Elefanten, Leoparden und viele Vögel. Reisen Sie mit <strong style="color: #166880;">Star Lanka Tours Sri Lanka</strong> — jedes Safari ist eine neue Geschichte.`,
                    button: "Safaris ansehen"
                }
            },
            gallery: {
                title: "Unsere Fotos", subtitle: "Schöne Bilder aus Sri Lanka — voller Staunen, Spaß und Schönheit.",
                alt1: "Sonnenaufgang über Sigiriya Rock", alt2: "Elefanten im Yala Nationalpark", alt3: "Tee-Pflückerinnen in nebligem Nuwara Eliya",
                alt4: "Sonnenuntergang am Mirissa Beach", alt5: "Gebet im Kandy Tempel", alt6: "Alte Ruinen in Polonnaruwa",
                alt7: "Wale vor der Südküste", alt8: "Zugfahrt in den Ella-Hügeln", alt9: "Galle Fort im Abendlicht",
                alt10: "Fischer in Negombo", alt11: "Kandyan-Tanzvorführung", alt12: "Heißluftballon über Dambulla"
            },
            cta: {
                title: "Star Lanka Tours Sri Lanka — Glückliche Reisen schaffen",
                desc: "Jede Reise ist besonders — voller Kultur, Spaß und ruhiger Momente. Lassen Sie uns Ihre Geschichte im wunderschönen Sri Lanka schreiben.",
                button: "Jetzt starten",
                alt: "Ihre Reise gestalten"
            },
        },
        // German (de)
        hero: {
            title: {
                line1: "Entdecken Sie das Paradies mit",
                line2: "Star Lanka Tours",
                line3: "Sri Lanka"
            },
            subtitle: "Tauchen Sie ein in üppige smaragdgrüne Dschungel, sonnendurchflutete goldene Strände, zeitlose antike Städte und aufregende Wildtier-Abenteuer —",
            subtitle2: "perfekt auf Ihre Träume zugeschnitten.",

            cta: "Starten Sie Ihr Abenteuer",
            trust: "Geliebt von Reisenden aus über 50 Ländern • Anerkannt von führenden Reiseexperten weltweit"
        },
        // German (de)
        footer: {
            brand: "Star Lanka Tours",

            nav: {
                home: "Home",
                about: "Über uns",
                explore: "Sri Lanka entdecken",
                tours: "Tourenpakete",
                gallery: "Galerie",
                events: "Besondere Veranstaltungen",
                things: "Aktivitäten",
                contact: "Kontakt"
            },

            contact: {
                title: "Lassen Sie uns gemeinsam großartige Erinnerungen schaffen",
                address: "Beruwala Area,<br />Western Province, Sri Lanka",
                email: "info@starlankatours.com",          // ← change to your real email
                phone: "+94 76 805 1224"                   // ← change to your real phone/WhatsApp number
            },

            newsletter: {
                title: "Werden Sie Teil unseres Abenteuers",
                desc: "Erhalten Sie als Erster Neuigkeiten zu Sonderangeboten, Geheimtipps und unglaublichen Reisen in Sri Lanka.",
                placeholder: "Ihre E-Mail-Adresse",
                subscribe: "Abonnieren"
            },

            tagline: "\"Nicht alle, die wandern, sind verloren…<br /><span class='text-[#96BA33] font-semibold'>manche reisen mit Star Lanka Tours</span>\"",

            copyright: "Alle Rechte vorbehalten.",
            developedBy: "Gestaltet von"
        },
        ayurveda: {
            title: "Ayurveda - Die uralte Wissenschaft des Lebens",
            introParagraph1: "Das Wort 'Ayurveda' existiert seit mehr als dreitausend Jahren. Im Sanskrit bedeutet das Wort 'Lebenswissenschaft'. Die Technik basiert auf der ayurvedischen Heilansicht von Krankheiten statt deren Folgen, die normalerweise die europäische Medizin bekämpft. Sie postuliert folgende Prinzipien:",
            corePrinciplesTitle: "Kernprinzipien",
            principle1: "Der Körper sollte frei von Energie sein und das Gleichgewicht für normale Stoffwechsel- und Herzaktivität aufrechterhalten.",
            principle2: "Der Körper sollte eine normale Muskelkontraktion mit regelmäßiger Hormonaktivität haben.",
            principle3: "Der Körper benötigt ein gesundes Immunsystem, um richtig zu funktionieren.",
            sriLankaDoctors: "Laut aktuellen Daten gibt es in Sri Lanka mehr als 6.000 ausgebildete Ayurveda-Absolventen. Sie durchlaufen sieben Jahre Studium und zwei Jahre Praxis in öffentlichen Krankenhäusern. Ayurveda-Programme umfassen:",
            benefit1: "Beseitigung von Stress, Müdigkeit und Angst",
            benefit2: "Sauerstoffsättigung",
            benefit3: "Stimulation der Muskelsysteme und Beseitigung von Toxinen",
            benefit4: "Wiederherstellung des Gleichgewichts des Nervensystems",
            benefit5: "Wiederherstellung des Blutflusses zu inneren Organen",
            benefit6: "Produktion von Endorphinen",
            mainImageAlt: "Ayurveda Wellness",
            faceTreatmentAlt: "Ayurveda Gesichtsbehandlung",
            faceTreatmentCaption: "Ayurveda Gesichtsbehandlung",
            massageTreatmentAlt: "Ayurveda Massage-Behandlung",
            massageTreatmentCaption: "Ayurveda Massage-Behandlung",
            treatmentDescription: "Standardbehandlungen umfassen Körpermassagen und Kopfhautmassagen mit speziellen Ölen, Kräutersauna-Behandlungen und mit Kräutern angereicherte Bäder. Die beliebteste Technik ist das „Shirodhara-Verfahren, bei dem warmes Kräuteröl rhythmisch auf die Stirn getropft wird.Dies hilft, das Gleichgewicht des Nervensystems wiederherzustellen und Entspannung zu erreichen.",
            tipsTitle: "Tipps für ayurvedische Behandlung",
            tip1: "Vergessen Sie Probleme. Entspannen Sie sich und klären Sie Ihren Geist für beste Ergebnisse.",
            tip2: "Wählen Sie den richtigen Standort. Wählen Sie eine Umgebung, die Ihrem Komfort und Ihren Vorlieben für optimale Heilung entspricht.",
            tip3: "Wählen Sie das richtige Programm. Besprechen Sie Ihre Anliegen mit dem Arzt und probieren Sie verschiedene Therapien aus, um herauszufinden, was zu Ihnen passt.",
            tip4: "Nehmen Sie vor der Behandlung ein warmes Bad, um Ihre Muskeln zu entspannen und Ihren Körper vorzubereiten.",
            tip5: "Essen Sie vor dem Eingriff eine leichte Mahlzeit. Vermeiden Sie schwere Mahlzeiten, um einen ordnungsgemäßen Blutfluss während der Massage zu ermöglichen.",
            tip6: "Entspannung nach den Eingriffen ist unerlässlich. Richtige Entspannung erhöht die Wirksamkeit ayurvedischer Behandlungen."
        },
        ballooning: {
            title: "Ballonfahren in Sri Lanka",
            introParagraph1: "Heißluftballonfahren in Sri Lanka bietet ein unvergessliches Erlebnis, sanft über die atemberaubenden Landschaften der Insel zu schweben. Bei Sonnenaufgang beginnend bieten Ballonfahrten atemberaubende Luftansichten von hügeligen Hügeln, üppigen Wäldern, antiken Ruinen und ruhigen Dörfern.",
            introParagraph2: "Das beliebteste Ballonfahrtziel in Sri Lanka ist Dambulla, im Herzen des kulturellen Dreiecks gelegen. Ballonfahrten hier führen Sie oft über die ikonische Sigiriya-Felsenfestung und bieten eine Perspektive wie keine andere. Flüge dauern in der Regel 60-90 Minuten und geben Ihnen ausreichend Zeit, die Schönheit Sri Lankas von oben zu genießen.",
            mainImageAlt: "Heißluftballonfahren in Sri Lanka",
            mainImageCaption: "Heißluftballonfahren in Sri Lanka",
            highlightsTitle: "Warum Heißluftballonfahren in Sri Lanka versuchen?",
            highlightsIntro: "Heißluftballonfahren verbindet Abenteuer mit Ruhe und ermöglicht es Ihnen, die Schönheit Sri Lankas auf einzigartige Weise zu erleben. Einige der Highlights des Ballonfahrens umfassen:",
            highlight1: "Ununterbrochene Panoramablicke auf die atemberaubenden Landschaften der Insel.",
            highlight2: "Fliegen über ikonische Wahrzeichen wie den Sigiriya-Felsen und nahe gelegene Seen.",
            highlight3: "Eine ruhige und friedliche Fahrt über üppiges Grün und charmante Dörfer.",
            highlight4: "Erleben Sie einen spektakulären Sonnenaufgang vom Himmel aus.",
            highlight5: "Perfekt für Fotografie-Enthusiasten, die die landschaftliche Schönheit von oben einfangen möchten.",
            sunriseImageAlt: "Genießen Sie atemberaubende Ausblicke auf den Sonnenaufgang, während Sie sanft in einem Heißluftballon schweben.",
            sunriseImageCaption: "Genießen Sie atemberaubende Ausblicke auf den Sonnenaufgang, während Sie sanft in einem Heißluftballon schweben.",
            landscapeImageAlt: "Erleben Sie atemberaubende Landschaften Sri Lankas von oben, einschließlich hügeliger Hügel und üppiger Wälder.",
            landscapeImageCaption: "Erleben Sie atemberaubende Landschaften Sri Lankas von oben, einschließlich hügeliger Hügel und üppiger Wälder.",
            tipsTitle: "Tipps für eine unvergessliche Ballonfahrt",
            tip1: "Buchen Sie Ihre Fahrt früh, da Ballonfahren wetterabhängig ist und Plätze sich schnell füllen.",
            tip2: "Tragen Sie bequeme Kleidung und bringen Sie eine leichte Jacke mit, da frühe Morgen kühl sein können.",
            tip3: "Bringen Sie eine Kamera oder ein Smartphone mit, um die atemberaubenden Ausblicke einzufangen.",
            tip4: "Hören Sie aufmerksam auf die Sicherheitsanweisungen Ihres Piloten.",
            tip5: "Kommen Sie rechtzeitig an, um die Vorbereitung und das Aufblasen des Ballons zu beobachten, was ein faszinierender Prozess ist."
        },
        diving: {
            title: "Tauchen in Sri Lanka",
            introParagraph1: "Ein breites Korallenriff umgibt die Küste Sri Lankas in Tiefen von 2 bis 40 Metern. Die warmen Gewässer des Indischen Ozeans, zwischen 27°C und 30°C, und die hohe Transparenz des Wassers, von 15 bis 35 Metern, bieten hervorragende Bedingungen zum Tauchen und Schnorcheln. Beim Tauchen in Sri Lanka können Sie endlose unberührte Korallenriffe, alte Wracks und faszinierende Unterwasserhöhlen erkunden.",
            introParagraph2: "Der Nordosten der Insel bietet eine Vielfalt von mehr als 130 Arten bunter Korallen, die Heimat für Meereslebewesen wie Meeresschildkröten, Clownfische, Feuerfische und Seepferdchen sind. Besuchen Sie Schiffswracks in der Nähe von Unterwasserfelsen und Riffen für ein unvergessliches Erlebnis. Wenn Sie in den klaren Gewässern schweben, tauchen Sie in die faszinierende Vergangenheit von Ceylon ein.",
            mainImageAlt: "Tauchen in Sri Lanka",
            mainImageCaption: "Tauchen in Sri Lanka",
            facilitiesTitle: "Einrichtungen und beste Tauchplätze",
            facilitiesParagraph1: "Insel-Tauchzentren sind mit der neuesten Tauchausrüstung von renommierten Herstellern ausgestattet. Zertifizierte Instruktoren mit PADI- und CMAS-Qualifikationen sorgen für sichere und angenehme Tauchgänge. Tauchzentren befinden sich entlang der Südwestküste der Insel und sind zwischen Mitte Oktober und Ende April in Betrieb. Die Nordostküste, einschließlich Nilaveli und Trincomalee, ist von März bis Oktober ideal zum Tauchen.",
            facilitiesParagraph2: "Die Korallenriffe in der Nähe von Kalpitiya im Westen und die Schiffswrack-Tauchplätze in Hikkaduwa gehören zu den beliebtesten Attraktionen für Taucher.",
            coralImageAlt: "Erkunden Sie lebendige Korallenriffe, die Heimat für vielfältiges Meeresleben sind.",
            coralImageCaption: "Erkunden Sie lebendige Korallenriffe, die Heimat für vielfältiges Meeresleben sind.",
            shipwreckImageAlt: "Entdecken Sie historische Schiffswracks, die einen Einblick in die maritime Vergangenheit Sri Lankas bieten.",
            shipwreckImageCaption: "Entdecken Sie historische Schiffswracks, die einen Einblick in die maritime Vergangenheit Sri Lankas bieten.",
            tipsTitle: "Tipps für Taucher",
            tip1: "Wählen Sie die beste Saison zum Tauchen basierend auf dem Standort: Südwestküste (Oktober bis April) oder Nordostküste (März bis Oktober).",
            tip2: "Stellen Sie sicher, dass Ihr Tauchzentrum zertifiziert und mit moderner Ausrüstung für ein sicheres Erlebnis ausgestattet ist.",
            tip3: "Hören Sie auf die Ratschläge Ihres Instruktors, besonders wenn Sie Anfänger sind.",
            tip4: "Respektieren Sie das Meeresleben, indem Sie Korallen nicht berühren oder die Unterwasserumgebung stören.",
            tip5: "Bringen Sie eine wasserdichte Kamera mit, um die faszinierende Schönheit der Unterwasserwelt Sri Lankas einzufangen."
        },
        elephantRide: {
            title: "Elefantenrückenritt",
            introParagraph1: "Elefantentrekking ist eine faszinierende, aufregende Aktivität und ein einzigartiges Erlebnis in Sri Lanka. Wenn Sie in der Nähe des kulturellen Dreiecks in Gebieten wie Habarana, Sigiriya oder Dambulla bleiben, können Sie an einer Elefantensafari teilnehmen. Diese Fahrten beginnen bei etwa 30 $ für eine Stunde unvergesslichen Abenteuers.",
            introParagraph2: "Vor der Fahrt werden Elefanten mit einem Mehrkorbsattel für 4 bis 6 Personen gesattelt. Diese sanften Riesen führen Sie durch malerische Dschungelpfade, überqueren überschwemmte Gebiete und navigieren durch üppige Vegetation. Elefanten gehen normalerweise langsam, sodass Sie die Schönheit der umgebenden Natur vollständig schätzen können, obwohl sie Geschwindigkeiten von bis zu 40 km/h erreichen können.",
            mainImageAlt: "Elefantenrückenritt",
            mainImageCaption: "Elefantenrückenritt",
            highlightsTitle: "Highlights eines Elefantenritts",
            highlightsIntro: "Auf einem Elefanten in Sri Lanka zu reiten bietet eine einzigartige Möglichkeit, mit der Natur in Kontakt zu kommen und die Landschaft zu erkunden. Einige Highlights des Erlebnisses umfassen:",
            highlight1: "Durch dichte Dschungel voller exotischer Vegetation und Wildtiere gehen.",
            highlight2: "Flüsse und überschwemmte Gebiete überqueren, die atemberaubende Ausblicke auf die natürliche Landschaft bieten.",
            highlight3: "Über die enge Beziehung zwischen Elefanten und sri-lankischer Kultur lernen.",
            highlight4: "Auf einem bequemen Sattel entspannen, während der Elefant Sie sanft durch verschiedene Gelände trägt.",
            jungleImageAlt: "Erkunden Sie dichte Dschungel und malerische Pfade, während Sie auf einem Elefanten reiten.",
            jungleImageCaption: "Erkunden Sie dichte Dschungel und malerische Pfade, während Sie auf einem Elefanten reiten.",
            waterImageAlt: "Überqueren Sie Flüsse und genießen Sie die ruhige Schönheit des Wassers und der Vegetation.",
            waterImageCaption: "Überqueren Sie Flüsse und genießen Sie die ruhige Schönheit des Wassers und der Vegetation.",
            tipsTitle: "Tipps für einen sicheren und angenehmen Elefantenritt",
            tip1: "Tragen Sie bequeme Kleidung und Schuhe, die für Outdoor-Aktivitäten geeignet sind.",
            tip2: "Befolgen Sie die Anweisungen Ihres Führers für eine sichere und angenehme Fahrt.",
            tip3: "Stellen Sie sicher, dass die Elefanten gut behandelt werden und der Fahrtenanbieter ethische Praktiken befolgt.",
            tip4: "Bringen Sie eine Kamera mit, um die atemberaubende Landschaft und Momente einzufangen.",
            tip5: "Respektieren Sie die Elefanten und vermeiden Sie Handlungen, die sie stressen oder ihnen schaden könnten."
        },
        fishing: {
            title: "Angeln in Sri Lanka",
            introParagraph1: "Sri Lanka, mit seiner weiten Küste und Fülle von Süßwasserseen und Flüssen, bietet ein unvergleichliches Angelerlebnis. Ob Sie ein professioneller Angler oder ein Hobbyist sind, Sri Lanka hat etwas zu bieten. Von Hochseeangel-Expeditionen bis zum traditionellen Stelzenfischen, das von lokalen Fischern praktiziert wird, werden Sie ein unvergessliches Abenteuer haben.",
            introParagraph2: "Beliebte Angelziele sind die Südküste rund um Galle und Mirissa, die Negombo-Lagune und die ruhigen Gewässer von Trincomalee. Je nach Vorliebe können Sie verschiedene Angeltechniken wie Schleppangeln, Grundangeln oder Fliegenfischen ausprobieren.",
            mainImageAlt: "Angeln in Sri Lanka",
            mainImageCaption: "Angeln in Sri Lanka",
            experiencesTitle: "Angelerlebnisse in Sri Lanka",
            experiencesIntro: "Angeln in Sri Lanka geht nicht nur darum, Fische zu fangen; es ist eine Gelegenheit, in die Kultur und Traditionen der Insel einzutauchen. Einige einzigartige Angelerlebnisse umfassen:",
            expStiltTitle: "Stelzenfischen",
            expStiltDesc: "Eine traditionelle Methode, bei der Fischer auf Stelzen sitzen, um Fische in der Nähe der Küste zu fangen, eine Praxis einzigartig für Sri Lanka.",
            expDeepSeaTitle: "Hochseeangeln",
            expDeepSeaDesc: "Wagen Sie sich in den Indischen Ozean, um Marline, Thunfische, Barrakudas und andere große Fischarten zu fangen.",
            expLagoonTitle: "Lagunen- und Flussangeln",
            expLagoonDesc: "Entspannen Sie beim Angeln in ruhigen Lagunen und Flüssen voller Fische wie Tilapia und Welse.",
            expNightTitle: "Nachtangeln",
            expNightDesc: "Erleben Sie den Nervenkitzel des Angelns unter den Sternen, eine gängige Praxis in Küstendörfern.",
            stiltImageAlt: "Stelzenfischen, eine traditionelle Methode und ikonischer Teil des Angelerbes Sri Lankas.",
            stiltImageCaption: "Stelzenfischen ist eine traditionelle Methode und ein ikonisches Bild des Angelerbes Sri Lankas.",
            deepSeaImageAlt: "Hochseeangeln bietet ein abenteuerliches Erlebnis und zielt auf große Fischarten im Indischen Ozean ab.",
            deepSeaImageCaption: "Hochseeangeln bietet ein abenteuerliches Erlebnis und zielt auf große Fischarten im Indischen Ozean ab.",
            tipsTitle: "Tipps für einen angenehmen Angelausflug",
            tip1: "Wählen Sie die richtige Saison für Ihre Angelexpedition; Oktober bis April ist ideal für die Südküste, während März bis Oktober für die Ostküste geeignet ist.",
            tip2: "Bringen Sie Sonnencreme, einen Hut und Schutzkleidung mit, um während Ihrer Reise komfortabel zu bleiben.",
            tip3: "Buchen Sie einen Angelführer oder Charter, um das Beste aus Ihrem Erlebnis zu machen und von den Experten zu lernen.",
            tip4: "Respektieren Sie die lokale Umwelt, indem Sie nicht littern und nachhaltige Angelpraktiken einhalten.",
            tip5: "Bleiben Sie hydratisiert und bringen Sie Snacks für längere Angelausflüge mit."
        },
        jeepSafari: {
            title: "Jeep-Safari in Sri Lanka",
            introParagraph1: "Die Nationalparks Sri Lankas bieten ein aufregendes Jeep-Safari-Erlebnis, das es Ihnen ermöglicht, die reiche Biodiversität der Insel zu erkunden und Wildtiere in ihren natürlichen Lebensräumen zu beobachten. Der Yala-Nationalpark, der Wilpattu-Nationalpark und der Udawalawe-Nationalpark gehören zu den beliebtesten Zielen für Jeep-Safaris.",
            introParagraph2: "Diese Safaris bieten die Möglichkeit, Elefanten, Leoparden, Lippenbären, Wasserbüffel, Krokodile und eine Vielzahl von Vogelarten zu sehen. Geführt von erfahrenen Naturforschern und Trackern sind Jeep-Safaris perfekt für Wildtier-Enthusiasten und Fotografen gleichermaßen.",
            mainImageAlt: "Jeep-Safari in Sri Lanka",
            mainImageCaption: "Jeep-Safari in Sri Lanka",
            whyChooseTitle: "Warum eine Jeep-Safari wählen?",
            whyChooseIntro: "Jeep-Safaris sind eine der besten Möglichkeiten, die vielfältige Tierwelt Sri Lankas zu erkunden. Hier sind einige Highlights:",
            highlight1: "Nahbegegnungen mit ikonischen Arten wie Elefanten und Leoparden.",
            highlight2: "Zugang zu abgelegenen und malerischen Gebieten innerhalb von Nationalparks.",
            highlight3: "Möglichkeiten für Wildtierfotografie in natürlicher Umgebung.",
            highlight4: "Führung von sachkundigen Naturforschern und Parkrangern.",
            highlight5: "Ein Abenteuer, das für alle Altersgruppen geeignet ist und Spannung mit Bildung verbindet.",
            wildlifeImageAlt: "Erleben Sie ikonische Wildtiere wie Leoparden, Elefanten und Krokodile während Ihrer Safari.",
            wildlifeImageCaption: "Erleben Sie ikonische Wildtiere wie Leoparden, Elefanten und Krokodile während Ihrer Safari.",
            landscapeImageAlt: "Erkunden Sie die atemberaubenden Landschaften der Nationalparks Sri Lankas, von dichten Wäldern bis zu offenen Ebenen.",
            landscapeImageCaption: "Erkunden Sie die atemberaubenden Landschaften der Nationalparks Sri Lankas, von dichten Wäldern bis zu offenen Ebenen.",
            tipsTitle: "Tipps für eine angenehme Jeep-Safari",
            tip1: "Tragen Sie bequeme, neutral gefärbte Kleidung, um sich in die Umgebung einzufügen.",
            tip2: "Bringen Sie Sonnencreme, einen Hut und Insektenschutzmittel zum Schutz mit.",
            tip3: "Bringen Sie ein Fernglas und eine Kamera mit, um Ihr Erlebnis zu verbessern und Wildtiere einzufangen.",
            tip4: "Befolgen Sie die Anweisungen des Führers, um Sicherheit und Respekt für die Tiere zu gewährleisten.",
            tip5: "Buchen Sie Ihre Safari früh, besonders während der Hochsaison, um sich einen Platz zu sichern."
        },
        riverSafari: {
            title: "Fluss-Safari in Sri Lanka",
            introParagraph1: "Eine Fluss-Safari in Sri Lanka bietet eine einzigartige Möglichkeit, die reiche Biodiversität und landschaftliche Schönheit der Insel zu erkunden. Gleiten Sie entlang ruhiger Wasserwege, umgeben von üppigen Mangroven, entdecken Sie exotische Wildtiere und genießen Sie malerische Sonnenuntergänge, die Sie faszinieren werden.",
            introParagraph2: "Beliebte Fluss-Safari-Ziele sind die Madu Ganga (Madu-Fluss) und der Bentota-Fluss. Diese Safaris bieten die Möglichkeit, verschiedene Vogelarten, Warane, Krokodile und sogar Affen in ihren natürlichen Lebensräumen zu beobachten. Die ruhige Umgebung ist perfekt für Naturliebhaber und Fotografen.",
            mainImageAlt: "Fluss-Safari in Sri Lanka",
            mainImageCaption: "Fluss-Safari in Sri Lanka",
            whyChooseTitle: "Warum eine Fluss-Safari wählen?",
            whyChooseIntro: "Eine Fluss-Safari ist ein entspannendes und immersives Erlebnis, das Natur, Wildtiere und kulturelle Erkundung kombiniert. Hier sind einige Highlights:",
            highlight1: "Erkunden Sie üppige Mangroven voller Leben.",
            highlight2: "Entdecken Sie exotische Vögel, Krokodile und andere Wildtiere.",
            highlight3: "Besuchen Sie kleine Inseln und lokale Dörfer entlang des Flusses.",
            highlight4: "Genießen Sie die Ruhe und malerische Schönheit der Wasserwege Sri Lankas.",
            highlight5: "Perfekt für Familien, Paare und Alleinreisende, die einen friedlichen Rückzugsort suchen.",
            mangrovesImageAlt: "Entdecken Sie die üppigen Mangroven, die Sri Lankas malerische Wasserwege säumen.",
            mangrovesImageCaption: "Entdecken Sie die üppigen Mangroven, die Sri Lankas malerische Wasserwege säumen.",
            wildlifeImageAlt: "Entdecken Sie exotische Wildtiere wie Krokodile, Warane und bunte Vögel während Ihrer Safari.",
            wildlifeImageCaption: "Entdecken Sie exotische Wildtiere wie Krokodile, Warane und bunte Vögel während Ihrer Safari.",
            tipsTitle: "Tipps für eine angenehme Fluss-Safari",
            tip1: "Tragen Sie bequeme Kleidung und bringen Sie einen Hut und Sonnencreme zum Schutz mit.",
            tip2: "Bringen Sie ein Fernglas mit, um entfernte Wildtiere und Vögel zu entdecken.",
            tip3: "Bringen Sie eine Kamera oder ein Smartphone mit, um die atemberaubende Landschaft und Wildtiere einzufangen.",
            tip4: "Befolgen Sie die Anweisungen Ihres Führers für ein sicheres und angenehmes Erlebnis.",
            tip5: "Respektieren Sie die natürliche Umwelt, indem Sie nicht littern und Wildtiere nicht stören."
        },
        snorkeling: {
            title: "Schnorcheln in Sri Lanka",
            introParagraph1: "Schnorcheln in Sri Lanka bietet ein unvergessliches Unterwassererlebnis, bei dem Sie lebendige Korallenriffe und vielfältiges Meeresleben erkunden können. Mit seinen kristallklaren natürlichen Gewässern und reichhaltigen aquatischen Ökosystemen ist Sri Lanka ein Paradies für Schnorchler aller Könnensstufen.",
            introParagraph2: "Einige der beliebtesten Schnorchelplätze sind Hikkaduwa, bekannt für seine bunten Korallengärten und Schildkröten, Pigeon Island in Trincomalee, berühmt für seine unberührten Riffe, und Mirissa, wo Sie während der Schnorchelsaison sogar einen Wal oder zwei entdecken könnten.",
            mainImageAlt: "Schnorcheln in Sri Lanka",
            mainImageCaption: "Schnorcheln in Sri Lanka",
            whyChooseTitle: "Warum Schnorcheln in Sri Lanka wählen?",
            whyChooseIntro: "Schnorcheln in Sri Lanka ist ein magisches Erlebnis, das Abenteuer und natürliche Schönheit verbindet. Hier sind einige Highlights:",
            highlight1: "Erkunden Sie lebendige Korallenriffe voller Leben.",
            highlight2: "Schwimmen Sie neben bunten tropischen Fischen, Schildkröten und sogar Riffhaien.",
            highlight3: "Entdecken Sie unberührte Unterwasserlandschaften in klarem, warmem Wasser.",
            highlight4: "Geeignet sowohl für Anfänger als auch für erfahrene Schnorchler.",
            highlight5: "Zugänglich von einigen der besten Strandziele in Sri Lanka.",
            coralImageAlt: "Entdecken Sie atemberaubende Korallenriffe und ihre lebendigen Ökosysteme.",
            coralImageCaption: "Entdecken Sie atemberaubende Korallenriffe und ihre lebendigen Ökosysteme.",
            marineLifeImageAlt: "Begegnen Sie vielfältigem Meeresleben, einschließlich Schildkröten, tropischen Fischen und mehr.",
            marineLifeImageCaption: "Begegnen Sie vielfältigem Meeresleben, einschließlich Schildkröten, tropischen Fischen und mehr.",
            tipsTitle: "Tipps für ein unvergessliches Schnorchelerlebnis",
            tip1: "Tragen Sie eine bequeme Maske und Schnorchel, um eine klare Sicht unter Wasser zu gewährleisten.",
            tip2: "Verwenden Sie riffsichere Sonnencreme, um sowohl Ihre Haut als auch das Meeresleben zu schützen.",
            tip3: "Schwimmen Sie sanft, um zu vermeiden, Korallenriffe und Wasserlebewesen zu stören.",
            tip4: "Bleiben Sie hydratisiert und machen Sie Pausen zwischen den Sitzungen.",
            tip5: "Nehmen Sie an einer geführten Tour teil, um die besten Schnorchelplätze und Sicherheitstipps zu erhalten."
        },
        teaTasting: {
            title: "Tee-Verkostungstour in Sri Lanka",
            introParagraph1: "Sri Lanka, oft als die 'Perle des Indischen Ozeans' bezeichnet, ist berühmt für seine weltklasse Teeproduktion. Begeben Sie sich auf eine Tee-Verkostungstour und erkunden Sie die üppigen Teeplantagen in Regionen wie Nuwara Eliya, Ella und Kandy. Lernen Sie die Kunst des Teeanbaus, den sorgfältigen Prozess der Teeproduktion kennen und genießen Sie die reichen Aromen des authentischen Ceylon-Tees.",
            introParagraph2: "Ob Sie ein Tee-Enthusiast sind oder einfach nur neugierig, eine Tee-Verkostungstour bietet eine einzigartige Gelegenheit, in das Teeerbe Sri Lankas einzutauchen und die ruhige Schönheit seiner Hochländer zu erleben.",
            mainImageAlt: "Tee-Verkostungstour in Sri Lanka",
            mainImageCaption: "Tee-Verkostungstour in Sri Lanka",
            whyChooseTitle: "Warum eine Tee-Verkostungstour wählen?",
            whyChooseIntro: "Eine Tee-Verkostungstour in Sri Lanka geht nicht nur um das Verkosten von Tee – es ist ein immersives kulturelles Erlebnis. Hier sind einige Highlights:",
            highlight1: "Besuchen Sie malerische Teeplantagen, die in den kühlen Hochländern eingebettet sind.",
            highlight2: "Erfahren Sie mehr über die Geschichte und Bedeutung von Ceylon-Tee.",
            highlight3: "Nehmen Sie am Teepflücken teil und beobachten Sie den Produktionsprozess in Teefabriken.",
            highlight4: "Genießen Sie verschiedene Teesorten, von schwarzem bis grünem bis aromatisierten Mischungen.",
            highlight5: "Genießen Sie die atemberaubende Landschaft nebliger Berge und kaskadierender Wasserfälle.",
            plantationImageAlt: "Erkunden Sie üppige Teeplantagen und lernen Sie über Teeanbau.",
            plantationImageCaption: "Erkunden Sie üppige Teeplantagen und lernen Sie über Teeanbau.",
            preparationImageAlt: "Entdecken Sie die Kunst der Teezubereitung und genießen Sie authentischen Ceylon-Tee.",
            preparationImageCaption: "Entdecken Sie die Kunst der Teezubereitung und genießen Sie authentischen Ceylon-Tee.",
            tipsTitle: "Tipps für eine angenehme Tee-Verkostungstour",
            tip1: "Tragen Sie bequeme Kleidung und Schuhe zum Spazierengehen durch Plantagen.",
            tip2: "Bringen Sie eine leichte Jacke mit, da Hochlandregionen kühl und neblig sein können.",
            tip3: "Probieren Sie verschiedene Teesorten und nehmen Sie einige Favoriten als Souvenirs mit nach Hause.",
            tip4: "Stellen Sie während der Tour Fragen, um mehr über den Teeherstellungsprozess zu erfahren.",
            tip5: "Kombinieren Sie Ihre Teetour mit Besuchen nahegelegener Attraktionen wie Wasserfällen und Aussichtspunkten."
        },
        templeVisit: {
            title: "Tempelbesuch in Sri Lanka",
            introParagraph1: "Sri Lanka, bekannt als das Land Buddhas, ist die Heimat alter Tempel, die sein reiches spirituelles und kulturelles Erbe widerspiegeln. Begeben Sie sich auf eine Reise, um ikonische Tempel wie den Zahntempel in Kandy, den Dambulla-Höhlentempel und Ruwanwelisaya in Anuradhapura zu erkunden.",
            introParagraph2: "Diese heiligen Stätten, geschmückt mit komplizierten Schnitzereien, Wandmalereien und Statuen, bieten einen Einblick in die spirituellen Traditionen und architektonische Brillanz der Insel. Ein Tempelbesuch ist nicht nur ein kulturelles Erlebnis, sondern auch eine Gelegenheit, Frieden und Ruhe zu finden.",
            mainImageAlt: "Tempelbesuch in Sri Lanka",
            mainImageCaption: "Tempelbesuch in Sri Lanka",
            whyVisitTitle: "Warum Tempel in Sri Lanka besuchen?",
            whyVisitIntro: "Der Besuch von Tempeln in Sri Lanka bietet eine einzigartige Gelegenheit, sich mit der Geschichte, Kultur und Spiritualität der Insel zu verbinden. Hier sind einige Highlights:",
            highlight1: "Bewundern Sie die komplizierte Architektur und jahrhundertealte Statuen.",
            highlight2: "Erfahren Sie von sachkundigen Führern über buddhistische Traditionen und Rituale.",
            highlight3: "Erkunden Sie UNESCO-Welterbestätten wie den Goldenen Tempel von Dambulla.",
            highlight4: "Erleben Sie die Gelassenheit und spirituelle Atmosphäre heiliger Räume.",
            highlight5: "Erleben Sie lebhafte Festivals wie Esala Perahera im Zahntempel.",
            interiorImageAlt: "Bewundern Sie die atemberaubenden Innenräume, geschmückt mit komplizierten Schnitzereien und Wandmalereien.",
            interiorImageCaption: "Bewundern Sie die atemberaubenden Innenräume, geschmückt mit komplizierten Schnitzereien und Wandmalereien.",
            sacredImageAlt: "Besuchen Sie heilige Tempel wie Ruwanwelisaya und tauchen Sie in spirituelle Traditionen ein.",
            sacredImageCaption: "Besuchen Sie heilige Tempel wie Ruwanwelisaya und tauchen Sie in spirituelle Traditionen ein.",
            tipsTitle: "Tipps für den Besuch von Tempeln in Sri Lanka",
            tip1: "Kleiden Sie sich bescheiden und bedecken Sie Ihre Schultern und Knie als Zeichen des Respekts.",
            tip2: "Ziehen Sie Ihre Schuhe aus, bevor Sie das Tempelgelände betreten.",
            tip3: "Berühren Sie keine Statuen oder heiligen Objekte.",
            tip4: "Bringen Sie eine kleine Spende für den Tempel mit, wenn Sie beitragen möchten.",
            tip5: "Respektieren Sie die Stille und spirituelle Atmosphäre während Ihres Besuchs."
        },
        whiteWaterRafting: {
            title: "Wildwasser-Rafting in Sri Lanka",
            introParagraph1: "Wildwasser-Rafting in Sri Lanka ist ein aufregendes Erlebnis, besonders in Kitulgala, der Abenteuerhauptstadt der Insel. Der Kelani-Fluss mit seinen tosenden Stromschnellen und malerischer Umgebung bietet eine perfekte Kulisse sowohl für Anfänger als auch für erfahrene Rafter.",
            introParagraph2: "Rafting-Expeditionen umfassen in der Regel eine 5-Kilometer-Strecke mit Stromschnellen von Grad 2 bis Grad 4. Teilnehmer können den Nervenkitzel des Navigierens durch herausfordernde Strömungen genießen, während sie das üppige Grün und die atemberaubenden Aussichten auf die Flussufer genießen.",
            mainImageAlt: "Wildwasser-Rafting in Sri Lanka",
            mainImageCaption: "Wildwasser-Rafting in Sri Lanka",
            whyChooseTitle: "Warum Wildwasser-Rafting in Sri Lanka wählen?",
            whyChooseIntro: "Wildwasser-Rafting in Sri Lanka bietet eine einzigartige Kombination aus Abenteuer und natürlicher Schönheit. Hier sind einige Highlights des Erlebnisses:",
            highlight1: "Navigieren Sie durch aufregende Stromschnellen unter der Leitung erfahrener Instruktoren.",
            highlight2: "Genießen Sie atemberaubende Aussichten auf den umgebenden Regenwald und das bergige Gelände.",
            highlight3: "Kombinieren Sie Rafting mit anderen Aktivitäten wie Trekking, Vogelbeobachtung und Canyoning in Kitulgala.",
            highlight4: "Perfekt für Gruppen, Familien oder Alleinreisende, die einen Adrenalinkick suchen.",
            actionImageAlt: "Spüren Sie den Adrenalinkick, wenn Sie herausfordernde Stromschnellen auf dem Kelani-Fluss erobern.",
            actionImageCaption: "Spüren Sie den Adrenalinkick, wenn Sie herausfordernde Stromschnellen auf dem Kelani-Fluss erobern.",
            scenicImageAlt: "Genießen Sie die ruhige Schönheit der üppigen Umgebung während Ihres Rafting-Abenteuers.",
            scenicImageCaption: "Genießen Sie die ruhige Schönheit der üppigen Umgebung während Ihres Rafting-Abenteuers.",
            tipsTitle: "Tipps für eine sichere und aufregende Rafting-Tour",
            tip1: "Tragen Sie eine Schwimmweste und einen Helm, die von Ihrem Rafting-Führer bereitgestellt werden, zur Sicherheit.",
            tip2: "Hören Sie aufmerksam auf die Sicherheitsanweisungen, bevor Sie Ihre Fahrt beginnen.",
            tip3: "Tragen Sie bequeme, schnell trocknende Kleidung und sicheres Schuhwerk wie Wasserschuhe.",
            tip4: "Bringen Sie Wechselkleidung und ein Handtuch für nach der Fahrt mit.",
            tip5: "Buchen Sie Ihre Rafting-Tour bei einem seriösen Anbieter, um ein sicheres und angenehmes Erlebnis zu gewährleisten."
        },
        wildlifeSafari: {
            title: "Wildtiersafari in Sri Lanka",
            introParagraph1: "Sri Lanka, bekannt für seine reiche Biodiversität, bietet unglaubliche Wildtiersafaris in Nationalparks wie Yala, Wilpattu, Minneriya und Udawalawe. Diese Safaris bieten die Möglichkeit, Elefanten, Leoparden, Lippenbären und eine Vielzahl von Vogelarten in ihren natürlichen Lebensräumen zu beobachten.",
            introParagraph2: "Erkunden Sie vielfältige Landschaften von dichten Wäldern bis zu offenen Graslandschaften und halten Sie unvergessliche Momente von Wildtieren in Aktion fest. Mit Expertenführern und gut gewarteten Safari-Jeeps ist eine Wildtiersafari in Sri Lanka ein Muss für Naturliebhaber und Abenteuersucher.",
            mainImageAlt: "Wildtiersafari in Sri Lanka",
            mainImageCaption: "Wildtiersafari in Sri Lanka",
            whyChooseTitle: "Warum eine Wildtiersafari wählen?",
            whyChooseIntro: "Eine Wildtiersafari in Sri Lanka bietet eine einzigartige Gelegenheit, sich mit der Natur zu verbinden und die bemerkenswerte Biodiversität der Insel zu erkunden. Highlights umfassen:",
            highlight1: "Beobachten Sie ikonische Arten wie Elefanten, Leoparden und Krokodile.",
            highlight2: "Erkunden Sie üppige Wälder, Feuchtgebiete und offene Ebenen voller Wildtiere.",
            highlight3: "Erfassen Sie atemberaubende Wildtierfotografie in natürlicher Umgebung.",
            highlight4: "Erleben Sie den Nervenkitzel, schwer fassbare Tiere wie den Sri-Lanka-Leoparden zu entdecken.",
            highlight5: "Erfahren Sie von erfahrenen Führern und Naturforschern über Naturschutzbemühungen.",
            elephantsImageAlt: "Erleben Sie majestätische Elefanten, die frei in Sri Lankas Nationalparks umherstreifen.",
            elephantsImageCaption: "Erleben Sie majestätische Elefanten, die frei in Sri Lankas Nationalparks umherstreifen.",
            leopardImageAlt: "Entdecken Sie den schwer fassbaren Sri-Lanka-Leoparden, ein Highlight jeder Wildtiersafari.",
            leopardImageCaption: "Entdecken Sie den schwer fassbaren Sri-Lanka-Leoparden, ein Highlight jeder Wildtiersafari.",
            tipsTitle: "Tipps für eine aufregende Wildtiersafari",
            tip1: "Tragen Sie neutral gefärbte Kleidung, um sich in die Umgebung einzufügen.",
            tip2: "Bringen Sie Sonnencreme, einen Hut und Insektenschutzmittel zum Schutz mit.",
            tip3: "Bringen Sie ein Fernglas und eine Kamera mit, um Wildtiere zu entdecken und einzufangen.",
            tip4: "Befolgen Sie die Anweisungen Ihres Führers für ein sicheres und angenehmes Erlebnis.",
            tip5: "Buchen Sie früh, besonders während der Hochsaison, um sich einen Platz in beliebten Parks zu sichern."
        },
        // German (de)
        tourpackages: {
            heroTitle: 'Unsere Tourenpakete',
            heroSubtitle: 'Entdecken Sie Sri Lanka an einem Tag — handgefertigte Abenteuer von <span class="text-[#009CE6] font-bold">Star Lanka Tours</span>',
            heroAlt: 'Star Lanka Tours Sri Lanka - Eintägige Abenteuer',
            chooseAdventure: 'Wählen Sie Ihr Abenteuer',
            packagesSubtitle: '25 handverlesene Erlebnisse — von Wildtiersafaris bis kulturellen Eintauchungen.',
            viewDetails: 'Details ansehen',
            itineraryTitle: 'Reiseverlauf',
            bookViaWhatsApp: 'Über WhatsApp buchen',
            whatsappMessage: 'Hallo Star Lanka Tours! Ich möchte buchen: *{{title}}* ({{duration}})\n\nBitte teilen Sie mir Verfügbarkeit und Preise mit!',

            packages: {
                '1': {
                    title: 'Ella Abenteuertag',
                    duration: '1 Tag',
                    category: 'Natur & Abenteuer',
                    description: 'Reise durch neblige Hügel, tosende Wasserfälle und ikonische Brücken — perfekte Mischung aus Nervenkitzel und Ruhe.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana-Wasserfall</strong> – Schwimmen in kristallklaren Pools</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Ikonischer Zugfoto-Stopp</li>
                <li><strong>Teeplantage</strong> – Spaziergang zwischen smaragdgrünen Hügeln</li>
                <li><strong>Zugfahrt</strong> – Malerische Strecke Ella nach Demodara</li>
                <li><strong>Kleiner Adams Peak</strong> – Panoramablick bei Sonnenauf-/-untergang</li>
                <li><strong>Udawalawe Elefanten-Milchfütterung</strong> – Herzerwärmender Wildtiermoment</li>
                <li><strong>Ayurvedischer Kräutergarten</strong> – Alte Wellness-Geheimnisse kennenlernen</li>
            </ul>`
                },
                '2': {
                    title: 'Ella & Yala Safari',
                    duration: '1 Tag',
                    category: 'Wildtiere & Landschaft',
                    description: 'Von nebligen Hochländern bis wilder Savanne — das Beste der Natur an einem unvergesslichen Tag.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana-Wasserfall</strong> – Erfrischender natürlicher Pool</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Architektonisches Wunder</li>
                <li><strong>Teeplantage</strong> – Malerische Hügelspaziergänge</li>
                <li><strong>Kleiner Adams Peak</strong> – Atemberaubende Aussicht vom Gipfel</li>
                <li><strong>Yala Safari</strong> – Jeep-Abenteuer mit Leoparden & Elefanten</li>
            </ul>`
                },
                '3': {
                    title: 'Kandy Kulturtag',
                    duration: '1 Tag',
                    category: 'Erbe & Natur',
                    description: 'Tauchen Sie ein in heilige Tempel, üppige Gärten und lokale Traditionen im Herzen Sri Lankas.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Stadt Kandy</strong> – Lebendiges Kulturzentrum</li>
                <li><strong>Königlicher Botanischer Garten</strong> – Tropisches Paradies</li>
                <li><strong>Teefabrik & Plantage</strong> – Ceylon-Tee-Erlebnis</li>
                <li><strong>Elefanten füttern, baden & reiten</strong> – Ethische Interaktion</li>
                <li><strong>Ayurvedischer Kräutergarten</strong> – Naturheilkundetour</li>
                <li><strong>Ambuluwawa-Turm</strong> – 360° Panoramablick</li>
                <li><strong>Schmuck- & Edelsteinfabrik</strong> – Funkelnde Handwerkskunst</li>
                <li><strong>Seidenfabrik</strong> – Traditionelles Weben</li>
            </ul>`
                },
                '4': {
                    title: 'Kandy Heilige Reise',
                    duration: '1 Tag',
                    category: 'Spirituell & Kulturell',
                    description: 'Ein seelvoller Tag der Andacht, des Erbes und der natürlichen Schönheit in der heiligen Stadt Kandy.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tempel der Zahnreliquie</strong> – Heilige buddhistische Stätte</li>
                <li><strong>Teefabrik & Plantage</strong> – Frische Teeverkostung</li>
                <li><strong>Elefanten füttern, baden & reiten</strong> – Sanfte Riesen</li>
                <li><strong>Ayurvedischer Kräutergarten</strong> – Wellness-Weisheit</li>
                <li><strong>Ambuluwawa-Turm</strong> – Spiralaufstieg zum Himmel</li>
                <li><strong>Schmuck- & Edelsteinfabrik</strong> – Lokale Edelsteine</li>
                <li><strong>Seidenfabrik</strong> – Seidenkunst</li>
            </ul>`
                },
                '5': {
                    title: 'Sigiriya Erbetag',
                    duration: '1 Tag',
                    category: 'Geschichte & Abenteuer',
                    description: 'Erklimmen Sie alte Felsenfestungen, erkunden Sie goldene Höhlen und kosten Sie authentisches Dorfleben.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Löwenfelsen</strong> – UNESCO-Weltkulturerbe</li>
                <li><strong>Dambulla Goldener Tempel</strong> – Antike Höhlenkunst</li>
                <li><strong>Dorftour</strong> – Ochsenkarren, Katamaran, traditionelles Mittagessen</li>
                <li><strong>Ayurvedischer Kräutergarten</strong> – Heilpflanzen</li>
                <li><strong>Pidurangala-Felsen</strong> – Beste Aussicht auf Sigiriya</li>
            </ul>`
                },
                '6': {
                    title: 'Galle Küstenerbe',
                    duration: '1 Tag',
                    category: 'Geschichte & Natur',
                    description: 'Spazieren Sie durch Kolonialfestungen, fahren Sie auf Mangrovenflüssen und erleben Sie Meeresschildkrötenschutz.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Kande Viharaya Tempel</strong> – Riesige Buddha-Statue</li>
                <li><strong>Schildkrötenbrüterei</strong> – Freilassung von Babyschildkröten</li>
                <li><strong>Bootssafari</strong> – Madu-Fluss-Mangroven</li>
                <li><strong>Mondstein-Mine</strong> – Edelsteinabbau-Erlebnis</li>
                <li><strong>Niederländisches Fort Galle</strong> – UNESCO-Kolonialstadt</li>
                <li><strong>Ayurvedischer Kräutergarten</strong> – Natürliche Heilmittel</li>
            </ul>`
                },
                '7': {
                    title: 'Colombo Stadt-Entdeckung',
                    duration: '1 Tag',
                    category: 'Urban & Kultur',
                    description: 'Erkunden Sie moderne Wahrzeichen, heilige Stätten und lebhaftes Einkaufen in Sri Lankas geschäftiger Hauptstadt.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Lotus-Turm</strong> – 360° Stadtblick</li>
                <li><strong>Rote Moschee</strong> – Beeindruckende islamische Architektur</li>
                <li><strong>Shopping</strong> – Lokale Märkte & Einkaufszentren</li>
                <li><strong>Ayurvedischer Kräutergarten</strong> – Wellness-Stopp</li>
                <li><strong>Gangaramaya-Tempel</strong> – Heilige urbane Oase</li>
            </ul>`
                },
                '8': {
                    title: 'Yala Wild Safari',
                    duration: '1 Tag',
                    category: 'Wildtiere',
                    description: 'Verfolgen Sie Leoparden, Elefanten und seltene Vögel in einem der besten Nationalparks Asiens.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala Jeep-Safari</strong> – 3-stündiges Wildtierabenteuer</li>
                <li>Entdecken Sie Leoparden, Elefanten, Lippenbären und über 200 Vogelarten</li>
            </ul>`
                },
                '9': {
                    title: 'Mirissa Wal-Odyssee',
                    duration: '1 Tag',
                    category: 'Meeresabenteuer',
                    description: 'Segeln Sie mit Blauwalen in hochkomfortablen Booten — die größten Kreaturen der Welt hautnah.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Blauwal-Beobachtung</strong> – 4-stündige Ozeansafari</li>
                <li><strong>Mirissa Strand</strong> – Entspannen Sie sich an goldenen Sandstränden</li>
                <li><strong>Stelzenfischerei</strong> – Ikonischer Foto-Moment</li>
                <li><strong>Ayurvedischer Kräutergarten</strong> – Küsten-Wellness</li>
            </ul>`
                },
                '10': {
                    title: 'Udawalawe Elefantentag',
                    duration: '1 Tag',
                    category: 'Wildtiere & Mitgefühl',
                    description: 'Erleben Sie, wie Babyelefanten gefüttert werden und streifen Sie mit wilden Herden in ihrem natürlichen Lebensraum.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Udawalawe Nationalpark</strong> – Jeep-Safari</li>
                <li><strong>Elefanten-Milchfütterung</strong> – Waisenhausbesuch</li>
            </ul>`
                },
                '11': {
                    title: 'Ella & Galle Express',
                    duration: '1 Tag',
                    category: 'Landschaft & Erbe',
                    description: 'Von Bergzügen bis zu Kolonialfestungen — eine schnelle Reise voller Schönheit und Geschichte.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Zugfahrt</strong> – Ella nach Galle</li>
                <li><strong>Kleiner Adams Peak</strong> – Sonnenaufgangswanderung</li>
                <li><strong>Niederländisches Fort Galle</strong> – Sonnenuntergangsspaziergang</li>
                <li><strong>Teeplantage</strong> – Hügelblick</li>
                <li><strong>Ayurvedischer Kräutergarten</strong> – Wellness-Stopp</li>
            </ul>`
                },
                '12': {
                    title: 'Yala & Galle Safari',
                    duration: '1 Tag',
                    category: 'Wild & Kolonial',
                    description: 'Morgen-Wildtiersafari, Nachmittags-Erbespaziergang — die ultimative Südküsten-Kombination.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala Nationalpark-Safari</strong> – Morgen-Jeep-Tour</li>
                <li><strong>Niederländisches Fort Galle</strong> – Nachmittags-Kolonialspaziergang</li>
            </ul>`
                },
                '13': {
                    title: 'Kandy & Ella & Yala Express',
                    duration: '2 Tage',
                    category: 'Kulturell & Landschaftlich',
                    description: 'Von heiligen Tempeln zu nebligen Hügeln und wilden Safaris — eine Wirbelwind-Tour der Höhepunkte Sri Lankas.',
                    itinerary: `<h3>Tag 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala Nationalpark-Safari</strong> – Morgen-Jeep-Tour</li>
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Zugfahrt</strong> – Luxus-Zugfahrt</li>
                <li><strong>Teeplantage</strong> – Hügelblick</li>
            </ul>
            <h3 class="mt-4">Tag 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Kurze Wanderung</li>
                <li><strong>Botanische Gärten</strong> – Tropisches Paradies</li>
                <li><strong>Tempel der Zahnreliquie</strong> – Heiliger Besuch</li>
                <li><strong>Elefantenritt</strong> – Ethische Interaktion</li>
                <li><strong>Teefabrik</strong> – Ceylon-Tee-Erlebnis</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Kandy (Luxushotel)</h3>`
                },
                '14': {
                    title: 'Kandy Kulturell',
                    duration: '2 Tage',
                    category: 'Kulturell',
                    description: 'Tauchen Sie ein in heilige Tempel, üppige Gärten und lokale Traditionen im Herzen Sri Lankas.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Stadt Kandy</strong> – Lebendiges Kulturzentrum</li>
                <li><strong>Königlicher Botanischer Garten</strong> – Tropisches Paradies</li>
                <li><strong>Teefabrik & Plantage</strong> – Ceylon-Tee-Erlebnis</li>
                <li><strong>Elefanten füttern, baden & reiten</strong> – Ethische Interaktion</li>
                <li><strong>Ayurvedischer Kräutergarten</strong> – Naturheilkundetour</li>
                <li><strong>Ambuluwawa-Turm</strong> – 360° Panoramablick</li>
                <li><strong>Schmuck- & Edelsteinfabrik</strong> – Funkelnde Handwerkskunst</li>
                <li><strong>Seidenfabrik</strong> – Traditionelles Weben</li>
                <li><strong>Nelligala</strong> – Traditioneller Tempel</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Kandy (Luxushotel)</h3>`
                },
                '15': {
                    title: 'Ella/Nuwara Eliya/Kandy Kulturell',
                    duration: '2 Tage',
                    category: 'Kulturell & Landschaftlich',
                    description: 'Von nebligen Hochländern zu heiligen Tempeln — eine seelvolle Reise durch Sri Lankas Herzland.',
                    itinerary: `<h3>Tag 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Kleiner Adams Peak</strong> – Landschaftliche Wanderung</li>
                <li><strong>Zugfahrt</strong> – Luxus-Zugfahrt</li>
                <li><strong>Teeplantage</strong> – Hügelblick</li>
                <li><strong>Rosa Postamt</strong> – Kulturelle Schönheit</li>
                <li><strong>Ambuluwawa</strong> – Ruhige Spaziergänge</li>
            </ul>
            <h3 class="mt-4">Tag 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Hindu-Tempel</strong> – Kultureller Besuch</li>
                <li><strong>Botanische Gärten</strong> – Tropisches Paradies</li>
                <li><strong>Nelligala</strong> – Heiliger Besuch</li>
                <li><strong>Ramboda-Wasserfall</strong></li>
                <li><strong>Teefabrik</strong> – Ceylon-Tee-Erlebnis</li>
                <li><strong>Elefantenritt</strong> – Ethische Interaktion</li>
                <li><strong>Kräutergarten</strong> – Tropisches Paradies</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Kandy (Luxushotel)</h3>`
                },
                '16': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy Kulturell',
                    duration: '3 Tage',
                    category: 'Kulturell & Landschaftlich',
                    description: 'Von nebligen Hochländern zu heiligen Tempeln — eine seelvolle Reise durch Sri Lankas Herzland.',
                    itinerary: `<h3>Tag 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Kleiner Adams Peak</strong> – Landschaftliche Wanderung</li>
                <li><strong>Zugfahrt</strong> – Luxus-Zugfahrt</li>
                <li><strong>Teeplantage</strong> – Hügelblick</li>
                <li><strong>Hindu-Tempel</strong> – Kultureller Besuch</li>
                <li><strong>Yala Nationalpark-Safari</strong> – Morgen-Jeep-Tour</li>
            </ul>
            <h3 class="mt-4">Tag 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Ruhige Spaziergänge</li>
                <li><strong>Rosa Postamt</strong> – Kulturelle Schönheit</li>
                <li><strong>Botanische Gärten</strong> – Tropisches Paradies</li>
                <li><strong>Tempel der Zahnreliquie</strong> – Heiliger Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Heiliger Besuch</li>
                <li><strong>Teefabrik</strong> – Ceylon-Tee-Erlebnis</li>
                <li><strong>Edelstein & Schmuck</strong> – Ceylon-Edelstein-Erlebnis</li>
                <li><strong>Holzschnitzerei</strong> – Traditionelle Schnitzerei</li>
                <li><strong>Elefantenritt</strong> – Ethische Interaktion</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Nuwara Eliya & Kandy (Luxushotel)</h3>`
                },
                '17': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya Kulturell',
                    duration: '3 Tage',
                    category: 'Kulturell & Landschaftlich',
                    description: 'Von nebligen Hochländern zu heiligen Tempeln — eine seelvolle Reise durch Sri Lankas Herzland.',
                    itinerary: `<h3>Tag 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Kleiner Adams Peak</strong> – Landschaftliche Wanderung</li>
                <li><strong>Zugfahrt</strong> – Luxus-Zugfahrt</li>
                <li><strong>Teeplantage</strong> – Hügelblick</li>
                <li><strong>Hindu-Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Ruhige Spaziergänge</li>
                <li><strong>Botanische Gärten</strong> – Tropisches Paradies</li>
                <li><strong>Pidurangala</strong> – Landschaftliche Wanderung</li>
            </ul>
            <h3 class="mt-4">Tag 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Goldener Tempel</strong> – Heiliger Besuch</li>
                <li><strong>Sigiriya Löwenfelsen</strong> – Alte Festung</li>
                <li><strong>Dorftour mit Bootsfahrt & traditionellem Mittagessen</strong> – Kulturelles Erlebnis</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Nuwara Eliya & Sigiriya (Luxushotel)</h3>`
                },
                '18': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa Kulturell',
                    duration: '3 Tage',
                    category: 'Kulturell & Landschaftlich',
                    description: 'Von nebligen Hochländern zu heiligen Tempeln — eine seelvolle Reise durch Sri Lankas Herzland.',
                    itinerary: `<h3>Tag 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Kleiner Adams Peak</strong> – Landschaftliche Wanderung</li>
                <li><strong>Zugfahrt</strong> – Luxus-Zugfahrt</li>
                <li><strong>Teeplantage</strong> – Hügelblick</li>
                <li><strong>Hindu-Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Ruhige Spaziergänge</li>
                <li><strong>Botanische Gärten</strong> – Tropisches Paradies</li>
                <li><strong>Teefabrik</strong> – Ceylon-Tee-Erlebnis</li>
                <li><strong>Elefantenritt</strong> – Ethische Interaktion</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Löwenfelsen</strong> – UNESCO-Weltkulturerbe</li>
                <li><strong>Polonnaruwa Antike Stadt-Tour</strong> – Kulturelle Stadt</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Kandy & Sigiriya (Luxushotel)</h3>`
                },
                '19': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Polonnaruwa Kulturell',
                    duration: '4 Tage',
                    category: 'Kulturell & Landschaftlich',
                    description: 'Von nebligen Hochländern zu heiligen Tempeln — eine seelvolle Reise durch Sri Lankas Herzland.',
                    itinerary: `<h3>Tag 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala Nationalpark-Safari</strong> – Morgen-Jeep-Tour</li>
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Kleiner Adams Peak</strong> – Landschaftliche Wanderung</li>
                <li><strong>Zugfahrt</strong> – Luxus-Zugfahrt</li>
            </ul>
            <h3 class="mt-4">Tag 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Teeplantage</strong> – Hügelblick</li>
                <li><strong>Hindu-Tempel</strong> – Kultureller Besuch</li>
                <li><strong>Ambuluwawa</strong> – Ruhige Spaziergänge</li>
                <li><strong>Königliche Botanische Gärten</strong> – Tropisches Paradies</li>
                <li><strong>Teefabrik</strong> – Ceylon-Tee-Erlebnis</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Heiliger Besuch</li>
                <li><strong>Schmuck- & Edelsteinfabrik</strong> – Funkelnde Handwerkskunst</li>
                <li><strong>Elefantenritt</strong> – Ethische Interaktion</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Löwenfelsen</strong> – UNESCO-Weltkulturerbe</li>
                <li><strong>Polonnaruwa Antike Stadt-Tour</strong> – Kulturelle Stadt</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Ella, Nuwara Eliya & Kandy (Luxushotel)</h3>`
                },
                '20': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura Kulturell',
                    duration: '5 Tage',
                    category: 'Kulturell & Landschaftlich',
                    description: 'Von nebligen Hochländern zu heiligen Tempeln — eine seelvolle Reise durch Sri Lankas Herzland.',
                    itinerary: `<h3>Tag 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala Nationalpark-Safari</strong> – Morgen-Jeep-Tour</li>
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Kleiner Adams Peak</strong> – Landschaftliche Wanderung</li>
                <li><strong>Zugfahrt</strong> – Luxus-Zugfahrt</li>
            </ul>
            <h3 class="mt-4">Tag 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Teeplantage</strong> – Hügelblick</li>
                <li><strong>Hindu-Tempel</strong> – Kultureller Besuch</li>
                <li><strong>Ambuluwawa</strong> – Ruhige Spaziergänge</li>
                <li><strong>Königliche Botanische Gärten</strong> – Tropisches Paradies</li>
                <li><strong>Teefabrik</strong> – Ceylon-Tee-Erlebnis</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Heiliger Besuch</li>
                <li><strong>Schmuck- & Edelsteinfabrik</strong> – Funkelnde Handwerkskunst</li>
                <li><strong>Elefantenritt</strong> – Ethische Interaktion</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Löwenfelsen</strong> – UNESCO-Weltkulturerbe</li>
                <li><strong>Polonnaruwa Antike Stadt-Tour</strong> – Kulturelle Stadt</li>
            </ul>
            <h3 class="mt-4">Tag 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Anuradhapura Antike Stadt-Tour</strong> – Historische Erkundung</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Sigiriya, Nuwara Eliya & Kandy (Luxushotel)</h3>`
                },
                '21': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Colombo Kulturell',
                    duration: '5 Tage',
                    category: 'Kulturell & Landschaftlich',
                    description: 'Von nebligen Hochländern zu heiligen Tempeln — eine seelvolle Reise durch Sri Lankas Herzland.',
                    itinerary: `<h3>Tag 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala Nationalpark-Safari</strong> – Morgen-Jeep-Tour</li>
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Kleiner Adams Peak</strong> – Landschaftliche Wanderung</li>
                <li><strong>Zugfahrt</strong> – Luxus-Zugfahrt</li>
            </ul>
            <h3 class="mt-4">Tag 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Teeplantage</strong> – Hügelblick</li>
                <li><strong>Hindu-Tempel</strong> – Kultureller Besuch</li>
                <li><strong>Ambuluwawa</strong> – Ruhige Spaziergänge</li>
                <li><strong>Königliche Botanische Gärten</strong> – Tropisches Paradies</li>
                <li><strong>Teefabrik</strong> – Ceylon-Tee-Erlebnis</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Heiliger Besuch</li>
                <li><strong>Schmuck- & Edelsteinfabrik</strong> – Funkelnde Handwerkskunst</li>
                <li><strong>Elefantenritt</strong> – Ethische Interaktion</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Löwenfelsen</strong> – UNESCO-Weltkulturerbe</li>
                <li><strong>Polonnaruwa Antike Stadt-Tour</strong> – Kulturelle Stadt</li>
            </ul>
            <h3 class="mt-4">Tag 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Colombo Stadt-Tour</strong> – Urbane Erkundung</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Nuwara Eliya, Sigiriya, Polonnaruwa & Kandy (Luxushotel)</h3>`
                },
                '22': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Galle Kulturell',
                    duration: '5 Tage',
                    category: 'Kulturell & Landschaftlich',
                    description: 'Von nebligen Hochländern zu heiligen Tempeln — eine seelvolle Reise durch Sri Lankas Herzland.',
                    itinerary: `<h3>Tag 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala Nationalpark-Safari</strong> – Morgen-Jeep-Tour</li>
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Kleiner Adams Peak</strong> – Landschaftliche Wanderung</li>
                <li><strong>Zugfahrt</strong> – Luxus-Zugfahrt</li>
            </ul>
            <h3 class="mt-4">Tag 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Teeplantage</strong> – Hügelblick</li>
                <li><strong>Hindu-Tempel</strong> – Kultureller Besuch</li>
                <li><strong>Ambuluwawa</strong> – Ruhige Spaziergänge</li>
                <li><strong>Königliche Botanische Gärten</strong> – Tropisches Paradies</li>
                <li><strong>Teefabrik</strong> – Ceylon-Tee-Erlebnis</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Heiliger Besuch</li>
                <li><strong>Schmuck- & Edelsteinfabrik</strong> – Funkelnde Handwerkskunst</li>
                <li><strong>Elefantenritt</strong> – Ethische Interaktion</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Löwenfelsen</strong> – UNESCO-Weltkulturerbe</li>
                <li><strong>Polonnaruwa Antike Stadt-Tour</strong> – Kulturelle Stadt</li>
            </ul>
            <h3 class="mt-4">Tag 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Galle Stadt</strong> – Koloniale Erkundung</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Nuwara Eliya, Sigiriya, Polonnaruwa & Galle (Luxushotel)</h3>`
                },
                '23': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Colombo',
                    duration: '6 Tage',
                    category: 'Kulturell & Landschaftlich',
                    description: 'Von nebligen Hochländern zu heiligen Tempeln — eine seelvolle Reise durch Sri Lankas Herzland.',
                    itinerary: `<h3>Tag 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Kleiner Adams Peak</strong> – Landschaftliche Wanderung</li>
                <li><strong>Zugfahrt</strong> – Luxus-Zugfahrt</li>
            </ul>
            <h3 class="mt-4">Tag 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Teeplantage</strong> – Hügelblick</li>
                <li><strong>Hindu-Tempel</strong> – Kultureller Besuch</li>
                <li><strong>Ambuluwawa</strong> – Ruhige Spaziergänge</li>
                <li><strong>Königliche Botanische Gärten</strong> – Tropisches Paradies</li>
                <li><strong>Teefabrik</strong> – Ceylon-Tee-Erlebnis</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Heiliger Besuch</li>
                <li><strong>Schmuck- & Edelsteinfabrik</strong> – Funkelnde Handwerkskunst</li>
                <li><strong>Elefantenritt</strong> – Ethische Interaktion</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Löwenfelsen</strong> – UNESCO-Weltkulturerbe</li>
                <li><strong>Polonnaruwa Antike Stadt-Tour</strong> – Kulturelle Stadt</li>
            </ul>
            <h3 class="mt-4">Tag 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Anuradhapura Antike Stadt-Tour</strong> – Historische Erkundung</li>
            </ul>
            <h3 class="mt-4">Tag 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Colombo Stadt-Tour</strong> – Urbane Erkundung</li>
                <li><strong>Galle Stadt</strong> – Koloniale Erkundung</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Ella, Nuwara Eliya, Sigiriya (Luxushotel)</h3>`
                },
                '24': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Colombo',
                    duration: '6 Tage',
                    category: 'Kulturell & Landschaftlich',
                    description: 'Von nebligen Hochländern zu heiligen Tempeln — eine seelvolle Reise durch Sri Lankas Herzland.',
                    itinerary: `<h3>Tag 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Kleiner Adams Peak</strong> – Landschaftliche Wanderung</li>
                <li><strong>Zugfahrt</strong> – Luxus-Zugfahrt</li>
            </ul>
            <h3 class="mt-4">Tag 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Teeplantage</strong> – Hügelblick</li>
                <li><strong>Hindu-Tempel</strong> – Kultureller Besuch</li>
                <li><strong>Ambuluwawa</strong> – Ruhige Spaziergänge</li>
                <li><strong>Königliche Botanische Gärten</strong> – Tropisches Paradies</li>
                <li><strong>Teefabrik</strong> – Ceylon-Tee-Erlebnis</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Heiliger Besuch</li>
                <li><strong>Schmuck- & Edelsteinfabrik</strong> – Funkelnde Handwerkskunst</li>
                <li><strong>Elefantenritt</strong> – Ethische Interaktion</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Löwenfelsen</strong> – UNESCO-Weltkulturerbe</li>
                <li><strong>Polonnaruwa Antike Stadt-Tour</strong> – Kulturelle Stadt</li>
            </ul>
            <h3 class="mt-4">Tag 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Anuradhapura Antike Stadt-Tour</strong> – Historische Erkundung</li>
            </ul>
            <h3 class="mt-4">Tag 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Colombo Stadt-Tour</strong> – Urbane Erkundung</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Ella, Nuwara Eliya, Kandy, Sigiriya & Colombo (Luxushotel)</h3>`
                },
                '25': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Galle',
                    duration: '6 Tage',
                    category: 'Kulturell & Landschaftlich',
                    description: 'Von nebligen Hochländern zu heiligen Tempeln — eine seelvolle Reise durch Sri Lankas Herzland.',
                    itinerary: `<h3>Tag 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana-Wasserfall</strong> – Kurzes Bad</li>
                <li><strong>Neun-Bogen-Brücke</strong> – Zugüberquerung</li>
                <li><strong>Kleiner Adams Peak</strong> – Landschaftliche Wanderung</li>
                <li><strong>Zugfahrt</strong> – Luxus-Zugfahrt</li>
            </ul>
            <h3 class="mt-4">Tag 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Teeplantage</strong> – Hügelblick</li>
                <li><strong>Hindu-Tempel</strong> – Kultureller Besuch</li>
                <li><strong>Ambuluwawa</strong> – Ruhige Spaziergänge</li>
                <li><strong>Königliche Botanische Gärten</strong> – Tropisches Paradies</li>
                <li><strong>Teefabrik</strong> – Ceylon-Tee-Erlebnis</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Heiliger Besuch</li>
                <li><strong>Schmuck- & Edelsteinfabrik</strong> – Funkelnde Handwerkskunst</li>
                <li><strong>Elefantenritt</strong> – Ethische Interaktion</li>
                <li><strong>Goldener Tempel</strong> – Kultureller Besuch</li>
            </ul>
            <h3 class="mt-4">Tag 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Löwenfelsen</strong> – UNESCO-Weltkulturerbe</li>
                <li><strong>Polonnaruwa Antike Stadt-Tour</strong> – Kulturelle Stadt</li>
            </ul>
            <h3 class="mt-4">Tag 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Anuradhapura Antike Stadt-Tour</strong> – Historische Erkundung</li>
            </ul>
            <h3 class="mt-4">Tag 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Galle Stadt</strong> – Koloniale Erkundung</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Übernachtung in Ella, Nuwara Eliya, Kandy, Sigiriya & Galle (Luxushotel)</h3>`
                },
            },

        },
    },
    ru: {
        translation: {
            home: 'Главная',
            aboutUs: 'О нас',
            sriLankanav: 'Шри-Ланка',
            gallerynav: 'Галерея',
            bookATour: 'Забронировать тур',
            thingsToDo: 'Чем заняться',
            contactUs: 'Связаться с нами',
        },
        // Russian (ru)
        contactus: {
            heroTitle: 'Свяжитесь с нами',
            heroSubtitle: 'Star Lanka Tours Sri Lanka - Ваш портал в незабываемые приключения на Шри-Ланке',
            feelFree: 'Не стесняйтесь обращаться к нам',
            planDream: 'Планируйте свое путешествие мечты на Шри-Ланке',
            reachOutDesc: 'Свяжитесь с Star Lanka Tours Sri Lanka для персонализированных турпакетов, экспертных советов и незабываемых впечатлений от путешествий по всей Шри-Ланке.',
            callCenter: 'Call Center',
            phone: '+94 76 805 1224', // ← Change to your real WhatsApp/call number
            emailTitle: 'Электронная почта',
            email: 'info@starlankatours.com', // ← Change to your real email   
            locationTitle: 'Наше местоположение',
            location: 'Берувала / Бентота, Шри-Ланка', // ← Update to your actual address (e.g. if in Negombo like your location)
            socialTitle: 'Социальные сети',
            getInTouch: 'Свяжитесь с нами',
            getInTouchDesc: 'Исследуйте Шри-Ланку с Star Lanka Tours Sri Lanka — мы доступны 24/7, чтобы сделать ваше путешествие незабываемым.',
            nameLabel: 'Имя',
            namePlaceholder: 'Ваше полное имя',
            emailLabel: 'Электронная почта',
            emailPlaceholder: 'ваш@пример.ком',
            phoneLabel: 'Номер телефона',
            phonePlaceholder: '+94 7X XXX XXXX',
            messageLabel: 'Сообщение',
            messagePlaceholder: 'Расскажите нам о вашем путешествии мечты...',
            sendButton: 'Отправить сообщение',
            sendingButton: 'Отправка...',
            successMsg: 'Ваш запрос был отправлен через WhatsApp!',
            errorMsg: 'Не удалось открыть WhatsApp. Пожалуйста, попробуйте еще раз.',
            findUsTitle: 'Найдите нас в Шри-Ланке',
        },
        // Russian (ru)
        thingstodo: {
            heroTitle: 'Незабываемые впечатления на Шри-Ланке',
            heroSubtitle: 'Приключения • Наследие • Природа • Оздоровление',

            sectionTitle: 'Главные развлечения и обязательные к посещению активности',

            // Activity titles (used in cards)
            ayurveda: 'Аутентичные аюрведические процедуры и оздоровление',
            diving: 'Скуба-дайвинг мирового уровня',
            elephantRide: 'Катание с добрыми великанами',
            fishing: 'Традиционная и глубоководная рыбалка',
            ballooning: 'Волшебный полёт на воздушном шаре',
            jeepSafari: 'Увлекательные сафари на джипах',
            whiteWaterRafting: 'Адреналиновый рафтинг',
            riverSafari: 'Прекрасное речное сафари',
            snorkeling: 'Яркий опыт снорклинга',
            teaTasting: 'Путешествие и дегустация цейлонского чая',
            templeVisit: 'Исследование древних храмов и священных мест',
            wildlifeSafari: 'Big Five и встречи с дикой природой',

            viewMore: 'Посмотреть ещё',
        },
        // Russian (ru)
        gallery: {
            heroTitle: 'Галерея',
            heroSubtitle: 'Запечатленные моменты, cherished воспоминания — наша галерея демонстрирует приключения, улыбки и захватывающие виды, которые делают каждое путешествие по Шри-Ланке незабываемым',

            tabPlaces: 'Места',
            tabEvents: 'События',

            // Image labels (used in alt text and overlay)
            nuwaraEliya: 'Нувара-Элия',
            sigiriya: 'Сигирия',
            anuradhapura: 'Анурадхапура',
            rambodaFalls: 'Водопад Рамбода',
            ella: 'Элла',
            yala: 'Национальный парк Яла',
            kandy: 'Канди',
            bodhiViharaya: 'Бодхи Вихарая',
            knuckles: 'Горы Наклс',
            udawalawe: 'Национальный парк Удавалаве',
            bentota: 'Сафари на лодке в Бентоте',
            colombo: 'Коломбо',
            galle: 'Форт Галле',
            mirissa: 'Пляж Мирисса',
            jaffna: 'Джафна',
            ambuluwawaTower: 'Башня Амбулувава',
            turtle: 'Питомник черепах',
            polonnaruwa: 'Древний город Полоннарува',
            polgampala: 'Водный бассейн Полгампала',
            beach: 'Пляжи Шри-Ланки',
        },
        // Russian (ru)
        events: {
            heroTitle: 'События',
            heroSubtitle: 'Празднуйте дух Шри-Ланки через её фестивали — от священных буддийских церемоний до ярких культурных парадов, каждое событие — шанс почувствовать биение сердца острова.',

            tabPlaces: 'Места',
            tabEvents: 'События',

            // Event names
            kandyPerahera: 'Канди Эсала Перахера (Фестиваль Зуба)',
            vesak: 'Фестиваль Весак',
            sinhalaNewYear: 'Сингальский и тамильский Новый год',
            christmas: 'Рождество',
            thaiPongal: 'Тай Понгал',
            deepavali: 'Дипавали',
            holi: 'Холи',
            poson: 'Фестиваль Посон',
        },
        // Russian (ru)
        srilanka: {
            heroTitle: 'Откройте для себя Шри-Ланку',
            heroSubtitle: 'Жемчужина Индийского океана',

            sectionPlaces: 'Привлекательные места на Шри-Ланке',
            sectionFamous: 'Знаменитые вещи на Шри-Ланке',
            viewMore: 'Посмотреть больше',

            // Intro paragraphs
            intro1: 'Шри-Ланка, известная как "Изумрудный остров", — это тропический драгоценный камень, прославленный потрясающими пейзажами, древним наследием и искренним гостеприимством.',
            intro2: 'С наследием более двух тысячелетий Шри-Ланка является домом для объектов ЮНЕСКО, таких как скальная крепость Сигирия и священный город Анурадхапура. Её культурное богатство сочетает буддийские, индуистские и колониальные влияния, видимые в ярких фестивалях и изысканной архитектуре.',
            intro3: 'Разнообразный рельеф острова завораживает — от холмистых чайных плантаций в Элле до бирюзовых вод Тринкомали. Национальные парки вроде Вилпатту населяют леопарды, крокодилы и редкие виды птиц, радуя любителей природы.',
            intro4: 'Для любителей адреналина Шри-Ланка предлагает рафтинг по бурным рекам, сёрфинг в Аругам-Бей и треккинг по пышным джунглям. Кухня, пропитанная ароматными специями, свежей рыбой и джекфрутом, рассказывает историю традиций и вкусов.',
            intro5: 'От священных паломничеств до спокойных пляжных отдыхов Шри-Ланка обещает завораживающий опыт, полный красоты и культуры.',

            // Place names & descriptions
            sigiriya: 'Скальная крепость Сигирия',
            sigiriyaDesc: 'Объект ЮНЕСКО с древними садами, фресками и захватывающими видами с вершины.',

            templeOfTooth: 'Храм Зуба',
            templeOfToothDesc: 'Священное буддийское место, хранящее реликвию зуба Будды.',

            ella: 'Элла',
            ellaDesc: 'Горный городок, окружённый чайными плантациями, знаменит Девятиарочным мостом.',

            yala: 'Национальный парк Яла',
            yalaDesc: 'Известен слонами, леопардами и сафари на диких животных.',

            galleFort: 'Форт Галле',
            galleFortDesc: 'Колониальный форт с булыжными улицами и голландской архитектурой.',

            nuwaraEliya: 'Нувара-Элия',
            nuwaraEliyaDesc: 'Известна как "Маленькая Англия" с прохладным климатом и чайными плантациями.',

            adamsPeak: 'Пик Адама',
            adamsPeakDesc: 'Священная гора с уникальным отпечатком стопы, место паломничества.',

            hortonPlains: 'Хортон Плейнс',
            hortonPlainsDesc: 'Холмистые равнины, водопады и смотровая площадка World’s End.',

            bentota: 'Пляж Бентота',
            bentotaDesc: 'Нетронутое побережье с золотыми песками и водными видами спорта.',

            jaffna: 'Джафна',
            jaffnaDesc: 'Богата тамильской культурой, историей и кухней.',

            anuradhapura: 'Анурадхапура',
            anuradhapuraDesc: 'Древний город со священными буддийскими местами и руинами.',

            polonnaruwa: 'Полоннарува',
            polonnaruwaDesc: 'Объект ЮНЕСКО с хорошо сохранившимися храмами и статуями.',

            unawatuna: 'Пляж Унаватуна',
            unawatunaDesc: 'Живой пляж со снорклингом и ночной жизнью.',

            colombo: 'Коломбо',
            colomboDesc: 'Оживлённая столица с современной и колониальной архитектурой.',

            udawalawe: 'Национальный парк Удавалаве',
            udawalaweDesc: 'Знаменит большими стадами слонов и потрясающими пейзажами.',

            dambulla: 'Пещерный храм Дамбулла',
            dambullaDesc: 'Объект ЮНЕСКО с древними буддийскими фресками и статуями.',

            // Famous Things
            ceylonTea: 'Цейлонский чай',
            ceylonTeaDesc: 'Всемирно известен своим вкусом, особенно из Нувара-Элии и Увы.',

            spices: 'Специи',
            spicesDesc: 'Корица, кардамон, гвоздика — цейлонская корица лучшая.',

            gems: 'Драгоценные камни',
            gemsDesc: 'Сапфиры, рубины, лунные камни — остров редких самоцветов.',

            ayurveda: 'Аюрведа',
            ayurvedaDesc: 'Оздоровительные процедуры с массажами и травяными терапиями.',

            handicrafts: 'Ремесла',
            handicraftsDesc: 'Маски, батик, резьба по дереву, лакированные изделия.',

            elephants: 'Слоны',
            elephantsDesc: 'Культурный символ, участвующий в грандиозных фестивальных процессиях.',

            food: 'Традиционная еда',
            foodDesc: 'Рис и карри, хопперы, котту роти, ватталаппам.',

            festivals: 'Фестивали',
            festivalsDesc: 'Эсала Перахера, Весак, сингальско-тамильский Новый год.',

            coconut: 'Продукты из кокоса',
            coconutDesc: 'Масло, молоко, койр-волокно для верёвок и циновок.',

            sarees: 'Кандянская сари',
            sareesDesc: 'Элегантная традиционная одежда для церемоний.',

            dances: 'Традиционные танцы',
            dancesDesc: 'Кандянские, дьявольские и низменные танцы.',

            stiltFishing: 'Рыбалка на ходулях',
            stiltFishingDesc: 'Иконическая техника рыбалки на южном побережье.',

            moonstones: 'Лунные камни',
            moonstonesDesc: 'Полудрагоценные камни, знаменитые шахтами Митиягода.',

            cricket: 'Крикет',
            cricketDesc: 'Национальная страсть — победители чемпионата мира 1996 года.',

            herbs: 'Аюрведические травы',
            herbsDesc: 'Готу кола, корица, ним для лечебных средств.',

            masks: 'Маски',
            masksDesc: 'Маски Амбалангода, используемые в ритуальных представлениях.',
        },
        // Russian (ru)
        about: {
            hero: {
                discover: "ОТКРОЙТЕ",
                starLankaTours: "STAR LANKA TOURS",
                tagline1: "Увидьте старые большие руины, зелёные чайные холмы и захватывающие сафари с животными. Шри-Ланка полна жизни. Этот прекрасный остров — больше, чем место для посещения, это большое приключение.",
                tagline2: "Солнечные пляжи, облачные горы и множество сюрпризов ждут вас. Star Lanka Tours Sri Lanka делает каждую минуту особенной."
            },
            slider: {
                sigiriya: "Скальная крепость Сигирия",
                yala: "Национальный парк Яла",
                tea: "Чайная страна",
                beaches: "Чистые пляжи",
                temples: "Святые храмы"
            },
            about: {
                title: "О Star Lanka Tours Sri Lanka",
                signature: "Особенные поездки по Шри-Ланке"
            },
            tours: {
                days4: "4 Дня",
                classic: "БАЗОВАЯ ПОЕЗДКА",
                days5: "5 Дней",
                safari: "ПОЕЗДКИ К ЖИВОТНЫМ",
                days6: "6 Дней",
                retreat: "Тихий отдых",
                desc1: "Star Lanka Tours Sri Lanka показывает вам каждую часть этого прекрасного острова — оживлённые города, туманные холмы и чистые южные пляжи.",
                desc2: "Наслаждайтесь лучшим на Шри-Ланке — священным Кandy, весёлым Colombo и спокойным южным побережьем.",
                desc3: "Хотите приключений, древней культуры, животных или покоя? Star Lanka Tours Sri Lanka создаёт отличные поездки в любое время года."
            },
            whoWeAre: {
                title: "Кто мы",
                description: "<p>Добро пожаловать в Star Lanka Tours Sri Lanka — вашего друга для путешествий по этому волшебному острову. Наш руководитель — гид Nethaj. Наша дружелюбная местная команда создаёт поездки, показывающие настоящее Шри-Ланку, а не просто обычные туристические места.</p><br /><p>Мы отвезём вас в древние города, зелёные чайные холмы, солнечные пляжи и парки, полные животных. Каждая поездка помогает почувствовать настоящую культуру, добрых людей, древние традиции и красивую природу Шри-Ланки.</p><br /><p>Хотите культуру, приключения, отдых, здоровье или особую приватную поездку? Мы планируем всё тщательно, даём личную помощь и обеспечиваем счастливые воспоминания.</p>",
                imageAlt: "Команда Star Lanka Tours",
                item1: { title: "Путешествия по всей Шри-Ланке", text: "Мы ездим с севера на юг — настоящие местные впечатления везде." },
                item2: { title: "Поездки под вас", text: "Мы планируем поездку под ваши предпочтения — приключения, культура, природа или отдых." },
                item3: { title: "Хорошие местные гиды", text: "Nethaj и его команда знают много секретных мест, старых историй и настоящего духа Шри-Ланки." },
                item4: { title: "Помощь круглосуточно", text: "Star Lanka Tours помогает вам 24 часа в сутки во время всей поездки." }
            },
            offers: {
                title: "Что мы вам предлагаем",
                cultural: { title: "Культурный опыт", text: "Увидьте местные обычаи, фестивали и повседневную жизнь.", alt: "Культурный опыт" },
                adventure: { title: "Приключенческие поездки", text: "Пешие прогулки, сафари с животными, морские развлечения и природа в действии.", alt: "Приключения" },
                luxury: { title: "Комфорт и люкс", text: "Хорошие отели, личные машины и особый сервис.", alt: "Люкс" },
                wellness: { title: "Здоровье и релакс", text: "Йога, Аюрведа и спокойные места.", alt: "Релакс" }
            },
            guides: {
                title: "Наши гиды",
                text: "Nethaj — наш главный туроператор. Наши обученные и весёлые гиды делают вашу поездку захватывающей. Они показывают секретные места, старые истории и особенные вещи на Шри-Ланке.",
                imageAlt: "Гид Star Lanka Tours - Nethaj"
            },
            expert: {
                name: "Nethaj",
                role: "(Главный гид и туроператор)",
                bio: "Nethaj — сердце Star Lanka Tours Sri Lanka. Он отлично знает Шри-Ланку. От пляжей до высоких холмов, животных до древних мест — он создаёт поездки, которые вы никогда не забудете.",
                imageAlt: "Nethaj - Star Lanka Tours"
            },
            vehicles: {
                title: "Туристические автомобили",
                text: "Star Lanka Tours Sri Lanka заботится о вашей безопасности и комфорте. Под присмотром Nethaj мы используем современные, кондиционированные и чистые машины для лёгких поездок по острову.",
                bookButton: "Забронировать поездку",
                car: { title: "Автомобиль", text: "Подходит для 2–3 человек. Маленький, экономичный, идеален для коротких поездок." },
                van: { title: "Минивэн", text: "Подходит для семей или малых групп (до 6). Большой и комфортный для длинных поездок." },
                minibus: { title: "Микроавтобус", text: "Подходит для больших групп (8–12). Удобные сиденья и место для багажа." },
                luxury: { title: "Люксовый автомобиль", text: "Очень комфортные машины с мягкими сиденьями, Wi-Fi и личным водителем." }
            },
            accommodations: {
                intro: "Отдыхайте в хороших 3-звёздочных, 4-звёздочных, 5-звёздочных отелях и особых местах. Мы выбираем их за спокойствие, красоту и комфорт в вашей поездке Star Lanka Tours.",
                item1: "Частные виллы с большими бассейнами и расслабляющими видами на море.",
                item2: "Старинные люксовые отели у моря с хорошей едой.",
                item3: "Природный лодж с современными номерами и видами на диких животных.",
                item4: "Красивый дом в природе с отличными видами и зелёным дизайном."
            },
            notices: {
                title: "Бесплатные дополнения",
                intro: "Star Lanka Tours Sri Lanka даёт вам эти бесплатные вещи в каждой поездке:",
                bike: { title: "Бесплатный велосипед для каждого гостя", text: "Катайтесь свободно — мы даём велосипед каждому." },
                fruits: { title: "Свежие фрукты в конце", text: "Завершите поездку приятной упаковкой свежих фруктов." },
                meals: { title: "Бесплатное питание на особых мероприятиях", text: "Присоединяйтесь к местным традициям — мы даём бесплатные блюда во время церемоний кормления денег." }
            },
        },
        // Russian (ru)
        home: {
            common: { viewAll: "Посмотреть все" },
            sections: {
                recommendations: { title: "Лучшие места", subtitle: "Не знаете, куда поехать? Мы поможем выбрать." },
                excursions: { title: "Наши туры", desc: "Многодневные поездки — смесь древней культуры, природы и счастливых воспоминаний." },
                packages: { title: "Специальные пакеты" },
                reviews: { title: "Что говорят гости", subtitle: "Настоящие слова от людей, которые путешествовали с нами" },
                gallery: { title: "Наши фото", subtitle: "Красивые снимки Шри-Ланки — полные чудес, веселья и приятных моментов." }
            },
            recommendations: {
                sigiriya: { label: "Сигирия", name: "Большая старая скальная крепость высоко над землёй." },
                udawalawa: { label: "Удавалаве", name: "Большие поля со многими свободными слонами." },
                ella: { label: "Элла", name: "Облачные холмы, красивая поездка на поезде, потрясающие виды." },
                mirissa: { label: "Мирисса", name: "Жёлтые пляжи, синее море, отлично для наблюдения за китами." },
                nuwaraeliya: { label: "Нувара-Элия", name: "Много чайных полей и прохладный свежий воздух." },
                kandy: { label: "Канди", name: "Священный город с Храмом Зуба." },
                galle: { label: "Галле", name: "Старый форт у самого моря." },
                yala: { label: "Яла", name: "Большой парк с леопардами, слонами и множеством животных." },
                anuradhapura: { label: "Анурадхапура", name: "Древнее место, где начался буддизм, большие ступы." },
                polonnaruwa: { label: "Полоннарува", name: "Руины старого города из далёкого прошлого." }
            },
            excursions: {
                oneDay: { title: "1 День – Шри-Ланка за один день", des: "Один день магии — от древних мест до солнечных пляжей." },
                twoDays: { title: "2 Дня – Зов природы", des: "Два дня в дикой природе: сафари, чайные холмы, звуки джунглей." },
                threeDays: { title: "3 Дня – Душа и море", des: "Три дня для сердца — утренние храмы, вечернее море, настоящая культура." },
                fourDays: { title: "4 Дня – Древнее и спокойное", des: "Четыре дня древних чудес: большие крепости, старые улицы, настоящие традиции." },
                fiveDays: { title: "5 Дней – Сердце Шри-Ланки", des: "Пять дней, чтобы полюбить Шри-Ланку — туманные холмы до синего моря." },
                sixDays: { title: "6 Дней – Особая поездка", des: "Шесть дней прекрасного — святые места, сафари, спокойные закаты." }
            },
            packages: {
                one: { title: "1 День / 0 Ночей: Шри-Ланка за один день", duration: "1 День", desc: "Один большой день — старые ступы, золотые пляжи, настоящее чувство Шри-Ланки.", category: "Быстрый тур" },
                two: { title: "2 Дня / 1 Ночь: Зов природы", duration: "2 Дня", desc: "Два дня в природе — ночные сафари, аромат чая, жизнь джунглей.", category: "Дикий тур" },
                three: { title: "3 Дня / 2 Ночи: Душа и море", duration: "3 Дня", desc: "Три дня для души — храмы утром, спокойное море вечером.", category: "Море и дух" },
                four: { title: "4 Дня / 3 Ночи: Древнее и спокойное", duration: "4 Дня", desc: "Четыре дня древностей — крепости, старые города, настоящая культура.", category: "Культурный тур" },
                five: { title: "5 Дней / 4 Ночи: Сердце Шри-Ланки", duration: "5 Дней", desc: "Пять дней любви к острову — холмы, синее море, счастливые моменты.", category: "Тур любви" },
                six: { title: "6 Дней / 5 Ночей: Особая поездка", duration: "6 Дней", desc: "Шесть дней лучших впечатлений — святые места, животные, красивые закаты.", category: "Лучший тур" }
            },
            featured: {
                perahera: {
                    h2: "Посмотрите это грандиозное шоу", h3: "Канди Эсала Перахера", h4: "(Фестиваль Зуба)",
                    paragraph: `Один из крупнейших буддийских фестивалей Азии. Каждый год в Канди люди почитают Священный Зуб. Слоны в красивых одеждах, громкие барабаны, танцоры с огнём и огни создают волшебную ночь. Приезжайте посмотреть это с <strong style="color: #166880;">Star Lanka Tours Sri Lanka</strong> — здесь культура жива.`,
                    button: "Подробнее"
                },
                safari: {
                    h2: "Отправьтесь в дикую природу", h3: "Сафари-туры",
                    paragraph: `На Шри-Ланке одни из лучших животных Азии. Смотрите широкие просторы в <span style="color: #D5A44F; font-weight: 600;">Яла</span> и <span style="color: #D5A44F; font-weight: 600;">Удавалаве</span> или озёра в <span style="color: #D5A44F; font-weight: 600;">Вилпатту</span>. Встречайте слонов, леопардов и множество птиц. Путешествуйте с <strong style="color: #166880;">Star Lanka Tours Sri Lanka</strong> — каждое сафари — новая история.`,
                    button: "Посмотреть сафари"
                }
            },
            gallery: {
                title: "Наши фото", subtitle: "Красивые снимки Шри-Ланки — полные чудес, веселья и красоты.",
                alt1: "Восход солнца над скалой Сигирия", alt2: "Слоны в национальном парке Яла", alt3: "Сборщицы чая в туманной Нувара-Элии",
                alt4: "Закат на пляже Мирисса", alt5: "Молитва в храме Канди", alt6: "Древние руины в Полоннаруве",
                alt7: "Киты у южного побережья", alt8: "Поездка на поезде в холмах Эллы", alt9: "Форт Галле в вечернем свете",
                alt10: "Рыбак в Негомбо", alt11: "Шоу танцев Канди", alt12: "Полёт на воздушном шаре над Дамбуллой"
            },
            cta: {
                title: "Star Lanka Tours Sri Lanka — Создаём счастливые путешествия",
                desc: "Каждое путешествие особенное — полное культуры, веселья и спокойных моментов. Позвольте нам написать вашу историю в прекрасной Шри-Ланке.",
                button: "Начать сейчас",
                alt: "Создать вашу поездку"
            },
        },
        // Russian (ru)
        hero: {
            title: {
                line1: "Откройте рай вместе с",
                line2: "Star Lanka Tours",
                line3: "Sri Lanka"
            },
            subtitle: "Погрузитесь в пышные изумрудные джунгли, залитые солнцем золотые берега, вечные древние города и захватывающие приключения с дикой природой —",
            subtitle2: "идеально подобранные под ваши мечты.",

            cta: "Начните своё приключение",
            trust: "Любим путешественниками из более чем 50 стран • Признан ведущими экспертами по путешествиям по всему миру"
        },
        // Russian (ru)
        footer: {
            brand: "Star Lanka Tours",

            nav: {
                home: "Главная",
                about: "О нас",
                explore: "Исследуйте Шри-Ланку",
                tours: "Турпакеты",
                gallery: "Галерея",
                events: "Особые события",
                things: "Что посмотреть",
                contact: "Контакты"
            },

            contact: {
                title: "Давайте создадим вместе незабываемые воспоминания",
                address: "Beruwala Area,<br />Western Province, Sri Lanka",
                email: "info@starlankatours.com",          // ← change to your real email
                phone: "+94 76 805 1224"                   // ← change to your real phone/WhatsApp number
            },

            newsletter: {
                title: "Присоединяйтесь к нашему приключению",
                desc: "Получайте первыми новости о специальных предложениях, секретных местах и потрясающих поездках по Шри-Ланке.",
                placeholder: "Ваш адрес электронной почты",
                subscribe: "Подписаться"
            },

            tagline: "\"Не все, кто бродит, потерялись…<br /><span class='text-[#96BA33] font-semibold'>некоторые путешествуют с Star Lanka Tours</span>\"",

            copyright: "Все права защищены.",
            developedBy: "Разработано"
        },
        ayurveda: {
            title: "Аюрведа - древняя наука жизни",
            introParagraph1: "Слово 'Аюрведа' существует уже более трех тысячелетий. На санскрите это слово означает 'наука жизни'. Техника основана на аюрведическом подходе лечения причин заболеваний, а не их последствий, с которыми обычно борется европейская медицина. Она постулирует следующие принципы:",
            corePrinciplesTitle: "Основные принципы",
            principle1: "Тело должно быть свободно от энергии и поддерживать баланс для нормальной метаболической и сердечной активности.",
            principle2: "Тело должно иметь нормальное мышечное сокращение с регулярной гормональной активностью.",
            principle3: "Тело нуждается в здоровой иммунной системе для правильного функционирования.",
            sriLankaDoctors: "Согласно текущим данным, в Шри-Ланке насчитывается более 6000 обученных выпускников Аюрведы. Они проходят семилетнее обучение и два года практики в государственных больницах. Аюрведические программы включают:",
            benefit1: "Устранение стресса, усталости и тревоги",
            benefit2: "Насыщение кислородом",
            benefit3: "Стимуляция мышечных систем и устранение токсинов",
            benefit4: "Восстановление баланса нервной системы",
            benefit5: "Восстановление кровотока к внутренним органам",
            benefit6: "Производство эндорфинов",
            mainImageAlt: "Аюрведическое оздоровление",
            faceTreatmentAlt: "Аюрведическая процедура для лица",
            faceTreatmentCaption: "Аюрведическая процедура для лица",
            massageTreatmentAlt: "Аюрведическая массажная процедура",
            massageTreatmentCaption: "Аюрведическая массажная процедура",
            treatmentDescription: "Стандартные процедуры включают массаж тела и массаж головы специальными маслами, лечение в травяной сауне и ванны, обогащенные травами. Самая популярная техника - это 'процедура Широдхара', при которой теплое травяное масло ритмично капает на лоб. Это помогает восстановить баланс нервной системы и достичь расслабления.",
            tipsTitle: "Советы для аюрведического лечения",
            tip1: "Забудьте о проблемах. Расслабьтесь и очистите свой ум для лучших результатов.",
            tip2: "Выберите правильное место. Выберите среду, соответствующую вашему комфорту и предпочтениям для оптимального исцеления.",
            tip3: "Выберите правильную программу. Обсудите свои проблемы с врачом и попробуйте различные терапии, чтобы узнать, что подходит вам.",
            tip4: "Примите теплую ванну перед лечением, чтобы расслабить мышцы и подготовить тело.",
            tip5: "Ешьте легкую пищу перед процедурой. Избегайте тяжелой пищи, чтобы обеспечить правильный кровоток во время массажа.",
            tip6: "Расслабление после процедур необходимо. Правильное расслабление увеличивает эффективность аюрведических процедур."
        },
        ballooning: {
            title: "Полеты на воздушном шаре в Шри-Ланке",
            introParagraph1: "Полет на воздушном шаре в Шри-Ланке предлагает незабываемый опыт мягкого парения над потрясающими пейзажами острова. Начиная с восхода солнца, полеты на воздушном шаре предлагают захватывающие дух виды холмистых холмов, пышных лесов, древних руин и спокойных деревень.",
            introParagraph2: "Самым популярным местом для полетов на воздушном шаре в Шри-Ланке является Дамбулла, расположенная в сердце культурного треугольника. Полеты на воздушном шаре здесь часто проходят над знаковой скальной крепостью Сигирия, предлагая перспективу, не похожую ни на одну другую. Полеты обычно длятся 60-90 минут, давая вам достаточно времени, чтобы насладиться красотой Шри-Ланки с воздуха.",
            mainImageAlt: "Полет на воздушном шаре в Шри-Ланке",
            mainImageCaption: "Полет на воздушном шаре в Шри-Ланке",
            highlightsTitle: "Почему стоит попробовать полеты на воздушном шаре в Шри-Ланке?",
            highlightsIntro: "Полеты на воздушном шаре сочетают приключения со спокойствием, позволяя вам испытать красоту Шри-Ланки уникальным образом. Некоторые из основных моментов полетов на воздушном шаре включают:",
            highlight1: "Непрерывные панорамные виды на потрясающие пейзажи острова.",
            highlight2: "Полет над знаковыми достопримечательностями, такими как скала Сигирия и близлежащие озера.",
            highlight3: "Спокойная и мирная поездка над пышной зеленью и очаровательными деревнями.",
            highlight4: "Наблюдение за захватывающим восходом солнца с неба.",
            highlight5: "Идеально для энтузиастов фотографии, желающих запечатлеть живописную красоту сверху.",
            sunriseImageAlt: "Наслаждайтесь потрясающими видами восхода солнца, мягко паря на воздушном шаре.",
            sunriseImageCaption: "Наслаждайтесь потрясающими видами восхода солнца, мягко паря на воздушном шаре.",
            landscapeImageAlt: "Испытайте захватывающие дух пейзажи Шри-Ланки сверху, включая холмистые холмы и пышные леса.",
            landscapeImageCaption: "Испытайте захватывающие дух пейзажи Шри-Ланки сверху, включая холмистые холмы и пышные леса.",
            tipsTitle: "Советы для незабываемого полета на воздушном шаре",
            tip1: "Бронируйте поездку заранее, так как полеты на воздушном шаре зависят от погоды, и места быстро заполняются.",
            tip2: "Надевайте удобную одежду и принесите легкую куртку, так как ранее утро может быть прохладным.",
            tip3: "Принесите камеру или смартфон для фотографирования захватывающих видов.",
            tip4: "Внимательно слушайте инструкции по безопасности вашего пилота.",
            tip5: "Приходите вовремя, чтобы наблюдать за подготовкой и надуванием воздушного шара, что является увлекательным процессом."
        },
        diving: {
            title: "Дайвинг в Шри-Ланке",
            introParagraph1: "Широкий коралловый риф окружает побережье Шри-Ланки на глубинах от 2 до 40 метров. Теплые воды Индийского океана, от 27°C до 30°C, и высокая прозрачность воды, от 15 до 35 метров, обеспечивают отличные условия для дайвинга и снорклинга. Занимаясь дайвингом в Шри-Ланке, вы можете исследовать бесконечные нетронутые коралловые рифы, древние затонувшие корабли и увлекательные подводные пещеры.",
            introParagraph2: "Северо-восток острова предлагает разнообразие более 130 видов красочных кораллов, являющихся домом для морской жизни, такой как морские черепахи, рыбы-клоуны, крылатки и морские коньки. Посетите затонувшие корабли возле подводных скал и рифов для незабываемого опыта. Паря в чистых водах, вы погружаетесь в увлекательное прошлое Цейлона.",
            mainImageAlt: "Дайвинг в Шри-Ланке",
            mainImageCaption: "Дайвинг в Шри-Ланке",
            facilitiesTitle: "Удобства и лучшие места для дайвинга",
            facilitiesParagraph1: "Дайвинг-центры острова оснащены новейшим оборудованием для дайвинга от известных производителей. Сертифицированные инструкторы с квалификациями PADI и CMAS обеспечивают безопасные и приятные погружения. Дайвинг-центры расположены вдоль юго-западного побережья острова и работают с середины октября до конца апреля. Северо-восточное побережье, включая Нилавели и Тринкомали, идеально для дайвинга с марта по октябрь.",
            facilitiesParagraph2: "Коралловые рифы возле Калпития на западе и места для погружений на затонувшие корабли в Хиккадуве являются одними из самых популярных достопримечательностей для дайверов.",
            coralImageAlt: "Исследуйте яркие коралловые рифы, являющиеся домом для разнообразной морской жизни.",
            coralImageCaption: "Исследуйте яркие коралловые рифы, являющиеся домом для разнообразной морской жизни.",
            shipwreckImageAlt: "Откройте для себя исторические затонувшие корабли, которые дают представление о морском прошлом Шри-Ланки.",
            shipwreckImageCaption: "Откройте для себя исторические затонувшие корабли, которые дают представление о морском прошлом Шри-Ланки.",
            tipsTitle: "Советы для дайверов",
            tip1: "Выберите лучший сезон для дайвинга в зависимости от местоположения: юго-западное побережье (октябрь-апрель) или северо-восточное побережье (март-октябрь).",
            tip2: "Убедитесь, что ваш дайвинг-центр сертифицирован и оснащен современным оборудованием для безопасного опыта.",
            tip3: "Слушайте советы вашего инструктора, особенно если вы новичок.",
            tip4: "Уважайте морскую жизнь, не трогая кораллы или не нарушая подводную среду.",
            tip5: "Принесите водонепроницаемую камеру, чтобы запечатлеть завораживающую красоту подводного мира Шри-Ланки."
        },
        elephantRide: {
            title: "Прогулка на слоне",
            introParagraph1: "Треккинг на слонах - это захватывающее, волнующее занятие и уникальный опыт в Шри-Ланке. Если вы остановитесь рядом с культурным треугольником в таких районах, как Хабарана, Сигирия или Дамбулла, вы можете принять участие в сафари на слонах. Эти поездки начинаются примерно с $30 за час незабываемого приключения.",
            introParagraph2: "Перед поездкой слонам надевают многокорзинное седло на 4-6 человек. Эти нежные гиганты проведут вас через живописные джунгли, пересекая затопленные участки и навигацию через пышную растительность. Слоны обычно идут медленно, позволяя вам полностью оценить красоту окружающей природы, хотя они могут развивать скорость до 40 км/ч.",
            mainImageAlt: "Прогулка на слоне",
            mainImageCaption: "Прогулка на слоне",
            highlightsTitle: "Основные моменты прогулки на слоне",
            highlightsIntro: "Поездка на слоне в Шри-Ланке предлагает уникальную возможность соединиться с природой и исследовать пейзаж. Некоторые основные моменты опыта включают:",
            highlight1: "Прогулка через густые джунгли, наполненные экзотической растительностью и дикой природой.",
            highlight2: "Пересечение рек и затопленных районов, предлагающих захватывающие виды на природный ландшафт.",
            highlight3: "Изучение тесной связи между слонами и шриланкийской культурой.",
            highlight4: "Расслабление на удобном седле, пока слон мягко несет вас через различные местности.",
            jungleImageAlt: "Исследуйте густые джунгли и живописные тропы, катаясь на слоне.",
            jungleImageCaption: "Исследуйте густые джунгли и живописные тропы, катаясь на слоне.",
            waterImageAlt: "Пересекайте реки и наслаждайтесь спокойной красотой воды и растительности.",
            waterImageCaption: "Пересекайте реки и наслаждайтесь спокойной красотой воды и растительности.",
            tipsTitle: "Советы для безопасной и приятной прогулки на слоне",
            tip1: "Надевайте удобную одежду и обувь, подходящую для активного отдыха.",
            tip2: "Следуйте инструкциям вашего гида для безопасной и приятной поездки.",
            tip3: "Убедитесь, что со слонами хорошо обращаются, и провайдер поездки следует этичным практикам.",
            tip4: "Принесите камеру, чтобы запечатлеть потрясающий пейзаж и моменты.",
            tip5: "Уважайте слонов и избегайте действий, которые могут их напрячь или навредить им."
        },
        fishing: {
            title: "Рыбалка в Шри-Ланке",
            introParagraph1: "Шри-Ланка, с её обширной береговой линией и изобилием пресноводных озёр и рек, предлагает непревзойденный опыт рыбалки. Независимо от того, являетесь ли вы профессиональным рыболовом или любителем, Шри-Ланка предлагает что-то для вас. От глубоководных рыболовных экспедиций до традиционной рыбалки на сваях, практикуемой местными рыбаками, у вас будет незабываемое приключение.",
            introParagraph2: "Популярные места для рыбалки включают южное побережье вокруг Галле и Мириссы, лагуну Негомбо и спокойные воды Тринкомали. В зависимости от ваших предпочтений, вы можете попробовать различные методы рыбалки, такие как троллинг, донная рыбалка или ловля нахлыстом.",
            mainImageAlt: "Рыбалка в Шри-Ланке",
            mainImageCaption: "Рыбалка в Шри-Ланке",
            experiencesTitle: "Рыболовные впечатления в Шри-Ланке",
            experiencesIntro: "Рыбалка в Шри-Ланке - это не только ловля рыбы; это возможность погрузиться в культуру и традиции острова. Некоторые уникальные рыболовные впечатления включают:",
            expStiltTitle: "Рыбалка на сваях",
            expStiltDesc: "Традиционный метод, при котором рыбаки сидят на сваях, чтобы ловить рыбу недалеко от побережья, практика уникальная для Шри-Ланки.",
            expDeepSeaTitle: "Глубоководная рыбалка",
            expDeepSeaDesc: "Отправляйтесь в Индийский океан, чтобы ловить марлинов, тунцов, барракуд и другие крупные виды рыб.",
            expLagoonTitle: "Рыбалка в лагунах и реках",
            expLagoonDesc: "Расслабьтесь, ловя рыбу в спокойных лагунах и реках, наполненных рыбой, такой как тилапия и сом.",
            expNightTitle: "Ночная рыбалка",
            expNightDesc: "Испытайте азарт рыбалки под звездами, распространенная практика в прибрежных деревнях.",
            stiltImageAlt: "Рыбалка на сваях, традиционный метод и знаковое изображение рыболовного наследия Шри-Ланки.",
            stiltImageCaption: "Рыбалка на сваях - это традиционный метод и знаковое изображение рыболовного наследия Шри-Ланки.",
            deepSeaImageAlt: "Глубоководная рыбалка предлагает авантюрный опыт, нацеленный на крупные виды рыб в Индийском океане.",
            deepSeaImageCaption: "Глубоководная рыбалка предлагает авантюрный опыт, нацеленный на крупные виды рыб в Индийском океане.",
            tipsTitle: "Советы для приятной рыбалки",
            tip1: "Выберите правильный сезон для вашей рыболовной экспедиции; октябрь-апрель идеален для южного побережья, в то время как март-октябрь подходит для восточного побережья.",
            tip2: "Принесите солнцезащитный крем, шляпу и защитную одежду, чтобы оставаться комфортным во время поездки.",
            tip3: "Забронируйте рыболовного гида или чартер, чтобы максимально использовать ваш опыт и учиться у экспертов.",
            tip4: "Уважайте местную окружающую среду, не мусоря и придерживаясь устойчивых рыболовных практик.",
            tip5: "Оставайтесь гидратированными и принесите закуски для более длительных рыболовных поездок."
        },
        jeepSafari: {
            title: "Джип-сафари в Шри-Ланке",
            introParagraph1: "Национальные парки Шри-Ланки предлагают захватывающий опыт джип-сафари, позволяя вам исследовать богатое биоразнообразие острова и наблюдать дикую природу в их естественной среде обитания. Национальный парк Яла, Национальный парк Вилпатту и Национальный парк Удавалаве являются одними из самых популярных мест для джип-сафари.",
            introParagraph2: "Эти сафари предоставляют возможность увидеть слонов, леопардов, медведей-губачей, водяных буйволов, крокодилов и множество видов птиц. Под руководством опытных натуралистов и следопытов, джип-сафари идеально подходят как для энтузиастов дикой природы, так и для фотографов.",
            mainImageAlt: "Джип-сафари в Шри-Ланке",
            mainImageCaption: "Джип-сафари в Шри-Ланке",
            whyChooseTitle: "Почему выбрать джип-сафари?",
            whyChooseIntro: "Джип-сафари - один из лучших способов исследовать разнообразную дикую природу Шри-Ланки. Вот некоторые основные моменты:",
            highlight1: "Близкие встречи с культовыми видами, такими как слоны и леопарды.",
            highlight2: "Доступ к отдаленным и живописным районам внутри национальных парков.",
            highlight3: "Возможности для фотографирования дикой природы в естественной среде.",
            highlight4: "Руководство от знающих натуралистов и рейнджеров парка.",
            highlight5: "Приключение, подходящее для всех возрастов, сочетающее волнение с образованием.",
            wildlifeImageAlt: "Встречайте культовую дикую природу, такую как леопарды, слоны и крокодилы во время вашего сафари.",
            wildlifeImageCaption: "Встречайте культовую дикую природу, такую как леопарды, слоны и крокодилы во время вашего сафари.",
            landscapeImageAlt: "Исследуйте потрясающие пейзажи национальных парков Шри-Ланки, от густых лесов до открытых равнин.",
            landscapeImageCaption: "Исследуйте потрясающие пейзажи национальных парков Шри-Ланки, от густых лесов до открытых равнин.",
            tipsTitle: "Советы для приятного джип-сафари",
            tip1: "Надевайте удобную одежду нейтральных цветов, чтобы смешаться с окружающей средой.",
            tip2: "Принесите солнцезащитный крем, шляпу и средство от насекомых для защиты.",
            tip3: "Принесите бинокль и камеру, чтобы усилить ваш опыт и запечатлеть дикую природу.",
            tip4: "Следуйте инструкциям гида, чтобы обеспечить безопасность и уважение к животным.",
            tip5: "Бронируйте свое сафари заранее, особенно в высокий сезон, чтобы обеспечить место."
        },
        riverSafari: {
            title: "Речное сафари в Шри-Ланке",
            introParagraph1: "Речное сафари в Шри-Ланке предлагает уникальную возможность исследовать богатое биоразнообразие и живописную красоту острова. Скользите по спокойным водным путям, окруженным пышными мангровыми зарослями, обнаруживайте экзотическую дикую природу и наслаждайтесь живописными закатами, которые вас очаруют.",
            introParagraph2: "Популярные места для речного сафари включают Маду Ганга (река Маду) и реку Бентота. Эти сафари предоставляют возможность наблюдать различные виды птиц, варанов, крокодилов и даже обезьян в их естественной среде обитания. Спокойная обстановка идеально подходит для любителей природы и фотографов.",
            mainImageAlt: "Речное сафари в Шри-Ланке",
            mainImageCaption: "Речное сафари в Шри-Ланке",
            whyChooseTitle: "Почему выбрать речное сафари?",
            whyChooseIntro: "Речное сафари - это расслабляющий и погружающий опыт, сочетающий природу, дикую природу и культурное исследование. Вот некоторые основные моменты:",
            highlight1: "Исследуйте пышные мангровые заросли, полные жизни.",
            highlight2: "Обнаружьте экзотических птиц, крокодилов и другую дикую природу.",
            highlight3: "Посетите маленькие острова и местные деревни вдоль реки.",
            highlight4: "Наслаждайтесь спокойствием и живописной красотой водных путей Шри-Ланки.",
            highlight5: "Идеально подходит для семей, пар и индивидуальных путешественников, ищущих мирное убежище.",
            mangrovesImageAlt: "Откройте для себя пышные мангровые заросли, выстилающие живописные водные пути Шри-Ланки.",
            mangrovesImageCaption: "Откройте для себя пышные мангровые заросли, выстилающие живописные водные пути Шри-Ланки.",
            wildlifeImageAlt: "Обнаружьте экзотическую дикую природу, такую как крокодилы, вараны и красочные птицы во время вашего сафари.",
            wildlifeImageCaption: "Обнаружьте экзотическую дикую природу, такую как крокодилы, вараны и красочные птицы во время вашего сафари.",
            tipsTitle: "Советы для приятного речного сафари",
            tip1: "Надевайте удобную одежду и принесите шляпу и солнцезащитный крем для защиты.",
            tip2: "Принесите бинокль, чтобы замечать далекую дикую природу и птиц.",
            tip3: "Принесите камеру или смартфон, чтобы запечатлеть потрясающий пейзаж и дикую природу.",
            tip4: "Следуйте инструкциям вашего гида для безопасного и приятного опыта.",
            tip5: "Уважайте природную окружающую среду, не мусоря и не беспокоя дикую природу."
        },
        snorkeling: {
            title: "Снорклинг в Шри-Ланке",
            introParagraph1: "Снорклинг в Шри-Ланке предлагает незабываемый подводный опыт, позволяя вам исследовать яркие коралловые рифы и разнообразную морскую жизнь. Благодаря кристально чистым природным водам и богатым водным экосистемам, Шри-Ланка - это рай для снорклеров всех уровней навыков.",
            introParagraph2: "Некоторые из самых популярных мест для снорклинга включают Хиккадува, известную своими красочными коралловыми садами и черепахами, остров Голубь в Тринкомали, знаменитый своими девственными рифами, и Мириссу, где вы можете даже заметить кита или два во время сезона снорклинга.",
            mainImageAlt: "Снорклинг в Шри-Ланке",
            mainImageCaption: "Снорклинг в Шри-Ланке",
            whyChooseTitle: "Почему выбрать снорклинг в Шри-Ланке?",
            whyChooseIntro: "Снорклинг в Шри-Ланке - это волшебный опыт, сочетающий приключения с природной красотой. Вот некоторые основные моменты:",
            highlight1: "Исследуйте яркие коралловые рифы, полные жизни.",
            highlight2: "Плавайте рядом с красочными тропическими рыбами, черепахами и даже рифовыми акулами.",
            highlight3: "Откройте для себя девственные подводные пейзажи в чистой, теплой воде.",
            highlight4: "Подходит как для начинающих, так и для опытных снорклеров.",
            highlight5: "Доступен из некоторых лучших пляжных направлений в Шри-Ланке.",
            coralImageAlt: "Откройте для себя потрясающие коралловые рифы и их яркие экосистемы.",
            coralImageCaption: "Откройте для себя потрясающие коралловые рифы и их яркие экосистемы.",
            marineLifeImageAlt: "Встречайте разнообразную морскую жизнь, включая черепах, тропических рыб и многое другое.",
            marineLifeImageCaption: "Встречайте разнообразную морскую жизнь, включая черепах, тропических рыб и многое другое.",
            tipsTitle: "Советы для незабываемого снорклинга",
            tip1: "Надевайте удобную маску и трубку, чтобы обеспечить четкое зрение под водой.",
            tip2: "Используйте безопасный для рифов солнцезащитный крем, чтобы защитить как вашу кожу, так и морскую жизнь.",
            tip3: "Плавайте мягко, чтобы избежать нарушения коралловых рифов и водной жизни.",
            tip4: "Оставайтесь гидратированными и делайте перерывы между сессиями.",
            tip5: "Присоединитесь к управляемому туру, чтобы получить лучшие места для снорклинга и советы по безопасности."
        },
        teaTasting: {
            title: "Тур дегустации чая в Шри-Ланке",
            introParagraph1: "Шри-Ланка, часто называемая 'Жемчужиной Индийского океана', знаменита своим мировым классом производством чая. Отправьтесь в тур дегустации чая и исследуйте пышные чайные плантации в регионах, таких как Нувара Элия, Элла и Канди. Узнайте об искусстве выращивания чая, тщательном процессе производства чая и насладитесь богатыми вкусами аутентичного цейлонского чая.",
            introParagraph2: "Будь вы энтузиастом чая или просто любопытны, тур дегустации чая предоставляет уникальную возможность погрузиться в чайное наследие Шри-Ланки и испытать безмятежную красоту ее высокогорий.",
            mainImageAlt: "Тур дегустации чая в Шри-Ланке",
            mainImageCaption: "Тур дегустации чая в Шри-Ланке",
            whyChooseTitle: "Почему выбрать тур дегустации чая?",
            whyChooseIntro: "Тур дегустации чая в Шри-Ланке - это не только дегустация чая - это погружающийся культурный опыт. Вот некоторые основные моменты:",
            highlight1: "Посетите живописные чайные плантации, расположенные в прохладных высокогорьях.",
            highlight2: "Узнайте об истории и значении цейлонского чая.",
            highlight3: "Участвуйте в сборе чая и наблюдайте за процессом производства на чайных фабриках.",
            highlight4: "Попробуйте различные сорта чая, от черного до зеленого и ароматизированных смесей.",
            highlight5: "Наслаждайтесь потрясающими пейзажами туманных гор и каскадных водопадов.",
            plantationImageAlt: "Исследуйте пышные чайные плантации и узнайте о выращивании чая.",
            plantationImageCaption: "Исследуйте пышные чайные плантации и узнайте о выращивании чая.",
            preparationImageAlt: "Откройте для себя искусство приготовления чая и насладитесь аутентичным цейлонским чаем.",
            preparationImageCaption: "Откройте для себя искусство приготовления чая и насладитесь аутентичным цейлонским чаем.",
            tipsTitle: "Советы для приятного тура дегустации чая",
            tip1: "Надевайте удобную одежду и обувь для прогулок по плантациям.",
            tip2: "Принесите легкую куртку, так как высокогорные регионы могут быть прохладными и туманными.",
            tip3: "Попробуйте различные сорта чая и возьмите некоторые любимые домой в качестве сувениров.",
            tip4: "Задавайте вопросы во время тура, чтобы узнать больше о процессе производства чая.",
            tip5: "Комбинируйте свой чайный тур с посещениями близлежащих достопримечательностей, таких как водопады и смотровые площадки."
        },
        templeVisit: {
            title: "Посещение храма в Шри-Ланке",
            introParagraph1: "Шри-Ланка, известная как земля Будды, является домом для древних храмов, которые отражают её богатое духовное и культурное наследие. Отправьтесь в путешествие, чтобы исследовать знаковые храмы, такие как Храм Зуба Будды в Канди, пещерный храм Дамбулла и Руванвелисая в Анурадхапуре.",
            introParagraph2: "Эти священные места, украшенные сложной резьбой, фресками и статуями, предлагают взгляд на духовные традиции и архитектурный блеск острова. Посещение храма - это не только культурный опыт, но и возможность найти мир и спокойствие.",
            mainImageAlt: "Посещение храма в Шри-Ланке",
            mainImageCaption: "Посещение храма в Шри-Ланке",
            whyVisitTitle: "Почему посещать храмы в Шри-Ланке?",
            whyVisitIntro: "Посещение храмов в Шри-Ланке предлагает уникальную возможность соединиться с историей, культурой и духовностью острова. Вот некоторые основные моменты:",
            highlight1: "Полюбуйтесь замысловатой архитектурой и статуями многовековой давности.",
            highlight2: "Узнайте о буддийских традициях и ритуалах от знающих гидов.",
            highlight3: "Исследуйте объекты всемирного наследия ЮНЕСКО, такие как Золотой храм Дамбуллы.",
            highlight4: "Испытайте безмятежность и духовную атмосферу священных пространств.",
            highlight5: "Станьте свидетелем живых фестивалей, таких как Эсала Перахера в Храме Зуба.",
            interiorImageAlt: "Полюбуйтесь потрясающими интерьерами, украшенными замысловатой резьбой и фресками.",
            interiorImageCaption: "Полюбуйтесь потрясающими интерьерами, украшенными замысловатой резьбой и фресками.",
            sacredImageAlt: "Посетите священные храмы, такие как Руванвелисая, и погрузитесь в духовные традиции.",
            sacredImageCaption: "Посетите священные храмы, такие как Руванвелисая, и погрузитесь в духовные традиции.",
            tipsTitle: "Советы для посещения храмов в Шри-Ланке",
            tip1: "Одевайтесь скромно и покрывайте плечи и колени в знак уважения.",
            tip2: "Снимайте обувь перед входом на территорию храма.",
            tip3: "Не трогайте статуи или священные объекты.",
            tip4: "Принесите небольшое пожертвование для храма, если хотите внести свой вклад.",
            tip5: "Уважайте тишину и духовную атмосферу во время вашего визита."
        },
        whiteWaterRafting: {
            title: "Рафтинг по белой воде в Шри-Ланке",
            introParagraph1: "Рафтинг по белой воде в Шри-Ланке - это захватывающий опыт, особенно в Китулгале, столице приключений острова. Река Келани с её бурными порогами и живописной обстановкой обеспечивает идеальный фон как для начинающих, так и для опытных рафтеров.",
            introParagraph2: "Рафтинговые экспедиции обычно включают 5-километровую трассу с порогами от 2-го до 4-го класса. Участники могут насладиться волнением навигации через сложные течения, любуясь пышной зеленью и захватывающими видами на берега реки.",
            mainImageAlt: "Рафтинг по белой воде в Шри-Ланке",
            mainImageCaption: "Рафтинг по белой воде в Шри-Ланке",
            whyChooseTitle: "Почему выбрать рафтинг по белой воде в Шри-Ланке?",
            whyChooseIntro: "Рафтинг по белой воде в Шри-Ланке предлагает уникальное сочетание приключений и природной красоты. Вот некоторые основные моменты опыта:",
            highlight1: "Навигация через захватывающие пороги под руководством опытных инструкторов.",
            highlight2: "Наслаждайтесь захватывающими видами на окружающий тропический лес и горную местность.",
            highlight3: "Совместите рафтинг с другими активностями, такими как треккинг, наблюдение за птицами и каньонинг в Китулгале.",
            highlight4: "Идеально подходит для групп, семей или индивидуальных путешественников, ищущих адреналин.",
            actionImageAlt: "Почувствуйте прилив адреналина, когда вы покоряете сложные пороги на реке Келани.",
            actionImageCaption: "Почувствуйте прилив адреналина, когда вы покоряете сложные пороги на реке Келани.",
            scenicImageAlt: "Наслаждайтесь безмятежной красотой пышной обстановки во время вашего рафтинг-приключения.",
            scenicImageCaption: "Наслаждайтесь безмятежной красотой пышной обстановки во время вашего рафтинг-приключения.",
            tipsTitle: "Советы для безопасного и захватывающего рафтинг-тура",
            tip1: "Надевайте спасательный жилет и шлем, предоставленные вашим рафтинг-гидом, для безопасности.",
            tip2: "Внимательно слушайте инструкции по безопасности перед началом вашей поездки.",
            tip3: "Надевайте удобную, быстросохнущую одежду и безопасную обувь, такую как водная обувь.",
            tip4: "Принесите сменную одежду и полотенце для после поездки.",
            tip5: "Бронируйте свой рафтинг-тур у уважаемого провайдера, чтобы обеспечить безопасный и приятный опыт."
        },
        wildlifeSafari: {
            title: "Сафари дикой природы в Шри-Ланке",
            introParagraph1: "Шри-Ланка, известная своим богатым биоразнообразием, предлагает невероятные сафари дикой природы в национальных парках, таких как Яла, Вилпатту, Миннерия и Удавалаве. Эти сафари предоставляют возможность наблюдать слонов, леопардов, медведей-губачей и множество видов птиц в их естественных средах обитания.",
            introParagraph2: "Исследуйте разнообразные ландшафты от густых лесов до открытых лугов и запечатлейте незабываемые моменты дикой природы в действии. С экспертными гидами и хорошо обслуживаемыми сафари-джипами, сафари дикой природы в Шри-Ланке - это обязательное занятие для любителей природы и искателей приключений.",
            mainImageAlt: "Сафари дикой природы в Шри-Ланке",
            mainImageCaption: "Сафари дикой природы в Шри-Ланке",
            whyChooseTitle: "Почему выбрать сафари дикой природы?",
            whyChooseIntro: "Сафари дикой природы в Шри-Ланке предлагает уникальную возможность соединиться с природой и исследовать замечательное биоразнообразие острова. Основные моменты включают:",
            highlight1: "Наблюдайте культовые виды, такие как слоны, леопарды и крокодилы.",
            highlight2: "Исследуйте пышные леса, водно-болотные угодья и открытые равнины, полные дикой природы.",
            highlight3: "Запечатлейте потрясающую фотографию дикой природы в естественной обстановке.",
            highlight4: "Испытайте волнение от обнаружения неуловимых животных, таких как шриланкийский леопард.",
            highlight5: "Узнайте об усилиях по сохранению от опытных гидов и натуралистов.",
            elephantsImageAlt: "Наблюдайте величественных слонов, свободно бродящих по национальным паркам Шри-Ланки.",
            elephantsImageCaption: "Наблюдайте величественных слонов, свободно бродящих по национальным паркам Шри-Ланки.",
            leopardImageAlt: "Обнаружьте неуловимого шриланкийского леопарда, главную изюминку любого сафари дикой природы.",
            leopardImageCaption: "Обнаружьте неуловимого шриланкийского леопарда, главную изюминку любого сафари дикой природы.",
            tipsTitle: "Советы для захватывающего сафари дикой природы",
            tip1: "Надевайте одежду нейтральных цветов, чтобы смешаться с окружающей средой.",
            tip2: "Принесите солнцезащитный крем, шляпу и средство от насекомых для защиты.",
            tip3: "Принесите бинокль и камеру, чтобы замечать и запечатлевать дикую природу.",
            tip4: "Следуйте инструкциям вашего гида для безопасного и приятного опыта.",
            tip5: "Бронируйте заранее, особенно в высокий сезон, чтобы обеспечить место в популярных парках."
        },
        tourpackages: {
            heroTitle: 'Наши турпакеты',
            heroSubtitle: 'Откройте Шри-Ланку за один день — авторские приключения от <span class="text-[#009CE6] font-bold">Star Lanka Tours</span>',
            heroAlt: 'Star Lanka Tours Шри-Ланка - Однодневные приключения',
            chooseAdventure: 'Выберите ваше приключение',
            packagesSubtitle: '25 тщательно отобранных впечатлений — от сафари с дикими животными до культурных погружений.',
            viewDetails: 'Подробнее',
            itineraryTitle: 'Маршрут',
            bookViaWhatsApp: 'Забронировать через WhatsApp',
            whatsappMessage: 'Привет, Star Lanka Tours! Хочу забронировать: *{{title}}* ({{duration}})\n\nСообщите о доступности и ценах!',

            packages: {
                '1': {
                    title: 'День приключений в Элле',
                    duration: '1 день',
                    category: 'Природа и приключения',
                    description: 'Путешествие по туманным холмам, каскадным водопадам и знаковым мостам — идеальное сочетание азарта и безмятежности.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> – Купание в кристальных бассейнах</li>
                <li><strong>Мост с девятью арками</strong> – Знаковая фотостоп с поездом</li>
                <li><strong>Чайная плантация</strong> – Прогулка среди изумрудных холмов</li>
                <li><strong>Поездка на поезде</strong> – Живописный маршрут от Эллы до Демодары</li>
                <li><strong>Малый пик Адама</strong> – Панорамные виды на рассвет/закат</li>
                <li><strong>Кормление слонят молоком в Удавалаве</strong> – Трогательный момент с дикой природой</li>
                <li><strong>Аюрведический травяной сад</strong> – Изучение древних секретов здоровья</li>
            </ul>`
                },
                '2': {
                    title: 'Элла и сафари в Яла',
                    duration: '1 день',
                    category: 'Дикая природа и пейзажи',
                    description: 'От туманных высокогорий до дикой саванны — лучшее из природы за один незабываемый день.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> – Освежающий природный бассейн</li>
                <li><strong>Мост с девятью арками</strong> – Архитектурное чудо</li>
                <li><strong>Чайная плантация</strong> – Живописные прогулки по холмам</li>
                <li><strong>Малый пик Адама</strong> – Потрясающие виды с вершины</li>
                <li><strong>Сафари в Яла</strong> – Джип-приключение с леопардами и слонами</li>
            </ul>`
                },
                '3': {
                    title: 'Культурный день в Канди',
                    duration: '1 день',
                    category: 'Наследие и природа',
                    description: 'Погрузитесь в священные храмы, пышные сады и местные традиции в сердце Шри-Ланки.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Город Канди</strong> – Яркий культурный центр</li>
                <li><strong>Королевский ботанический сад</strong> – Тропический рай</li>
                <li><strong>Чайная фабрика и плантация</strong> – Опыт цейлонского чая</li>
                <li><strong>Кормление, купание и катание на слонах</strong> – Этичное взаимодействие</li>
                <li><strong>Аюрведический травяной сад</strong> – Тур по натуральному исцелению</li>
                <li><strong>Башня Амбулувава</strong> – Панорамный вид на 360°</li>
                <li><strong>Фабрика ювелирных изделий и драгоценных камней</strong> – Сверкающее мастерство</li>
                <li><strong>Шелковая фабрика</strong> – Традиционное ткачество</li>
            </ul>`
                },
                '4': {
                    title: 'Священное путешествие в Канди',
                    duration: '1 день',
                    category: 'Духовное и культурное',
                    description: 'Душевный день преданности, наследия и природной красоты в священном городе Канди.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Храм Зуба Будды</strong> – Священное буддийское место</li>
                <li><strong>Чайная фабрика и плантация</strong> – Дегустация свежего чая</li>
                <li><strong>Кормление, купание и катание на слонах</strong> – Нежные гиганты</li>
                <li><strong>Аюрведический травяной сад</strong> – Мудрость здоровья</li>
                <li><strong>Башня Амбулувава</strong> – Спиральный подъем к небесам</li>
                <li><strong>Фабрика ювелирных изделий и драгоценных камней</strong> – Местные камни</li>
                <li><strong>Шелковая фабрика</strong> – Искусство шелка</li>
            </ul>`
                },
                '5': {
                    title: 'День наследия в Сигирии',
                    duration: '1 день',
                    category: 'История и приключения',
                    description: 'Поднимитесь на древние скальные крепости, исследуйте золотые пещеры и ощутите аутентичную деревенскую жизнь.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> – Объект всемирного наследия ЮНЕСКО</li>
                <li><strong>Золотой храм Дамбулла</strong> – Древнее пещерное искусство</li>
                <li><strong>Деревенский тур</strong> – Воловья повозка, катамаран, традиционный обед</li>
                <li><strong>Аюрведический травяной сад</strong> – Лечебные растения</li>
                <li><strong>Скала Пидурангала</strong> – Лучший вид на Сигирию</li>
            </ul>`
                },
                '6': {
                    title: 'Прибрежное наследие Галле',
                    duration: '1 день',
                    category: 'История и природа',
                    description: 'Прогуляйтесь по колониальным фортам, поплавайте по мангровым рекам и станьте свидетелями охраны морских черепах.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Храм Канде Вихарая</strong> – Гигантская статуя Будды</li>
                <li><strong>Черепаший питомник</strong> – Выпуск детенышей черепах</li>
                <li><strong>Сафари на лодке</strong> – Мангровые заросли реки Маду</li>
                <li><strong>Шахта лунных камней</strong> – Опыт добычи драгоценных камней</li>
                <li><strong>Голландский форт Галле</strong> – Колониальный город ЮНЕСКО</li>
                <li><strong>Аюрведический травяной сад</strong> – Натуральные средства</li>
            </ul>`
                },
                '7': {
                    title: 'Открытие города Коломбо',
                    duration: '1 день',
                    category: 'Городское и культурное',
                    description: 'Исследуйте современные достопримечательности, священные места и оживленный шоппинг в шумной столице Шри-Ланки.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Башня Лотос</strong> – 360° вид на город</li>
                <li><strong>Красная мечеть</strong> – Потрясающая исламская архитектура</li>
                <li><strong>Шоппинг</strong> – Местные рынки и торговые центры</li>
                <li><strong>Аюрведический травяной сад</strong> – Остановка для здоровья</li>
                <li><strong>Храм Гангарамая</strong> – Священный городской оазис</li>
            </ul>`
                },
                '8': {
                    title: 'Дикое сафари в Яла',
                    duration: '1 день',
                    category: 'Дикая природа',
                    description: 'Выслеживайте леопардов, слонов и редких птиц в одном из лучших национальных парков Азии.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Сафари на джипе в Яла</strong> – 3-часовое приключение с дикой природой</li>
                <li>Встречайте леопардов, слонов, губачей и более 200 видов птиц</li>
            </ul>`
                },
                '9': {
                    title: 'Китовая одиссея в Мириссе',
                    duration: '1 день',
                    category: 'Морские приключения',
                    description: 'Плывите с синими китами в высококомфортабельных лодках — самые большие существа в мире вблизи.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Наблюдение за синими китами</strong> – 4-часовое океанское сафари</li>
                <li><strong>Пляж Мирисса</strong> – Расслабьтесь на золотых песках</li>
                <li><strong>Рыбалка на ходулях</strong> – Знаковый фотомомент</li>
                <li><strong>Аюрведический травяной сад</strong> – Прибрежное здоровье</li>
            </ul>`
                },
                '10': {
                    title: 'День слонов в Удавалаве',
                    duration: '1 день',
                    category: 'Дикая природа и сострадание',
                    description: 'Станьте свидетелями кормления слонят и бродите с дикими стадами в их естественной среде обитания.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Национальный парк Удавалаве</strong> – Сафари на джипе</li>
                <li><strong>Кормление слонят молоком</strong> – Посещение приюта</li>
            </ul>`
                },
                '11': {
                    title: 'Экспресс Элла и Галле',
                    duration: '1 день',
                    category: 'Пейзажи и наследие',
                    description: 'От горных поездов до колониальных фортов — быстрое путешествие красоты и истории.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Поездка на поезде</strong> – Элла в Галле</li>
                <li><strong>Малый пик Адама</strong> – Поход на рассвете</li>
                <li><strong>Голландский форт Галле</strong> – Прогулка на закате</li>
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
                <li><strong>Аюрведический травяной сад</strong> – Остановка для здоровья</li>
            </ul>`
                },
                '12': {
                    title: 'Сафари Яла и Галле',
                    duration: '1 день',
                    category: 'Дикое и колониальное',
                    description: 'Утреннее сафари с дикой природой, послеобеденная прогулка по наследию — идеальная комбинация южного побережья.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Сафари в национальном парке Яла</strong> – Утренний джип-тур</li>
                <li><strong>Голландский форт Галле</strong> – Послеобеденная колониальная прогулка</li>
            </ul>`
                },
                '13': {
                    title: 'Экспресс Канди, Элла и Яла',
                    duration: '2 дня',
                    category: 'Культурное и пейзажное',
                    description: 'От священных храмов до туманных холмов и диких сафари — вихревой тур по главным достопримечательностям Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Сафари в национальном парке Яла</strong> – Утренний джип-тур</li>
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Поездка на поезде</strong> – Роскошная поездка на поезде</li>
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Амбулувава</strong> – Быстрый поход</li>
                <li><strong>Ботанические сады</strong> – Тропический рай</li>
                <li><strong>Храм Зуба Будды</strong> – Священное посещение</li>
                <li><strong>Катание на слонах</strong> – Этичное взаимодействие</li>
                <li><strong>Чайная фабрика</strong> – Опыт цейлонского чая</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Канди (Роскошный отель)</h3>`
                },
                '14': {
                    title: 'Канди культурный',
                    duration: '2 дня',
                    category: 'Культурное',
                    description: 'Погрузитесь в священные храмы, пышные сады и местные традиции в сердце Шри-Ланки.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Город Канди</strong> – Яркий культурный центр</li>
                <li><strong>Королевский ботанический сад</strong> – Тропический рай</li>
                <li><strong>Чайная фабрика и плантация</strong> – Опыт цейлонского чая</li>
                <li><strong>Кормление, купание и катание на слонах</strong> – Этичное взаимодействие</li>
                <li><strong>Аюрведический травяной сад</strong> – Тур по натуральному исцелению</li>
                <li><strong>Башня Амбулувава</strong> – Панорамный вид на 360°</li>
                <li><strong>Фабрика ювелирных изделий и драгоценных камней</strong> – Сверкающее мастерство</li>
                <li><strong>Шелковая фабрика</strong> – Традиционное ткачество</li>
                <li><strong>Неллигала</strong> – Традиционный храм</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Канди (Роскошный отель)</h3>`
                },
                '15': {
                    title: 'Элла/Нувара Элия/Канди культурный',
                    duration: '2 дня',
                    category: 'Культурное и пейзажное',
                    description: 'От туманных высокогорий до священных храмов — душевное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Малый пик Адама</strong> – Живописный поход</li>
                <li><strong>Поездка на поезде</strong> – Роскошная поездка на поезде</li>
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
                <li><strong>Розовое почтовое отделение</strong> – Культурная красота</li>
                <li><strong>Амбулувава</strong> – Спокойные прогулки</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Индуистский храм</strong> – Культурное посещение</li>
                <li><strong>Ботанические сады</strong> – Тропический рай</li>
                <li><strong>Неллигала</strong> – Священное посещение</li>
                <li><strong>Водопад Рамбода</strong></li>
                <li><strong>Чайная фабрика</strong> – Опыт цейлонского чая</li>
                <li><strong>Катание на слонах</strong> – Этичное взаимодействие</li>
                <li><strong>Травяной сад</strong> – Тропический рай</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Канди (Роскошный отель)</h3>`
                },
                '16': {
                    title: 'Яла/Элла/Нувара Элия/Канди культурный',
                    duration: '3 дня',
                    category: 'Культурное и пейзажное',
                    description: 'От туманных высокогорий до священных храмов — душевное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Малый пик Адама</strong> – Живописный поход</li>
                <li><strong>Поездка на поезде</strong> – Роскошная поездка на поезде</li>
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
                <li><strong>Индуистский храм</strong> – Культурное посещение</li>
                <li><strong>Сафари в национальном парке Яла</strong> – Утренний джип-тур</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Амбулувава</strong> – Спокойные прогулки</li>
                <li><strong>Розовое почтовое отделение</strong> – Культурная красота</li>
                <li><strong>Ботанические сады</strong> – Тропический рай</li>
                <li><strong>Храм Зуба Будды</strong> – Священное посещение</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Неллигала</strong> – Священное посещение</li>
                <li><strong>Чайная фабрика</strong> – Опыт цейлонского чая</li>
                <li><strong>Драгоценные камни и ювелирные изделия</strong> – Опыт цейлонских камней</li>
                <li><strong>Резьба по дереву</strong> – Традиционная резьба</li>
                <li><strong>Катание на слонах</strong> – Этичное взаимодействие</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Нувара Элия и Канди (Роскошный отель)</h3>`
                },
                '17': {
                    title: 'Элла/Нувара Элия/Канди/Сигирия культурный',
                    duration: '3 дня',
                    category: 'Культурное и пейзажное',
                    description: 'От туманных высокогорий до священных храмов — душевное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Малый пик Адама</strong> – Живописный поход</li>
                <li><strong>Поездка на поезде</strong> – Роскошная поездка на поезде</li>
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
                <li><strong>Индуистский храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Амбулувава</strong> – Спокойные прогулки</li>
                <li><strong>Ботанические сады</strong> – Тропический рай</li>
                <li><strong>Пидурангала</strong> – Живописный поход</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Золотой храм</strong> – Священное посещение</li>
                <li><strong>Львиная скала Сигирия</strong> – Древняя крепость</li>
                <li><strong>Деревенский тур с поездкой на лодке и традиционным обедом</strong> – Культурный опыт</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Нувара Элия и Сигирия (Роскошный отель)</h3>`
                },
                '18': {
                    title: 'Элла/Нувара Элия/Канди/Сигирия/Полоннарува культурный',
                    duration: '3 дня',
                    category: 'Культурное и пейзажное',
                    description: 'От туманных высокогорий до священных храмов — душевное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Малый пик Адама</strong> – Живописный поход</li>
                <li><strong>Поездка на поезде</strong> – Роскошная поездка на поезде</li>
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
                <li><strong>Индуистский храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Амбулувава</strong> – Спокойные прогулки</li>
                <li><strong>Ботанические сады</strong> – Тропический рай</li>
                <li><strong>Чайная фабрика</strong> – Опыт цейлонского чая</li>
                <li><strong>Катание на слонах</strong> – Этичное взаимодействие</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> – Объект всемирного наследия ЮНЕСКО</li>
                <li><strong>Тур по древнему городу Полоннарува</strong> – Культурный город</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Канди и Сигирия (Роскошный отель)</h3>`
                },
                '19': {
                    title: 'Яла/Элла/Нувара Элия/Канди/Полоннарува культурный',
                    duration: '4 дня',
                    category: 'Культурное и пейзажное',
                    description: 'От туманных высокогорий до священных храмов — душевное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Сафари в национальном парке Яла</strong> – Утренний джип-тур</li>
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Малый пик Адама</strong> – Живописный поход</li>
                <li><strong>Поездка на поезде</strong> – Роскошная поездка на поезде</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
                <li><strong>Индуистский храм</strong> – Культурное посещение</li>
                <li><strong>Амбулувава</strong> – Спокойные прогулки</li>
                <li><strong>Королевские ботанические сады</strong> – Тропический рай</li>
                <li><strong>Чайная фабрика</strong> – Опыт цейлонского чая</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Неллигала</strong> – Священное посещение</li>
                <li><strong>Фабрика ювелирных изделий и драгоценных камней</strong> – Сверкающее мастерство</li>
                <li><strong>Катание на слонах</strong> – Этичное взаимодействие</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> – Объект всемирного наследия ЮНЕСКО</li>
                <li><strong>Тур по древнему городу Полоннарува</strong> – Культурный город</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Элла, Нувара Элия и Канди (Роскошный отель)</h3>`
                },
                '20': {
                    title: 'Яла/Элла/Нувара Элия/Канди/Сигирия/Полоннарува/Анурадхапура культурный',
                    duration: '5 дней',
                    category: 'Культурное и пейзажное',
                    description: 'От туманных высокогорий до священных храмов — душевное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Сафари в национальном парке Яла</strong> – Утренний джип-тур</li>
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Малый пик Адама</strong> – Живописный поход</li>
                <li><strong>Поездка на поезде</strong> – Роскошная поездка на поезде</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
                <li><strong>Индуистский храм</strong> – Культурное посещение</li>
                <li><strong>Амбулувава</strong> – Спокойные прогулки</li>
                <li><strong>Королевские ботанические сады</strong> – Тропический рай</li>
                <li><strong>Чайная фабрика</strong> – Опыт цейлонского чая</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Неллигала</strong> – Священное посещение</li>
                <li><strong>Фабрика ювелирных изделий и драгоценных камней</strong> – Сверкающее мастерство</li>
                <li><strong>Катание на слонах</strong> – Этичное взаимодействие</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> – Объект всемирного наследия ЮНЕСКО</li>
                <li><strong>Тур по древнему городу Полоннарува</strong> – Культурный город</li>
            </ul>
            <h3 class="mt-4">День 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Тур по древнему городу Анурадхапура</strong> – Историческое исследование</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Сигирия, Нувара Элия и Канди (Роскошный отель)</h3>`
                },
                '21': {
                    title: 'Яла/Элла/Нувара Элия/Канди/Сигирия/Полоннарува/Коломбо культурный',
                    duration: '5 дней',
                    category: 'Культурное и пейзажное',
                    description: 'От туманных высокогорий до священных храмов — душевное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Сафари в национальном парке Яла</strong> – Утренний джип-тур</li>
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Малый пик Адама</strong> – Живописный поход</li>
                <li><strong>Поездка на поезде</strong> – Роскошная поездка на поезде</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
                <li><strong>Индуистский храм</strong> – Культурное посещение</li>
                <li><strong>Амбулувава</strong> – Спокойные прогулки</li>
                <li><strong>Королевские ботанические сады</strong> – Тропический рай</li>
                <li><strong>Чайная фабрика</strong> – Опыт цейлонского чая</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Неллигала</strong> – Священное посещение</li>
                <li><strong>Фабрика ювелирных изделий и драгоценных камней</strong> – Сверкающее мастерство</li>
                <li><strong>Катание на слонах</strong> – Этичное взаимодействие</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> – Объект всемирного наследия ЮНЕСКО</li>
                <li><strong>Тур по древнему городу Полоннарува</strong> – Культурный город</li>
            </ul>
            <h3 class="mt-4">День 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Тур по городу Коломбо</strong> – Городское исследование</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Нувара Элия, Сигирия, Полоннарува и Канди (Роскошный отель)</h3>`
                },
                '22': {
                    title: 'Яла/Элла/Нувара Элия/Канди/Сигирия/Полоннарува/Галле культурный',
                    duration: '5 дней',
                    category: 'Культурное и пейзажное',
                    description: 'От туманных высокогорий до священных храмов — душевное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Сафари в национальном парке Яла</strong> – Утренний джип-тур</li>
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Малый пик Адама</strong> – Живописный поход</li>
                <li><strong>Поездка на поезде</strong> – Роскошная поездка на поезде</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
                <li><strong>Индуистский храм</strong> – Культурное посещение</li>
                <li><strong>Амбулувава</strong> – Спокойные прогулки</li>
                <li><strong>Королевские ботанические сады</strong> – Тропический рай</li>
                <li><strong>Чайная фабрика</strong> – Опыт цейлонского чая</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Неллигала</strong> – Священное посещение</li>
                <li><strong>Фабрика ювелирных изделий и драгоценных камней</strong> – Сверкающее мастерство</li>
                <li><strong>Катание на слонах</strong> – Этичное взаимодействие</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> – Объект всемирного наследия ЮНЕСКО</li>
                <li><strong>Тур по древнему городу Полоннарува</strong> – Культурный город</li>
            </ul>
            <h3 class="mt-4">День 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Город Галле</strong> – Колониальное исследование</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Нувара Элия, Сигирия, Полоннарува и Галле (Роскошный отель)</h3>`
                },
                '23': {
                    title: 'Элла/Нувара Элия/Канди/Сигирия/Полоннарува/Анурадхапура/Коломбо',
                    duration: '6 дней',
                    category: 'Культурное и пейзажное',
                    description: 'От туманных высокогорий до священных храмов — душевное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Малый пик Адама</strong> – Живописный поход</li>
                <li><strong>Поездка на поезде</strong> – Роскошная поездка на поезде</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
                <li><strong>Индуистский храм</strong> – Культурное посещение</li>
                <li><strong>Амбулувава</strong> – Спокойные прогулки</li>
                <li><strong>Королевские ботанические сады</strong> – Тропический рай</li>
                <li><strong>Чайная фабрика</strong> – Опыт цейлонского чая</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Неллигала</strong> – Священное посещение</li>
                <li><strong>Фабрика ювелирных изделий и драгоценных камней</strong> – Сверкающее мастерство</li>
                <li><strong>Катание на слонах</strong> – Этичное взаимодействие</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> – Объект всемирного наследия ЮНЕСКО</li>
                <li><strong>Тур по древнему городу Полоннарува</strong> – Культурный город</li>
            </ul>
            <h3 class="mt-4">День 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Тур по древнему городу Анурадхапура</strong> – Историческое исследование</li>
            </ul>
            <h3 class="mt-4">День 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Тур по городу Коломбо</strong> – Городское исследование</li>
                <li><strong>Город Галле</strong> – Колониальное исследование</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Элла, Нувара Элия, Сигирия (Роскошный отель)</h3>`
                },
                '24': {
                    title: 'Элла/Нувара Элия/Канди/Сигирия/Полоннарува/Анурадхапура/Коломбо',
                    duration: '6 дней',
                    category: 'Культурное и пейзажное',
                    description: 'От туманных высокогорий до священных храмов — душевное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Малый пик Адама</strong> – Живописный поход</li>
                <li><strong>Поездка на поезде</strong> – Роскошная поездка на поезде</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
                <li><strong>Индуистский храм</strong> – Культурное посещение</li>
                <li><strong>Амбулувава</strong> – Спокойные прогулки</li>
                <li><strong>Королевские ботанические сады</strong> – Тропический рай</li>
                <li><strong>Чайная фабрика</strong> – Опыт цейлонского чая</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Неллигала</strong> – Священное посещение</li>
                <li><strong>Фабрика ювелирных изделий и драгоценных камней</strong> – Сверкающее мастерство</li>
                <li><strong>Катание на слонах</strong> – Этичное взаимодействие</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> – Объект всемирного наследия ЮНЕСКО</li>
                <li><strong>Тур по древнему городу Полоннарува</strong> – Культурный город</li>
            </ul>
            <h3 class="mt-4">День 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Тур по древнему городу Анурадхапура</strong> – Историческое исследование</li>
            </ul>
            <h3 class="mt-4">День 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Тур по городу Коломбо</strong> – Городское исследование</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Элла, Нувара Элия, Канди, Сигирия и Коломбо (Роскошный отель)</h3>`
                },
                '25': {
                    title: 'Элла/Нувара Элия/Канди/Сигирия/Полоннарува/Анурадхапура/Галле',
                    duration: '6 дней',
                    category: 'Культурное и пейзажное',
                    description: 'От туманных высокогорий до священных храмов — душевное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> – Быстрое купание</li>
                <li><strong>Мост с девятью арками</strong> – Переезд поезда</li>
                <li><strong>Малый пик Адама</strong> – Живописный поход</li>
                <li><strong>Поездка на поезде</strong> – Роскошная поездка на поезде</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Чайная плантация</strong> – Виды с холмов</li>
                <li><strong>Индуистский храм</strong> – Культурное посещение</li>
                <li><strong>Амбулувава</strong> – Спокойные прогулки</li>
                <li><strong>Королевские ботанические сады</strong> – Тропический рай</li>
                <li><strong>Чайная фабрика</strong> – Опыт цейлонского чая</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Неллигала</strong> – Священное посещение</li>
                <li><strong>Фабрика ювелирных изделий и драгоценных камней</strong> – Сверкающее мастерство</li>
                <li><strong>Катание на слонах</strong> – Этичное взаимодействие</li>
                <li><strong>Золотой храм</strong> – Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> – Объект всемирного наследия ЮНЕСКО</li>
                <li><strong>Тур по древнему городу Полоннарува</strong> – Культурный город</li>
            </ul>
            <h3 class="mt-4">День 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Тур по древнему городу Анурадхапура</strong> – Историческое исследование</li>
            </ul>
            <h3 class="mt-4">День 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Город Галле</strong> – Колониальное исследование</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Ночевка в Элла, Нувара Элия, Канди, Сигирия и Галле (Роскошный отель)</h3>`
                },
            },

        },
    },
    pl: {
        translation: {
            home: 'Strona główna',
            aboutUs: 'O nas',
            sriLankanav: 'Sri Lanka',
            gallerynav: 'Galeria',
            bookATour: 'Zarezerwuj wycieczkę',
            thingsToDo: 'Atrakcje',
            contactUs: 'Kontakt',
        },
        // Polish (pl)
        contactus: {
            heroTitle: 'Skontaktuj się z nami',
            heroSubtitle: 'Star Lanka Tours Sri Lanka - Twoje drzwi do niezapomnianych przygód na Sri Lance',
            feelFree: 'Nie wahaj się z nami skontaktować',
            planDream: 'Zaplanuj swoją wymarzoną przygodę na Sri Lance',
            reachOutDesc: 'Skontaktuj się ze Star Lanka Tours Sri Lanka, aby uzyskać spersonalizowane pakiety wycieczek, fachowe porady i niezapomniane wrażenia z podróży po całej Sri Lance.',
            callCenter: 'Centrum obsługi',
            phone: '+94 76 805 1224', // ← Change to your real WhatsApp/call number
            emailTitle: 'E-mail',
            email: 'info@starlankatours.com', // ← Change to your real email   
            locationTitle: 'Nasza lokalizacja',
            location: 'Beruwala / Bentota, Sri Lanka', // ← Update to your actual address (e.g. if in Negombo like your location)
            socialTitle: 'Media społecznościowe',
            getInTouch: 'Skontaktuj się z nami',
            getInTouchDesc: 'Odkryj Sri Lankę z Star Lanka Tours Sri Lanka — jesteśmy dostępni 24/7, aby uczynić Twoją podróż niezapomnianą.',
            nameLabel: 'Imię',
            namePlaceholder: 'Twoje pełne imię',
            emailLabel: 'E-mail',
            emailPlaceholder: 'twoj@przyklad.com',
            phoneLabel: 'Numer telefonu',
            phonePlaceholder: '+94 7X XXX XXXX',
            messageLabel: 'Wiadomość',
            messagePlaceholder: 'Opowiedz nam o swojej wymarzonej podróży...',
            sendButton: 'Wyślij wiadomość',
            sendingButton: 'Wysyłanie...',
            successMsg: 'Twoje zapytanie zostało wysłane przez WhatsApp!',
            errorMsg: 'Nie udało się otworzyć WhatsApp. Proszę spróbuj ponownie.',
            findUsTitle: 'Znajdź nas na Sri Lance',
        },
        // Polish (pl)
        thingstodo: {
            heroTitle: 'Niezapomniane przeżycia na Sri Lance',
            heroSubtitle: 'Przygoda • Dziedzictwo • Natura • Wellness',

            sectionTitle: 'Najlepsze rzeczy do zrobienia i obowiązkowe aktywności',

            // Activity titles (used in cards)
            ayurveda: 'Autentyczne zabiegi ajurwedyjskie i wellness',
            diving: 'Nurkowanie klasy światowej',
            elephantRide: 'Jazda z łagodnymi olbrzymami',
            fishing: 'Tradycyjne i głębokomorskie wędkowanie',
            ballooning: 'Magiczny lot balonem na gorące powietrze',
            jeepSafari: 'Ekscytujące przygody safari jeepem',
            whiteWaterRafting: 'Rafting pełen adrenaliny',
            riverSafari: 'Piękna podróż safari po rzece',
            snorkeling: 'Żywe doświadczenie snorkelingu',
            teaTasting: 'Podróż i degustacja herbaty cejlońskiej',
            templeVisit: 'Odkrywanie starożytnych świątyń i świętych miejsc',
            wildlifeSafari: 'Big Five i spotkania z dziką przyrodą',

            viewMore: 'Zobacz więcej',
        },
        // Polish (pl)
        gallery: {
            heroTitle: 'Galeria',
            heroSubtitle: 'Uchwycone chwile, pielęgnowane wspomnienia — nasza galeria prezentuje przygody, uśmiechy i zapierające dech w piersiach widoki, które czynią każdą podróż po Sri Lance niezapomnianą',

            tabPlaces: 'Miejsca',
            tabEvents: 'Wydarzenia',

            // Image labels (used in alt text and overlay)
            nuwaraEliya: 'Nuwara Eliya',
            sigiriya: 'Sigiriya',
            anuradhapura: 'Anuradhapura',
            rambodaFalls: 'Wodospad Ramboda',
            ella: 'Ella',
            yala: 'Park Narodowy Yala',
            kandy: 'Kandy',
            bodhiViharaya: 'Bodhi Viharaya',
            knuckles: 'Góry Knuckles',
            udawalawe: 'Park Narodowy Udawalawe',
            bentota: 'Safari łodzią w Bentocie',
            colombo: 'Colombo',
            galle: 'Fort Galle',
            mirissa: 'Plaża Mirissa',
            jaffna: 'Jaffna',
            ambuluwawaTower: 'Wieża Ambuluwawa',
            turtle: 'Hodowla żółwi',
            polonnaruwa: 'Starożytne miasto Polonnaruwa',
            polgampala: 'Basen wodny Polgampala',
            beach: 'Plaże Sri Lanki',
        },
        // Polish (pl)
        events: {
            heroTitle: 'Wydarzenia',
            heroSubtitle: 'Świętujcie ducha Sri Lanki poprzez jej festiwale — od świętych buddyjskich ceremonii po kolorowe parady kulturalne, każde wydarzenie to szansa, by poczuć bicie serca wyspy.',

            tabPlaces: 'Miejsca',
            tabEvents: 'Wydarzenia',

            // Event names
            kandyPerahera: 'Kandy Esala Perahera (Festiwal Zęba)',
            vesak: 'Festiwal Vesak',
            sinhalaNewYear: 'Nowy Rok Singhaleski i Tamilski',
            christmas: 'Boże Narodzenie',
            thaiPongal: 'Thai Pongal',
            deepavali: 'Deepavali',
            holi: 'Holi',
            poson: 'Festiwal Poson',
        },
        ayurveda: {
            title: "Ajurweda - starożytna nauka o życiu",
            introParagraph1: "Słowo 'Ajurweda' istnieje od ponad trzech tysięcy lat. W sanskrycie oznacza 'naukę o życiu'. Technika opiera się na ajurwedyjskim podejściu do leczenia przyczyn chorób, a nie ich skutków, z którymi zazwyczaj mierzy się medycyna europejska. Zakłada następujące zasady:",
            corePrinciplesTitle: "Główne zasady",
            principle1: "Organizm powinien utrzymywać równowagę energetyczną dla prawidłowej przemiany materii i pracy serca.",
            principle2: "Organizm powinien mieć prawidłowe skurcze mięśni przy regularnej aktywności hormonalnej.",
            principle3: "Organizm potrzebuje zdrowego układu odpornościowego, aby działać prawidłowo.",
            sriLankaDoctors: "Według aktualnych danych w Sri Lance jest ponad 6000 wykwalifikowanych absolwentów ajurwedy. Przechodzą siedem lat nauki i dwa lata praktyki w publicznych szpitalach. Programy ajurwedy obejmują:",
            benefit1: "Usuwanie stresu, zmęczenia i lęku",
            benefit2: "Dotlenienie organizmu",
            benefit3: "Stymulację układu mięśniowego i eliminację toksyn",
            benefit4: "Przywrócenie równowagi układu nerwowego",
            benefit5: "Przywrócenie przepływu krwi do narządów wewnętrznych",
            benefit6: "Produkcję endorfin",
            mainImageAlt: "Ajurwedyjski wellness",
            faceTreatmentAlt: "Ajurwedyjski zabieg na twarz",
            faceTreatmentCaption: "Ajurwedyjski zabieg na twarz",
            massageTreatmentAlt: "Ajurwedyjski masaż",
            massageTreatmentCaption: "Ajurwedyjski masaż",
            treatmentDescription: "Standardowe zabiegi obejmują masaże ciała i skóry głowy specjalnymi olejami, saunę ziołową oraz kąpiele wzbogacone ziołami. Najpopularniejszą techniką jest 'procedura Shirodhara', w której ciepły olej ziołowy rytmicznie kapie na czoło. Pomaga to przywrócić równowagę układu nerwowego i osiągnąć relaks.",
            tipsTitle: "Wskazówki do zabiegów ajurwedy",
            tip1: "Odrzuć problemy. Zrelaksuj się i oczyść umysł dla najlepszych efektów.",
            tip2: "Wybierz odpowiednie miejsce. Postaw na otoczenie, które sprzyja Twojemu komfortowi i preferencjom.",
            tip3: "Dobierz właściwy program. Omów potrzeby z lekarzem i wypróbuj różne terapie, by znaleźć najlepszą.",
            tip4: "Weź ciepłą kąpiel przed zabiegiem, aby rozluźnić mięśnie i przygotować ciało.",
            tip5: "Zjedz lekki posiłek przed zabiegiem. Unikaj ciężkiego jedzenia, by zapewnić prawidłowy przepływ krwi podczas masażu.",
            tip6: "Odpoczynek po zabiegach jest kluczowy. Właściwe rozluźnienie zwiększa skuteczność terapii ajurwedyjskich."
        },
        ballooning: {
            title: "Lot balonem na Sri Lance",
            introParagraph1: "Loty balonem na Sri Lance to niezapomniane doświadczenie łagodnego unoszenia się nad zachwycającymi krajobrazami wyspy. Rozpoczynając o wschodzie słońca, loty oferują panoramiczne widoki na pagórki, bujne lasy, starożytne ruiny i spokojne wioski.",
            introParagraph2: "Najpopularniejszym miejscem lotów balonem jest Dambulla, w sercu kulturalnego trójkąta. Trasa często przebiega nad ikoniczną twierdzą skalną Sigiriya, dając wyjątkową perspektywę. Loty trwają zwykle 60-90 minut, co pozwala w pełni nacieszyć się pięknem Sri Lanki z powietrza.",
            mainImageAlt: "Lot balonem na Sri Lance",
            mainImageCaption: "Lot balonem na Sri Lance",
            highlightsTitle: "Dlaczego warto spróbować lotu balonem?",
            highlightsIntro: "Lot balonem łączy przygodę ze spokojem i pozwala doświadczyć piękna Sri Lanki w wyjątkowy sposób. Oto kilka najważniejszych atutów:",
            highlight1: "Nieprzerwane, panoramiczne widoki na oszałamiające krajobrazy wyspy.",
            highlight2: "Przelot nad kultowymi miejscami, jak skała Sigiriya i okoliczne jeziora.",
            highlight3: "Cicha, kojąca podróż nad zielenią i uroczymi wioskami.",
            highlight4: "Spektakularny wschód słońca oglądany z nieba.",
            highlight5: "Idealne dla miłośników fotografii pragnących uchwycić piękno z góry.",
            sunriseImageAlt: "Podziwiaj zachwycający wschód słońca, unosząc się delikatnie balonem.",
            sunriseImageCaption: "Podziwiaj zachwycający wschód słońca, unosząc się delikatnie balonem.",
            landscapeImageAlt: "Oglądaj zapierające dech krajobrazy Sri Lanki z góry, w tym pagórki i bujne lasy.",
            landscapeImageCaption: "Oglądaj zapierające dech krajobrazy Sri Lanki z góry, w tym pagórki i bujne lasy.",
            tipsTitle: "Wskazówki na niezapomniany lot",
            tip1: "Rezerwuj z wyprzedzeniem – loty zależą od pogody i miejsca szybko się zapełniają.",
            tip2: "Załóż wygodne ubranie i weź lekką kurtkę – poranki mogą być chłodne.",
            tip3: "Zabierz aparat lub telefon, by uchwycić widoki.",
            tip4: "Uważnie słuchaj instrukcji bezpieczeństwa pilota.",
            tip5: "Przyjedź punktualnie, by zobaczyć przygotowanie i napełnianie balonu – to fascynujący proces."
        },
        diving: {
            title: "Nurkowanie na Sri Lance",
            introParagraph1: "Szeroka rafa koralowa otacza wybrzeże Sri Lanki na głębokości 2–40 m. Ciepłe wody Oceanu Indyjskiego (27–30°C) i przejrzystość 15–35 m zapewniają świetne warunki do nurkowania i snorkelingu. Możesz odkrywać nieskończone, dziewicze rafy, stare wraki i fascynujące podwodne groty.",
            introParagraph2: "Północny wschód wyspy oferuje ponad 130 gatunków kolorowych korali – dom dla żółwi, błazenków, skrzydlic czy koników morskich. Odwiedź wraki przy podwodnych skałach i rafach, by przeżyć niezapomnianą przygodę. Dryfując w krystalicznej wodzie, zanurzasz się w historię Cejlonu.",
            mainImageAlt: "Nurkowanie na Sri Lance",
            mainImageCaption: "Nurkowanie na Sri Lance",
            facilitiesTitle: "Centra i najlepsze miejsca",
            facilitiesParagraph1: "Centra nurkowe są wyposażone w nowoczesny sprzęt renomowanych producentów. Certyfikowani instruktorzy PADI/CMAS dbają o bezpieczeństwo. Ośrodki na południowo-zachodnim wybrzeżu działają od połowy października do końca kwietnia, a na północno-wschodnim (Nilaveli, Trincomalee) od marca do października.",
            facilitiesParagraph2: "Rafy w okolicach Kalpitiya na zachodzie oraz wraki w Hikkaduwie to jedne z najpopularniejszych miejsc dla nurków.",
            coralImageAlt: "Odkrywaj barwne rafy koralowe pełne życia morskiego.",
            coralImageCaption: "Odkrywaj barwne rafy koralowe pełne życia morskiego.",
            shipwreckImageAlt: "Poznaj historyczne wraki statków i morską przeszłość Sri Lanki.",
            shipwreckImageCaption: "Poznaj historyczne wraki statków i morską przeszłość Sri Lanki.",
            tipsTitle: "Wskazówki dla nurków",
            tip1: "Wybierz sezon do lokalizacji: południowy zachód (X–IV) lub północny wschód (III–X).",
            tip2: "Upewnij się, że centrum jest certyfikowane i ma nowoczesny sprzęt.",
            tip3: "Słuchaj rad instruktora, zwłaszcza gdy zaczynasz.",
            tip4: "Szanuj życie morskie – nie dotykaj korali i nie płosz zwierząt.",
            tip5: "Weź wodoodporny aparat, by uchwycić podwodne piękno Sri Lanki."
        },
        elephantRide: {
            title: "Przejażdżka na słoniu",
            introParagraph1: "Trekking na słoniach to ekscytująca i niepowtarzalna atrakcja w Sri Lance. W rejonie Trójkąta Kulturalnego (Habarana, Sigiriya, Dambulla) możesz wybrać się na safari na słoniach. Ceny zaczynają się od ok. 30 USD za godzinę niezapomnianej przygody.",
            introParagraph2: "Przed wyruszeniem słonie są siodłane koszem dla 4–6 osób. Te łagodne olbrzymy prowadzą przez malownicze dżungle, brodzą w zalanych miejscach i mijają bujną roślinność. Zwykle idą powoli, byś mógł w pełni docenić otaczającą naturę, choć potrafią osiągnąć do 40 km/h.",
            mainImageAlt: "Przejażdżka na słoniu",
            mainImageCaption: "Przejażdżka na słoniu",
            highlightsTitle: "Atuty przejażdżki na słoniu",
            highlightsIntro: "Jazda na słoniu na Sri Lance to wyjątkowy sposób kontaktu z naturą i poznania krajobrazu. Oto kluczowe wrażenia:",
            highlight1: "Wędrówka przez gęste dżungle pełne egzotycznej roślinności i zwierząt.",
            highlight2: "Przekraczanie rzek i zalanych terenów z malowniczymi widokami.",
            highlight3: "Poznanie więzi między słoniami a kulturą Sri Lanki.",
            highlight4: "Relaks na wygodnym siodle, gdy słoń niesie cię przez różne tereny.",
            jungleImageAlt: "Zwiedzaj gęste dżungle i malownicze ścieżki na grzbiecie słonia.",
            jungleImageCaption: "Zwiedzaj gęste dżungle i malownicze ścieżki na grzbiecie słonia.",
            waterImageAlt: "Przekraczaj rzeki i ciesz się spokojem wody i roślinności.",
            waterImageCaption: "Przekraczaj rzeki i ciesz się spokojem wody i roślinności.",
            tipsTitle: "Wskazówki dla bezpiecznej i przyjemnej jazdy",
            tip1: "Ubierz wygodne ubrania i obuwie turystyczne.",
            tip2: "Stosuj się do poleceń przewodnika dla bezpieczeństwa.",
            tip3: "Upewnij się, że słonie są traktowane etycznie, a organizator dba o ich dobro.",
            tip4: "Zabierz aparat, by uchwycić krajobrazy i chwile.",
            tip5: "Szanuj słonie – unikaj działań, które mogą je stresować lub im szkodzić."
        },
        fishing: {
            title: "Wędkarstwo na Sri Lance",
            introParagraph1: "Sri Lanka, z rozległą linią brzegową i wieloma jeziorami oraz rzekami słodkowodnymi, oferuje wyjątkowe warunki do wędkarstwa. Niezależnie czy jesteś profesjonalistą, czy amatorem – znajdziesz tu coś dla siebie. Od dalekomorskich wypraw po tradycyjne łowienie na palach praktykowane przez lokalnych rybaków.",
            introParagraph2: "Popularne miejsca to południowe wybrzeże wokół Galle i Mirissy, laguna Negombo oraz spokojne wody Trincomalee. W zależności od preferencji możesz spróbować trollingu, wędkarstwa dennego czy muchowego.",
            mainImageAlt: "Wędkarstwo na Sri Lance",
            mainImageCaption: "Wędkarstwo na Sri Lance",
            experiencesTitle: "Wędkarskie doświadczenia na Sri Lance",
            experiencesIntro: "Wędkarstwo to nie tylko łowienie ryb – to zanurzenie w kulturę i tradycje wyspy. Wyjątkowe doświadczenia obejmują:",
            expStiltTitle: "Łowienie na palach",
            expStiltDesc: "Tradycyjna metoda, w której rybacy siedzą na palach blisko brzegu – unikalna dla Sri Lanki.",
            expDeepSeaTitle: "Połów dalekomorski",
            expDeepSeaDesc: "Wyprawa na Ocean Indyjski za marlina, tuńczykiem, barakudą i innymi dużymi rybami.",
            expLagoonTitle: "Połów w lagunach i rzekach",
            expLagoonDesc: "Relaksujące łowienie w spokojnych lagunach i rzekach pełnych tilapii czy suma.",
            expNightTitle: "Nocne wędkowanie",
            expNightDesc: "Emocje łowienia pod gwiazdami, popularne w nadmorskich wioskach.",
            stiltImageAlt: "Łowienie na palach – ikona rybackiego dziedzictwa Sri Lanki.",
            stiltImageCaption: "Łowienie na palach to tradycyjna metoda i ikona rybackiego dziedzictwa Sri Lanki.",
            deepSeaImageAlt: "Połów dalekomorski to przygoda i celowanie w duże gatunki w Oceanie Indyjskim.",
            deepSeaImageCaption: "Połów dalekomorski to przygoda i celowanie w duże gatunki w Oceanie Indyjskim.",
            tipsTitle: "Wskazówki na udaną wyprawę",
            tip1: "Dobierz sezon: X–IV dla południa, III–X dla wschodu.",
            tip2: "Zabierz krem z filtrem, kapelusz i ochronne ubranie, by czuć się komfortowo.",
            tip3: "Zarezerwuj przewodnika lub czarter, by w pełni skorzystać i uczyć się od ekspertów.",
            tip4: "Szanuj środowisko – nie śmieć i stosuj zrównoważone praktyki.",
            tip5: "Nawadniaj się i zabierz przekąski na dłuższe wyprawy."
        },
        jeepSafari: {
            title: "Safari jeepem na Sri Lance",
            introParagraph1: "Parki narodowe Sri Lanki oferują ekscytujące safari jeepem, pozwalając odkrywać bogatą bioróżnorodność wyspy i obserwować zwierzęta w naturalnym środowisku. Najpopularniejsze to Yala, Wilpattu i Udawalawe.",
            introParagraph2: "Podczas safari możesz zobaczyć słonie, lamparty, niedźwiedzie wargacze, bawoły wodne, krokodyle i wiele gatunków ptaków. Z przewodnikami–przyrodnikami i tropicielami safari jeepem to idealna opcja dla miłośników przyrody i fotografii.",
            mainImageAlt: "Safari jeepem na Sri Lance",
            mainImageCaption: "Safari jeepem na Sri Lance",
            whyChooseTitle: "Dlaczego wybrać safari jeepem?",
            whyChooseIntro: "Safari jeepem to jeden z najlepszych sposobów na poznanie dzikiej przyrody Sri Lanki. Kluczowe atuty:",
            highlight1: "Bliskie spotkania z ikonami, jak słonie i lamparty.",
            highlight2: "Dostęp do odległych, malowniczych rejonów parków.",
            highlight3: "Szansa na fotografię dzikiej natury w naturalnym otoczeniu.",
            highlight4: "Prowadzenie przez doświadczonych przyrodników i strażników.",
            highlight5: "Przygoda dla wszystkich grup wiekowych, łącząca emocje i edukację.",
            wildlifeImageAlt: "Zobacz lamparty, słonie i krokodyle podczas safari.",
            wildlifeImageCaption: "Zobacz lamparty, słonie i krokodyle podczas safari.",
            landscapeImageAlt: "Odkrywaj krajobrazy parków – od gęstych lasów po otwarte równiny.",
            landscapeImageCaption: "Odkrywaj krajobrazy parków – od gęstych lasów po otwarte równiny.",
            tipsTitle: "Wskazówki na udane safari",
            tip1: "Załóż wygodne, stonowane kolory, by wtopić się w otoczenie.",
            tip2: "Weź krem z filtrem, kapelusz i repelent na owady.",
            tip3: "Zabierz lornetkę i aparat, by wzmocnić doświadczenie i zdjęcia.",
            tip4: "Stosuj się do poleceń przewodnika dla bezpieczeństwa i szacunku dla zwierząt.",
            tip5: "Rezerwuj wcześniej, szczególnie w sezonie, by zapewnić sobie miejsce."
        },
        riverSafari: {
            title: "Safari rzeczne na Sri Lance",
            introParagraph1: "Safari rzeczne to wyjątkowy sposób na poznanie bioróżnorodności i malowniczych krajobrazów wyspy. Płyniesz spokojnymi kanałami wśród mangrowców, obserwujesz egzotyczne zwierzęta i zachwycające zachody słońca.",
            introParagraph2: "Popularne miejsca to Madu Ganga i rzeka Bentota. Na trasie zobaczysz różnorodne ptaki, warany, krokodyle, a nawet małpy w naturalnym środowisku. Spokojna sceneria jest idealna dla miłośników natury i fotografów.",
            mainImageAlt: "Safari rzeczne na Sri Lance",
            mainImageCaption: "Safari rzeczne na Sri Lance",
            whyChooseTitle: "Dlaczego wybrać safari rzeczne?",
            whyChooseIntro: "To relaksujące i immersyjne doświadczenie łączące naturę, dziką faunę i lokalną kulturę. Kluczowe atuty:",
            highlight1: "Zwiedzanie bujnych mangrowców pełnych życia.",
            highlight2: "Spotkanie egzotycznych ptaków, krokodyli i innej fauny.",
            highlight3: "Wizyta na małych wyspach i w lokalnych wioskach.",
            highlight4: "Spokój i malowniczość wodnych szlaków Sri Lanki.",
            highlight5: "Idealne dla rodzin, par i solo podróżników szukających ciszy.",
            mangrovesImageAlt: "Odkrywaj mangrowce wzdłuż malowniczych szlaków wodnych.",
            mangrovesImageCaption: "Odkrywaj mangrowce wzdłuż malowniczych szlaków wodnych.",
            wildlifeImageAlt: "Zobacz krokodyle, warany i kolorowe ptaki podczas safari.",
            wildlifeImageCaption: "Zobacz krokodyle, warany i kolorowe ptaki podczas safari.",
            tipsTitle: "Wskazówki na udane safari rzeczne",
            tip1: "Załóż wygodne ubrania, weź kapelusz i krem z filtrem.",
            tip2: "Weź lornetkę, by wypatrzyć odległe ptaki i zwierzęta.",
            tip3: "Zabierz aparat lub telefon, by uchwycić krajobrazy i faunę.",
            tip4: "Stosuj się do zaleceń przewodnika dla bezpieczeństwa.",
            tip5: "Szanuj naturę – nie śmieć i nie niepokój zwierząt."
        },
        snorkeling: {
            title: "Snorkeling na Sri Lance",
            introParagraph1: "Snorkeling na Sri Lance to niezapomniane podwodne wrażenia wśród barwnych raf i bogatej fauny morskiej. Krystaliczne wody i bogate ekosystemy czynią wyspę rajem dla osób na każdym poziomie zaawansowania.",
            introParagraph2: "Popularne miejsca to Hikkaduwa z kolorowymi ogrodami koralowymi i żółwiami, Pigeon Island w Trincomalee z dziewiczymi rafami oraz Mirissa, gdzie w sezonie można nawet dostrzec walenie.",
            mainImageAlt: "Snorkeling na Sri Lance",
            mainImageCaption: "Snorkeling na Sri Lance",
            whyChooseTitle: "Dlaczego snorkeling na Sri Lance?",
            whyChooseIntro: "To magiczne połączenie przygody i naturalnego piękna. Atuty:",
            highlight1: "Zwiedzanie tętniących życiem raf koralowych.",
            highlight2: "Pływanie z kolorowymi rybami, żółwiami, a nawet rekinami rafowymi.",
            highlight3: "Odkrywanie dziewiczych podwodnych pejzaży w ciepłej, czystej wodzie.",
            highlight4: "Odpowiednie dla początkujących i zaawansowanych.",
            highlight5: "Dostępne z najlepszych plażowych destynacji Sri Lanki.",
            coralImageAlt: "Podziwiaj zachwycające rafy koralowe i ich ekosystemy.",
            coralImageCaption: "Podziwiaj zachwycające rafy koralowe i ich ekosystemy.",
            marineLifeImageAlt: "Spotkaj różnorodną faunę morską, w tym żółwie i ryby tropikalne.",
            marineLifeImageCaption: "Spotkaj różnorodną faunę morską, w tym żółwie i ryby tropikalne.",
            tipsTitle: "Wskazówki na świetny snorkeling",
            tip1: "Załóż wygodną maskę i fajkę dla dobrej widoczności.",
            tip2: "Używaj kremu przyjaznego rafom, by chronić skórę i środowisko.",
            tip3: "Pływaj delikatnie, by nie uszkodzić raf i nie stresować zwierząt.",
            tip4: "Nawadniaj się i rób przerwy między sesjami.",
            tip5: "Dołącz do wycieczki z przewodnikiem, by poznać najlepsze miejsca i zasady bezpieczeństwa."
        },
        teaTasting: {
            title: "Degustacja herbaty na Sri Lance",
            introParagraph1: "Sri Lanka, znana jako 'Perła Oceanu Indyjskiego', słynie z herbaty światowej klasy. Wybierz się na degustację i odkryj plantacje w Nuwara Eliya, Ella czy Kandy. Poznaj sztukę uprawy, proces produkcji i skosztuj bogatych smaków autentycznej herbaty cejlońskiej.",
            introParagraph2: "Niezależnie czy jesteś pasjonatem herbaty, czy po prostu ciekawym podróżnikiem, degustacja to wyjątkowa okazja, by zanurzyć się w herbacianym dziedzictwie Sri Lanki i doświadczyć spokoju górskich krajobrazów.",
            mainImageAlt: "Degustacja herbaty na Sri Lance",
            mainImageCaption: "Degustacja herbaty na Sri Lance",
            whyChooseTitle: "Dlaczego wybrać degustację herbaty?",
            whyChooseIntro: "To nie tylko próbowanie naparu – to pełne kulturowe zanurzenie. Atuty:",
            highlight1: "Wizyta na malowniczych plantacjach w chłodnych górach.",
            highlight2: "Poznanie historii i znaczenia herbaty cejlońskiej.",
            highlight3: "Udział w zbiorach i obserwacja procesu w fabrykach.",
            highlight4: "Degustacja różnych odmian – czarnych, zielonych i aromatyzowanych.",
            highlight5: "Podziwianie krajobrazów mglistych gór i wodospadów.",
            plantationImageAlt: "Zwiedzaj zielone plantacje i poznaj uprawę herbaty.",
            plantationImageCaption: "Zwiedzaj zielone plantacje i poznaj uprawę herbaty.",
            preparationImageAlt: "Odkryj sztukę parzenia i skosztuj autentycznej herbaty cejlońskiej.",
            preparationImageCaption: "Odkryj sztukę parzenia i skosztuj autentycznej herbaty cejlońskiej.",
            tipsTitle: "Wskazówki na udaną degustację",
            tip1: "Załóż wygodne ubrania i buty do spacerów po plantacjach.",
            tip2: "Weź lekką kurtkę – w górach bywa chłodno i mgliście.",
            tip3: "Spróbuj różnych rodzajów i zabierz ulubione jako pamiątkę.",
            tip4: "Zadawaj pytania podczas wizyty, by lepiej poznać proces.",
            tip5: "Połącz degustację z wizytą przy wodospadach i punktach widokowych."
        },
        templeVisit: {
            title: "Zwiedzanie świątyń na Sri Lance",
            introParagraph1: "Sri Lanka, znana jako kraina Buddy, pełna jest starożytnych świątyń odzwierciedlających bogate dziedzictwo duchowe i kulturowe. Odwiedź kultowe miejsca, takie jak Świątynia Zęba w Kandy, jaskinie Dambulla czy Ruwanwelisaya w Anuradhapurze.",
            introParagraph2: "Święte miejsca zdobione rzeźbami, freskami i posągami ukazują tradycje duchowe i kunszt architektoniczny wyspy. Wizyta to nie tylko doświadczenie kulturowe, ale też szansa na spokój i wyciszenie.",
            mainImageAlt: "Zwiedzanie świątyń na Sri Lance",
            mainImageCaption: "Zwiedzanie świątyń na Sri Lance",
            whyVisitTitle: "Dlaczego odwiedzać świątynie?",
            whyVisitIntro: "To wyjątkowa okazja, by połączyć się z historią, kulturą i duchowością wyspy. Kluczowe atuty:",
            highlight1: "Podziwianie misternych budowli i wielowiekowych posągów.",
            highlight2: "Poznanie tradycji i rytuałów buddyjskich z pomocą przewodników.",
            highlight3: "Zwiedzanie obiektów UNESCO, jak Złota Świątynia Dambulla.",
            highlight4: "Doświadczenie spokoju i duchowej atmosfery świętych miejsc.",
            highlight5: "Obserwacja barwnych festiwali, np. Esala Perahera w Świątyni Zęba.",
            interiorImageAlt: "Podziwiaj wnętrza zdobione rzeźbami i freskami.",
            interiorImageCaption: "Podziwiaj wnętrza zdobione rzeźbami i freskami.",
            sacredImageAlt: "Odwiedź święte świątynie, takie jak Ruwanwelisaya, i zanurz się w tradycjach.",
            sacredImageCaption: "Odwiedź święte świątynie, takie jak Ruwanwelisaya, i zanurz się w tradycjach.",
            tipsTitle: "Wskazówki przy odwiedzaniu świątyń",
            tip1: "Ubierz się skromnie, zakrywając ramiona i kolana.",
            tip2: "Zdejmij obuwie przed wejściem na teren świątyni.",
            tip3: "Nie dotykaj posągów ani świętych przedmiotów.",
            tip4: "Weź drobną ofiarę, jeśli chcesz wesprzeć świątynię.",
            tip5: "Szanuj ciszę i duchową atmosferę podczas wizyty."
        },
        whiteWaterRafting: {
            title: "Rafting górski na Sri Lance",
            introParagraph1: "Rafting na górskich rzekach Sri Lanki to ekscytujące przeżycie, zwłaszcza w Kitulgali – stolicy przygód wyspy. Rzeka Kelani z bystrzami i malowniczą scenerią jest idealna dla początkujących i doświadczonych.",
            introParagraph2: "Wyprawy obejmują zwykle 5 km odcinek z bystrzami w klasie 2–4. Uczestnicy doświadczą dreszczyku, pokonując nurt wśród zieleni i pięknych widoków brzegów.",
            mainImageAlt: "Rafting górski na Sri Lance",
            mainImageCaption: "Rafting górski na Sri Lance",
            whyChooseTitle: "Dlaczego rafting na Sri Lance?",
            whyChooseIntro: "To unikalne połączenie adrenaliny i natury. Kluczowe atuty:",
            highlight1: "Pokonywanie ekscytujących bystrzy pod opieką instruktorów.",
            highlight2: "Widoki na tropikalny las i górzyste tereny.",
            highlight3: "Możliwość połączenia z trekkingiem, birdwatchingiem czy canyoningiem w Kitulgali.",
            highlight4: "Idealne dla grup, rodzin i solo podróżników szukających adrenaliny.",
            actionImageAlt: "Poczuj adrenalinę, zdobywając bystrza na rzece Kelani.",
            actionImageCaption: "Poczuj adrenalinę, zdobywając bystrza na rzece Kelani.",
            scenicImageAlt: "Ciesz się spokojem zielonego otoczenia podczas raftingu.",
            scenicImageCaption: "Ciesz się spokojem zielonego otoczenia podczas raftingu.",
            tipsTitle: "Wskazówki na bezpieczny i emocjonujący spływ",
            tip1: "Noś kamizelkę i kask zapewnione przez przewodnika.",
            tip2: "Uważnie słuchaj instrukcji bezpieczeństwa przed startem.",
            tip3: "Załóż wygodne, szybko schnące ubrania i pewne obuwie (np. buty wodne).",
            tip4: "Zabierz ubrania na zmianę i ręcznik po spływie.",
            tip5: "Rezerwuj u sprawdzonego operatora dla bezpieczeństwa i dobrej jakości wyprawy."
        },
        wildlifeSafari: {
            title: "Safari przyrodnicze na Sri Lance",
            introParagraph1: "Sri Lanka, słynąca z bogatej bioróżnorodności, oferuje niesamowite safari w parkach Yala, Wilpattu, Minneriya czy Udawalawe. To szansa zobaczyć słonie, lamparty, niedźwiedzie wargacze i wiele gatunków ptaków w ich naturalnym środowisku.",
            introParagraph2: "Odkrywaj zróżnicowane krajobrazy – od gęstych lasów po otwarte sawanny – i uwiecznij niezapomniane chwile dzikiej natury w akcji. Z doświadczonymi przewodnikami i dobrze utrzymanymi jeepami safari to obowiązkowy punkt dla miłośników przyrody i adrenaliny.",
            mainImageAlt: "Safari przyrodnicze na Sri Lance",
            mainImageCaption: "Safari przyrodnicze na Sri Lance",
            whyChooseTitle: "Dlaczego safari przyrodnicze?",
            whyChooseIntro: "To wyjątkowa okazja, by obcować z naturą i poznać bogactwo gatunków wyspy. Atuty:",
            highlight1: "Obserwacja ikon, takich jak słonie, lamparty i krokodyle.",
            highlight2: "Zwiedzanie lasów, mokradeł i równin pełnych zwierząt.",
            highlight3: "Fotografia dzikiej przyrody w naturalnej scenerii.",
            highlight4: "Ekscytacja przy poszukiwaniu rzadkiego lamparta cejlońskiego.",
            highlight5: "Wiedza o ochronie przyrody od doświadczonych przewodników.",
            elephantsImageAlt: "Zobacz majestatyczne słonie swobodnie wędrujące po parkach.",
            elephantsImageCaption: "Zobacz majestatyczne słonie swobodnie wędrujące po parkach.",
            leopardImageAlt: "Wypatrz rzadkiego lamparta cejlońskiego – gwiazdę safari.",
            leopardImageCaption: "Wypatrz rzadkiego lamparta cejlońskiego – gwiazdę safari.",
            tipsTitle: "Wskazówki na ekscytujące safari",
            tip1: "Ubierz się w neutralne kolory, by nie zwracać uwagi zwierząt.",
            tip2: "Weź krem z filtrem, kapelusz i repelent.",
            tip3: "Zabierz lornetkę i aparat, by wypatrywać i fotografować faunę.",
            tip4: "Słuchaj wskazówek przewodnika dla bezpieczeństwa i poszanowania przyrody.",
            tip5: "Rezerwuj z wyprzedzeniem, zwłaszcza w sezonie, by mieć pewne miejsce."
        },
        // Polish (pl)
        srilanka: {
            heroTitle: 'Odkryj Sri Lankę',
            heroSubtitle: 'Perła Oceanu Indyjskiego',

            sectionPlaces: 'Atrakcyjne miejsca na Sri Lance',
            sectionFamous: 'Słynne rzeczy na Sri Lance',
            viewMore: 'Zobacz więcej',

            // Intro paragraphs
            intro1: 'Sri Lanka, znana jako "Szmaragdowa Wyspa", to tropikalny klejnot słynący z oszałamiających krajobrazów, starożytnego dziedzictwa i serdecznej gościnności.',
            intro2: 'Z dziedzictwem ponad dwóch tysiącleci Sri Lanka jest domem dla obiektów UNESCO, takich jak skalna forteca Sigiriya i święte miasto Anuradhapura. Jej bogactwo kulturowe łączy wpływy buddyjskie, hinduistyczne i kolonialne, widoczne w żywych festiwalach i misternych budowlach.',
            intro3: 'Różnorodny teren wyspy zachwyca — od falujących plantacji herbaty w Ella po turkusowe wody Trincomalee. Parki narodowe jak Wilpattu zamieszkują lamparty, krokodyle i rzadkie gatunki ptaków, zachwycając miłośników przyrody.',
            intro4: 'Dla poszukiwaczy wrażeń Sri Lanka oferuje rafting, surfing w Arugam Bay i trekking przez bujne dżungle. Kuchnia, nasycona aromatycznymi przyprawami, świeżą rybą i chlebowcem, opowiada historię tradycji i smaku.',
            intro5: 'Od świętych pielgrzymek po spokojne plażowe ucieczki Sri Lanka obiecuje urzekające doświadczenie pełne piękna i kultury.',

            // Place names & descriptions
            sigiriya: 'Forteca skalna Sigiriya',
            sigiriyaDesc: 'Obiekt UNESCO z antycznymi ogrodami, freskami i zapierającymi dech widokami z szczytu.',

            templeOfTooth: 'Świątynia Zęba',
            templeOfToothDesc: 'Święte miejsce buddyjskie przechowujące relikwię zęba Buddy.',

            ella: 'Ella',
            ellaDesc: 'Miasteczko górskie otoczone plantacjami herbaty, słynne z Mostu Dziewięciu Łuków.',

            yala: 'Park Narodowy Yala',
            yalaDesc: 'Słynny z słoni, lampartów i safari przyrodniczego.',

            galleFort: 'Fort Galle',
            galleFortDesc: 'Kolonialny fort z brukowanymi ulicami i holenderską architekturą.',

            nuwaraEliya: 'Nuwara Eliya',
            nuwaraEliyaDesc: 'Znana jako "Mała Anglia" z chłodnym klimatem i plantacjami herbaty.',

            adamsPeak: 'Szczyt Adama',
            adamsPeakDesc: 'Święta góra z unikalnym odciskiem stopy, miejsce pielgrzymek.',

            hortonPlains: 'Horton Plains',
            hortonPlainsDesc: 'Falujące wzgórza, wodospady i punkt widokowy World’s End.',

            bentota: 'Plaża Bentota',
            bentotaDesc: 'Nietknięte wybrzeże ze złotymi piaskami i sportami wodnymi.',

            jaffna: 'Jaffna',
            jaffnaDesc: 'Bogata w tamilską kulturę, historię i kuchnię.',

            anuradhapura: 'Anuradhapura',
            anuradhapuraDesc: 'Starożytne miasto ze świętymi miejscami buddyjskimi i ruinami.',

            polonnaruwa: 'Polonnaruwa',
            polonnaruwaDesc: 'Obiekt UNESCO z dobrze zachowanymi świątyniami i posągami.',

            unawatuna: 'Plaża Unawatuna',
            unawatunaDesc: 'Żywa plaża ze snorkelingiem i życiem nocnym.',

            colombo: 'Colombo',
            colomboDesc: 'Tętniąca życiem stolica z nowoczesną i kolonialną architekturą.',

            udawalawe: 'Park Narodowy Udawalawe',
            udawalaweDesc: 'Słynny z dużych stad słoni i wspaniałych krajobrazów.',

            dambulla: 'Jaskiniowa Świątynia Dambulla',
            dambullaDesc: 'Obiekt UNESCO z antycznymi buddyjskimi malowidłami i posągami.',

            // Famous Things
            ceylonTea: 'Herbata Ceylon',
            ceylonTeaDesc: 'Światowej sławy ze względu na smak, zwłaszcza z Nuwara Eliya i Uva.',

            spices: 'Przyprawy',
            spicesDesc: 'Cynamon, kardamon, goździki — cynamon ze Sri Lanki jest najlepszy.',

            gems: 'Klejnoty',
            gemsDesc: 'Szafiry, rubiny, kamienie księżycowe — wyspa rzadkich klejnotów.',

            ayurveda: 'Ajurweda',
            ayurvedaDesc: 'Zabiegi wellness z masażami i terapiami ziołowymi.',

            handicrafts: 'Rękodzieło',
            handicraftsDesc: 'Maski, batik, rzeźby w drewnie, lakierowane wyroby.',

            elephants: 'Słonie',
            elephantsDesc: 'Symbol kulturowy, obecny w wielkich procesjach festiwalowych.',

            food: 'Tradycyjne jedzenie',
            foodDesc: 'Ryż z curry, hoppery, kottu roti, wattalappam.',

            festivals: 'Festiwale',
            festivalsDesc: 'Esala Perahera, Vesak, Nowy Rok Singhalesko-Tamilski.',

            coconut: 'Produkty kokosowe',
            coconutDesc: 'Olej, mleko, włókno coir na liny i maty.',

            sarees: 'Sari kandyańskie',
            sareesDesc: 'Elegancki tradycyjny strój na ceremonie.',

            dances: 'Tradycyjne tańce',
            dancesDesc: 'Tańce kandyańskie, diabelskie i nizinne.',

            stiltFishing: 'Rybactwo na palach',
            stiltFishingDesc: 'Ikoniczna technika rybacka na południowym wybrzeżu.',

            moonstones: 'Kamienie księżycowe',
            moonstonesDesc: 'Półszlachetne kamienie, słynne z kopalni w Meetiyagoda.',

            cricket: 'Krykiet',
            cricketDesc: 'Narodowa pasja — mistrzowie świata 1996.',

            herbs: 'Zioła ajurwedyjskie',
            herbsDesc: 'Gotu kola, cynamon, neem do remedium.',

            masks: 'Maski',
            masksDesc: 'Maski z Ambalangoda używane w rytualnych przedstawieniach.',
        },
        // Polish (pl)
        about: {
            hero: {
                discover: "ODKRYJ",
                starLankaTours: "STAR LANKA TOURS",
                tagline1: "Zobacz stare wielkie ruiny, zielone wzgórza herbaciane i ekscytujące safari z zwierzętami. Sri Lanka tętni życiem. Ta piękna wyspa to więcej niż miejsce do odwiedzenia — to wielkie przygodowe doświadczenie.",
                tagline2: "Słoneczne plaże, pochmurne góry i wiele niespodzianek czeka na Ciebie. Star Lanka Tours Sri Lanka czyni każdą minutę wyjątkową."
            },
            slider: {
                sigiriya: "Forteca skalna Sigiriya",
                yala: "Park Narodowy Yala",
                tea: "Kraina herbaty",
                beaches: "Czyste plaże",
                temples: "Święte świątynie"
            },
            about: {
                title: "O Star Lanka Tours Sri Lanka",
                signature: "Specjalne wycieczki po Sri Lance"
            },
            tours: {
                days4: "4 Dni",
                classic: "PODSTAWOWA WYCIECZKA",
                days5: "5 Dni",
                safari: "WYCIECZKI Z ZWIERZĘTAMI",
                days6: "6 Dni",
                retreat: "Spokojny wypoczynek",
                desc1: "Star Lanka Tours Sri Lanka pokazuje Ci każdą część tej pięknej wyspy — tętniące życiem miasta, mgliste wzgórza i czyste południowe plaże.",
                desc2: "Ciesz się najlepszym na Sri Lance — świętym Kandy, zabawnym Colombo i spokojnym południowym wybrzeżem.",
                desc3: "Chcesz przygód, starej kultury, zwierząt czy spokoju? Star Lanka Tours Sri Lanka tworzy świetne wycieczki o każdej porze roku."
            },
            whoWeAre: {
                title: "Kim jesteśmy",
                description: "<p>Witamy w Star Lanka Tours Sri Lanka — Twoim przyjacielu w podróżach po tej magicznej wyspie. Nasz szef to przewodnik Nethaj. Nasz przyjazny lokalny zespół tworzy wycieczki pokazujące prawdziwą Sri Lankę, nie tylko zwykłe miejsca turystyczne.</p><br /><p>Zabieramy Cię do starych miast, zielonych wzgórz herbacianych, słonecznych plaż i parków pełnych zwierząt. Każda wycieczka pozwala poczuć prawdziwą kulturę, życzliwych ludzi, stare zwyczaje i piękną naturę Sri Lanki.</p><br /><p>Chcesz kultury, przygód, odpoczynku, zdrowia czy specjalnej prywatnej wycieczki? Planujemy wszystko starannie, dajemy osobistą pomoc i zapewniamy szczęśliwe wspomnienia.</p>",
                imageAlt: "Zespół Star Lanka Tours",
                item1: { title: "Podróże po całej Sri Lance", text: "Jeździmy z północy na południe — prawdziwe lokalne doświadczenia wszędzie." },
                item2: { title: "Wycieczki dopasowane do Ciebie", text: "Planujemy wycieczkę pod Twoje upodobania — przygoda, kultura, natura czy odpoczynek." },
                item3: { title: "Dobrzy lokalni przewodnicy", text: "Nethaj i jego zespół znają wiele sekretnych miejsc, starych historii i prawdziwego ducha Sri Lanki." },
                item4: { title: "Pomoc non-stop", text: "Star Lanka Tours pomaga Ci 24 godziny na dobę podczas całej wycieczki." }
            },
            offers: {
                title: "Co oferujemy",
                cultural: { title: "Doświadczenie kultury", text: "Zobacz lokalne zwyczaje, festiwale i codzienne życie.", alt: "Doświadczenie kultury" },
                adventure: { title: "Wycieczki przygodowe", text: "Wędrówki, safari z zwierzętami, zabawy morskie i akcja w naturze.", alt: "Przygoda" },
                luxury: { title: "Komfort i luksus", text: "Ładne hotele, prywatne auta i specjalna obsługa.", alt: "Luksus" },
                wellness: { title: "Zdrowie i relaks", text: "Joga, Ajurweda i spokojne miejsca.", alt: "Relaks" }
            },
            guides: {
                title: "Nasi przewodnicy",
                text: "Nethaj to nasz główny operator wycieczek. Nasi wyszkoleni i radośni przewodnicy sprawiają, że Twoja wycieczka jest ekscytująca. Pokazują sekretne miejsca, stare historie i specjalne rzeczy na Sri Lance.",
                imageAlt: "Przewodnik Star Lanka Tours - Nethaj"
            },
            expert: {
                name: "Nethaj",
                role: "(Główny przewodnik i operator wycieczek)",
                bio: "Nethaj to serce Star Lanka Tours Sri Lanka. Bardzo dobrze zna Sri Lankę. Od plaż po wysokie wzgórza, zwierzęta po stare miejsca — tworzy wycieczki, których nigdy nie zapomnisz.",
                imageAlt: "Nethaj - Star Lanka Tours"
            },
            vehicles: {
                title: "Pojazdy wycieczkowe",
                text: "Star Lanka Tours Sri Lanka dba o Twoje bezpieczeństwo i komfort. Pod nadzorem Nethaja używamy nowoczesnych, klimatyzowanych i czystych samochodów na łatwe podróże po wyspie.",
                bookButton: "Zarezerwuj swoją wycieczkę",
                car: { title: "Samochód", text: "Dobry dla 2 lub 3 osób. Mały, oszczędny, idealny na krótkie trasy." },
                van: { title: "Van", text: "Dobry dla rodzin lub małych grup (do 6). Duży i wygodny na długie jazdy." },
                minibus: { title: "Minibus", text: "Dobry dla większych grup (8–12). Wygodne siedzenia i miejsce na bagaż." },
                luxury: { title: "Luksusowy samochód", text: "Bardzo komfortowe auta z miękkimi siedzeniami, Wi-Fi i prywatnym kierowcą." }
            },
            accommodations: {
                intro: "Odpoczywaj w ładnych hotelach 3-gwiazdkowych, 4-gwiazdkowych, 5-gwiazdkowych i specjalnych miejscach. Wybieramy je za spokój, piękno i komfort podczas Twojej wycieczki Star Lanka Tours.",
                item1: "Prywatne wille z dużymi basenami i relaksującymi widokami na morze.",
                item2: "Stylowe luksusowe hotele nad morzem z dobrą kuchnią.",
                item3: "Lodge w naturze z nowoczesnymi pokojami i widokami na dzikie zwierzęta.",
                item4: "Piękny dom w naturze z wspaniałymi widokami i zielonym designem."
            },
            notices: {
                title: "Darmowe dodatki",
                intro: "Star Lanka Tours Sri Lanka daje Ci te darmowe rzeczy na każdej wycieczce:",
                bike: { title: "Darmowy rower dla każdego gościa", text: "Jeździj swobodnie — dajemy rower każdej osobie." },
                fruits: { title: "Świeże owoce na koniec", text: "Zakończ wycieczkę miłym pakietem świeżych owoców." },
                meals: { title: "Darmowe posiłki na specjalne okazje", text: "Dołącz do lokalnych tradycji — dajemy darmowe posiłki podczas ceremonii karmienia pieniędzmi." }
            },
        },
        // Polish (pl)
        home: {
            common: { viewAll: "Zobacz wszystkie" },
            sections: {
                recommendations: { title: "Najlepsze miejsca", subtitle: "Nie wiesz, dokąd jechać? Pomagamy wybrać." },
                excursions: { title: "Nasze wycieczki", desc: "Wielodniowe wyjazdy — mieszanka starej kultury, natury i szczęśliwych wspomnień." },
                packages: { title: "Specjalne pakiety" },
                reviews: { title: "Co mówią goście", subtitle: "Prawdziwe słowa od osób, które podróżowały z nami" },
                gallery: { title: "Nasze zdjęcia", subtitle: "Piękne zdjęcia ze Sri Lanki — pełne zachwytu, zabawy i miłych chwil." }
            },
            recommendations: {
                sigiriya: { label: "Sigiriya", name: "Wielka stara skalna forteca wysoko nad ziemią." },
                udawalawa: { label: "Udawalawe", name: "Duże pola z wieloma wolnymi słoniami." },
                ella: { label: "Ella", name: "Mgliste wzgórza, ładna jazda pociągiem, wielkie widoki." },
                mirissa: { label: "Mirissa", name: "Żółte plaże, błękitne morze, idealne do obserwacji wielorybów." },
                nuwaraeliya: { label: "Nuwara Eliya", name: "Mnóstwo pól herbacianych i chłodne świeże powietrze." },
                kandy: { label: "Kandy", name: "Święte miasto z Świątynią Zęba." },
                galle: { label: "Galle", name: "Stary fort tuż przy morzu." },
                yala: { label: "Yala", name: "Duży park z lampartami, słoniami i wieloma zwierzętami." },
                anuradhapura: { label: "Anuradhapura", name: "Stare miejsce, gdzie zaczął się buddyzm, wielkie stupy." },
                polonnaruwa: { label: "Polonnaruwa", name: "Ruiny starego miasta sprzed wieków." }
            },
            excursions: {
                oneDay: { title: "1 Dzień – Sri Lanka w jeden dzień", des: "Jeden dzień pełen magii — od starych miejsc po słoneczne plaże." },
                twoDays: { title: "2 Dni – Wołanie natury", des: "Dwa dni w dzikiej naturze: safari, wzgórza herbaciane, dźwięki dżungli." },
                threeDays: { title: "3 Dni – Dusza i morze", des: "Trzy dni dla serca — poranne świątynie, wieczorne morze, prawdziwa kultura." },
                fourDays: { title: "4 Dni – Stare i spokojne", des: "Cztery dni starych cudów: wielkie forty, stare ulice, prawdziwe tradycje." },
                fiveDays: { title: "5 Dni – Serce Sri Lanki", des: "Pięć dni, by pokochać Sri Lankę — mgliste wzgórza po błękitne morze." },
                sixDays: { title: "6 Dni – Specjalna wycieczka", des: "Sześć dni pięknych rzeczy — święte miejsca, safari, spokojne zachody słońca." }
            },
            packages: {
                one: { title: "1 Dzień / 0 Nocy: Sri Lanka w jeden dzień", duration: "1 Dzień", desc: "Jeden wielki dzień — stare stupy, złote plaże, prawdziwe uczucie Sri Lanki.", category: "Szybki wyjazd" },
                two: { title: "2 Dni / 1 Noc: Wołanie natury", duration: "2 Dni", desc: "Dwa dni w naturze — nocne safari, zapach herbaty, życie dżungli.", category: "Dziki wyjazd" },
                three: { title: "3 Dni / 2 Noce: Dusza i morze", duration: "3 Dni", desc: "Trzy dni dla duszy — świątynie rano, spokojne morze wieczorem.", category: "Morze i duch" },
                four: { title: "4 Dni / 3 Noce: Stare i spokojne", duration: "4 Dni", desc: "Cztery dni starożytności — forty, stare miasta, prawdziwa kultura.", category: "Kulturowy wyjazd" },
                five: { title: "5 Dni / 4 Noce: Serce Sri Lanki", duration: "5 Dni", desc: "Pięć dni miłości do wyspy — wzgórza, błękitne morze, szczęśliwe chwile.", category: "Wyjazd miłosny" },
                six: { title: "6 Dni / 5 Nocy: Specjalna wycieczka", duration: "6 Dni", desc: "Sześć dni najlepszych rzeczy — święte miejsca, zwierzęta, piękne zachody.", category: "Najlepszy wyjazd" }
            },
            featured: {
                perahera: {
                    h2: "Obejrzyj to wielkie widowisko", h3: "Kandy Esala Perahera", h4: "(Festiwal Zęba)",
                    paragraph: `Jeden z największych buddyjskich festiwali w Azji. Co roku w Kandy ludzie oddają cześć Świętemu Zębowi. Słonie w pięknych strojach, głośne bębny, tancerze z ogniem i światła tworzą magiczną noc. Przyjedź zobaczyć to z <strong style="color: #166880;">Star Lanka Tours Sri Lanka</strong> — tutaj kultura żyje.`,
                    button: "Zobacz więcej"
                },
                safari: {
                    h2: "Wyrusz w dzicz", h3: "Wycieczki safari",
                    paragraph: `Sri Lanka ma jedne z najlepszych zwierząt w Azji. Zobacz rozległe tereny w <span style="color: #D5A44F; font-weight: 600;">Yala</span> i <span style="color: #D5A44F; font-weight: 600;">Udawalawe</span> lub jeziora w <span style="color: #D5A44F; font-weight: 600;">Wilpattu</span>. Spotkaj słonie, lamparty i mnóstwo ptaków. Podróżuj z <strong style="color: #166880;">Star Lanka Tours Sri Lanka</strong> — każde safari to nowa historia.`,
                    button: "Zobacz safari"
                }
            },
            gallery: {
                title: "Nasze zdjęcia", subtitle: "Ładne zdjęcia ze Sri Lanki — pełne zachwytu, zabawy i piękna.",
                alt1: "Wschód słońca nad Sigiriya Rock", alt2: "Słonie w Parku Narodowym Yala", alt3: "Pracownice herbaciane we mgle Nuwara Eliya",
                alt4: "Zachód słońca na plaży Mirissa", alt5: "Modlitwa w świątyni Kandy", alt6: "Stare ruiny w Polonnaruwa",
                alt7: "Wieloryby przy południowym wybrzeżu", alt8: "Przejazd pociągiem w wzgórzach Ella", alt9: "Fort Galle w wieczornym świetle",
                alt10: "Rybak w Negombo", alt11: "Pokaz tańca Kandyan", alt12: "Balon na gorące powietrze nad Dambullą"
            },
            cta: {
                title: "Star Lanka Tours Sri Lanka — Tworzymy szczęśliwe podróże",
                desc: "Każda podróż jest wyjątkowa — pełna kultury, zabawy i spokojnych chwil. Pozwól nam napisać Twoją historię w pięknej Sri Lance.",
                button: "Zacznij teraz",
                alt: "Stwórz swoją podróż"
            },
        },
        // Polish (pl)
        hero: {
            title: {
                line1: "Odkryj raj z",
                line2: "Star Lanka Tours",
                line3: "Sri Lanka"
            },
            subtitle: "Zanurz się w bujnych szmaragdowych dżunglach, skąpanych w słońcu złotych plażach, ponadczasowych starożytnych miastach i ekscytujących przygodach z dziką przyrodą —",
            subtitle2: "dopasowanych idealnie do Twoich marzeń.",

            cta: "Rozpocznij swoją przygodę",
            trust: "Uwielbiany przez podróżników z ponad 50 krajów • Doceniany przez czołowych ekspertów turystycznych na świecie"
        },
        // Polish (pl)
        footer: {
            brand: "Star Lanka Tours",

            nav: {
                home: "Strona główna",
                about: "O nas",
                explore: "Poznaj Sri Lankę",
                tours: "Pakiety wycieczek",
                gallery: "Galeria",
                events: "Specjalne wydarzenia",
                things: "Atrakcje",
                contact: "Kontakt"
            },

            contact: {
                title: "Twórzmy razem wspaniałe wspomnienia",
                address: "Beruwala Area,<br />Western Province, Sri Lanka",
                email: "info@starlankatours.com",          // ← change to your real email
                phone: "+94 76 805 1224"                   // ← change to your real phone/WhatsApp number
            },

            newsletter: {
                title: "Dołącz do naszej przygody",
                desc: "Otrzymuj jako pierwszy informacje o specjalnych ofertach, ukrytych miejscach i niesamowitych podróżach po Sri Lance.",
                placeholder: "Twój adres e-mail",
                subscribe: "Zapisz się"
            },

            tagline: "\"Nie wszyscy, którzy wędrują, są zgubieni…<br /><span class='text-[#96BA33] font-semibold'>niektórzy podróżują z Star Lanka Tours</span>\"",

            copyright: "Wszystkie prawa zastrzeżone.",
            developedBy: "Zaprojektowane przez"
        },
        tourpackages: {
            heroTitle: 'Nasze pakiety wycieczek',
            heroSubtitle: 'Odkryj Sri Lankę w jeden dzień — ręcznie dobrane przygody od <span class="text-[#009CE6] font-bold">Star Lanka Tours</span>',
            heroAlt: 'Star Lanka Tours Sri Lanka - Jednodniowe przygody',
            chooseAdventure: 'Wybierz swoją przygodę',
            packagesSubtitle: '25 starannie dobranych doświadczeń — od safari z dziką przyrodą po zanurzenie w kulturze.',
            viewDetails: 'Zobacz szczegóły',
            itineraryTitle: 'Program',
            bookViaWhatsApp: 'Zarezerwuj przez WhatsApp',
            whatsappMessage: 'Cześć Star Lanka Tours! Chciałbym zarezerwować: *{{title}}* ({{duration}})\n\nProszę o informacje o dostępności i cenach!',

            packages: {
                '1': {
                    title: 'Dzień przygody w Ella',
                    duration: '1 dzień',
                    category: 'Przyroda i przygoda',
                    description: 'Podróż przez mgliste wzgórza, kaskadowe wodospady i kultowe mosty — idealne połączenie emocji i spokoju.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wodospad Ravana</strong> – Pływanie w krystalicznych basenach</li>
                <li><strong>Most dziewięciu łuków</strong> – Kultowy przystanek na zdjęcia z pociągiem</li>
                <li><strong>Plantacja herbaty</strong> – Spacer wśród szmaragdowych wzgórz</li>
                <li><strong>Przejażdżka pociągiem</strong> – Malownicza trasa z Ella do Demodara</li>
                <li><strong>Mały Szczyt Adama</strong> – Panoramiczne widoki o wschodzie/zachodzie słońca</li>
                <li><strong>Karmienie słoni mlekiem w Udawalawe</strong> – Wzruszający moment z dziką przyrodą</li>
                <li><strong>Ogród ajurwedyjskich ziół</strong> – Poznaj starożytne sekrety zdrowia</li>
            </ul>`
                },
                '2': {
                    title: 'Ella i safari w Yala',
                    duration: '1 dzień',
                    category: 'Dzika przyroda i krajobrazy',
                    description: 'Od mglistych wyżyn po dziką sawannę — najlepsze z natury w jeden niezapomniany dzień.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wodospad Ravana</strong> – Orzeźwiający naturalny basen</li>
                <li><strong>Most dziewięciu łuków</strong> – Cud architektury</li>
                <li><strong>Plantacja herbaty</strong> – Malownicze spacery po wzgórzach</li>
                <li><strong>Mały Szczyt Adama</strong> – Wspaniałe widoki ze szczytu</li>
                <li><strong>Safari w Yala</strong> – Przygoda dżipem z lampartami i słoniami</li>
            </ul>`
                },
                '3': {
                    title: 'Dzień kulturalny w Kandy',
                    duration: '1 dzień',
                    category: 'Dziedzictwo i przyroda',
                    description: 'Zanurz się w świętych świątyniach, bujnych ogrodach i lokalnych tradycjach w sercu Sri Lanki.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Miasto Kandy</strong> – Tętniące życiem centrum kulturalne</li>
                <li><strong>Królewskie Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Fabryka herbaty i plantacja</strong> – Doświadczenie herbaty cejlońskiej</li>
                <li><strong>Karmienie, kąpiel i jazda na słoniach</strong> – Etyczna interakcja</li>
                <li><strong>Ogród ajurwedyjskich ziół</strong> – Wycieczka po naturalnym leczeniu</li>
                <li><strong>Wieża Ambuluwawa</strong> – 360° panoramiczny widok</li>
                <li><strong>Fabryka biżuterii i kamieni szlachetnych</strong> – Błyszczące rzemiosło</li>
                <li><strong>Fabryka jedwabiu</strong> – Tradycyjne tkactwo</li>
            </ul>`
                },
                '4': {
                    title: 'Święta podróż do Kandy',
                    duration: '1 dzień',
                    category: 'Duchowe i kulturalne',
                    description: 'Duchowy dzień poświęcenia, dziedzictwa i naturalnego piękna w świętym mieście Kandy.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Świątynia Relikwii Zęba Buddy</strong> – Święte miejsce buddyjskie</li>
                <li><strong>Fabryka herbaty i plantacja</strong> – Degustacja świeżej herbaty</li>
                <li><strong>Karmienie, kąpiel i jazda na słoniach</strong> – Delikatne giganty</li>
                <li><strong>Ogród ajurwedyjskich ziół</strong> – Mądrość wellness</li>
                <li><strong>Wieża Ambuluwawa</strong> – Spiralne wzniesienie do nieba</li>
                <li><strong>Fabryka biżuterii i kamieni szlachetnych</strong> – Lokalne klejnoty</li>
                <li><strong>Fabryka jedwabiu</strong> – Sztuka jedwabiu</li>
            </ul>`
                },
                '5': {
                    title: 'Dzień dziedzictwa w Sigiriya',
                    duration: '1 dzień',
                    category: 'Historia i przygoda',
                    description: 'Wspinaj się na starożytne skalne forty, odkrywaj złote jaskinie i skosztuj autentycznego życia wiejskiego.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Skała Lwa Sigiriya</strong> – Dziedzictwo światowe UNESCO</li>
                <li><strong>Złota Świątynia Dambulla</strong> – Starożytna sztuka jaskiniowa</li>
                <li><strong>Wycieczka wiejska</strong> – Wóz wołowy, katamaran, tradycyjny lunch</li>
                <li><strong>Ogród ajurwedyjskich ziół</strong> – Lecznicze rośliny</li>
                <li><strong>Skała Pidurangala</strong> – Najlepszy widok na Sigiriya</li>
            </ul>`
                },
                '6': {
                    title: 'Dziedzictwo przybrzeżne Galle',
                    duration: '1 dzień',
                    category: 'Historia i przyroda',
                    description: 'Spaceruj po kolonialnych fortach, przepływaj mangrowe rzeki i obserwuj ochronę żółwi morskich.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Świątynia Kande Viharaya</strong> – Gigantyczny posąg Buddy</li>
                <li><strong>Wylęgarnia żółwi</strong> – Wypuszczanie małych żółwi</li>
                <li><strong>Safari łodzią</strong> – Mangrowy las rzeki Madu</li>
                <li><strong>Kopalnia kamienia księżycowego</strong> – Doświadczenie wydobywania klejnotów</li>
                <li><strong>Holenderski Fort Galle</strong> – Miasto kolonialne UNESCO</li>
                <li><strong>Ogród ajurwedyjskich ziół</strong> – Naturalne środki</li>
            </ul>`
                },
                '7': {
                    title: 'Odkrycie miasta Colombo',
                    duration: '1 dzień',
                    category: 'Miejskie i kulturalne',
                    description: 'Odkryj nowoczesne zabytki, święte miejsca i tętniące życiem zakupy w tętniącej życiem stolicy Sri Lanki.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wieża Lotus</strong> – 360° widok na miasto</li>
                <li><strong>Czerwony Meczet</strong> – Oszałamiająca islamska architektura</li>
                <li><strong>Zakupy</strong> – Lokalne rynki i centra handlowe</li>
                <li><strong>Ogród ajurwedyjskich ziół</strong> – Przystanek wellness</li>
                <li><strong>Świątynia Gangaramaya</strong> – Święta miejska oaza</li>
            </ul>`
                },
                '8': {
                    title: 'Dzikie safari w Yala',
                    duration: '1 dzień',
                    category: 'Dzika przyroda',
                    description: 'Tropij lamparty, słonie i rzadkie ptaki w jednym z najlepszych parków narodowych Azji.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari dżipem w Yala</strong> – 3-godzinna przygoda z dziką przyrodą</li>
                <li>Spotkaj lamparty, słonie, niedźwiedzie leniwe i ponad 200 gatunków ptaków</li>
            </ul>`
                },
                '9': {
                    title: 'Odyseą wielorybów w Mirissa',
                    duration: '1 dzień',
                    category: 'Przygody morskie',
                    description: 'Żegluj z błękitnymi wielorybami w łodziach o wysokim komforcie — największe stworzenia świata z bliska.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Obserwacja błękitnych wielorybów</strong> – 4-godzinne safari oceaniczne</li>
                <li><strong>Plaża Mirissa</strong> – Odpoczynek na złotych piaskach</li>
                <li><strong>Rybacy na szczudłach</strong> – Kultowy moment fotograficzny</li>
                <li><strong>Ogród ajurwedyjskich ziół</strong> – Nadmorskie wellness</li>
            </ul>`
                },
                '10': {
                    title: 'Dzień słoni w Udawalawe',
                    duration: '1 dzień',
                    category: 'Dzika przyroda i współczucie',
                    description: 'Obserwuj karmienie słoniąt i wędruj z dzikimi stadami w ich naturalnym środowisku.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Park Narodowy Udawalawe</strong> – Safari dżipem</li>
                <li><strong>Karmienie słoni mlekiem</strong> – Wizyta w sierocińcu</li>
            </ul>`
                },
                '11': {
                    title: 'Ekspres Ella i Galle',
                    duration: '1 dzień',
                    category: 'Krajobrazy i dziedzictwo',
                    description: 'Od górskich pociągów po kolonialne forty — szybka podróż pełna piękna i historii.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Przejażdżka pociągiem</strong> – Ella do Galle</li>
                <li><strong>Mały Szczyt Adama</strong> – Wędrówka o wschodzie słońca</li>
                <li><strong>Holenderski Fort Galle</strong> – Spacer o zachodzie słońca</li>
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
                <li><strong>Ogród ajurwedyjskich ziół</strong> – Przystanek wellness</li>
            </ul>`
                },
                '12': {
                    title: 'Safari Yala i Galle',
                    duration: '1 dzień',
                    category: 'Dzikie i kolonialne',
                    description: 'Poranne safari z dziką przyrodą, popołudniowy spacer po dziedzictwie — idealne połączenie południowego wybrzeża.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari w Parku Narodowym Yala</strong> – Poranny wycieczka dżipem</li>
                <li><strong>Holenderski Fort Galle</strong> – Popołudniowy spacer kolonialny</li>
            </ul>`
                },
                '13': {
                    title: 'Ekspres Kandy, Ella i Yala',
                    duration: '2 dni',
                    category: 'Kulturalne i krajobrazowe',
                    description: 'Od świętych świątyń po mgliste wzgórza i dzikie safari — wichrowa wycieczka po głównych atrakcjach Sri Lanki.',
                    itinerary: `<h3>Dzień 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari w Parku Narodowym Yala</strong> – Poranny wycieczka dżipem</li>
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Przejażdżka pociągiem</strong> – Luksusowa przejażdżka pociągiem</li>
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
            </ul>
            <h3 class="mt-4">Dzień 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Szybka wędrówka</li>
                <li><strong>Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Świątynia Relikwii Zęba Buddy</strong> – Święta wizyta</li>
                <li><strong>Jazda na słoniu</strong> – Etyczna interakcja</li>
                <li><strong>Fabryka herbaty</strong> – Doświadczenie herbaty cejlońskiej</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Kandy (Luksusowy hotel)</h3>`
                },
                '14': {
                    title: 'Kandy kulturalne',
                    duration: '2 dni',
                    category: 'Kulturalne',
                    description: 'Zanurz się w świętych świątyniach, bujnych ogrodach i lokalnych tradycjach w sercu Sri Lanki.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Miasto Kandy</strong> – Tętniące życiem centrum kulturalne</li>
                <li><strong>Królewskie Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Fabryka herbaty i plantacja</strong> – Doświadczenie herbaty cejlońskiej</li>
                <li><strong>Karmienie, kąpiel i jazda na słoniach</strong> – Etyczna interakcja</li>
                <li><strong>Ogród ajurwedyjskich ziół</strong> – Wycieczka po naturalnym leczeniu</li>
                <li><strong>Wieża Ambuluwawa</strong> – 360° panoramiczny widok</li>
                <li><strong>Fabryka biżuterii i kamieni szlachetnych</strong> – Błyszczące rzemiosło</li>
                <li><strong>Fabryka jedwabiu</strong> – Tradycyjne tkactwo</li>
                <li><strong>Nelligala</strong> – Tradycyjna świątynia</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Kandy (Luksusowy hotel)</h3>`
                },
                '15': {
                    title: 'Ella/Nuwara Eliya/Kandy kulturalne',
                    duration: '2 dni',
                    category: 'Kulturalne i krajobrazowe',
                    description: 'Od mglistych wyżyn do świętych świątyń — duchowa podróż przez serce Sri Lanki.',
                    itinerary: `<h3>Dzień 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Mały Szczyt Adama</strong> – Malownicza wędrówka</li>
                <li><strong>Przejażdżka pociągiem</strong> – Luksusowa przejażdżka pociągiem</li>
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
                <li><strong>Różowy Urząd Pocztowy</strong> – Kulturalne piękno</li>
                <li><strong>Ambuluwawa</strong> – Spokojne spacery</li>
            </ul>
            <h3 class="mt-4">Dzień 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Świątynia hinduistyczna</strong> – Kulturalna wizyta</li>
                <li><strong>Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Nelligala</strong> – Święta wizyta</li>
                <li><strong>Wodospad Ramboda</strong></li>
                <li><strong>Fabryka herbaty</strong> – Doświadczenie herbaty cejlońskiej</li>
                <li><strong>Jazda na słoniu</strong> – Etyczna interakcja</li>
                <li><strong>Ogród ziołowy</strong> – Tropikalny raj</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Kandy (Luksusowy hotel)</h3>`
                },
                '16': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy kulturalne',
                    duration: '3 dni',
                    category: 'Kulturalne i krajobrazowe',
                    description: 'Od mglistych wyżyn do świętych świątyń — duchowa podróż przez serce Sri Lanki.',
                    itinerary: `<h3>Dzień 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Mały Szczyt Adama</strong> – Malownicza wędrówka</li>
                <li><strong>Przejażdżka pociągiem</strong> – Luksusowa przejażdżka pociągiem</li>
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
                <li><strong>Świątynia hinduistyczna</strong> – Kulturalna wizyta</li>
                <li><strong>Safari w Parku Narodowym Yala</strong> – Poranny wycieczka dżipem</li>
            </ul>
            <h3 class="mt-4">Dzień 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Spokojne spacery</li>
                <li><strong>Różowy Urząd Pocztowy</strong> – Kulturalne piękno</li>
                <li><strong>Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Świątynia Relikwii Zęba Buddy</strong> – Święta wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Święta wizyta</li>
                <li><strong>Fabryka herbaty</strong> – Doświadczenie herbaty cejlońskiej</li>
                <li><strong>Klejnoty i biżuteria</strong> – Doświadczenie cejlońskich klejnotów</li>
                <li><strong>Rzeźba w drewnie</strong> – Tradycyjna rzeźba</li>
                <li><strong>Jazda na słoniu</strong> – Etyczna interakcja</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Nuwara Eliya i Kandy (Luksusowy hotel)</h3>`
                },
                '17': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya kulturalne',
                    duration: '3 dni',
                    category: 'Kulturalne i krajobrazowe',
                    description: 'Od mglistych wyżyn do świętych świątyń — duchowa podróż przez serce Sri Lanki.',
                    itinerary: `<h3>Dzień 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Mały Szczyt Adama</strong> – Malownicza wędrówka</li>
                <li><strong>Przejażdżka pociągiem</strong> – Luksusowa przejażdżka pociągiem</li>
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
                <li><strong>Świątynia hinduistyczna</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Spokojne spacery</li>
                <li><strong>Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Pidurangala</strong> – Malownicza wędrówka</li>
            </ul>
            <h3 class="mt-4">Dzień 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Złota Świątynia</strong> – Święta wizyta</li>
                <li><strong>Skała Lwa Sigiriya</strong> – Starożytna forteca</li>
                <li><strong>Wycieczka wiejska z przejażdżką łodzią i tradycyjnym lunchem</strong> – Doświadczenie kulturalne</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Nuwara Eliya i Sigiriya (Luksusowy hotel)</h3>`
                },
                '18': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa kulturalne',
                    duration: '3 dni',
                    category: 'Kulturalne i krajobrazowe',
                    description: 'Od mglistych wyżyn do świętych świątyń — duchowa podróż przez serce Sri Lanki.',
                    itinerary: `<h3>Dzień 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Mały Szczyt Adama</strong> – Malownicza wędrówka</li>
                <li><strong>Przejażdżka pociągiem</strong> – Luksusowa przejażdżka pociągiem</li>
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
                <li><strong>Świątynia hinduistyczna</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Spokojne spacery</li>
                <li><strong>Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Fabryka herbaty</strong> – Doświadczenie herbaty cejlońskiej</li>
                <li><strong>Jazda na słoniu</strong> – Etyczna interakcja</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Skała Lwa Sigiriya</strong> – Dziedzictwo światowe UNESCO</li>
                <li><strong>Wycieczka po starożytnym mieście Polonnaruwa</strong> – Miasto kulturalne</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Kandy i Sigiriya (Luksusowy hotel)</h3>`
                },
                '19': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Polonnaruwa kulturalne',
                    duration: '4 dni',
                    category: 'Kulturalne i krajobrazowe',
                    description: 'Od mglistych wyżyn do świętych świątyń — duchowa podróż przez serce Sri Lanki.',
                    itinerary: `<h3>Dzień 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari w Parku Narodowym Yala</strong> – Poranny wycieczka dżipem</li>
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Mały Szczyt Adama</strong> – Malownicza wędrówka</li>
                <li><strong>Przejażdżka pociągiem</strong> – Luksusowa przejażdżka pociągiem</li>
            </ul>
            <h3 class="mt-4">Dzień 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
                <li><strong>Świątynia hinduistyczna</strong> – Kulturalna wizyta</li>
                <li><strong>Ambuluwawa</strong> – Spokojne spacery</li>
                <li><strong>Królewskie Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Fabryka herbaty</strong> – Doświadczenie herbaty cejlońskiej</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Święta wizyta</li>
                <li><strong>Fabryka biżuterii i kamieni szlachetnych</strong> – Błyszczące rzemiosło</li>
                <li><strong>Jazda na słoniu</strong> – Etyczna interakcja</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Skała Lwa Sigiriya</strong> – Dziedzictwo światowe UNESCO</li>
                <li><strong>Wycieczka po starożytnym mieście Polonnaruwa</strong> – Miasto kulturalne</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Ella, Nuwara Eliya i Kandy (Luksusowy hotel)</h3>`
                },
                '20': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura kulturalne',
                    duration: '5 dni',
                    category: 'Kulturalne i krajobrazowe',
                    description: 'Od mglistych wyżyn do świętych świątyń — duchowa podróż przez serce Sri Lanki.',
                    itinerary: `<h3>Dzień 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari w Parku Narodowym Yala</strong> – Poranny wycieczka dżipem</li>
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Mały Szczyt Adama</strong> – Malownicza wędrówka</li>
                <li><strong>Przejażdżka pociągiem</strong> – Luksusowa przejażdżka pociągiem</li>
            </ul>
            <h3 class="mt-4">Dzień 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
                <li><strong>Świątynia hinduistyczna</strong> – Kulturalna wizyta</li>
                <li><strong>Ambuluwawa</strong> – Spokojne spacery</li>
                <li><strong>Królewskie Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Fabryka herbaty</strong> – Doświadczenie herbaty cejlońskiej</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Święta wizyta</li>
                <li><strong>Fabryka biżuterii i kamieni szlachetnych</strong> – Błyszczące rzemiosło</li>
                <li><strong>Jazda na słoniu</strong> – Etyczna interakcja</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Skała Lwa Sigiriya</strong> – Dziedzictwo światowe UNESCO</li>
                <li><strong>Wycieczka po starożytnym mieście Polonnaruwa</strong> – Miasto kulturalne</li>
            </ul>
            <h3 class="mt-4">Dzień 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wycieczka po starożytnym mieście Anuradhapura</strong> – Historyczne odkrywanie</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Sigiriya, Nuwara Eliya i Kandy (Luksusowy hotel)</h3>`
                },
                '21': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Colombo kulturalne',
                    duration: '5 dni',
                    category: 'Kulturalne i krajobrazowe',
                    description: 'Od mglistych wyżyn do świętych świątyń — duchowa podróż przez serce Sri Lanki.',
                    itinerary: `<h3>Dzień 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari w Parku Narodowym Yala</strong> – Poranny wycieczka dżipem</li>
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Mały Szczyt Adama</strong> – Malownicza wędrówka</li>
                <li><strong>Przejażdżka pociągiem</strong> – Luksusowa przejażdżka pociągiem</li>
            </ul>
            <h3 class="mt-4">Dzień 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
                <li><strong>Świątynia hinduistyczna</strong> – Kulturalna wizyta</li>
                <li><strong>Ambuluwawa</strong> – Spokojne spacery</li>
                <li><strong>Królewskie Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Fabryka herbaty</strong> – Doświadczenie herbaty cejlońskiej</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Święta wizyta</li>
                <li><strong>Fabryka biżuterii i kamieni szlachetnych</strong> – Błyszczące rzemiosło</li>
                <li><strong>Jazda na słoniu</strong> – Etyczna interakcja</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Skała Lwa Sigiriya</strong> – Dziedzictwo światowe UNESCO</li>
                <li><strong>Wycieczka po starożytnym mieście Polonnaruwa</strong> – Miasto kulturalne</li>
            </ul>
            <h3 class="mt-4">Dzień 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wycieczka po mieście Colombo</strong> – Odkrywanie miasta</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Nuwara Eliya, Sigiriya, Polonnaruwa i Kandy (Luksusowy hotel)</h3>`
                },
                '22': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Galle kulturalne',
                    duration: '5 dni',
                    category: 'Kulturalne i krajobrazowe',
                    description: 'Od mglistych wyżyn do świętych świątyń — duchowa podróż przez serce Sri Lanki.',
                    itinerary: `<h3>Dzień 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari w Parku Narodowym Yala</strong> – Poranny wycieczka dżipem</li>
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Mały Szczyt Adama</strong> – Malownicza wędrówka</li>
                <li><strong>Przejażdżka pociągiem</strong> – Luksusowa przejażdżka pociągiem</li>
            </ul>
            <h3 class="mt-4">Dzień 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
                <li><strong>Świątynia hinduistyczna</strong> – Kulturalna wizyta</li>
                <li><strong>Ambuluwawa</strong> – Spokojne spacery</li>
                <li><strong>Królewskie Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Fabryka herbaty</strong> – Doświadczenie herbaty cejlońskiej</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Święta wizyta</li>
                <li><strong>Fabryka biżuterii i kamieni szlachetnych</strong> – Błyszczące rzemiosło</li>
                <li><strong>Jazda na słoniu</strong> – Etyczna interakcja</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Skała Lwa Sigiriya</strong> – Dziedzictwo światowe UNESCO</li>
                <li><strong>Wycieczka po starożytnym mieście Polonnaruwa</strong> – Miasto kulturalne</li>
            </ul>
            <h3 class="mt-4">Dzień 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Miasto Galle</strong> – Odkrywanie kolonialne</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Nuwara Eliya, Sigiriya, Polonnaruwa i Galle (Luksusowy hotel)</h3>`
                },
                '23': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Colombo',
                    duration: '6 dni',
                    category: 'Kulturalne i krajobrazowe',
                    description: 'Od mglistych wyżyn do świętych świątyń — duchowa podróż przez serce Sri Lanki.',
                    itinerary: `<h3>Dzień 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Mały Szczyt Adama</strong> – Malownicza wędrówka</li>
                <li><strong>Przejażdżka pociągiem</strong> – Luksusowa przejażdżka pociągiem</li>
            </ul>
            <h3 class="mt-4">Dzień 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
                <li><strong>Świątynia hinduistyczna</strong> – Kulturalna wizyta</li>
                <li><strong>Ambuluwawa</strong> – Spokojne spacery</li>
                <li><strong>Królewskie Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Fabryka herbaty</strong> – Doświadczenie herbaty cejlońskiej</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Święta wizyta</li>
                <li><strong>Fabryka biżuterii i kamieni szlachetnych</strong> – Błyszczące rzemiosło</li>
                <li><strong>Jazda na słoniu</strong> – Etyczna interakcja</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Skała Lwa Sigiriya</strong> – Dziedzictwo światowe UNESCO</li>
                <li><strong>Wycieczka po starożytnym mieście Polonnaruwa</strong> – Miasto kulturalne</li>
            </ul>
            <h3 class="mt-4">Dzień 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wycieczka po starożytnym mieście Anuradhapura</strong> – Historyczne odkrywanie</li>
            </ul>
            <h3 class="mt-4">Dzień 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wycieczka po mieście Colombo</strong> – Odkrywanie miasta</li>
                <li><strong>Miasto Galle</strong> – Odkrywanie kolonialne</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Ella, Nuwara Eliya, Sigiriya (Luksusowy hotel)</h3>`
                },
                '24': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Colombo',
                    duration: '6 dni',
                    category: 'Kulturalne i krajobrazowe',
                    description: 'Od mglistych wyżyn do świętych świątyń — duchowa podróż przez serce Sri Lanki.',
                    itinerary: `<h3>Dzień 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Mały Szczyt Adama</strong> – Malownicza wędrówka</li>
                <li><strong>Przejażdżka pociągiem</strong> – Luksusowa przejażdżka pociągiem</li>
            </ul>
            <h3 class="mt-4">Dzień 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
                <li><strong>Świątynia hinduistyczna</strong> – Kulturalna wizyta</li>
                <li><strong>Ambuluwawa</strong> – Spokojne spacery</li>
                <li><strong>Królewskie Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Fabryka herbaty</strong> – Doświadczenie herbaty cejlońskiej</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Święta wizyta</li>
                <li><strong>Fabryka biżuterii i kamieni szlachetnych</strong> – Błyszczące rzemiosło</li>
                <li><strong>Jazda na słoniu</strong> – Etyczna interakcja</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Skała Lwa Sigiriya</strong> – Dziedzictwo światowe UNESCO</li>
                <li><strong>Wycieczka po starożytnym mieście Polonnaruwa</strong> – Miasto kulturalne</li>
            </ul>
            <h3 class="mt-4">Dzień 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wycieczka po starożytnym mieście Anuradhapura</strong> – Historyczne odkrywanie</li>
            </ul>
            <h3 class="mt-4">Dzień 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wycieczka po mieście Colombo</strong> – Odkrywanie miasta</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Ella, Nuwara Eliya, Kandy, Sigiriya i Colombo (Luksusowy hotel)</h3>`
                },
                '25': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Galle',
                    duration: '6 dni',
                    category: 'Kulturalne i krajobrazowe',
                    description: 'Od mglistych wyżyn do świętych świątyń — duchowa podróż przez serce Sri Lanki.',
                    itinerary: `<h3>Dzień 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wodospad Ravana</strong> – Szybka kąpiel</li>
                <li><strong>Most dziewięciu łuków</strong> – Przejazd pociągu</li>
                <li><strong>Mały Szczyt Adama</strong> – Malownicza wędrówka</li>
                <li><strong>Przejażdżka pociągiem</strong> – Luksusowa przejażdżka pociągiem</li>
            </ul>
            <h3 class="mt-4">Dzień 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Plantacja herbaty</strong> – Widoki ze wzgórz</li>
                <li><strong>Świątynia hinduistyczna</strong> – Kulturalna wizyta</li>
                <li><strong>Ambuluwawa</strong> – Spokojne spacery</li>
                <li><strong>Królewskie Ogrody Botaniczne</strong> – Tropikalny raj</li>
                <li><strong>Fabryka herbaty</strong> – Doświadczenie herbaty cejlońskiej</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Święta wizyta</li>
                <li><strong>Fabryka biżuterii i kamieni szlachetnych</strong> – Błyszczące rzemiosło</li>
                <li><strong>Jazda na słoniu</strong> – Etyczna interakcja</li>
                <li><strong>Złota Świątynia</strong> – Kulturalna wizyta</li>
            </ul>
            <h3 class="mt-4">Dzień 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Skała Lwa Sigiriya</strong> – Dziedzictwo światowe UNESCO</li>
                <li><strong>Wycieczka po starożytnym mieście Polonnaruwa</strong> – Miasto kulturalne</li>
            </ul>
            <h3 class="mt-4">Dzień 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Wycieczka po starożytnym mieście Anuradhapura</strong> – Historyczne odkrywanie</li>
            </ul>
            <h3 class="mt-4">Dzień 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Miasto Galle</strong> – Odkrywanie kolonialne</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Nocleg w Ella, Nuwara Eliya, Kandy, Sigiriya i Galle (Luksusowy hotel)</h3>`
                },
            },

        },
    },
    it: {
        translation: {
            home: 'Home',
            aboutUs: 'Chi siamo',
            sriLankanav: 'Sri Lanka',
            gallerynav: 'Galleria',
            bookATour: 'Prenota un tour',
            thingsToDo: 'Cose da fare',
            contactUs: 'Contattaci',
        },
        // Italian (it)
        contactus: {
            heroTitle: 'Contattaci',
            heroSubtitle: 'Star Lanka Tours Sri Lanka - La tua porta per avventure indimenticabili in Sri Lanka',
            feelFree: 'Non esitare a contattarci',
            planDream: 'Pianifica la tua avventura da sogno in Sri Lanka',
            reachOutDesc: 'Contatta Star Lanka Tours Sri Lanka per pacchetti tour personalizzati, consulenza esperta e esperienze di viaggio indimenticabili in tutto il Sri Lanka.',
            callCenter: 'Centro chiamate',
            phone: '+94 76 805 1224', // ← Change to your real WhatsApp/call number
            emailTitle: 'E-mail',
            email: 'info@starlankatours.com', // ← Change to your real email   
            locationTitle: 'La nostra posizione',
            location: 'Beruwala / Bentota, Sri Lanka', // ← Update to your actual address (e.g. if in Negombo like your location)
            socialTitle: 'Social media',
            getInTouch: 'Mettiti in contatto',
            getInTouchDesc: 'Esplora lo Sri Lanka con Star Lanka Tours Sri Lanka — siamo disponibili 24/7 per rendere il tuo viaggio indimenticabile.',
            nameLabel: 'Nome',
            namePlaceholder: 'Il tuo nome completo',
            emailLabel: 'E-mail',
            emailPlaceholder: 'tuo@esempio.com',
            phoneLabel: 'Numero di telefono',
            phonePlaceholder: '+94 7X XXX XXXX',
            messageLabel: 'Messaggio',
            messagePlaceholder: 'Raccontaci del tuo viaggio da sogno...',
            sendButton: 'Invia messaggio',
            sendingButton: 'Invio in corso...',
            successMsg: 'La tua richiesta è stata inviata tramite WhatsApp!',
            errorMsg: 'Impossibile aprire WhatsApp. Per favore riprova.',
            findUsTitle: 'Trova la nostra posizione in Sri Lanka',
        },
        // Italian (it)
        thingstodo: {
            heroTitle: 'Esperienze indimenticabili in Sri Lanka',
            heroSubtitle: 'Avventura • Patrimonio • Natura • Benessere',

            sectionTitle: 'Le cose da fare imperdibili e attività da non perdere',

            // Activity titles (used in cards)
            ayurveda: 'Trattamenti ayurvedici autentici e benessere',
            diving: 'Immersioni subacquee di classe mondiale',
            elephantRide: 'Cavalcare con i giganti gentili',
            fishing: 'Pesca tradizionale e in alto mare',
            ballooning: 'Magico volo in mongolfiera',
            jeepSafari: 'Avventure emozionanti in safari jeep',
            whiteWaterRafting: 'Rafting adrenalinico',
            riverSafari: 'Splendido viaggio safari fluviale',
            snorkeling: 'Esperienza di snorkeling vibrante',
            teaTasting: 'Viaggio e degustazione del tè di Ceylon',
            templeVisit: 'Esplorare antichi templi e siti sacri',
            wildlifeSafari: 'Big Five e incontri con la fauna selvatica',

            viewMore: 'Vedi di più',
        },
        // Italian (it)
        gallery: {
            heroTitle: 'Galleria',
            heroSubtitle: 'Momenti catturati, ricordi custoditi — la nostra galleria mostra le avventure, i sorrisi e le viste mozzafiato che rendono ogni viaggio in Sri Lanka indimenticabile',

            tabPlaces: 'Luoghi',
            tabEvents: 'Eventi',

            // Image labels (used in alt text and overlay)
            nuwaraEliya: 'Nuwara Eliya',
            sigiriya: 'Sigiriya',
            anuradhapura: 'Anuradhapura',
            rambodaFalls: 'Cascate Ramboda',
            ella: 'Ella',
            yala: 'Parco Nazionale Yala',
            kandy: 'Kandy',
            bodhiViharaya: 'Bodhi Viharaya',
            knuckles: 'Catena montuosa Knuckles',
            udawalawe: 'Parco Nazionale Udawalawe',
            bentota: 'Safari in barca a Bentota',
            colombo: 'Colombo',
            galle: 'Fortezza di Galle',
            mirissa: 'Spiaggia di Mirissa',
            jaffna: 'Jaffna',
            ambuluwawaTower: 'Torre di Ambuluwawa',
            turtle: 'Allevamento di tartarughe',
            polonnaruwa: 'Città antica di Polonnaruwa',
            polgampala: 'Piscina naturale Polgampala',
            beach: 'Spiagge dello Sri Lanka',
        },
        // Italian (it)
        events: {
            heroTitle: 'Eventi',
            heroSubtitle: 'Celebra lo spirito dello Sri Lanka attraverso i suoi festival — dalle sacre cerimonie buddiste alle colorate parate culturali, ogni evento è un\'occasione per vivere il battito del cuore dell\'isola.',

            tabPlaces: 'Luoghi',
            tabEvents: 'Eventi',

            // Event names
            kandyPerahera: 'Kandy Esala Perahera (La Festa del Dente)',
            vesak: 'Festa di Vesak',
            sinhalaNewYear: 'Capodanno Sinhala e Tamil',
            christmas: 'Natale',
            thaiPongal: 'Thai Pongal',
            deepavali: 'Deepavali',
            holi: 'Holi',
            poson: 'Festa di Poson',
        },
        // Italian (it)
        srilanka: {
            heroTitle: 'Scopri lo Sri Lanka',
            heroSubtitle: 'Perla dell\'Oceano Indiano',

            sectionPlaces: 'Luoghi affascinanti in Sri Lanka',
            sectionFamous: 'Cose famose in Sri Lanka',
            viewMore: 'Vedi di più',

            // Intro paragraphs
            intro1: 'Lo Sri Lanka, noto come "Isola di Smeraldo", è un gioiello tropicale celebrato per i suoi paesaggi mozzafiato, l\'antico patrimonio e l\'ospitalità sincera.',
            intro2: 'Con un\'eredità di oltre due millenni, lo Sri Lanka ospita siti UNESCO come la fortezza rocciosa di Sigiriya e la città sacra di Anuradhapura. La sua ricchezza culturale fonde influenze buddiste, induiste e coloniali, visibili nei vivaci festival e nell\'architettura intricata.',
            intro3: 'Il terreno diversificato dell\'isola incanta — dalle piantagioni di tè ondulate di Ella alle acque turchesi di Trincomalee. Parchi nazionali come Wilpattu ospitano leopardi, coccodrilli e specie di uccelli rare, deliziando gli amanti della natura.',
            intro4: 'Per gli amanti del brivido, lo Sri Lanka offre rafting in acque bianche, surf ad Arugam Bay e trekking attraverso giungle lussureggianti. La cucina, infusa di spezie aromatiche, pesce fresco e jackfruit, racconta una storia di tradizione e sapore.',
            intro5: 'Dalle sacre pellegrinazioni alle fughe serene in spiaggia, lo Sri Lanka promette un\'esperienza incantata intrisa di bellezza e cultura.',

            // Place names & descriptions
            sigiriya: 'Fortezza rocciosa di Sigiriya',
            sigiriyaDesc: 'Sito UNESCO con giardini antichi, affreschi e viste mozzafiato dalla cima.',

            templeOfTooth: 'Tempio del Dente',
            templeOfToothDesc: 'Sito buddista sacro che custodisce una reliquia del dente di Buddha.',

            ella: 'Ella',
            ellaDesc: 'Cittadina collinare circondata da piantagioni di tè, famosa per il Ponte dei Nove Archi.',

            yala: 'Parco Nazionale Yala',
            yalaDesc: 'Rinomato per elefanti, leopardi e safari naturalistici.',

            galleFort: 'Fortezza di Galle',
            galleFortDesc: 'Fortezza coloniale con strade acciottolate e architettura olandese.',

            nuwaraEliya: 'Nuwara Eliya',
            nuwaraEliyaDesc: 'Conosciuta come "Piccola Inghilterra" con clima fresco e piantagioni di tè.',

            adamsPeak: 'Picco di Adamo',
            adamsPeakDesc: 'Montagna sacra con un\'impronta unica, sito di pellegrinaggio.',

            hortonPlains: 'Horton Plains',
            hortonPlainsDesc: 'Colline ondulate, cascate e punto panoramico World’s End.',

            bentota: 'Spiaggia di Bentota',
            bentotaDesc: 'Costa incontaminata con sabbie dorate e sport acquatici.',

            jaffna: 'Jaffna',
            jaffnaDesc: 'Ricca di cultura tamil, storia e cucina.',

            anuradhapura: 'Anuradhapura',
            anuradhapuraDesc: 'Città antica con siti buddisti sacri e rovine.',

            polonnaruwa: 'Polonnaruwa',
            polonnaruwaDesc: 'Sito UNESCO con templi e statue ben conservati.',

            unawatuna: 'Spiaggia di Unawatuna',
            unawatunaDesc: 'Spiaggia vivace con snorkeling e vita notturna.',

            colombo: 'Colombo',
            colomboDesc: 'Capitale vivace con architettura moderna e coloniale.',

            udawalawe: 'Parco Nazionale Udawalawe',
            udawalaweDesc: 'Famoso per grandi mandrie di elefanti e paesaggi mozzafiato.',

            dambulla: 'Tempio delle Grotte di Dambulla',
            dambullaDesc: 'Sito UNESCO con antichi affreschi buddisti e statue.',

            // Famous Things
            ceylonTea: 'Tè di Ceylon',
            ceylonTeaDesc: 'Famoso in tutto il mondo per il suo sapore, specialmente da Nuwara Eliya e Uva.',

            spices: 'Spezie',
            spicesDesc: 'Cannella, cardamomo, chiodi di garofano — la cannella dello Sri Lanka è la migliore.',

            gems: 'Gemme',
            gemsDesc: 'Zaffiri, rubini, pietre di luna — isola di gemme rare.',

            ayurveda: 'Ayurveda',
            ayurvedaDesc: 'Trattamenti benessere con massaggi e terapie erboristiche.',

            handicrafts: 'Artigianato',
            handicraftsDesc: 'Maschere, batik, intagli in legno, lacche.',

            elephants: 'Elefanti',
            elephantsDesc: 'Simbolo culturale, protagonista nelle grandi processioni festive.',

            food: 'Cucina tradizionale',
            foodDesc: 'Riso e curry, hoppers, kottu roti, wattalappam.',

            festivals: 'Festival',
            festivalsDesc: 'Esala Perahera, Vesak, Capodanno Sinhala-Tamil.',

            coconut: 'Prodotti di cocco',
            coconutDesc: 'Olio, latte, fibra di coir per corde e stuoie.',

            sarees: 'Sari kandiano',
            sareesDesc: 'Elegante abito tradizionale per cerimonie.',

            dances: 'Danze tradizionali',
            dancesDesc: 'Danze kandiane, del diavolo e delle terre basse.',

            stiltFishing: 'Pesca su trampoli',
            stiltFishingDesc: 'Tecnica iconica di pesca sulla costa meridionale.',

            moonstones: 'Pietre di luna',
            moonstonesDesc: 'Gemme semipreziose, famose dalle miniere di Meetiyagoda.',

            cricket: 'Cricket',
            cricketDesc: 'Passione nazionale — vincitori della Coppa del Mondo 1996.',

            herbs: 'Erbe ayurvediche',
            herbsDesc: 'Gotu kola, cannella, neem per rimedi.',

            masks: 'Maschere',
            masksDesc: 'Maschere di Ambalangoda usate in performance rituali.',
        },
        // Italian (it)
        about: {
            hero: {
                discover: "SCOPRI",
                starLankaTours: "STAR LANKA TOURS",
                tagline1: "Vedi antiche grandi rovine, verdi colline del tè e safari emozionanti con animali. Lo Sri Lanka è pieno di vita. Questa bellissima isola è più di un posto da visitare — è una grande avventura.",
                tagline2: "Spiagge soleggiate, montagne nuvolose e tante sorprese ti aspettano. Star Lanka Tours Sri Lanka rende ogni minuto speciale."
            },
            slider: {
                sigiriya: "Fortezza rocciosa di Sigiriya",
                yala: "Parco Nazionale Yala",
                tea: "Terra del tè",
                beaches: "Spiagge pulite",
                temples: "Templi sacri"
            },
            about: {
                title: "Chi è Star Lanka Tours Sri Lanka",
                signature: "Viaggi speciali in Sri Lanka"
            },
            tours: {
                days4: "4 Giorni",
                classic: "VIAGGIO BASE",
                days5: "5 Giorni",
                safari: "VIAGGI ANIMALI",
                days6: "6 Giorni",
                retreat: "Riposo tranquillo",
                desc1: "Star Lanka Tours Sri Lanka ti mostra ogni parte di questa bellissima isola — città animate, colline nebbiose e spiagge pulite del sud.",
                desc2: "Goditi il meglio dello Sri Lanka — sacro Kandy, divertente Colombo e tranquilla costa sud.",
                desc3: "Vuoi avventura, antica cultura, animali o pace? Star Lanka Tours Sri Lanka crea viaggi fantastici in ogni periodo dell'anno."
            },
            whoWeAre: {
                title: "Chi siamo",
                description: "<p>Benvenuti in Star Lanka Tours Sri Lanka — il tuo amico per viaggiare in tutta quest'isola magica. Il nostro capo è la guida Nethaj. Il nostro team locale amichevole crea viaggi che mostrano lo Sri Lanka autentico, non solo i soliti posti turistici.</p><br /><p>Ti portiamo in antiche città, verdi colline del tè, spiagge soleggiate e parchi pieni di animali. Ogni viaggio ti fa sentire la vera cultura, le persone gentili, le antiche tradizioni e la bellissima natura dello Sri Lanka.</p><br /><p>Vuoi cultura, avventura, relax, benessere o un viaggio privato speciale? Pianifichiamo tutto con cura, offriamo aiuto personale e assicuriamo ricordi felici.</p>",
                imageAlt: "Team Star Lanka Tours",
                item1: { title: "Viaggi in tutta lo Sri Lanka", text: "Andiamo da nord a sud — esperienze locali autentiche ovunque." },
                item2: { title: "Viaggi fatti per te", text: "Pianifichiamo il viaggio in base a ciò che ti piace — avventura, cultura, natura o relax." },
                item3: { title: "Guide locali eccellenti", text: "Nethaj e il suo team conoscono tanti posti segreti, storie antiche e il vero spirito dello Sri Lanka." },
                item4: { title: "Assistenza 24/7", text: "Star Lanka Tours ti aiuta 24 ore su 24 durante tutto il viaggio." }
            },
            offers: {
                title: "Cosa ti offriamo",
                cultural: { title: "Esperienza culturale", text: "Vedi usanze locali, festival e vita quotidiana.", alt: "Esperienza culturale" },
                adventure: { title: "Viaggi avventura", text: "Trekking, safari animali, divertimento in mare e azione nella natura.", alt: "Avventura" },
                luxury: { title: "Comfort e lusso", text: "Bei hotel, auto private e servizio speciale.", alt: "Lusso" },
                wellness: { title: "Salute e relax", text: "Yoga, Ayurveda e luoghi tranquilli.", alt: "Relax" }
            },
            guides: {
                title: "Le nostre guide",
                text: "Nethaj è il nostro principale operatore turistico. Le nostre guide formate e allegre rendono il tuo viaggio emozionante. Ti mostrano posti segreti, storie antiche e cose speciali in Sri Lanka.",
                imageAlt: "Guida Star Lanka Tours - Nethaj"
            },
            expert: {
                name: "Nethaj",
                role: "(Guida principale e operatore turistico)",
                bio: "Nethaj è il cuore di Star Lanka Tours Sri Lanka. Conosce molto bene lo Sri Lanka. Dalle spiagge alle alte colline, dagli animali ai luoghi antichi — crea viaggi che non dimenticherai mai.",
                imageAlt: "Nethaj - Star Lanka Tours"
            },
            vehicles: {
                title: "Veicoli per i tour",
                text: "Star Lanka Tours Sri Lanka si prende cura della tua sicurezza e del tuo comfort. Sotto la supervisione di Nethaj usiamo auto moderne, climatizzate e pulite per viaggiare facilmente sull'isola.",
                bookButton: "Prenota il tuo viaggio",
                car: { title: "Auto", text: "Buona per 2 o 3 persone. Piccola, risparmia carburante, perfetta per viaggi brevi." },
                van: { title: "Van", text: "Buona per famiglie o piccoli gruppi (fino a 6). Grande e comoda per lunghe distanze." },
                minibus: { title: "Minibus", text: "Buona per gruppi più grandi (8–12). Sedili comodi e spazio per bagagli." },
                luxury: { title: "Auto di lusso", text: "Auto molto belle con sedili morbidi, Wi-Fi e autista privato." }
            },
            accommodations: {
                intro: "Riposati in bei hotel 3 stelle, 4 stelle, 5 stelle e luoghi speciali. Li scegliamo per la calma, la bellezza e il comfort durante il tuo viaggio Star Lanka Tours.",
                item1: "Ville private con grandi piscine e viste rilassanti sul mare.",
                item2: "Hotel di lusso in stile antico sul mare con buon cibo.",
                item3: "Lodge nella natura con camere moderne e viste su animali selvatici.",
                item4: "Bella casa nella natura con viste spettacolari e design verde."
            },
            notices: {
                title: "Extra gratuiti",
                intro: "Star Lanka Tours Sri Lanka ti offre queste cose gratuite in ogni viaggio:",
                bike: { title: "Bici gratuita per ogni ospite", text: "Pedala liberamente — diamo una bici a ogni persona." },
                fruits: { title: "Frutta fresca alla fine", text: "Concludi il viaggio con un bel pacchetto di frutta fresca." },
                meals: { title: "Pasti gratuiti per eventi speciali", text: "Partecipa alle tradizioni locali — offriamo pasti gratuiti durante le cerimonie di offerta di denaro." }
            },
        },
        // Italian (it)
        home: {
            common: { viewAll: "Vedi tutti" },
            sections: {
                recommendations: { title: "I posti migliori", subtitle: "Non sai dove andare? Ti aiutiamo a scegliere." },
                excursions: { title: "I nostri tour", desc: "Viaggi di più giorni — mix di antica cultura, natura e ricordi felici." },
                packages: { title: "Pacchetti speciali" },
                reviews: { title: "Cosa dicono gli ospiti", subtitle: "Parole vere da persone che hanno viaggiato con noi" },
                gallery: { title: "Le nostre foto", subtitle: "Belle immagini dello Sri Lanka — piene di meraviglia, divertimento e momenti belli." }
            },
            recommendations: {
                sigiriya: { label: "Sigiriya", name: "Grande antica fortezza rocciosa alta sopra il suolo." },
                udawalawa: { label: "Udawalawe", name: "Grandi campi con tanti elefanti liberi." },
                ella: { label: "Ella", name: "Colline nuvolose, bel giro in treno, viste enormi." },
                mirissa: { label: "Mirissa", name: "Spiagge gialle, mare blu, ottimo per vedere balene." },
                nuwaraeliya: { label: "Nuwara Eliya", name: "Tanti campi di tè e aria fresca e fresca." },
                kandy: { label: "Kandy", name: "Città sacra con il Tempio del Dente." },
                galle: { label: "Galle", name: "Vecchio forte vicino al mare." },
                yala: { label: "Yala", name: "Grande parco con leopardi, elefanti e tanti animali." },
                anuradhapura: { label: "Anuradhapura", name: "Luogo antico dove è iniziato il buddismo, grandi stupa." },
                polonnaruwa: { label: "Polonnaruwa", name: "Rovine di una vecchia città di tanto tempo fa." }
            },
            excursions: {
                oneDay: { title: "1 Giorno – Sri Lanka in un giorno", des: "Un giorno pieno di magia — da luoghi antichi a spiagge soleggiate." },
                twoDays: { title: "2 Giorni – Richiamo della natura", des: "Due giorni nella natura selvaggia: safari, colline del tè, suoni della giungla." },
                threeDays: { title: "3 Giorni – Anima e mare", des: "Tre giorni per il cuore — templi al mattino, mare la sera, vera cultura." },
                fourDays: { title: "4 Giorni – Antico e tranquillo", des: "Quattro giorni di meraviglie antiche: grandi fortezze, vecchie strade, tradizioni vere." },
                fiveDays: { title: "5 Giorni – Cuore dello Sri Lanka", des: "Cinque giorni per amare lo Sri Lanka — colline nebbiose fino al mare blu." },
                sixDays: { title: "6 Giorni – Viaggio speciale", des: "Sei giorni di cose belle — luoghi sacri, safari animali, tramonti tranquilli." }
            },
            packages: {
                one: { title: "1 Giorno / 0 Notti: Sri Lanka in un giorno", duration: "1 Giorno", desc: "Un grande giorno — antiche stupa, spiagge dorate, vero feeling dello Sri Lanka.", category: "Viaggio veloce" },
                two: { title: "2 Giorni / 1 Notte: Richiamo della natura", duration: "2 Giorni", desc: "Due giorni nella natura — safari notturni, profumo di tè, vita nella giungla.", category: "Viaggio selvaggio" },
                three: { title: "3 Giorni / 2 Notti: Anima e mare", duration: "3 Giorni", desc: "Tre giorni per l’anima — templi al mattino, mare calmo la sera.", category: "Mare e spirito" },
                four: { title: "4 Giorni / 3 Notti: Antico e tranquillo", duration: "4 Giorni", desc: "Quattro giorni di cose antiche — fortezze, vecchie città, vera cultura.", category: "Viaggio culturale" },
                five: { title: "5 Giorni / 4 Notti: Cuore dello Sri Lanka", duration: "5 Giorni", desc: "Cinque giorni per amare l’isola — colline, mare blu, momenti felici.", category: "Viaggio d’amore" },
                six: { title: "6 Giorni / 5 Notti: Viaggio speciale", duration: "6 Giorni", desc: "Sei giorni delle cose migliori — luoghi sacri, animali, bei tramonti.", category: "Miglior viaggio" }
            },
            featured: {
                perahera: {
                    h2: "Guarda questo grande spettacolo", h3: "Kandy Esala Perahera", h4: "(Festa del Dente)",
                    paragraph: `Uno dei più grandi festival buddisti in Asia. Ogni anno a Kandy la gente onora il Dente Sacro. Elefanti con abiti belli, tamburi forti, ballerini di fuoco e luci creano una notte meravigliosa. Vieni a vederlo con <strong style="color: #166880;">Star Lanka Tours Sri Lanka</strong> — qui la cultura è viva.`,
                    button: "Vedi di più"
                },
                safari: {
                    h2: "Vai nella natura selvaggia", h3: "Tour safari",
                    paragraph: `Lo Sri Lanka ha alcuni dei migliori animali in Asia. Vedi grandi spazi aperti a <span style="color: #D5A44F; font-weight: 600;">Yala</span> e <span style="color: #D5A44F; font-weight: 600;">Udawalawe</span>, o laghi a <span style="color: #D5A44F; font-weight: 600;">Wilpattu</span>. Trova elefanti, leopardi e tanti uccelli. Viaggia con <strong style="color: #166880;">Star Lanka Tours Sri Lanka</strong> — ogni safari è una nuova storia.`,
                    button: "Vedi safari"
                }
            },
            gallery: {
                title: "Le nostre foto", subtitle: "Belle immagini dello Sri Lanka — piene di meraviglia, divertimento e bellezza.",
                alt1: "Alba su Sigiriya Rock", alt2: "Elefanti nel Parco Nazionale Yala", alt3: "Lavoratrici del tè nella nebbiosa Nuwara Eliya",
                alt4: "Tramonto sulla spiaggia di Mirissa", alt5: "Preghiera al Tempio di Kandy", alt6: "Antiche rovine a Polonnaruwa",
                alt7: "Balene vicino alla costa sud", alt8: "Viaggio in treno nelle colline di Ella", alt9: "Fortezza di Galle alla luce della sera",
                alt10: "Pescatore al lavoro a Negombo", alt11: "Spettacolo di danza Kandyan", alt12: "Mongolfiera sopra Dambulla"
            },
            cta: {
                title: "Star Lanka Tours Sri Lanka — Creiamo viaggi felici",
                desc: "Ogni viaggio è speciale — pieno di cultura, divertimento e momenti di calma. Lasciaci scrivere la tua storia nella bellissima Sri Lanka.",
                button: "Inizia ora",
                alt: "Crea il tuo viaggio"
            },
        },
        // Italian (it)
        hero: {
            title: {
                line1: "Scopri il paradiso con",
                line2: "Star Lanka Tours",
                line3: "Sri Lanka"
            },
            subtitle: "Tuffati in lussureggianti giungle smeraldo, rive dorate baciate dal sole, antiche città senza tempo e avventure emozionanti con la fauna selvatica —",
            subtitle2: "perfettamente cucite sui tuoi sogni.",

            cta: "Inizia la tua avventura",
            trust: "Amato da viaggiatori di oltre 50 paesi • Riconosciuto dai migliori esperti di viaggio al mondo"
        },
        // Italian (it)
        footer: {
            brand: "Star Lanka Tours",

            nav: {
                home: "Home",
                about: "Chi siamo",
                explore: "Esplora lo Sri Lanka",
                tours: "Pacchetti turistici",
                gallery: "Galleria",
                events: "Eventi speciali",
                things: "Cose da fare",
                contact: "Contattaci"
            },

            contact: {
                title: "Creiamo insieme ricordi indimenticabili",
                address: "Beruwala Area,<br />Western Province, Sri Lanka",
                email: "info@starlankatours.com",          // ← change to your real email
                phone: "+94 76 805 1224"                   // ← change to your real phone/WhatsApp number
            },

            newsletter: {
                title: "Unisciti alla nostra avventura",
                desc: "Ricevi per primo notizie su offerte speciali, luoghi segreti e viaggi straordinari in Sri Lanka.",
                placeholder: "Il tuo indirizzo email",
                subscribe: "Iscriviti"
            },

            tagline: "\"Non tutti coloro che vagano sono perduti…<br /><span class='text-[#96BA33] font-semibold'>alcuni viaggiano con Star Lanka Tours</span>\"",

            copyright: "Tutti i diritti riservati.",
            developedBy: "Progettato da"
        },
        ayurveda: {
            title: "Ayurveda - l'antica scienza della vita",
            introParagraph1: "La parola 'Ayurveda' esiste da oltre tremila anni. In sanscrito significa 'scienza della vita'. La tecnica si basa sull'approccio ayurvedico di curare le cause delle malattie, non solo gli effetti, come spesso fa la medicina occidentale. Postula i seguenti principi:",
            corePrinciplesTitle: "Principi chiave",
            principle1: "Il corpo deve mantenere equilibrio energetico per un metabolismo e una funzione cardiaca normali.",
            principle2: "Il corpo deve avere contrazioni muscolari regolari con un'attività ormonale equilibrata.",
            principle3: "Il corpo ha bisogno di un sistema immunitario sano per funzionare correttamente.",
            sriLankaDoctors: "Secondo i dati attuali, in Sri Lanka ci sono oltre 6.000 laureati in Ayurveda. Studiano sette anni e fanno due anni di pratica negli ospedali pubblici. I programmi ayurvedici includono:",
            benefit1: "Eliminazione di stress, affaticamento e ansia",
            benefit2: "Ossigenazione",
            benefit3: "Stimolazione dei sistemi muscolari ed eliminazione delle tossine",
            benefit4: "Ripristino dell'equilibrio del sistema nervoso",
            benefit5: "Ripristino del flusso sanguigno agli organi interni",
            benefit6: "Produzione di endorfine",
            mainImageAlt: "Benessere ayurvedico",
            faceTreatmentAlt: "Trattamento viso ayurvedico",
            faceTreatmentCaption: "Trattamento viso ayurvedico",
            massageTreatmentAlt: "Trattamento massaggio ayurvedico",
            massageTreatmentCaption: "Trattamento massaggio ayurvedico",
            treatmentDescription: "I trattamenti standard includono massaggi del corpo e del cuoio capelluto con oli speciali, sauna alle erbe e bagni arricchiti con erbe. La tecnica più popolare è la 'procedura Shirodhara', in cui olio caldo alle erbe gocciola ritmicamente sulla fronte, aiutando a ristabilire l'equilibrio del sistema nervoso e a rilassarsi.",
            tipsTitle: "Suggerimenti per i trattamenti ayurvedici",
            tip1: "Lascia andare i problemi. Rilassati e libera la mente per ottenere i migliori risultati.",
            tip2: "Scegli il luogo giusto. Un ambiente che ti fa sentire a tuo agio favorisce la guarigione.",
            tip3: "Scegli il programma adatto. Confrontati col medico e prova diverse terapie per trovare quella giusta.",
            tip4: "Fai un bagno caldo prima del trattamento per rilassare i muscoli e preparare il corpo.",
            tip5: "Mangia leggero prima del trattamento. Evita pasti pesanti per un buon flusso sanguigno durante il massaggio.",
            tip6: "Il riposo dopo i trattamenti è essenziale: aumenta l'efficacia delle terapie ayurvediche."
        },
        ballooning: {
            title: "Volo in mongolfiera in Sri Lanka",
            introParagraph1: "Il volo in mongolfiera in Sri Lanka offre un'esperienza indimenticabile, sorvolando dolcemente paesaggi spettacolari. All'alba, i voli regalano viste mozzafiato su colline, foreste lussureggianti, rovine antiche e villaggi tranquilli.",
            introParagraph2: "La destinazione più popolare è Dambulla, nel cuore del triangolo culturale. I voli passano spesso sopra la rocca di Sigiriya, offrendo una prospettiva unica. Durano in genere 60-90 minuti, tempo sufficiente per ammirare la bellezza dello Sri Lanka dall'alto.",
            mainImageAlt: "Volo in mongolfiera in Sri Lanka",
            mainImageCaption: "Volo in mongolfiera in Sri Lanka",
            highlightsTitle: "Perché provare la mongolfiera?",
            highlightsIntro: "Unisce avventura e tranquillità, permettendo di vivere lo Sri Lanka da un punto di vista unico. Alcuni punti salienti:",
            highlight1: "Viste panoramiche continue sui paesaggi dell'isola.",
            highlight2: "Sorvolo di luoghi iconici come la rocca di Sigiriya e i laghi vicini.",
            highlight3: "Un viaggio silenzioso e sereno sopra il verde e i villaggi.",
            highlight4: "Osservare un'alba spettacolare dal cielo.",
            highlight5: "Ideale per chi ama fotografare scenari dall'alto.",
            sunriseImageAlt: "Goditi l'alba mentre ti sollevi dolcemente in mongolfiera.",
            sunriseImageCaption: "Goditi l'alba mentre ti sollevi dolcemente in mongolfiera.",
            landscapeImageAlt: "Ammira dall'alto colline e foreste lussureggianti dello Sri Lanka.",
            landscapeImageCaption: "Ammira dall'alto colline e foreste lussureggianti dello Sri Lanka.",
            tipsTitle: "Consigli per un volo memorabile",
            tip1: "Prenota in anticipo: il meteo è decisivo e i posti finiscono presto.",
            tip2: "Indossa abiti comodi e porta una giacca leggera: le mattine sono fresche.",
            tip3: "Porta una fotocamera o uno smartphone per catturare le viste.",
            tip4: "Ascolta con attenzione le istruzioni di sicurezza del pilota.",
            tip5: "Arriva puntuale per vedere gonfiaggio e preparazione del pallone: è affascinante."
        },
        diving: {
            title: "Immersioni in Sri Lanka",
            introParagraph1: "Una vasta barriera corallina circonda la costa dello Sri Lanka a profondità tra 2 e 40 m. Le calde acque dell'Oceano Indiano (27–30°C) e la grande visibilità (15–35 m) offrono condizioni eccellenti per immersioni e snorkeling. Puoi esplorare reef intatti, antichi relitti e grotte sottomarine.",
            introParagraph2: "Il nord-est dell'isola offre oltre 130 specie di coralli colorati, habitat per tartarughe, pesci pagliaccio, pesci leone e cavallucci marini. Visita i relitti vicino a rocce e reef per un'esperienza indimenticabile. Fluttuando nelle acque limpide, ti immergi nel passato di Ceylon.",
            mainImageAlt: "Immersioni in Sri Lanka",
            mainImageCaption: "Immersioni in Sri Lanka",
            facilitiesTitle: "Centri e siti migliori",
            facilitiesParagraph1: "I centri diving dell'isola hanno attrezzature moderne di marchi rinomati. Istruttori certificati PADI/CMAS garantiscono sicurezza. I centri sulla costa sud-ovest operano da metà ottobre a fine aprile; quelli su quella nord-est (Nilaveli, Trincomalee) da marzo a ottobre.",
            facilitiesParagraph2: "Le barriere di Kalpitiya a ovest e i relitti di Hikkaduwa sono tra le mete più amate dai sub.",
            coralImageAlt: "Esplora reef vivaci ricchi di vita marina.",
            coralImageCaption: "Esplora reef vivaci ricchi di vita marina.",
            shipwreckImageAlt: "Scopri relitti storici e la storia marittima dello Sri Lanka.",
            shipwreckImageCaption: "Scopri relitti storici e la storia marittima dello Sri Lanka.",
            tipsTitle: "Consigli per subacquei",
            tip1: "Scegli la stagione giusta: sud-ovest (ott–apr) o nord-est (mar–ott).",
            tip2: "Assicurati che il centro sia certificato e ben attrezzato.",
            tip3: "Segui i consigli dell'istruttore, soprattutto se sei principiante.",
            tip4: "Rispetta la vita marina: non toccare i coralli né disturbare l'ambiente.",
            tip5: "Porta una camera subacquea per catturare la bellezza sottomarina."
        },
        elephantRide: {
            title: "Passeggiata sull'elefante",
            introParagraph1: "Il trekking sugli elefanti è un'esperienza emozionante e unica in Sri Lanka. Nelle aree del Triangolo Culturale (Habarana, Sigiriya, Dambulla) puoi partecipare a un safari sugli elefanti. I prezzi partono da circa 30 $ per un'ora.",
            introParagraph2: "Prima di partire, gli elefanti sono equipaggiati con una sella a cesto per 4–6 persone. Questi giganti gentili ti guidano attraverso giungle panoramiche, attraversano zone allagate e vegetazione lussureggiante. Camminano lentamente per farti godere la natura, ma possono raggiungere anche 40 km/h.",
            mainImageAlt: "Passeggiata sull'elefante",
            mainImageCaption: "Passeggiata sull'elefante",
            highlightsTitle: "Punti forti della passeggiata",
            highlightsIntro: "Cavalcare un elefante in Sri Lanka offre un contatto speciale con la natura. Ecco i momenti salienti:",
            highlight1: "Camminare tra giungle dense ricche di vegetazione ed animali.",
            highlight2: "Attraversare fiumi e aree allagate con viste pittoresche.",
            highlight3: "Scoprire il legame tra elefanti e cultura cingalese.",
            highlight4: "Rilassarsi su una sella confortevole mentre l'elefante ti trasporta.",
            jungleImageAlt: "Esplora giungle e sentieri panoramici a dorso d'elefante.",
            jungleImageCaption: "Esplora giungle e sentieri panoramici a dorso d'elefante.",
            waterImageAlt: "Attraversa fiumi e ammira l'acqua e la vegetazione.",
            waterImageCaption: "Attraversa fiumi e ammira l'acqua e la vegetazione.",
            tipsTitle: "Consigli per una corsa sicura e piacevole",
            tip1: "Indossa abiti comodi e scarpe adatte alle attività outdoor.",
            tip2: "Segui le istruzioni della guida per sicurezza e comfort.",
            tip3: "Assicurati che gli elefanti siano trattati eticamente e che l'operatore rispetti il loro benessere.",
            tip4: "Porta una fotocamera per catturare paesaggi e momenti.",
            tip5: "Rispetta gli elefanti ed evita azioni che possano stressarli o danneggiarli."
        },
        fishing: {
            title: "Pesca in Sri Lanka",
            introParagraph1: "La Sri Lanka, con l'ampia costa e molti laghi e fiumi d'acqua dolce, offre esperienze di pesca impareggiabili. Che tu sia professionista o dilettante, troverai qualcosa. Dalle spedizioni d'altura alla tradizionale pesca su pali praticata dai pescatori locali.",
            introParagraph2: "Le mete popolari includono la costa sud (Galle, Mirissa), la laguna di Negombo e le acque tranquille di Trincomalee. Puoi provare tecniche diverse: traina, fondo o mosca, secondo le preferenze.",
            mainImageAlt: "Pesca in Sri Lanka",
            mainImageCaption: "Pesca in Sri Lanka",
            experiencesTitle: "Esperienze di pesca",
            experiencesIntro: "La pesca qui è anche immersione nella cultura e nelle tradizioni dell'isola. Alcune esperienze uniche:",
            expStiltTitle: "Pesca su pali",
            expStiltDesc: "Metodo tradizionale in cui i pescatori siedono su pali vicino alla costa – unico della Sri Lanka.",
            expDeepSeaTitle: "Pesca d'altura",
            expDeepSeaDesc: "Uscita nell'Oceano Indiano per marlin, tonni, barracuda e altre grandi specie.",
            expLagoonTitle: "Pesca in lagune e fiumi",
            expLagoonDesc: "Relax pescando in lagune e fiumi tranquilli, ricchi di tilapia e pesce gatto.",
            expNightTitle: "Pesca notturna",
            expNightDesc: "L'emozione della pesca sotto le stelle, comune nei villaggi costieri.",
            stiltImageAlt: "Pesca su pali, simbolo del patrimonio di pesca cingalese.",
            stiltImageCaption: "La pesca su pali è un metodo tradizionale e iconico in Sri Lanka.",
            deepSeaImageAlt: "La pesca d'altura offre avventura e grandi prede nell'Oceano Indiano.",
            deepSeaImageCaption: "La pesca d'altura offre avventura e grandi prede nell'Oceano Indiano.",
            tipsTitle: "Consigli per una buona uscita",
            tip1: "Scegli la stagione: ott–apr per il sud, mar–ott per l'est.",
            tip2: "Porta crema solare, cappello e abiti protettivi per stare comodo.",
            tip3: "Prenota una guida o un charter per sfruttare al meglio l'esperienza e imparare dagli esperti.",
            tip4: "Rispetta l'ambiente: non lasciare rifiuti e usa pratiche sostenibili.",
            tip5: "Rimani idratato e porta snack per le uscite più lunghe."
        },
        jeepSafari: {
            title: "Safari in jeep in Sri Lanka",
            introParagraph1: "I parchi nazionali dello Sri Lanka offrono safari in jeep emozionanti, per esplorare la biodiversità e osservare la fauna nel suo habitat naturale. Yala, Wilpattu e Udawalawe sono tra le mete più popolari.",
            introParagraph2: "Durante i safari puoi vedere elefanti, leopardi, orsi labiati, bufali d'acqua, coccodrilli e molti uccelli. Con guide naturalistiche esperte, i safari in jeep sono perfetti per appassionati di natura e fotografi.",
            mainImageAlt: "Safari in jeep in Sri Lanka",
            mainImageCaption: "Safari in jeep in Sri Lanka",
            whyChooseTitle: "Perché scegliere un safari in jeep?",
            whyChooseIntro: "È uno dei modi migliori per scoprire la fauna dello Sri Lanka. Punti forti:",
            highlight1: "Incontri ravvicinati con icone come elefanti e leopardi.",
            highlight2: "Accesso ad aree remote e sceniche dei parchi.",
            highlight3: "Opportunità fotografiche in ambienti naturali.",
            highlight4: "Guide qualificate e ranger del parco.",
            highlight5: "Avventura adatta a tutte le età che unisce emozione e scoperta.",
            wildlifeImageAlt: "Osserva leopardi, elefanti e coccodrilli durante il safari.",
            wildlifeImageCaption: "Osserva leopardi, elefanti e coccodrilli durante il safari.",
            landscapeImageAlt: "Esplora paesaggi che vanno da foreste fitte a pianure aperte.",
            landscapeImageCaption: "Esplora paesaggi che vanno da foreste fitte a pianure aperte.",
            tipsTitle: "Consigli per un safari piacevole",
            tip1: "Indossa colori neutri per mimetizzarti nell'ambiente.",
            tip2: "Porta crema solare, cappello e repellente per insetti.",
            tip3: "Porta binocolo e fotocamera per avvistare e fotografare la fauna.",
            tip4: "Segui le indicazioni della guida per sicurezza e rispetto degli animali.",
            tip5: "Prenota in anticipo, soprattutto in alta stagione, per assicurarti un posto."
        },
        riverSafari: {
            title: "Safari fluviale in Sri Lanka",
            introParagraph1: "Un safari fluviale permette di esplorare biodiversità e bellezza paesaggistica dell'isola. Scivola lungo corsi d'acqua tranquilli tra mangrovie lussureggianti, incontra fauna esotica e goditi tramonti pittoreschi.",
            introParagraph2: "Le mete più note sono Madu Ganga e il fiume Bentota. Potrai osservare molte specie di uccelli, varani, coccodrilli e anche scimmie nel loro habitat. L'ambiente sereno è perfetto per amanti della natura e fotografi.",
            mainImageAlt: "Safari fluviale in Sri Lanka",
            mainImageCaption: "Safari fluviale in Sri Lanka",
            whyChooseTitle: "Perché scegliere un safari fluviale?",
            whyChooseIntro: "È un'esperienza rilassante e immersiva che unisce natura, fauna e cultura locale. Punti salienti:",
            highlight1: "Esplora mangrovie rigogliose piene di vita.",
            highlight2: "Avvista uccelli esotici, coccodrilli e altra fauna.",
            highlight3: "Visita piccole isole e villaggi locali lungo il fiume.",
            highlight4: "Goditi la tranquillità e la bellezza dei corsi d'acqua cingalesi.",
            highlight5: "Ideale per famiglie, coppie e viaggiatori solitari in cerca di pace.",
            mangrovesImageAlt: "Scopri le mangrovie che costeggiano i corsi d'acqua scenici dello Sri Lanka.",
            mangrovesImageCaption: "Scopri le mangrovie che costeggiano i corsi d'acqua scenici dello Sri Lanka.",
            wildlifeImageAlt: "Avvista fauna esotica come coccodrilli, varani e uccelli colorati.",
            wildlifeImageCaption: "Avvista fauna esotica come coccodrilli, varani e uccelli colorati.",
            tipsTitle: "Consigli per un buon safari fluviale",
            tip1: "Indossa abiti comodi e porta cappello e crema solare.",
            tip2: "Porta un binocolo per vedere fauna e uccelli distanti.",
            tip3: "Porta una fotocamera o smartphone per catturare paesaggi e animali.",
            tip4: "Segui le istruzioni della guida per sicurezza e comfort.",
            tip5: "Rispetta l'ambiente: non lasciare rifiuti e non disturbare la fauna."
        },
        snorkeling: {
            title: "Snorkeling in Sri Lanka",
            introParagraph1: "Lo snorkeling in Sri Lanka offre un'esperienza subacquea memorabile tra reef vivaci e fauna marina varia. Acque cristalline ed ecosistemi ricchi rendono l'isola un paradiso per tutti i livelli.",
            introParagraph2: "Tra i siti più popolari: Hikkaduwa, nota per giardini di coralli e tartarughe; Pigeon Island a Trincomalee, famosa per reef intatti; Mirissa, dove in stagione puoi avvistare anche balene.",
            mainImageAlt: "Snorkeling in Sri Lanka",
            mainImageCaption: "Snorkeling in Sri Lanka",
            whyChooseTitle: "Perché scegliere lo snorkeling?",
            whyChooseIntro: "Un mix di avventura e bellezza naturale. Ecco i punti forti:",
            highlight1: "Esplora reef colorati pieni di vita.",
            highlight2: "Nuota accanto a pesci tropicali, tartarughe e persino squali di barriera.",
            highlight3: "Scopri paesaggi sottomarini incontaminati in acque calde e limpide.",
            highlight4: "Adatto sia a principianti che a esperti.",
            highlight5: "Accessibile da molte tra le migliori spiagge dello Sri Lanka.",
            coralImageAlt: "Ammira magnifici reef corallini e i loro ecosistemi.",
            coralImageCaption: "Ammira magnifici reef corallini e i loro ecosistemi.",
            marineLifeImageAlt: "Incontra una fauna marina diversificata, incluse tartarughe e pesci tropicali.",
            marineLifeImageCaption: "Incontra una fauna marina diversificata, incluse tartarughe e pesci tropicali.",
            tipsTitle: "Consigli per un grande snorkeling",
            tip1: "Indossa maschera e boccaglio comodi per una buona visibilità.",
            tip2: "Usa crema solare reef-safe per proteggere pelle e ambiente.",
            tip3: "Muoviti dolcemente per non danneggiare i coralli o stressare la fauna.",
            tip4: "Resta idratato e fai pause tra le sessioni.",
            tip5: "Unisciti a un tour guidato per scoprire i siti migliori e le norme di sicurezza."
        },
        teaTasting: {
            title: "Tour di degustazione del tè in Sri Lanka",
            introParagraph1: "La Sri Lanka, la 'Perla dell'Oceano Indiano', è famosa per il tè di classe mondiale. Parti per un tour di degustazione e visita le piantagioni di Nuwara Eliya, Ella e Kandy. Scopri l'arte della coltivazione, il processo produttivo e assaggia i sapori ricchi del tè di Ceylon.",
            introParagraph2: "Che tu sia appassionato o curioso, è un'occasione unica per immergersi nell'eredità del tè e godere la tranquillità degli altipiani cingalesi.",
            mainImageAlt: "Tour di degustazione del tè in Sri Lanka",
            mainImageCaption: "Tour di degustazione del tè in Sri Lanka",
            whyChooseTitle: "Perché scegliere un tour del tè?",
            whyChooseIntro: "Non è solo assaggio: è un'esperienza culturale immersiva. Punti salienti:",
            highlight1: "Visita piantagioni panoramiche nei freschi altipiani.",
            highlight2: "Scopri la storia e il valore del tè di Ceylon.",
            highlight3: "Partecipa alla raccolta e osserva la lavorazione nelle fabbriche.",
            highlight4: "Degusta diverse varietà: nero, verde e miscele aromatizzate.",
            highlight5: "Goditi paesaggi di montagne nebbiose e cascate.",
            plantationImageAlt: "Esplora piantagioni verdi e impara la coltivazione del tè.",
            plantationImageCaption: "Esplora piantagioni verdi e impara la coltivazione del tè.",
            preparationImageAlt: "Scopri l'arte dell'infusione e assaggia il vero tè di Ceylon.",
            preparationImageCaption: "Scopri l'arte dell'infusione e assaggia il vero tè di Ceylon.",
            tipsTitle: "Consigli per una degustazione riuscita",
            tip1: "Indossa abiti e scarpe comodi per camminare tra le piantagioni.",
            tip2: "Porta una giacca leggera: gli altipiani possono essere freschi e nebbiosi.",
            tip3: "Prova varietà diverse e porta a casa i tuoi tè preferiti.",
            tip4: "Fai domande durante la visita per capire il processo.",
            tip5: "Abbina il tour a cascate e punti panoramici vicini."
        },
        templeVisit: {
            title: "Visita ai templi in Sri Lanka",
            introParagraph1: "La Sri Lanka, terra del Buddha, ospita templi antichi che riflettono un ricco patrimonio spirituale e culturale. Visita luoghi iconici come il Tempio del Dente a Kandy, il tempio rupestre di Dambulla e Ruwanwelisaya ad Anuradhapura.",
            introParagraph2: "Siti sacri ornati da sculture, affreschi e statue offrono uno sguardo sulle tradizioni spirituali e sulla maestria architettonica dell'isola. È un'esperienza culturale e un'occasione di pace e contemplazione.",
            mainImageAlt: "Visita ai templi in Sri Lanka",
            mainImageCaption: "Visita ai templi in Sri Lanka",
            whyVisitTitle: "Perché visitare i templi?",
            whyVisitIntro: "Un'opportunità unica per connettersi con storia, cultura e spiritualità. Punti salienti:",
            highlight1: "Ammira architetture elaborate e statue secolari.",
            highlight2: "Apprendi tradizioni e rituali buddhisti con guide esperte.",
            highlight3: "Esplora siti UNESCO come il Tempio d'Oro di Dambulla.",
            highlight4: "Vivi la serenità e l'atmosfera spirituale degli spazi sacri.",
            highlight5: "Assisti a festival vivaci come l'Esala Perahera al Tempio del Dente.",
            interiorImageAlt: "Ammira interni splendidi con sculture e affreschi dettagliati.",
            interiorImageCaption: "Ammira interni splendidi con sculture e affreschi dettagliati.",
            sacredImageAlt: "Visita templi sacri come Ruwanwelisaya e immergiti nelle tradizioni spirituali.",
            sacredImageCaption: "Visita templi sacri come Ruwanwelisaya e immergiti nelle tradizioni spirituali.",
            tipsTitle: "Consigli per la visita ai templi",
            tip1: "Vesti in modo modesto, coprendo spalle e ginocchia.",
            tip2: "Togli le scarpe prima di entrare nel complesso.",
            tip3: "Non toccare statue o oggetti sacri.",
            tip4: "Porta una piccola offerta se vuoi contribuire al tempio.",
            tip5: "Rispetta silenzio e atmosfera spirituale durante la visita."
        },
        whiteWaterRafting: {
            title: "Rafting in acque bianche in Sri Lanka",
            introParagraph1: "Il rafting in acque bianche in Sri Lanka è un'avventura entusiasmante, soprattutto a Kitulgala, capitale delle attività outdoor. Il fiume Kelani, con rapide e scenari verdi, è perfetto per principianti ed esperti.",
            introParagraph2: "Le spedizioni coprono circa 5 km con rapide di grado 2–4. Proverai l'adrenalina nel superare correnti impegnative mentre ammiri il verde lussureggiante e le viste sui fianchi del fiume.",
            mainImageAlt: "Rafting in acque bianche in Sri Lanka",
            mainImageCaption: "Rafting in acque bianche in Sri Lanka",
            whyChooseTitle: "Perché scegliere il rafting in Sri Lanka?",
            whyChooseIntro: "Unisce avventura e natura. Punti salienti:",
            highlight1: "Affronta rapide emozionanti con istruttori esperti.",
            highlight2: "Goditi viste su foresta pluviale e terreni montuosi.",
            highlight3: "Combina rafting con trekking, birdwatching o canyoning a Kitulgala.",
            highlight4: "Ideale per gruppi, famiglie e viaggiatori solitari in cerca di adrenalina.",
            actionImageAlt: "Senti l'adrenalina conquistando rapide sul fiume Kelani.",
            actionImageCaption: "Senti l'adrenalina conquistando rapide sul fiume Kelani.",
            scenicImageAlt: "Goditi la quiete del verde circostante durante l'avventura.",
            scenicImageCaption: "Goditi la quiete del verde circostante durante l'avventura.",
            tipsTitle: "Consigli per un rafting sicuro ed emozionante",
            tip1: "Indossa giubbotto salvagente e casco forniti dalla guida.",
            tip2: "Ascolta attentamente il briefing di sicurezza prima di partire.",
            tip3: "Indossa abiti comodi e ad asciugatura rapida e scarpe sicure (es. da acqua).",
            tip4: "Porta un cambio e un asciugamano per dopo la discesa.",
            tip5: "Prenota con un operatore affidabile per sicurezza e qualità.",
        },
        wildlifeSafari: {
            title: "Safari nella fauna selvatica in Sri Lanka",
            introParagraph1: "La Sri Lanka, ricca di biodiversità, offre safari incredibili in parchi come Yala, Wilpattu, Minneriya e Udawalawe. Potrai vedere elefanti, leopardi, orsi labiati e molte specie di uccelli nel loro habitat naturale.",
            introParagraph2: "Esplora paesaggi che vanno da foreste dense a praterie aperte e cattura momenti indimenticabili di fauna in azione. Con guide esperte e jeep ben mantenute, il safari è imperdibile per amanti della natura e avventura.",
            mainImageAlt: "Safari nella fauna selvatica in Sri Lanka",
            mainImageCaption: "Safari nella fauna selvatica in Sri Lanka",
            whyChooseTitle: "Perché scegliere un safari fauna?",
            whyChooseIntro: "Un'occasione unica per connettersi con la natura e scoprire la biodiversità dell'isola. Punti salienti:",
            highlight1: "Osserva specie iconiche come elefanti, leopardi e coccodrilli.",
            highlight2: "Esplora foreste, zone umide e pianure ricche di fauna.",
            highlight3: "Cattura foto incredibili della fauna nel suo ambiente.",
            highlight4: "Vivi l'emozione di avvistare il raro leopardo dello Sri Lanka.",
            highlight5: "Apprendi gli sforzi di conservazione da guide e naturalisti esperti.",
            elephantsImageAlt: "Osserva elefanti maestosi che vagano nei parchi nazionali.",
            elephantsImageCaption: "Osserva elefanti maestosi che vagano nei parchi nazionali.",
            leopardImageAlt: "Avvista il raro leopardo dello Sri Lanka, punto forte di ogni safari.",
            leopardImageCaption: "Avvista il raro leopardo dello Sri Lanka, punto forte di ogni safari.",
            tipsTitle: "Consigli per un safari entusiasmante",
            tip1: "Indossa colori neutri per mimetizzarti nell'ambiente.",
            tip2: "Porta crema solare, cappello e repellente insetti.",
            tip3: "Porta binocolo e fotocamera per avvistare e fotografare la fauna.",
            tip4: "Segui le istruzioni della guida per sicurezza e rispetto della fauna.",
            tip5: "Prenota in anticipo, specie in alta stagione, per garantirti un posto."
        },
        tourpackages: {
            heroTitle: 'I Nostri Pacchetti Vacanze',
            heroSubtitle: 'Scopri lo Sri Lanka in un giorno — avventure su misura da <span class="text-[#009CE6] font-bold">Star Lanka Tours</span>',
            heroAlt: 'Star Lanka Tours Sri Lanka - Avventure di un giorno',
            chooseAdventure: 'Scegli la tua avventura',
            packagesSubtitle: '25 esperienze accuratamente selezionate — da safari nella savana a immersioni culturali.',
            viewDetails: 'Visualizza dettagli',
            itineraryTitle: 'Itinerario',
            bookViaWhatsApp: 'Prenota tramite WhatsApp',
            whatsappMessage: 'Ciao Star Lanka Tours! Vorrei prenotare: *{{title}}* ({{duration}})\n\nTi prego di farmi sapere la disponibilità e i prezzi!',

            packages: {
                '1': {
                    title: 'Giornata d\'avventura a Ella',
                    duration: '1 giorno',
                    category: 'Natura e avventura',
                    description: 'Viaggio attraverso colline nebbiose, cascate cascanti e ponti iconici — un perfetto mix di brividi e serenità.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Cascata Ravana</strong> – Nuoto in piscine cristalline</li>
                <li><strong>Ponte dalle nove arcate</strong> – Stop fotografico iconico con il treno</li>
                <li><strong>Piantagione di tè</strong> – Passeggiata tra colline smeraldine</li>
                <li><strong>Giro in treno</strong> – Rotta panoramica da Ella a Demodara</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Viste panoramiche all'alba/tramonto</li>
                <li><strong>Alimentazione di elefantini con latte a Udawalawe</strong> – Momento commovente con la fauna selvatica</li>
                <li><strong>Giardino di erbe ayurvediche</strong> – Scopri i segreti antichi del benessere</li>
            </ul>`
                },
                '2': {
                    title: 'Ella e safari a Yala',
                    duration: '1 giorno',
                    category: 'Fauna selvatica e paesaggi',
                    description: 'Dalle alture nebbiose alla savana selvaggia — il meglio della natura in una giornata indimenticabile.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Cascata Ravana</strong> – Piscina naturale rinfrescante</li>
                <li><strong>Ponte dalle nove arcate</strong> – Meraviglia architettonica</li>
                <li><strong>Piantagione di tè</strong> – Passeggiate panoramiche collinari</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Viste spettacolari dalla cima</li>
                <li><strong>Safari a Yala</strong> – Avventura in jeep con leopardi ed elefanti</li>
            </ul>`
                },
                '3': {
                    title: 'Giornata culturale a Kandy',
                    duration: '1 giorno',
                    category: 'Patrimonio e natura',
                    description: 'Immergiti in templi sacri, giardini lussureggianti e tradizioni locali nel cuore dello Sri Lanka.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Città di Kandy</strong> – Centro culturale vibrante</li>
                <li><strong>Orto Botanico Reale</strong> – Paradiso tropicale</li>
                <li><strong>Fabbrica di tè e piantagione</strong> – Esperienza del tè di Ceylon</li>
                <li><strong>Alimentazione, balneazione e cavalcata di elefanti</strong> – Interazione etica</li>
                <li><strong>Giardino di erbe ayurvediche</strong> – Tour di guarigione naturale</li>
                <li><strong>Torre Ambuluwawa</strong> – Vista panoramica a 360°</li>
                <li><strong>Fabbrica di gioielli e pietre preziose</strong> – Artigianato scintillante</li>
                <li><strong>Fabbrica di seta</strong> – Tessitura tradizionale</li>
            </ul>`
                },
                '4': {
                    title: 'Viaggio sacro a Kandy',
                    duration: '1 giorno',
                    category: 'Spirituale e culturale',
                    description: 'Una giornata consacrata a devozione, patrimonio e bellezza naturale nella città sacra di Kandy.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tempio della Reliquia del Dente di Buddha</strong> – Sito sacro buddhista</li>
                <li><strong>Fabbrica di tè e piantagione</strong> – Degustazione di tè fresco</li>
                <li><strong>Alimentazione, balneazione e cavalcata di elefanti</strong> – Giganti gentili</li>
                <li><strong>Giardino di erbe ayurvediche</strong> – Saggezza del benessere</li>
                <li><strong>Torre Ambuluwawa</strong> – Ascesa a spirale al cielo</li>
                <li><strong>Fabbrica di gioielli e pietre preziose</strong> – Gemme locali</li>
                <li><strong>Fabbrica di seta</strong> – Arte della seta</li>
            </ul>`
                },
                '5': {
                    title: 'Giornata patrimoniale a Sigiriya',
                    duration: '1 giorno',
                    category: 'Storia e avventura',
                    description: 'Scalate antiche fortezze rocciose, esplorate grotte d\'oro e assaporate la vita autentica dei villaggi.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Roccia del Leone di Sigiriya</strong> – Patrimonio mondiale dell'UNESCO</li>
                <li><strong>Tempio d'oro di Dambulla</strong> – Arte antica in grotta</li>
                <li><strong>Tour del villaggio</strong> – Carro a buoi, catamarano, pranzo tradizionale</li>
                <li><strong>Giardino di erbe ayurvediche</strong> – Piante medicinali</li>
                <li><strong>Roccia Pidurangala</strong> – Miglior vista di Sigiriya</li>
            </ul>`
                },
                '6': {
                    title: 'Patrimonio costiero di Galle',
                    duration: '1 giorno',
                    category: 'Storia e natura',
                    description: 'Passeggia attraverso forti coloniali, naviga fiumi di mangrovie e testimonia la conservazione delle tartarughe marine.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tempio Kande Viharaya</strong> – Statua gigante di Buddha</li>
                <li><strong>Fattoria di tartarughe</strong> – Rilascio di tartarughe piccole</li>
                <li><strong>Safari in barca</strong> – Foresta di mangrovie del fiume Madu</li>
                <li><strong>Miniera di pietra lunare</strong> – Esperienza di estrazione di gemme</li>
                <li><strong>Forte olandese di Galle</strong> – Città coloniale dell'UNESCO</li>
                <li><strong>Giardino di erbe ayurvediche</strong> – Rimedi naturali</li>
            </ul>`
                },
                '7': {
                    title: 'Scoperta della città di Colombo',
                    duration: '1 giorno',
                    category: 'Urbano e culturale',
                    description: 'Esplora monumenti moderni, siti sacri e vivaci shopping nella capitale in fermento dello Sri Lanka.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Torre Lotus</strong> – Vista della città a 360°</li>
                <li><strong>Moschea rossa</strong> – Architettura islamica stupefacente</li>
                <li><strong>Shopping</strong> – Mercati locali e centri commerciali</li>
                <li><strong>Giardino di erbe ayurvediche</strong> – Tappa benessere</li>
                <li><strong>Tempio Gangaramaya</strong> – Oasi urbana sacra</li>
            </ul>`
                },
                '8': {
                    title: 'Safari selvaggio a Yala',
                    duration: '1 giorno',
                    category: 'Fauna selvatica',
                    description: 'Rintraccia leopardi, elefanti e rari uccelli in uno dei migliori parchi nazionali dell\'Asia.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari in jeep a Yala</strong> – Avventura faunistica di 3 ore</li>
                <li>Avvista leopardi, elefanti, orsi pigri e oltre 200 specie di uccelli</li>
            </ul>`
                },
                '9': {
                    title: 'Odissea delle balene a Mirissa',
                    duration: '1 giorno',
                    category: 'Avventure marine',
                    description: 'Naviga con le balene blu in barche ad alto comfort — le creature più grandi del mondo da vicino.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Osservazione di balene blu</strong> – Safari oceanico di 4 ore</li>
                <li><strong>Spiaggia di Mirissa</strong> – Relax su sabbie dorate</li>
                <li><strong>Pesca su trampoli</strong> – Momento fotografico iconico</li>
                <li><strong>Giardino di erbe ayurvediche</strong> – Benessere costiero</li>
            </ul>`
                },
                '10': {
                    title: 'Giornata dell\'elefante a Udawalawe',
                    duration: '1 giorno',
                    category: 'Fauna selvatica e compassione',
                    description: 'Osserva gli elefantini che vengono nutriti e vagabonda con le mandrie selvatiche nel loro habitat naturale.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Parco nazionale di Udawalawe</strong> – Safari in jeep</li>
                <li><strong>Alimentazione di elefantini</strong> – Visita all'orfanotrofio</li>
            </ul>`
                },
                '11': {
                    title: 'Espresso Ella e Galle',
                    duration: '1 giorno',
                    category: 'Paesaggi e patrimonio',
                    description: 'Dai treni di montagna ai forti coloniali — un viaggio veloce pieno di bellezza e storia.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Giro in treno</strong> – Da Ella a Galle</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Escursione all'alba</li>
                <li><strong>Forte olandese di Galle</strong> – Passeggiata al tramonto</li>
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
                <li><strong>Giardino di erbe ayurvediche</strong> – Tappa benessere</li>
            </ul>`
                },
                '12': {
                    title: 'Safari Yala e Galle',
                    duration: '1 giorno',
                    category: 'Selvaggio e coloniale',
                    description: 'Safari faunistico mattutino, passeggiata patrimoniale pomeridiana — il massimo della combinazione della costa meridionale.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari nel Parco Nazionale Yala</strong> – Tour in jeep mattutino</li>
                <li><strong>Forte olandese di Galle</strong> – Passeggiata coloniale pomeridiana</li>
            </ul>`
                },
                '13': {
                    title: 'Espresso Kandy, Ella e Yala',
                    duration: '2 giorni',
                    category: 'Culturale e paesaggistico',
                    description: 'Da templi sacri a colline nebbiose e safari selvaggi — un tour veloce dei punti salienti dello Sri Lanka.',
                    itinerary: `<h3>Giorno 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari nel Parco Nazionale Yala</strong> – Tour in jeep mattutino</li>
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Giro in treno</strong> – Lussuosa gita in treno</li>
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
            </ul>
            <h3 class="mt-4">Giorno 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Escursione veloce</li>
                <li><strong>Giardini Botanici</strong> – Paradiso tropicale</li>
                <li><strong>Tempio della Reliquia del Dente di Buddha</strong> – Visita sacra</li>
                <li><strong>Cavalcata di elefanti</strong> – Interazione etica</li>
                <li><strong>Fabbrica di tè</strong> – Esperienza del tè di Ceylon</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Kandy (Hotel di lusso)</h3>`
                },
                '14': {
                    title: 'Kandy culturale',
                    duration: '2 giorni',
                    category: 'Culturale',
                    description: 'Immergiti in templi sacri, giardini lussureggianti e tradizioni locali nel cuore dello Sri Lanka.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Città di Kandy</strong> – Centro culturale vibrante</li>
                <li><strong>Orto Botanico Reale</strong> – Paradiso tropicale</li>
                <li><strong>Fabbrica di tè e piantagione</strong> – Esperienza del tè di Ceylon</li>
                <li><strong>Alimentazione, balneazione e cavalcata di elefanti</strong> – Interazione etica</li>
                <li><strong>Giardino di erbe ayurvediche</strong> – Tour di guarigione naturale</li>
                <li><strong>Torre Ambuluwawa</strong> – Vista panoramica a 360°</li>
                <li><strong>Fabbrica di gioielli e pietre preziose</strong> – Artigianato scintillante</li>
                <li><strong>Fabbrica di seta</strong> – Tessitura tradizionale</li>
                <li><strong>Nelligala</strong> – Tempio tradizionale</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Kandy (Hotel di lusso)</h3>`
                },
                '15': {
                    title: 'Ella/Nuwara Eliya/Kandy culturale',
                    duration: '2 giorni',
                    category: 'Culturale e paesaggistico',
                    description: 'Dalle alture nebbiose ai templi sacri — un viaggio dell\'anima attraverso il cuore dello Sri Lanka.',
                    itinerary: `<h3>Giorno 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Escursione panoramica</li>
                <li><strong>Giro in treno</strong> – Lussuosa gita in treno</li>
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
                <li><strong>Ufficio Postale Rosa</strong> – Bellezza culturale</li>
                <li><strong>Ambuluwawa</strong> – Passeggiate tranquille</li>
            </ul>
            <h3 class="mt-4">Giorno 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tempio indù</strong> – Visita culturale</li>
                <li><strong>Giardini Botanici</strong> – Paradiso tropicale</li>
                <li><strong>Nelligala</strong> – Visita sacra</li>
                <li><strong>Cascata Ramboda</strong></li>
                <li><strong>Fabbrica di tè</strong> – Esperienza del tè di Ceylon</li>
                <li><strong>Cavalcata di elefanti</strong> – Interazione etica</li>
                <li><strong>Giardino di erbe</strong> – Paradiso tropicale</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Kandy (Hotel di lusso)</h3>`
                },
                '16': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy culturale',
                    duration: '3 giorni',
                    category: 'Culturale e paesaggistico',
                    description: 'Dalle alture nebbiose ai templi sacri — un viaggio dell\'anima attraverso il cuore dello Sri Lanka.',
                    itinerary: `<h3>Giorno 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Escursione panoramica</li>
                <li><strong>Giro in treno</strong> – Lussuosa gita in treno</li>
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
                <li><strong>Tempio indù</strong> – Visita culturale</li>
                <li><strong>Safari nel Parco Nazionale Yala</strong> – Tour in jeep mattutino</li>
            </ul>
            <h3 class="mt-4">Giorno 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Passeggiate tranquille</li>
                <li><strong>Ufficio Postale Rosa</strong> – Bellezza culturale</li>
                <li><strong>Giardini Botanici</strong> – Paradiso tropicale</li>
                <li><strong>Tempio della Reliquia del Dente di Buddha</strong> – Visita sacra</li>
            </ul>
            <h3 class="mt-4">Giorno 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Visita sacra</li>
                <li><strong>Fabbrica di tè</strong> – Esperienza del tè di Ceylon</li>
                <li><strong>Gemme e gioielli</strong> – Esperienza di gemme dello Sri Lanka</li>
                <li><strong>Intaglio del legno</strong> – Intaglio tradizionale</li>
                <li><strong>Cavalcata di elefanti</strong> – Interazione etica</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Nuwara Eliya e Kandy (Hotel di lusso)</h3>`
                },
                '17': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya culturale',
                    duration: '3 giorni',
                    category: 'Culturale e paesaggistico',
                    description: 'Dalle alture nebbiose ai templi sacri — un viaggio dell\'anima attraverso il cuore dello Sri Lanka.',
                    itinerary: `<h3>Giorno 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Escursione panoramica</li>
                <li><strong>Giro in treno</strong> – Lussuosa gita in treno</li>
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
                <li><strong>Tempio indù</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Passeggiate tranquille</li>
                <li><strong>Giardini Botanici</strong> – Paradiso tropicale</li>
                <li><strong>Pidurangala</strong> – Escursione panoramica</li>
            </ul>
            <h3 class="mt-4">Giorno 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tempio d'oro</strong> – Visita sacra</li>
                <li><strong>Roccia del Leone di Sigiriya</strong> – Fortezza antica</li>
                <li><strong>Tour del villaggio con giro in barca e pranzo tradizionale</strong> – Esperienza culturale</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Nuwara Eliya e Sigiriya (Hotel di lusso)</h3>`
                },
                '18': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa culturale',
                    duration: '3 giorni',
                    category: 'Culturale e paesaggistico',
                    description: 'Dalle alture nebbiose ai templi sacri — un viaggio dell\'anima attraverso il cuore dello Sri Lanka.',
                    itinerary: `<h3>Giorno 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Escursione panoramica</li>
                <li><strong>Giro in treno</strong> – Lussuosa gita in treno</li>
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
                <li><strong>Tempio indù</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Passeggiate tranquille</li>
                <li><strong>Giardini Botanici</strong> – Paradiso tropicale</li>
                <li><strong>Fabbrica di tè</strong> – Esperienza del tè di Ceylon</li>
                <li><strong>Cavalcata di elefanti</strong> – Interazione etica</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Roccia del Leone di Sigiriya</strong> – Patrimonio mondiale dell'UNESCO</li>
                <li><strong>Tour della città antica di Polonnaruwa</strong> – Città culturale</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Kandy e Sigiriya (Hotel di lusso)</h3>`
                },
                '19': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Polonnaruwa culturale',
                    duration: '4 giorni',
                    category: 'Culturale e paesaggistico',
                    description: 'Dalle alture nebbiose ai templi sacri — un viaggio dell\'anima attraverso il cuore dello Sri Lanka.',
                    itinerary: `<h3>Giorno 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari nel Parco Nazionale Yala</strong> – Tour in jeep mattutino</li>
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Escursione panoramica</li>
                <li><strong>Giro in treno</strong> – Lussuosa gita in treno</li>
            </ul>
            <h3 class="mt-4">Giorno 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
                <li><strong>Tempio indù</strong> – Visita culturale</li>
                <li><strong>Ambuluwawa</strong> – Passeggiate tranquille</li>
                <li><strong>Giardini Botanici Reali</strong> – Paradiso tropicale</li>
                <li><strong>Fabbrica di tè</strong> – Esperienza del tè di Ceylon</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Visita sacra</li>
                <li><strong>Fabbrica di gioielli e pietre preziose</strong> – Artigianato scintillante</li>
                <li><strong>Cavalcata di elefanti</strong> – Interazione etica</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Roccia del Leone di Sigiriya</strong> – Patrimonio mondiale dell'UNESCO</li>
                <li><strong>Tour della città antica di Polonnaruwa</strong> – Città culturale</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Ella, Nuwara Eliya e Kandy (Hotel di lusso)</h3>`
                },
                '20': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura culturale',
                    duration: '5 giorni',
                    category: 'Culturale e paesaggistico',
                    description: 'Dalle alture nebbiose ai templi sacri — un viaggio dell\'anima attraverso il cuore dello Sri Lanka.',
                    itinerary: `<h3>Giorno 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari nel Parco Nazionale Yala</strong> – Tour in jeep mattutino</li>
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Escursione panoramica</li>
                <li><strong>Giro in treno</strong> – Lussuosa gita in treno</li>
            </ul>
            <h3 class="mt-4">Giorno 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
                <li><strong>Tempio indù</strong> – Visita culturale</li>
                <li><strong>Ambuluwawa</strong> – Passeggiate tranquille</li>
                <li><strong>Giardini Botanici Reali</strong> – Paradiso tropicale</li>
                <li><strong>Fabbrica di tè</strong> – Esperienza del tè di Ceylon</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Visita sacra</li>
                <li><strong>Fabbrica di gioielli e pietre preziose</strong> – Artigianato scintillante</li>
                <li><strong>Cavalcata di elefanti</strong> – Interazione etica</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Roccia del Leone di Sigiriya</strong> – Patrimonio mondiale dell'UNESCO</li>
                <li><strong>Tour della città antica di Polonnaruwa</strong> – Città culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tour della città antica di Anuradhapura</strong> – Esplorazione storica</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Sigiriya, Nuwara Eliya e Kandy (Hotel di lusso)</h3>`
                },
                '21': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Colombo culturale',
                    duration: '5 giorni',
                    category: 'Culturale e paesaggistico',
                    description: 'Dalle alture nebbiose ai templi sacri — un viaggio dell\'anima attraverso il cuore dello Sri Lanka.',
                    itinerary: `<h3>Giorno 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari nel Parco Nazionale Yala</strong> – Tour in jeep mattutino</li>
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Escursione panoramica</li>
                <li><strong>Giro in treno</strong> – Lussuosa gita in treno</li>
            </ul>
            <h3 class="mt-4">Giorno 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
                <li><strong>Tempio indù</strong> – Visita culturale</li>
                <li><strong>Ambuluwawa</strong> – Passeggiate tranquille</li>
                <li><strong>Giardini Botanici Reali</strong> – Paradiso tropicale</li>
                <li><strong>Fabbrica di tè</strong> – Esperienza del tè di Ceylon</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Visita sacra</li>
                <li><strong>Fabbrica di gioielli e pietre preziose</strong> – Artigianato scintillante</li>
                <li><strong>Cavalcata di elefanti</strong> – Interazione etica</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Roccia del Leone di Sigiriya</strong> – Patrimonio mondiale dell'UNESCO</li>
                <li><strong>Tour della città antica di Polonnaruwa</strong> – Città culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tour della città di Colombo</strong> – Esplorazione urbana</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Nuwara Eliya, Sigiriya, Polonnaruwa e Kandy (Hotel di lusso)</h3>`
                },
                '22': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Galle culturale',
                    duration: '5 giorni',
                    category: 'Culturale e paesaggistico',
                    description: 'Dalle alture nebbiose ai templi sacri — un viaggio dell\'anima attraverso il cuore dello Sri Lanka.',
                    itinerary: `<h3>Giorno 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Safari nel Parco Nazionale Yala</strong> – Tour in jeep mattutino</li>
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Escursione panoramica</li>
                <li><strong>Giro in treno</strong> – Lussuosa gita in treno</li>
            </ul>
            <h3 class="mt-4">Giorno 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
                <li><strong>Tempio indù</strong> – Visita culturale</li>
                <li><strong>Ambuluwawa</strong> – Passeggiate tranquille</li>
                <li><strong>Giardini Botanici Reali</strong> – Paradiso tropicale</li>
                <li><strong>Fabbrica di tè</strong> – Esperienza del tè di Ceylon</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Visita sacra</li>
                <li><strong>Fabbrica di gioielli e pietre preziose</strong> – Artigianato scintillante</li>
                <li><strong>Cavalcata di elefanti</strong> – Interazione etica</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Roccia del Leone di Sigiriya</strong> – Patrimonio mondiale dell'UNESCO</li>
                <li><strong>Tour della città antica di Polonnaruwa</strong> – Città culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Città di Galle</strong> – Esplorazione coloniale</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Nuwara Eliya, Sigiriya, Polonnaruwa e Galle (Hotel di lusso)</h3>`
                },
                '23': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Colombo',
                    duration: '6 giorni',
                    category: 'Culturale e paesaggistico',
                    description: 'Dalle alture nebbiose ai templi sacri — un viaggio dell\'anima attraverso il cuore dello Sri Lanka.',
                    itinerary: `<h3>Giorno 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Escursione panoramica</li>
                <li><strong>Giro in treno</strong> – Lussuosa gita in treno</li>
            </ul>
            <h3 class="mt-4">Giorno 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
                <li><strong>Tempio indù</strong> – Visita culturale</li>
                <li><strong>Ambuluwawa</strong> – Passeggiate tranquille</li>
                <li><strong>Giardini Botanici Reali</strong> – Paradiso tropicale</li>
                <li><strong>Fabbrica di tè</strong> – Esperienza del tè di Ceylon</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Visita sacra</li>
                <li><strong>Fabbrica di gioielli e pietre preziose</strong> – Artigianato scintillante</li>
                <li><strong>Cavalcata di elefanti</strong> – Interazione etica</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Roccia del Leone di Sigiriya</strong> – Patrimonio mondiale dell'UNESCO</li>
                <li><strong>Tour della città antica di Polonnaruwa</strong> – Città culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tour della città antica di Anuradhapura</strong> – Esplorazione storica</li>
            </ul>
            <h3 class="mt-4">Giorno 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tour della città di Colombo</strong> – Esplorazione urbana</li>
                <li><strong>Città di Galle</strong> – Esplorazione coloniale</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Ella, Nuwara Eliya, Sigiriya (Hotel di lusso)</h3>`
                },
                '24': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Colombo',
                    duration: '6 giorni',
                    category: 'Culturale e paesaggistico',
                    description: 'Dalle alture nebbiose ai templi sacri — un viaggio dell\'anima attraverso il cuore dello Sri Lanka.',
                    itinerary: `<h3>Giorno 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Escursione panoramica</li>
                <li><strong>Giro in treno</strong> – Lussuosa gita in treno</li>
            </ul>
            <h3 class="mt-4">Giorno 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
                <li><strong>Tempio indù</strong> – Visita culturale</li>
                <li><strong>Ambuluwawa</strong> – Passeggiate tranquille</li>
                <li><strong>Giardini Botanici Reali</strong> – Paradiso tropicale</li>
                <li><strong>Fabbrica di tè</strong> – Esperienza del tè di Ceylon</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Visita sacra</li>
                <li><strong>Fabbrica di gioielli e pietre preziose</strong> – Artigianato scintillante</li>
                <li><strong>Cavalcata di elefanti</strong> – Interazione etica</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Roccia del Leone di Sigiriya</strong> – Patrimonio mondiale dell'UNESCO</li>
                <li><strong>Tour della città antica di Polonnaruwa</strong> – Città culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tour della città antica di Anuradhapura</strong> – Esplorazione storica</li>
            </ul>
            <h3 class="mt-4">Giorno 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tour della città di Colombo</strong> – Esplorazione urbana</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Ella, Nuwara Eliya, Kandy, Sigiriya e Colombo (Hotel di lusso)</h3>`
                },
                '25': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Galle',
                    duration: '6 giorni',
                    category: 'Culturale e paesaggistico',
                    description: 'Dalle alture nebbiose ai templi sacri — un viaggio dell\'anima attraverso il cuore dello Sri Lanka.',
                    itinerary: `<h3>Giorno 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Cascata Ravana</strong> – Bagno veloce</li>
                <li><strong>Ponte dalle nove arcate</strong> – Attraversamento del treno</li>
                <li><strong>Piccolo Picco di Adamo</strong> – Escursione panoramica</li>
                <li><strong>Giro in treno</strong> – Lussuosa gita in treno</li>
            </ul>
            <h3 class="mt-4">Giorno 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Piantagione di tè</strong> – Viste da colline</li>
                <li><strong>Tempio indù</strong> – Visita culturale</li>
                <li><strong>Ambuluwawa</strong> – Passeggiate tranquille</li>
                <li><strong>Giardini Botanici Reali</strong> – Paradiso tropicale</li>
                <li><strong>Fabbrica di tè</strong> – Esperienza del tè di Ceylon</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Visita sacra</li>
                <li><strong>Fabbrica di gioielli e pietre preziose</strong> – Artigianato scintillante</li>
                <li><strong>Cavalcata di elefanti</strong> – Interazione etica</li>
                <li><strong>Tempio d'oro</strong> – Visita culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Roccia del Leone di Sigiriya</strong> – Patrimonio mondiale dell'UNESCO</li>
                <li><strong>Tour della città antica di Polonnaruwa</strong> – Città culturale</li>
            </ul>
            <h3 class="mt-4">Giorno 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tour della città antica di Anuradhapura</strong> – Esplorazione storica</li>
            </ul>
            <h3 class="mt-4">Giorno 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Città di Galle</strong> – Esplorazione coloniale</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Pernottamento a Ella, Nuwara Eliya, Kandy, Sigiriya e Galle (Hotel di lusso)</h3>`
                },
            },

        },
    },
    zh: {
        translation: {
            home: '首页',
            aboutUs: '关于我们',
            sriLankanav: '斯里兰卡',
            gallerynav: '画廊',
            bookATour: '预订旅游',
            thingsToDo: '活动',
            contactUs: '联系我们',
        },
        // Chinese (zh)
        contactus: {
            heroTitle: '联系我们',
            heroSubtitle: 'Star Lanka Tours Sri Lanka - 您通往斯里兰卡难忘冒险的门户',
            feelFree: '随时与我们联系',
            planDream: '规划您在斯里兰卡的梦想冒险',
            reachOutDesc: '联系Star Lanka Tours Sri Lanka，获取个性化旅游套餐、专业建议和在整个斯里兰卡难忘的旅行体验。',
            callCenter: '呼叫中心',
            phone: '+94 76 805 1224', // ← Change to your real WhatsApp/call number
            emailTitle: '电子邮件',
            email: 'info@starlankatours.com', // ← Change to your real email   
            locationTitle: '我们的位置',
            location: 'Beruwala / Bentota, 斯里兰卡', // ← Update to your actual address (e.g. if in Negombo like your location)
            socialTitle: '社交媒体',
            getInTouch: '保持联系',
            getInTouchDesc: '与Star Lanka Tours Sri Lanka一起探索斯里兰卡——我们全天候为您服务，让您的旅行难忘。',
            nameLabel: '姓名',
            namePlaceholder: '您的全名',
            emailLabel: '电子邮件',
            emailPlaceholder: '您的电子邮件地址',
            phoneLabel: '电话号码',
            phonePlaceholder: '+94 7X XXX XXXX',
            messageLabel: '留言',
            messagePlaceholder: '告诉我们您的梦想之旅...',
            sendButton: '发送消息',
            sendingButton: '发送中...',
            successMsg: '您的请求已通过WhatsApp发送！',
            errorMsg: '无法打开WhatsApp。请重试。',
            findUsTitle: '在斯里兰卡找到我们的位置',
        },
        // Simplified Chinese (zh)
        thingstodo: {
            heroTitle: '斯里兰卡难忘体验',
            heroSubtitle: '冒险 • 遗产 • 自然 • 养生',

            sectionTitle: '顶级活动 & 必体验项目',

            // Activity titles (used in cards)
            ayurveda: '地道阿育吠陀治疗与养生',
            diving: '世界级水肺潜水',
            elephantRide: '与温柔巨人们同行',
            fishing: '传统与深海钓鱼',
            ballooning: '魔幻热气球之旅',
            jeepSafari: '激动人心的吉普车Safari冒险',
            whiteWaterRafting: '肾上腺素飙升的漂流',
            riverSafari: '美丽的河流Safari之旅',
            snorkeling: '充满活力的浮潜体验',
            teaTasting: '锡兰红茶之旅与品鉴',
            templeVisit: '探索古老寺庙与圣地',
            wildlifeSafari: '五大动物与野生动物邂逅',

            viewMore: '查看更多',
        },
        // Simplified Chinese (zh)
        gallery: {
            heroTitle: '图库',
            heroSubtitle: '捕捉瞬间，珍藏回忆——我们的图库展示斯里兰卡的冒险、笑容和令人叹为观止的景色，让每一次旅程都变得难忘',

            tabPlaces: '地点',
            tabEvents: '活动',

            // Image labels (used in alt text and overlay)
            nuwaraEliya: '努沃勒埃利耶',
            sigiriya: '锡吉里耶',
            anuradhapura: '阿努拉德普勒',
            rambodaFalls: '兰博达瀑布',
            ella: '埃拉',
            yala: '亚拉国家公园',
            kandy: '康提',
            bodhiViharaya: '菩提寺',
            knuckles: '纳克尔斯山脉',
            udawalawe: '乌达瓦拉维国家公园',
            bentota: '本托塔船上Safari',
            colombo: '科伦坡',
            galle: '加勒堡',
            mirissa: '米瑞莎海滩',
            jaffna: '贾夫纳',
            ambuluwawaTower: '安布卢瓦瓦塔',
            turtle: '乌龟孵化场',
            polonnaruwa: '波隆纳鲁沃古城',
            polgampala: '波尔甘帕拉水池',
            beach: '斯里兰卡海滩',
        },
        // Simplified Chinese (zh)
        events: {
            heroTitle: '活动',
            heroSubtitle: '通过斯里兰卡的节日庆祝岛屿的精神——从神圣的佛教仪式到色彩缤纷的文化游行，每一个活动都是体验岛屿脉动心跳的机会。',

            tabPlaces: '地点',
            tabEvents: '活动',

            // Event names
            kandyPerahera: '康提埃萨拉佩拉赫拉（佛牙节）',
            vesak: '卫塞节',
            sinhalaNewYear: '僧伽罗与泰米尔新年',
            christmas: '圣诞节',
            thaiPongal: '泰蓬加尔节',
            deepavali: '排灯节',
            holi: '胡里节',
            poson: '波松节',
        },
        // Simplified Chinese (zh)
        srilanka: {
            heroTitle: '探索斯里兰卡',
            heroSubtitle: '印度洋上的珍珠',

            sectionPlaces: '斯里兰卡迷人景点',
            sectionFamous: '斯里兰卡著名特色',
            viewMore: '查看更多',

            // Intro paragraphs
            intro1: '斯里兰卡，被称为“翡翠岛”，是一颗热带宝石，以其壮丽的景观、古老的遗产和真挚的热情好客而闻名。',
            intro2: '拥有超过两千年的历史，斯里兰卡拥有联合国教科文组织世界遗产，如锡吉里耶岩石堡垒和神圣的阿努拉德普勒古城。其文化丰富融合了佛教、印度教和殖民影响，体现在充满活力的节日和精致的建筑中。',
            intro3: '岛屿多样的地形令人着迷——从埃拉起伏的茶园到亭可马里的碧蓝海水。像威尔帕图这样的国家公园栖息着豹子、鳄鱼和稀有鸟类，吸引着热爱自然的人们。',
            intro4: '对于寻求刺激的游客，斯里兰卡提供激流漂流、阿鲁甘湾冲浪以及穿越茂密丛林的徒步旅行。其美食融合芳香香料、新鲜鱼类和菠萝蜜，讲述着传统与风味的故事。',
            intro5: '从神圣的朝圣之旅到宁静的海滩逃逸，斯里兰卡承诺带来沉浸在美景与文化中的迷人体验。',

            // Place names & descriptions
            sigiriya: '锡吉里耶岩石堡垒',
            sigiriyaDesc: '联合国教科文组织遗址，拥有古老花园、壁画和令人叹为观止的山顶景色。',

            templeOfTooth: '佛牙寺',
            templeOfToothDesc: '神圣的佛教遗址，存放佛陀牙齿舍利。',

            ella: '埃拉',
            ellaDesc: '被茶园环绕的山城，以九拱桥闻名。',

            yala: '亚拉国家公园',
            yalaDesc: '以大象、豹子和野生动物Safari闻名。',

            galleFort: '加勒堡',
            galleFortDesc: '殖民堡垒，拥有鹅卵石街道和荷兰建筑。',

            nuwaraEliya: '努沃勒埃利耶',
            nuwaraEliyaDesc: '被称为“小英格兰”，气候凉爽，茶园遍布。',

            adamsPeak: '亚当峰',
            adamsPeakDesc: '神圣山峰，拥有独特足迹，是朝圣地。',

            hortonPlains: '霍顿平原',
            hortonPlainsDesc: '起伏丘陵、瀑布和世界尽头观景点。',

            bentota: '本托塔海滩',
            bentotaDesc: '原始海岸，金色沙滩和水上运动。',

            jaffna: '贾夫纳',
            jaffnaDesc: '泰米尔文化、历史和美食丰富。',

            anuradhapura: '阿努拉德普勒',
            anuradhapuraDesc: '古老城市，拥有神圣佛教遗址和废墟。',

            polonnaruwa: '波隆纳鲁沃',
            polonnaruwaDesc: '联合国教科文组织遗址，寺庙和雕像保存完好。',

            unawatuna: '乌纳瓦图纳海滩',
            unawatunaDesc: '充满活力的海滩，适合浮潜和夜生活。',

            colombo: '科伦坡',
            colomboDesc: '繁华首都，融合现代与殖民建筑。',

            udawalawe: '乌达瓦拉维国家公园',
            udawalaweDesc: '以大型象群和壮丽景观闻名。',

            dambulla: '丹布拉洞窟寺',
            dambullaDesc: '联合国教科文组织遗址，拥有古老佛教壁画和雕像。',

            // Famous Things
            ceylonTea: '锡兰红茶',
            ceylonTeaDesc: '以其风味闻名世界，尤其是努沃勒埃利耶和乌瓦产区。',

            spices: '香料',
            spicesDesc: '肉桂、豆蔻、丁香——斯里兰卡肉桂最佳。',

            gems: '宝石',
            gemsDesc: '蓝宝石、红宝石、月光石——稀有宝石之岛。',

            ayurveda: '阿育吠陀',
            ayurvedaDesc: '养生治疗，包括按摩和草药疗法。',

            handicrafts: '手工艺品',
            handicraftsDesc: '面具、蜡染、木雕、漆器。',

            elephants: '大象',
            elephantsDesc: '文化象征，在盛大节日游行中亮相。',

            food: '传统美食',
            foodDesc: '米饭咖喱、薄饼、Kottu Roti、Wattalappam。',

            festivals: '节日',
            festivalsDesc: '埃萨拉佩拉赫拉、卫塞节、僧伽罗-泰米尔新年。',

            coconut: '椰子产品',
            coconutDesc: '椰油、椰奶、椰棕纤维用于绳子和垫子。',

            sarees: '康提纱丽',
            sareesDesc: '优雅的传统礼服，用于仪式。',

            dances: '传统舞蹈',
            dancesDesc: '康提舞、魔鬼舞和低地舞。',

            stiltFishing: '高跷捕鱼',
            stiltFishingDesc: '南部海岸标志性捕鱼技术。',

            moonstones: '月光石',
            moonstonesDesc: '半宝石，米蒂亚戈达矿区著名。',

            cricket: '板球',
            cricketDesc: '全民热爱——1996年世界杯冠军。',

            herbs: '阿育吠陀草药',
            herbsDesc: '雷公根、肉桂、印楝用于治疗。',

            masks: '面具',
            masksDesc: '安巴朗戈达面具，用于仪式表演。',
        },
        // Simplified Chinese (zh)
        about: {
            hero: {
                discover: "探索",
                starLankaTours: "STAR LANKA TOURS",
                tagline1: "看看古老的大型遗迹、绿色的茶山和刺激的动物Safari。斯里兰卡充满活力。这座美丽的岛屿不仅仅是旅游地——它是一场大冒险。",
                tagline2: "阳光沙滩、云雾缭绕的山脉和无数惊喜在等着你。Star Lanka Tours Sri Lanka让每一分钟都变得特别。",
            },
            slider: {
                sigiriya: "锡吉里耶岩石堡垒",
                yala: "亚拉国家公园",
                tea: "茶叶之乡",
                beaches: "干净海滩",
                temples: "神圣寺庙"
            },
            about: {
                title: "关于 Star Lanka Tours Sri Lanka",
                signature: "专属斯里兰卡之旅"
            },
            tours: {
                days4: "4 天",
                classic: "基础行程",
                days5: "5 天",
                safari: "动物之旅",
                days6: "6 天",
                retreat: "宁静休憩",
                desc1: "Star Lanka Tours Sri Lanka带你游览这座美丽岛屿的每一个角落——热闹的城市、雾气缭绕的山丘和干净的南部海滩。",
                desc2: "享受斯里兰卡的最佳体验——神圣的康提、欢乐的科伦坡和宁静的南海岸。",
                desc3: "想要冒险、古老文化、动物还是宁静？Star Lanka Tours Sri Lanka全年打造精彩行程。"
            },
            whoWeAre: {
                title: "我们是谁",
                description: "<p>欢迎来到 Star Lanka Tours Sri Lanka——你探索这座神奇岛屿的朋友。我们的老板是导游 Nethaj。我们友好的本地团队打造行程，展示真实的斯里兰卡，而非普通的游客景点。</p><br /><p>我们带你去古老的城市、绿色的茶山、阳光沙滩和充满动物的公园。每一次旅行都让你感受到真正的文化、善良的人们、古老的传统和美丽的自然。</p><br /><p>想要文化、冒险、休息、健康还是特别的私人行程？我们精心规划，提供个性化帮助，确保你留下快乐的回忆。</p>",
                imageAlt: "Star Lanka Tours 团队",
                item1: { title: "游遍斯里兰卡", text: "我们从北到南——各地真实本地体验。" },
                item2: { title: "为你量身定制的行程", text: "根据你的喜好规划——冒险、文化、自然或休息。" },
                item3: { title: "优秀的本地导游", text: "Nethaj 和他的团队了解许多秘密地点、古老故事和斯里兰卡的真实感觉。" },
                item4: { title: "全天候帮助", text: "Star Lanka Tours 在你整个旅程中 24 小时提供帮助。" }
            },
            offers: {
                title: "我们为你提供什么",
                cultural: { title: "文化体验", text: "感受当地习俗、节日和日常生活。", alt: "文化体验" },
                adventure: { title: "冒险之旅", text: "徒步、动物Safari、海上乐趣和大自然活动。", alt: "冒险" },
                luxury: { title: "舒适与奢华", text: "优质酒店、私人车辆和专属服务。", alt: "奢华" },
                wellness: { title: "健康与放松", text: "瑜伽、阿育吠陀和宁静之地。", alt: "放松" }
            },
            guides: {
                title: "我们的导游",
                text: "Nethaj 是我们的主要旅游运营商。我们训练有素、热情的导游让你的旅程充满乐趣。他们带你去秘密地点、讲述古老故事，展示斯里兰卡的特别之处。",
                imageAlt: "Star Lanka Tours 导游 - Nethaj"
            },
            expert: {
                name: "Nethaj",
                role: "（首席导游 & 旅游运营商）",
                bio: "Nethaj 是 Star Lanka Tours Sri Lanka 的核心。他非常了解斯里兰卡。从海滩到高山、动物到古迹——他打造让你永生难忘的旅程。",
                imageAlt: "Nethaj - Star Lanka Tours"
            },
            vehicles: {
                title: "旅游车辆",
                text: "Star Lanka Tours Sri Lanka 注重你的安全与舒适。在 Nethaj 的监督下，我们使用现代、空调、干净的车辆，让你在岛上轻松旅行。",
                bookButton: "预订你的行程",
                car: { title: "轿车", text: "适合 2 或 3 人。小巧、省油，完美适合短途旅行。" },
                van: { title: "面包车", text: "适合家庭或小团体（最多 6 人）。宽敞舒适，适合长途驾驶。" },
                minibus: { title: "小型巴士", text: "适合更大团体（8–12 人）。舒适座椅和充足行李空间。" },
                luxury: { title: "豪华车", text: "非常舒适的车辆，配备软座、Wi-Fi 和私人司机。" }
            },
            accommodations: {
                intro: "入住优质的 3 星、4 星、5 星酒店和特别住宿。我们选择它们是为了让你在 Star Lanka Tours 旅程中享受宁静、美景和舒适。",
                item1: "带大泳池和放松海景的私人别墅。",
                item2: "海边老式豪华酒店，美食一流。",
                item3: "自然旅舍，现代房间，野生动物景观。",
                item4: "自然中的美丽住宅，绝佳景色和绿色设计。"
            },
            notices: {
                title: "免费额外服务",
                intro: "Star Lanka Tours Sri Lanka 在每趟旅程中为你提供这些免费内容：",
                bike: { title: "每位客人免费自行车", text: "自由骑行——我们为每人提供一辆自行车。" },
                fruits: { title: "结束时赠送新鲜水果", text: "用一份新鲜水果礼包结束你的旅程。" },
                meals: { title: "特殊活动免费餐饮", text: "参与本地传统——我们在金钱喂食仪式期间提供免费餐食。" }
            },
        },
        // Simplified Chinese (zh)
        home: {
            common: { viewAll: "查看全部" },
            sections: {
                recommendations: { title: "最佳景点", subtitle: "不知道去哪里？我们帮你选择。" },
                excursions: { title: "我们的行程", desc: "多日旅行——古老文化、自然与快乐回忆的完美结合。" },
                packages: { title: "特别套餐" },
                reviews: { title: "客人评价", subtitle: "与我们一起旅行的真实心声" },
                gallery: { title: "我们的照片", subtitle: "斯里兰卡的美图——充满惊叹、乐趣与美好瞬间。" }
            },
            recommendations: {
                sigiriya: { label: "锡吉里耶", name: "高耸地面的古老巨型岩石堡垒。" },
                udawalawa: { label: "乌达瓦拉维", name: "广阔原野，众多自由漫步的大象。" },
                ella: { label: "埃拉", name: "云雾缭绕的山丘，美丽火车之旅，壮观景色。" },
                mirissa: { label: "米瑞莎", name: "金黄沙滩，蔚蓝大海，观鲸绝佳地点。" },
                nuwaraeliya: { label: "努沃勒埃利耶", name: "大片茶园，清凉新鲜空气。" },
                kandy: { label: "康提", name: "神圣城市，拥有佛牙寺。" },
                galle: { label: "加勒", name: "海边的古老堡垒。" },
                yala: { label: "亚拉", name: "大型国家公园，有豹子、大象和众多野生动物。" },
                anuradhapura: { label: "阿努拉德普勒", name: "佛教起源的古老之地，巨大佛塔。" },
                polonnaruwa: { label: "波隆纳鲁沃", name: "很久以前的古城遗址。" }
            },
            excursions: {
                oneDay: { title: "1 天 – 一天游斯里兰卡", des: "充满魔力的一天——从古迹到阳光沙滩。" },
                twoDays: { title: "2 天 – 自然召唤", des: "两天野性自然：Safari、茶山、丛林之声。" },
                threeDays: { title: "3 天 – 灵魂与海洋", des: "三天滋养心灵——清晨寺庙，傍晚大海，真实文化。" },
                fourDays: { title: "4 天 – 古老与宁静", des: "四天古老奇迹：巨型堡垒、古街、真实传统。" },
                fiveDays: { title: "5 天 – 斯里兰卡之心", des: "五天爱上斯里兰卡——雾山到碧海。" },
                sixDays: { title: "6 天 – 特别之旅", des: "六天美好体验——圣地、动物Safari、宁静日落。" }
            },
            packages: {
                one: { title: "1 天 / 0 晚：一天游斯里兰卡", duration: "1 天", desc: "充实的一天——古老佛塔、金色沙滩，真实斯里兰卡感受。", category: "快速之旅" },
                two: { title: "2 天 / 1 晚：自然召唤", duration: "2 天", desc: "两天亲近自然——夜间Safari、茶香、丛林生活。", category: "野性之旅" },
                three: { title: "3 天 / 2 晚：灵魂与海洋", duration: "3 天", desc: "三天滋养灵魂——清晨寺庙，夜晚宁静大海。", category: "海洋与心灵" },
                four: { title: "4 天 / 3 晚：古老与宁静", duration: "4 天", desc: "四天古老风情——堡垒、古镇、真实文化。", category: "文化之旅" },
                five: { title: "5 天 / 4 晚：斯里兰卡之心", duration: "5 天", desc: "五天爱上这座岛——山丘、碧海、幸福时刻。", category: "爱之旅" },
                six: { title: "6 天 / 5 晚：特别之旅", duration: "6 天", desc: "六天最佳体验——圣地、动物、美丽日落。", category: "最佳之旅" }
            },
            featured: {
                perahera: {
                    h2: "来看这场盛大表演", h3: "康提埃萨拉佩拉赫拉", h4: "（佛牙节）",
                    paragraph: `亚洲最大的佛教节日之一。每年在康提，人们向圣牙致敬。身着华服的大象、响亮的鼓声、火舞者和灯光，营造出美丽的夜晚。与 <strong style="color: #166880;">Star Lanka Tours Sri Lanka</strong> 一起来体验——这里文化鲜活生动。`,
                    button: "了解更多"
                },
                safari: {
                    h2: "走进野性世界", h3: "Safari 之旅",
                    paragraph: `斯里兰卡拥有亚洲最棒的野生动物。在 <span style="color: #D5A44F; font-weight: 600;">亚拉</span> 和 <span style="color: #D5A44F; font-weight: 600;">乌达瓦拉维</span> 的广阔原野，或 <span style="color: #D5A44F; font-weight: 600;">威尔帕图</span> 的湖泊，遇见大象、豹子和众多鸟类。与 <strong style="color: #166880;">Star Lanka Tours Sri Lanka</strong> 一起旅行——每一次Safari都是一段新故事。`,
                    button: "查看Safari"
                }
            },
            gallery: {
                title: "我们的照片", subtitle: "斯里兰卡的美图——充满惊叹、乐趣与美丽。",
                alt1: "锡吉里耶岩石上的日出", alt2: "亚拉国家公园的大象", alt3: "雾气缭绕的努沃勒埃利耶茶园工人",
                alt4: "米瑞莎海滩的日落", alt5: "康提寺的祈祷", alt6: "波隆纳鲁沃的古老遗迹",
                alt7: "南部海岸附近的鲸鱼", alt8: "埃拉山丘的火车之旅", alt9: "加勒堡的傍晚光影",
                alt10: "内贡博的渔民", alt11: "康提舞蹈表演", alt12: "丹布拉上空的热气球"
            },
            cta: {
                title: "Star Lanka Tours Sri Lanka —— 打造快乐旅程",
                desc: "每一次旅行都独一无二——充满文化、乐趣与宁静时光。让我们为你书写在美丽斯里兰卡的故事。",
                button: "立即开始",
                alt: "开启你的旅程"
            },
        },
        // Simplified Chinese (zh)
        hero: {
            title: {
                line1: "与",
                line2: "Star Lanka Tours",
                line3: "斯里兰卡一起发现天堂"
            },
            subtitle: "沉浸在郁郁葱葱的翡翠丛林、阳光普照的金色海岸、永恒的古老城市和激动人心的野生动物冒险中——",
            subtitle2: "完美贴合您的梦想。",

            cta: "开启您的冒险",
            trust: "深受来自超过50个国家的旅行者喜爱 • 获得全球顶级旅行专家认可"
        },
        // Simplified Chinese (zh)
        footer: {
            brand: "Star Lanka Tours",

            nav: {
                home: "首页",
                about: "关于我们",
                explore: "探索斯里兰卡",
                tours: "旅游套餐",
                gallery: "图库",
                events: "特别活动",
                things: "活动推荐",
                contact: "联系我们"
            },

            contact: {
                title: "让我们一起创造美好回忆",
                address: "Beruwala Area,<br />Western Province, Sri Lanka",
                email: "info@starlankatours.com",          // ← change to your real email
                phone: "+94 76 805 1224"                   // ← change to your real phone/WhatsApp number
            },

            newsletter: {
                title: "加入我们的冒险",
                desc: "第一时间获取斯里兰卡的特别优惠、秘密景点和精彩旅行的最新消息。",
                placeholder: "您的电子邮件地址",
                subscribe: "订阅"
            },

            tagline: "\"并非所有漫游者都迷失……<br /><span class='text-[#96BA33] font-semibold'>有些人与 Star Lanka Tours 一起旅行</span>\"",

            copyright: "保留所有权利。",
            developedBy: "设计由"
        },
        ayurveda: {
            title: "阿育吠陀——古老的生命科学",
            introParagraph1: "“阿育吠陀”一词已有三千多年历史，在梵语中意为“生命的科学”。这种疗法注重治疗疾病的根源，而非仅处理症状，提出以下原则：",
            corePrinciplesTitle: "核心原则",
            principle1: "身体应保持能量平衡，以维持正常的新陈代谢和心脏功能。",
            principle2: "身体应有规律的肌肉收缩与稳定的荷尔蒙活动。",
            principle3: "身体需要健康的免疫系统以正常运作。",
            sriLankaDoctors: "目前斯里兰卡有超过6000名阿育吠陀毕业生，需完成7年学习和2年公共医院实习。常见疗程包括：",
            benefit1: "缓解压力、疲劳和焦虑",
            benefit2: "提升氧气供给",
            benefit3: "刺激肌肉系统、排除毒素",
            benefit4: "恢复神经系统平衡",
            benefit5: "改善内脏血液循环",
            benefit6: "促进内啡肽分泌",
            mainImageAlt: "阿育吠陀身心疗愈",
            faceTreatmentAlt: "阿育吠陀面部护理",
            faceTreatmentCaption: "阿育吠陀面部护理",
            massageTreatmentAlt: "阿育吠陀按摩疗程",
            massageTreatmentCaption: "阿育吠陀按摩疗程",
            treatmentDescription: "标准疗程包含全身和头皮按摩、草本蒸汽浴、草本浸泡等。最受欢迎的是“滴油疗”(Shirodhara)，将温热草本油有节奏地滴在额头，帮助放松并平衡神经系统。",
            tipsTitle: "阿育吠陀小贴士",
            tip1: "放下烦恼，放松心神，有助于疗效。",
            tip2: "选择让你舒适的环境，更易疗愈。",
            tip3: "与医生沟通，选择适合的疗程并尝试不同方案。",
            tip4: "疗程前洗个热水澡，放松肌肉、准备身体。",
            tip5: "疗程前吃清淡食物，避免油腻以保持良好血流。",
            tip6: "疗程后充分休息，能显著提升效果。"
        },
        ballooning: {
            title: "斯里兰卡热气球",
            introParagraph1: "在斯里兰卡乘热气球，于日出时分缓缓升空，俯瞰起伏山丘、茂密森林、古老遗址和宁静村庄，体验独特而难忘的旅程。",
            introParagraph2: "最受欢迎的地点在文化三角中心的丹布勒，常飞越标志性的锡吉里耶狮子岩。飞行约60–90分钟，足够尽情欣赏空中美景。",
            mainImageAlt: "斯里兰卡热气球飞行",
            mainImageCaption: "斯里兰卡热气球飞行",
            highlightsTitle: "为何选择热气球？",
            highlightsIntro: "热气球结合冒险与宁静，以全新视角欣赏斯里兰卡：",
            highlight1: "连续的全景视野，尽览壮丽风光。",
            highlight2: "飞越狮子岩等地标与湖泊。",
            highlight3: "安静平稳的旅程，穿越绿野与村庄。",
            highlight4: "在空中迎接震撼的日出。",
            highlight5: "摄影爱好者的理想选择。",
            sunriseImageAlt: "在热气球上欣赏震撼日出。",
            sunriseImageCaption: "在热气球上欣赏震撼日出。",
            landscapeImageAlt: "俯瞰斯里兰卡的山丘与森林。",
            landscapeImageCaption: "俯瞰斯里兰卡的山丘与森林。",
            tipsTitle: "飞行小贴士",
            tip1: "提前预订，受天气影响名额有限。",
            tip2: "穿舒适衣物，带轻便外套，清晨略凉。",
            tip3: "携带相机/手机，记录美景。",
            tip4: "听从飞行员的安全说明。",
            tip5: "准时到场，观看气球充气的有趣过程。"
        },
        diving: {
            title: "斯里兰卡潜水",
            introParagraph1: "斯里兰卡海岸外有宽广的珊瑚礁，水深2–40米。27–30°C的温暖海水和15–35米的能见度，提供极佳潜水与浮潜条件，可探访原始珊瑚、古老沉船与海底洞穴。",
            introParagraph2: "东北海域有130余种彩色珊瑚，栖息海龟、小丑鱼、狮子鱼、海马等。前往岩礁附近的沉船点，畅游清澈海水，仿佛回到锡兰的海洋历史。",
            mainImageAlt: "在斯里兰卡潜水",
            mainImageCaption: "在斯里兰卡潜水",
            facilitiesTitle: "设施与最佳潜点",
            facilitiesParagraph1: "岛上潜店配备知名品牌新式装备，PADI/CMAS教练确保安全。西南海岸潜店营运期为10月中至4月底；东北（尼拉维利、亭可马里）最佳时间为3–10月。",
            facilitiesParagraph2: "西部卡尔皮提耶的珊瑚礁与希卡杜瓦的沉船点深受潜水员喜爱。",
            coralImageAlt: "探索缤纷珊瑚礁与丰富海洋生物。",
            coralImageCaption: "探索缤纷珊瑚礁与丰富海洋生物。",
            shipwreckImageAlt: "发现历史沉船，了解斯里兰卡海洋过去。",
            shipwreckImageCaption: "发现历史沉船，了解斯里兰卡海洋过去。",
            tipsTitle: "潜水小贴士",
            tip1: "根据区域选季节：西南10–4月，东北3–10月。",
            tip2: "确认潜店有认证并配备现代装备。",
            tip3: "听从教练建议，尤其是初学者。",
            tip4: "尊重海洋生物，不触碰珊瑚、不干扰环境。",
            tip5: "带防水相机，记录海底之美。"
        },
        elephantRide: {
            title: "大象骑行体验",
            introParagraph1: "在文化三角（哈巴拉那、锡吉里耶、丹布勒）可参加大象骑行，约30美元/小时，独特且刺激。",
            introParagraph2: "骑行前会为大象安装可容纳4–6人的篮式座椅。温柔巨兽将带你穿越丛林小径、涉水越过浅滩，缓慢行进，让你尽情欣赏自然景观，最高时速可达40公里/小时。",
            mainImageAlt: "斯里兰卡大象骑行",
            mainImageCaption: "斯里兰卡大象骑行",
            highlightsTitle: "骑行亮点",
            highlightsIntro: "在斯里兰卡骑大象，是亲近自然的独特方式：",
            highlight1: "穿行茂密丛林，邂逅热带植被与野生动物。",
            highlight2: "涉水过河、穿越淹没区，欣赏壮丽景色。",
            highlight3: "了解大象与斯里兰卡文化的紧密联系。",
            highlight4: "舒适座椅上放松，感受大象平稳的步伐。",
            jungleImageAlt: "骑象探索丛林与美景小径。",
            jungleImageCaption: "骑象探索丛林与美景小径。",
            waterImageAlt: "跨过河流，欣赏水面与植被的静谧。",
            waterImageCaption: "跨过河流，欣赏水面与植被的静谧。",
            tipsTitle: "安全舒适小贴士",
            tip1: "穿着舒适的户外服与鞋。",
            tip2: "遵循向导指示以确保安全。",
            tip3: "确认营运方善待大象并遵循伦理。",
            tip4: "携带相机捕捉风景与瞬间。",
            tip5: "尊重大象，避免让它们紧张或受伤。"
        },
        fishing: {
            title: "斯里兰卡垂钓",
            introParagraph1: "斯里兰卡拥有绵长海岸线与丰富的淡水湖河，提供无与伦比的钓鱼体验。无论专业或爱好者，都能找到乐趣：从远洋钓到传统的桩钓。",
            introParagraph2: "热门地点包括南岸加勒、米瑞莎，内贡博泻湖，以及亭可马里的静谧水域。可尝试拖钓、底钓或飞蝇等多种方式。",
            mainImageAlt: "斯里兰卡钓鱼",
            mainImageCaption: "斯里兰卡钓鱼",
            experiencesTitle: "钓鱼体验",
            experiencesIntro: "钓鱼不仅是收获，更是融入岛上文化：",
            expStiltTitle: "桩钓",
            expStiltDesc: "渔民坐在海边木桩上垂钓，是斯里兰卡独有的传统。",
            expDeepSeaTitle: "深海钓",
            expDeepSeaDesc: "驶向印度洋，挑战马林鱼、金枪鱼、梭鱼等大鱼。",
            expLagoonTitle: "泻湖与河流钓",
            expLagoonDesc: "在宁静的泻湖/河流垂钓，常见罗非鱼、鲶鱼等。",
            expNightTitle: "夜钓",
            expNightDesc: "星空下的夜钓体验，沿海村庄常见。",
            stiltImageAlt: "桩钓是斯里兰卡渔业文化的标志。",
            stiltImageCaption: "桩钓是斯里兰卡渔业文化的标志。",
            deepSeaImageAlt: "深海钓充满冒险，目标大型海鱼。",
            deepSeaImageCaption: "深海钓充满冒险，目标大型海鱼。",
            tipsTitle: "出钓小贴士",
            tip1: "选择合适季节：南岸10–4月，东岸3–10月。",
            tip2: "带防晒、帽子与防护衣物，保持舒适。",
            tip3: "预约向导或包船，提升体验并向专家学习。",
            tip4: "尊重环境，不乱丢垃圾，践行可持续钓法。",
            tip5: "保持水分，长程可备少量零食。"
        },
        jeepSafari: {
            title: "吉普车野生动物园",
            introParagraph1: "斯里兰卡的国家公园提供刺激的吉普车野生动物园，可近距离观察岛上丰富的生物多样性。雅拉、维尔帕图、乌达瓦拉维等是热门选择。",
            introParagraph2: "你可能看到大象、豹、懒熊、水牛、鳄鱼及众多鸟类。在资深自然向导陪同下，非常适合野生动物爱好者与摄影师。",
            mainImageAlt: "斯里兰卡吉普车游猎",
            mainImageCaption: "斯里兰卡吉普车游猎",
            whyChooseTitle: "为什么选择吉普游猎？",
            whyChooseIntro: "这是探索斯里兰卡野生动植物的最佳方式之一：",
            highlight1: "近距离遇见大象、豹等标志性物种。",
            highlight2: "进入公园深处的偏远景观。",
            highlight3: "在自然环境中进行野生动物摄影。",
            highlight4: "由资深自然学家和护林员引导。",
            highlight5: "老少皆宜，兼具刺激与科普。",
            wildlifeImageAlt: "在游猎中邂逅豹、大象和鳄鱼。",
            wildlifeImageCaption: "在游猎中邂逅豹、大象和鳄鱼。",
            landscapeImageAlt: "探索从密林到开阔平原的多样景观。",
            landscapeImageCaption: "探索从密林到开阔平原的多样景观。",
            tipsTitle: "游猎小贴士",
            tip1: "穿中性色舒适衣物，便于融入环境。",
            tip2: "带防晒、帽子和防蚊用品。",
            tip3: "携带望远镜与相机，提升观赏与记录。",
            tip4: "遵从向导指示，确保安全并尊重动物。",
            tip5: "旺季请提前预约以确保名额。"
        },
        riverSafari: {
            title: "河流游船探险",
            introParagraph1: "河流游船让你以轻松方式探索岛上的丰富生物与风景。沿着静谧水道穿梭在茂密红树林间，邂逅奇异野生动物，欣赏迷人日落。",
            introParagraph2: "热门地点有马杜河与本托塔河，可观赏多种鸟类、巨蜥、鳄鱼，甚至猴子。静谧环境非常适合自然爱好者与摄影师。",
            mainImageAlt: "斯里兰卡河流游船",
            mainImageCaption: "斯里兰卡河流游船",
            whyChooseTitle: "为何选择河流游船？",
            whyChooseIntro: "这是一种融合自然、野生动物与文化的沉浸体验：",
            highlight1: "探索充满生命力的红树林。",
            highlight2: "发现奇异鸟类、鳄鱼及其他动物。",
            highlight3: "造访河中小岛与当地村落。",
            highlight4: "享受水道的宁静与美景。",
            highlight5: "适合家庭、情侣与独行旅客的惬意之选。",
            mangrovesImageAlt: "发现沿河的茂密红树林。",
            mangrovesImageCaption: "发现沿河的茂密红树林。",
            wildlifeImageAlt: "在游船中观察鳄鱼、巨蜥和色彩斑斓的鸟类。",
            wildlifeImageCaption: "在游船中观察鳄鱼、巨蜥和色彩斑斓的鸟类。",
            tipsTitle: "游船小贴士",
            tip1: "穿舒适衣物，携带帽子和防晒。",
            tip2: "带上望远镜以便远距离观鸟。",
            tip3: "带相机/手机记录风景与野生动物。",
            tip4: "遵循向导指示，确保安全。",
            tip5: "爱护环境，不乱扔垃圾、不惊扰动物。"
        },
        snorkeling: {
            title: "斯里兰卡浮潜",
            introParagraph1: "斯里兰卡的浮潜体验难忘，可探索多彩珊瑚礁与丰富海洋生物。清澈暖水和健全生态让各水平的潜友都能尽兴。",
            introParagraph2: "热门地点包括希卡杜瓦（缤纷珊瑚与海龟）、亭可马里鸽子岛（原始珊瑚），以及米瑞莎（季节性可见鲸鱼）。",
            mainImageAlt: "斯里兰卡浮潜",
            mainImageCaption: "斯里兰卡浮潜",
            whyChooseTitle: "为何选择浮潜？",
            whyChooseIntro: "融合冒险与自然美：",
            highlight1: "探索充满生机的珊瑚礁。",
            highlight2: "与热带鱼、海龟甚至礁鲨共游。",
            highlight3: "在温暖清澈的海水中欣赏原始海底景观。",
            highlight4: "适合新手与高手。",
            highlight5: "可从多处优质海滩便捷出发。",
            coralImageAlt: "欣赏壮丽的珊瑚礁及生态。",
            coralImageCaption: "欣赏壮丽的珊瑚礁及生态。",
            marineLifeImageAlt: "邂逅多样海洋生物，如海龟与热带鱼。",
            marineLifeImageCaption: "邂逅多样海洋生物，如海龟与热带鱼。",
            tipsTitle: "浮潜小贴士",
            tip1: "佩戴合适的面镜与呼吸管，确保清晰视野。",
            tip2: "使用对珊瑚友好的防晒品，保护皮肤与海洋。",
            tip3: "轻柔踢水，避免碰撞珊瑚、惊扰生物。",
            tip4: "及时补水，分段休息。",
            tip5: "参加导览团，获取最佳点位和安全指引。"
        },
        teaTasting: {
            title: "斯里兰卡品茶之旅",
            introParagraph1: "斯里兰卡被称为“印度洋明珠”，以世界级红茶闻名。前往努沃勒埃利耶、埃拉、康提的茶园，了解种植与制茶工艺，品味醇厚的锡兰茶。",
            introParagraph2: "无论你是茶迷还是好奇旅行者，品茶之旅都是深入茶文化、体验高地宁静的绝佳机会。",
            mainImageAlt: "斯里兰卡品茶之旅",
            mainImageCaption: "斯里兰卡品茶之旅",
            whyChooseTitle: "为何选择品茶之旅？",
            whyChooseIntro: "不仅是品饮，更是沉浸式文化体验：",
            highlight1: "造访清凉高地的秀美茶园。",
            highlight2: "了解锡兰茶的历史与重要性。",
            highlight3: "参与采茶，参观制茶工厂。",
            highlight4: "品尝红茶、绿茶与调味茶多种风味。",
            highlight5: "欣赏迷雾山峦与瀑布景色。",
            plantationImageAlt: "漫步茶园，学习茶叶种植。",
            plantationImageCaption: "漫步茶园，学习茶叶种植。",
            preparationImageAlt: "探索泡茶艺术，品味正宗锡兰茶。",
            preparationImageCaption: "探索泡茶艺术，品味正宗锡兰茶。",
            tipsTitle: "品茶小贴士",
            tip1: "穿舒适衣物与鞋子，便于园中行走。",
            tip2: "高地较凉且多雾，可带轻便外套。",
            tip3: "多尝几款茶，选喜欢的带回家。",
            tip4: "多向向导提问，加深对制茶流程的了解。",
            tip5: "可将行程与附近瀑布和观景点搭配。"
        },
        templeVisit: {
            title: "斯里兰卡寺庙之旅",
            introParagraph1: "斯里兰卡被称为佛国，古老寺庙展现丰富的精神与文化遗产。造访康提佛牙寺、丹布勒石窟寺、阿努拉德普勒的鲁梵维利大塔等地标。",
            introParagraph2: "这些神圣场所饰有精美雕刻、壁画与佛像，呈现岛上的精神传统与建筑巧思。寺庙之旅既是文化体验，也是寻求平静的机会。",
            mainImageAlt: "斯里兰卡寺庙参观",
            mainImageCaption: "斯里兰卡寺庙参观",
            whyVisitTitle: "为何参观寺庙？",
            whyVisitIntro: "连接历史、文化与心灵的独特机会：",
            highlight1: "欣赏精致建筑与百年佛像。",
            highlight2: "从专业导览了解佛教传统与仪式。",
            highlight3: "探索如丹布勒金寺等世界遗产。",
            highlight4: "感受神圣空间的宁静与氛围。",
            highlight5: "观赏佛牙寺的埃萨拉游行等节庆。",
            interiorImageAlt: "欣赏雕刻与壁画点缀的壮丽内饰。",
            interiorImageCaption: "欣赏雕刻与壁画点缀的壮丽内饰。",
            sacredImageAlt: "参观鲁梵维利大塔等圣地，沉浸精神传统。",
            sacredImageCaption: "参观鲁梵维利大塔等圣地，沉浸精神传统。",
            tipsTitle: "寺庙参观贴士",
            tip1: "着装端庄，遮住肩膀与膝盖。",
            tip2: "入寺前脱鞋。",
            tip3: "勿触摸佛像或圣物。",
            tip4: "如愿，可带小额供养。",
            tip5: "保持安静，尊重庄严氛围。"
        },
        whiteWaterRafting: {
            title: "斯里兰卡激流漂流",
            introParagraph1: "激流漂流在斯里兰卡极受欢迎，尤其在冒险之都基图加勒。凯勒尼河的湍急河段与青翠景致，适合新手与高手。",
            introParagraph2: "行程通常约5公里，急流等级2–4级。你将在征服浪涛时，欣赏雨林与山地的壮丽。",
            mainImageAlt: "斯里兰卡激流漂流",
            mainImageCaption: "斯里兰卡激流漂流",
            whyChooseTitle: "为何选择激流漂流？",
            whyChooseIntro: "融合冒险与自然之美的体验：",
            highlight1: "在专业教练带领下冲击刺激急流。",
            highlight2: "饱览雨林与山峦景观。",
            highlight3: "可在基图加勒搭配徒步、观鸟、峡谷探险。",
            highlight4: "适合团体、家庭与追求肾上腺素的旅人。",
            actionImageAlt: "征服凯勒尼河急流的肾上腺素瞬间。",
            actionImageCaption: "征服凯勒尼河急流的肾上腺素瞬间。",
            scenicImageAlt: "漂流途中欣赏葱郁环境的宁静。",
            scenicImageCaption: "漂流途中欣赏葱郁环境的宁静。",
            tipsTitle: "安全刺激的小贴士",
            tip1: "穿好救生衣和头盔，遵循教练要求。",
            tip2: "出发前仔细听安全讲解。",
            tip3: "穿舒适快干衣物和防滑水鞋。",
            tip4: "带换洗衣物与毛巾，以便结束后使用。",
            tip5: "选择信誉良好的运营商，确保安全体验。"
        },
        wildlifeSafari: {
            title: "斯里兰卡野生动物园",
            introParagraph1: "斯里兰卡以丰富的生物多样性著称，雅拉、维尔帕图、米内日亚、乌达瓦拉维等公园提供绝佳的野生动物园体验，可观赏大象、豹、懒熊及众多鸟类。",
            introParagraph2: "穿越茂密森林与开阔草原，捕捉野生动物的精彩瞬间。在资深向导和维护良好的吉普陪同下，这是自然与冒险爱好者不可错过的行程。",
            mainImageAlt: "斯里兰卡野生动物园",
            mainImageCaption: "斯里兰卡野生动物园",
            whyChooseTitle: "为何选择野生动物园？",
            whyChooseIntro: "与自然连结、探索岛屿生物多样性的绝佳机会：",
            highlight1: "观赏大象、豹、鳄鱼等标志性物种。",
            highlight2: "探索森林、湿地与草原等多元栖息地。",
            highlight3: "在自然环境中拍摄震撼野生影像。",
            highlight4: "体验寻找珍稀斯里兰卡豹的刺激。",
            highlight5: "从向导与自然学家处了解保育努力。",
            elephantsImageAlt: "欣赏在公园自由漫步的雄伟大象。",
            elephantsImageCaption: "欣赏在公园自由漫步的雄伟大象。",
            leopardImageAlt: "邂逅难得一见的斯里兰卡豹——行程亮点。",
            leopardImageCaption: "邂逅难得一见的斯里兰卡豹——行程亮点。",
            tipsTitle: "精彩游猎小贴士",
            tip1: "穿中性色服装以融入环境。",
            tip2: "带防晒、帽子与驱蚊用品。",
            tip3: "携带望远镜和相机，捕捉野生瞬间。",
            tip4: "遵循向导指示，确保安全与礼貌观赏。",
            tip5: "旺季请提前预约热门公园名额。"
        },
        tourpackages: {
            heroTitle: '我们的旅游套餐',
            heroSubtitle: '在一天内探索斯里兰卡 — 来自 <span class="text-[#009CE6] font-bold">Star Lanka Tours</span> 的定制冒险',
            heroAlt: 'Star Lanka Tours 斯里兰卡 - 一日冒险',
            chooseAdventure: '选择您的冒险',
            packagesSubtitle: '精心选择的 25 项体验 — 从草原野生动物园到文化浸入式体验。',
            viewDetails: '查看详情',
            itineraryTitle: '行程',
            bookViaWhatsApp: '通过 WhatsApp 预订',
            whatsappMessage: '您好 Star Lanka Tours！我想预订：*{{title}}* ({{duration}})\n\n请让我知道可用性和价格！',

            packages: {
                '1': {
                    title: '埃勒冒险日',
                    duration: '1 天',
                    category: '自然和冒险',
                    description: '穿越雾气缭绕的山丘、奔流的瀑布和标志性的桥梁——刺激与宁静的完美结合。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>拉瓦纳瀑布</strong> – 在水晶般清澈的池塘中游泳</li>
                <li><strong>九拱桥</strong> – 与火车的标志性摄影站</li>
                <li><strong>茶园</strong> – 在祖母绿山丘间漫步</li>
                <li><strong>火车之旅</strong> – 从埃勒到德莫达拉的全景路线</li>
                <li><strong>小亚当峰</strong> – 日出/日落全景景观</li>
                <li><strong>乌达瓦拉韦象牛奶喂食</strong> – 与野生动物的感人时刻</li>
                <li><strong>阿育吠陀草药花园</strong> – 发现古老健康的秘诀</li>
            </ul>`
                },
                '2': {
                    title: '埃勒和亚拉野生动物园',
                    duration: '1 天',
                    category: '野生动物和风景',
                    description: '从雾气缭绕的高地到野生稀树草原——在难忘的一天内尽享大自然的精华。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>拉瓦纳瀑布</strong> – 清爽天然池塘</li>
                <li><strong>九拱桥</strong> – 建筑奇迹</li>
                <li><strong>茶园</strong> – 全景山丘漫步</li>
                <li><strong>小亚当峰</strong> – 山顶壮观景色</li>
                <li><strong>亚拉野生动物园</strong> – 吉普车冒险与豹子和大象</li>
            </ul>`
                },
                '3': {
                    title: '康提文化日',
                    duration: '1 天',
                    category: '遗产和自然',
                    description: '沉浸在神圣的寺庙、郁郁葱葱的花园和斯里兰卡中心的当地传统中。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>康提城市</strong> – 充满活力的文化中心</li>
                <li><strong>皇家植物园</strong> – 热带天堂</li>
                <li><strong>茶厂和茶园</strong> – 锡兰茶体验</li>
                <li><strong>大象喂食、沐浴和骑行</strong> – 伦理互动</li>
                <li><strong>阿育吠陀草药花园</strong> – 天然愈合之旅</li>
                <li><strong>安布卢瓦瓦塔</strong> – 360° 全景</li>
                <li><strong>珠宝和宝石工厂</strong> – 闪闪发光的工艺</li>
                <li><strong>丝绸工厂</strong> – 传统编织</li>
            </ul>`
                },
                '4': {
                    title: '康提圣祭',
                    duration: '1 天',
                    category: '精神和文化',
                    description: '在圣城康提享受奉献、遗产和自然美景的神圣一天。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>佛牙寺</strong> – 佛教圣地</li>
                <li><strong>茶厂和茶园</strong> – 新鲜茶品尝</li>
                <li><strong>大象喂食、沐浴和骑行</strong> – 温柔巨人</li>
                <li><strong>阿育吠陀草药花园</strong> – 健康智慧</li>
                <li><strong>安布卢瓦瓦塔</strong> – 螺旋式升天</li>
                <li><strong>珠宝和宝石工厂</strong> – 本地宝石</li>
                <li><strong>丝绸工厂</strong> – 丝绸艺术</li>
            </ul>`
                },
                '5': {
                    title: '西吉里亚遗产日',
                    duration: '1 天',
                    category: '历史和冒险',
                    description: '攀登古老的岩石堡垒，探索黄金洞穴并品尝村庄生活的真实风味。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>西吉里亚狮岩</strong> – 联合国教科文组织世界遗产</li>
                <li><strong>丹布拉黄金寺庙</strong> – 古老的洞穴艺术</li>
                <li><strong>村庄之旅</strong> – 牛车、独木舟、传统午餐</li>
                <li><strong>阿育吠陀草药花园</strong> – 药用植物</li>
                <li><strong>皮杜兰加拉岩石</strong> – 西吉里亚最佳景色</li>
            </ul>`
                },
                '6': {
                    title: '加勒沿海遗产',
                    duration: '1 天',
                    category: '历史和自然',
                    description: '漫步殖民时期的堡垒，驾船穿过红树林河流，见证海龟保护。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>坎德维哈拉寺庙</strong> – 巨大的佛像</li>
                <li><strong>海龟养殖场</strong> – 释放小龟</li>
                <li><strong>船上野生动物园</strong> – 玛都河红树林森林</li>
                <li><strong>月光石矿</strong> – 宝石开采体验</li>
                <li><strong>加勒荷兰堡垒</strong> – 联合国教科文组织殖民城市</li>
                <li><strong>阿育吠陀草药花园</strong> – 天然补救措施</li>
            </ul>`
                },
                '7': {
                    title: '科伦坡城市发现',
                    duration: '1 天',
                    category: '城市和文化',
                    description: '探索现代纪念碑、神圣遗址和斯里兰卡繁荣首都的活跃购物。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>莲花塔</strong> – 360° 城市景观</li>
                <li><strong>红清真寺</strong> – 惊人的伊斯兰建筑</li>
                <li><strong>购物</strong> – 本地市场和购物中心</li>
                <li><strong>阿育吠陀草药花园</strong> – 健康站点</li>
                <li><strong>甘加罗摩寺庙</strong> – 城市神圣绿洲</li>
            </ul>`
                },
                '8': {
                    title: '亚拉野生动物园',
                    duration: '1 天',
                    category: '野生动物',
                    description: '在亚洲最好的国家公园之一中追踪豹子、大象和稀有鸟类。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>亚拉国家公园吉普车野生动物园</strong> – 3 小时野生动物冒险</li>
                <li>发现豹子、大象、懒熊和 200+ 种鸟类</li>
            </ul>`
                },
                '9': {
                    title: '米里莎鲸鱼奥德赛',
                    duration: '1 天',
                    category: '海洋冒险',
                    description: '在舒适的船上与蓝鲸航行——近距离观赏世界上最大的生物。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>蓝鲸观测</strong> – 4 小时海洋野生动物园</li>
                <li><strong>米里莎海滩</strong> – 金色沙滩放松</li>
                <li><strong>跷跷板钓鱼</strong> – 标志性摄影时刻</li>
                <li><strong>阿育吠陀草药花园</strong> – 海滨健康</li>
            </ul>`
                },
                '10': {
                    title: '乌达瓦拉韦象日',
                    duration: '1 天',
                    category: '野生动物和同情',
                    description: '观看小象被喂食，与野生象群在其自然栖息地漫步。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>乌达瓦拉韦国家公园</strong> – 吉普车野生动物园</li>
                <li><strong>象牛奶喂食</strong> – 孤儿院参观</li>
            </ul>`
                },
                '11': {
                    title: '埃勒和加勒快速',
                    duration: '1 天',
                    category: '风景和遗产',
                    description: '从山地列车到殖民时期的堡垒——一次快速而充满美景和历史的旅程。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>火车之旅</strong> – 从埃勒到加勒</li>
                <li><strong>小亚当峰</strong> – 日出远足</li>
                <li><strong>加勒荷兰堡垒</strong> – 日落散步</li>
                <li><strong>茶园</strong> – 山丘景色</li>
                <li><strong>阿育吠陀草药花园</strong> – 健康站点</li>
            </ul>`
                },
                '12': {
                    title: '亚拉和加勒野生动物园',
                    duration: '1 天',
                    category: '野生和殖民',
                    description: '早晨野生动物园之旅，下午遗产散步——南海岸的最佳组合。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>亚拉国家公园野生动物园</strong> – 早晨吉普车之旅</li>
                <li><strong>加勒荷兰堡垒</strong> – 下午殖民散步</li>
            </ul>`
                },
                '13': {
                    title: '康提、埃勒和亚拉快速',
                    duration: '2 天',
                    category: '文化和风景',
                    description: '从神圣寺庙到雾蒙山丘和野生野生动物园——斯里兰卡亮点的快速旅游。',
                    itinerary: `<h3>第 1 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>亚拉国家公园野生动物园</strong> – 早晨吉普车之旅</li>
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>火车之旅</strong> – 豪华火车之旅</li>
                <li><strong>茶园</strong> – 山丘景色</li>
            </ul>
            <h3 class="mt-4">第 2 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>安布卢瓦瓦塔</strong> – 快速远足</li>
                <li><strong>植物园</strong> – 热带天堂</li>
                <li><strong>佛牙寺</strong> – 神圣参观</li>
                <li><strong>象骑行</strong> – 伦理互动</li>
                <li><strong>茶厂</strong> – 锡兰茶体验</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在康提住宿（豪华酒店）</h3>`
                },
                '14': {
                    title: '康提文化',
                    duration: '2 天',
                    category: '文化',
                    description: '沉浸在神圣的寺庙、郁郁葱葱的花园和斯里兰卡中心的当地传统中。',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>康提城市</strong> – 充满活力的文化中心</li>
                <li><strong>皇家植物园</strong> – 热带天堂</li>
                <li><strong>茶厂和茶园</strong> – 锡兰茶体验</li>
                <li><strong>大象喂食、沐浴和骑行</strong> – 伦理互动</li>
                <li><strong>阿育吠陀草药花园</strong> – 天然愈合之旅</li>
                <li><strong>安布卢瓦瓦塔</strong> – 360° 全景</li>
                <li><strong>珠宝和宝石工厂</strong> – 闪闪发光的工艺</li>
                <li><strong>丝绸工厂</strong> – 传统编织</li>
                <li><strong>内利加拉</strong> – 传统寺庙</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在康提住宿（豪华酒店）</h3>`
                },
                '15': {
                    title: '埃勒/努瓦勒埃利亚/康提文化',
                    duration: '2 天',
                    category: '文化和风景',
                    description: '从雾蒙高地到神圣寺庙——穿过斯里兰卡心脏的灵魂之旅。',
                    itinerary: `<h3>第 1 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>小亚当峰</strong> – 全景远足</li>
                <li><strong>火车之旅</strong> – 豪华火车之旅</li>
                <li><strong>茶园</strong> – 山丘景色</li>
                <li><strong>粉红色邮局</strong> – 文化美景</li>
                <li><strong>安布卢瓦瓦塔</strong> – 宁静漫步</li>
            </ul>
            <h3 class="mt-4">第 2 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>印度教寺庙</strong> – 文化参观</li>
                <li><strong>植物园</strong> – 热带天堂</li>
                <li><strong>内利加拉</strong> – 神圣参观</li>
                <li><strong>兰博达瀑布</strong></li>
                <li><strong>茶厂</strong> – 锡兰茶体验</li>
                <li><strong>象骑行</strong> – 伦理互动</li>
                <li><strong>草药花园</strong> – 热带天堂</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在康提住宿（豪华酒店）</h3>`
                },
                '16': {
                    title: '亚拉/埃勒/努瓦勒埃利亚/康提文化',
                    duration: '3 天',
                    category: '文化和风景',
                    description: '从雾蒙高地到神圣寺庙——穿过斯里兰卡心脏的灵魂之旅。',
                    itinerary: `<h3>第 1 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>小亚当峰</strong> – 全景远足</li>
                <li><strong>火车之旅</strong> – 豪华火车之旅</li>
                <li><strong>茶园</strong> – 山丘景色</li>
                <li><strong>印度教寺庙</strong> – 文化参观</li>
                <li><strong>亚拉国家公园野生动物园</strong> – 早晨吉普车之旅</li>
            </ul>
            <h3 class="mt-4">第 2 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>安布卢瓦瓦塔</strong> – 宁静漫步</li>
                <li><strong>粉红色邮局</strong> – 文化美景</li>
                <li><strong>植物园</strong> – 热带天堂</li>
                <li><strong>佛牙寺</strong> – 神圣参观</li>
            </ul>
            <h3 class="mt-4">第 3 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>内利加拉</strong> – 神圣参访</li>
                <li><strong>茶厂</strong> – 锡兰茶体验</li>
                <li><strong>宝石和珠宝</strong> – 斯里兰卡宝石体验</li>
                <li><strong>木雕</strong> – 传统雕刻</li>
                <li><strong>象骑行</strong> – 伦理互动</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在努瓦勒埃利亚和康提住宿（豪华酒店）</h3>`
                },
                '17': {
                    title: '埃勒/努瓦勒埃利亚/康提/西吉里亚文化',
                    duration: '3 天',
                    category: '文化和风景',
                    description: '从雾蒙高地到神圣寺庙——穿过斯里兰卡心脏的灵魂之旅。',
                    itinerary: `<h3>第 1 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>小亚当峰</strong> – 全景远足</li>
                <li><strong>火车之旅</strong> – 豪华火车之旅</li>
                <li><strong>茶园</strong> – 山丘景色</li>
                <li><strong>印度教寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 2 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>安布卢瓦瓦塔</strong> – 宁静漫步</li>
                <li><strong>植物园</strong> – 热带天堂</li>
                <li><strong>皮杜兰加拉</strong> – 全景远足</li>
            </ul>
            <h3 class="mt-4">第 3 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>黄金寺庙</strong> – 神圣参访</li>
                <li><strong>西吉里亚狮岩</strong> – 古代堡垒</li>
                <li><strong>村庄之旅与船游和传统午餐</strong> – 文化体验</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在努瓦勒埃利亚和西吉里亚住宿（豪华酒店）</h3>`
                },
                '18': {
                    title: '埃勒/努瓦勒埃利亚/康提/西吉里亚/波隆纳鲁沃文化',
                    duration: '3 天',
                    category: '文化和风景',
                    description: '从雾蒙高地到神圣寺庙——穿过斯里兰卡心脏的灵魂之旅。',
                    itinerary: `<h3>第 1 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>小亚当峰</strong> – 全景远足</li>
                <li><strong>火车之旅</strong> – 豪华火车之旅</li>
                <li><strong>茶园</strong> – 山丘景色</li>
                <li><strong>印度教寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 2 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>安布卢瓦瓦塔</strong> – 宁静漫步</li>
                <li><strong>植物园</strong> – 热带天堂</li>
                <li><strong>茶厂</strong> – 锡兰茶体验</li>
                <li><strong>象骑行</strong> – 伦理互动</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 3 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>西吉里亚狮岩</strong> – 联合国教科文组织世界遗产</li>
                <li><strong>波隆纳鲁沃古城之旅</strong> – 文化城市</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在康提和西吉里亚住宿（豪华酒店）</h3>`
                },
                '19': {
                    title: '亚拉/埃勒/努瓦勒埃利亚/康提/波隆纳鲁沃文化',
                    duration: '4 天',
                    category: '文化和风景',
                    description: '从雾蒙高地到神圣寺庙——穿过斯里兰卡心脏的灵魂之旅。',
                    itinerary: `<h3>第 1 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>亚拉国家公园野生动物园</strong> – 早晨吉普车之旅</li>
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>小亚当峰</strong> – 全景远足</li>
                <li><strong>火车之旅</strong> – 豪华火车之旅</li>
            </ul>
            <h3 class="mt-4">第 2 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>茶园</strong> – 山丘景色</li>
                <li><strong>印度教寺庙</strong> – 文化参观</li>
                <li><strong>安布卢瓦瓦塔</strong> – 宁静漫步</li>
                <li><strong>皇家植物园</strong> – 热带天堂</li>
                <li><strong>茶厂</strong> – 锡兰茶体验</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 3 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>内利加拉</strong> – 神圣参访</li>
                <li><strong>珠宝和宝石工厂</strong> – 闪闪发光的工艺</li>
                <li><strong>象骑行</strong> – 伦理互动</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 4 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>西吉里亚狮岩</strong> – 联合国教科文组织世界遗产</li>
                <li><strong>波隆纳鲁沃古城之旅</strong> – 文化城市</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在埃勒、努瓦勒埃利亚和康提住宿（豪华酒店）</h3>`
                },
                '20': {
                    title: '亚拉/埃勒/努瓦勒埃利亚/康提/西吉里亚/波隆纳鲁沃/阿努拉德普勒文化',
                    duration: '5 天',
                    category: '文化和风景',
                    description: '从雾蒙高地到神圣寺庙——穿过斯里兰卡心脏的灵魂之旅。',
                    itinerary: `<h3>第 1 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>亚拉国家公园野生动物园</strong> – 早晨吉普车之旅</li>
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>小亚当峰</strong> – 全景远足</li>
                <li><strong>火车之旅</strong> – 豪华火车之旅</li>
            </ul>
            <h3 class="mt-4">第 2 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>茶园</strong> – 山丘景色</li>
                <li><strong>印度教寺庙</strong> – 文化参观</li>
                <li><strong>安布卢瓦瓦塔</strong> – 宁静漫步</li>
                <li><strong>皇家植物园</strong> – 热带天堂</li>
                <li><strong>茶厂</strong> – 锡兰茶体验</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 3 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>内利加拉</strong> – 神圣参访</li>
                <li><strong>珠宝和宝石工厂</strong> – 闪闪发光的工艺</li>
                <li><strong>象骑行</strong> – 伦理互动</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 4 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>西吉里亚狮岩</strong> – 联合国教科文组织世界遗产</li>
                <li><strong>波隆纳鲁沃古城之旅</strong> – 文化城市</li>
            </ul>
            <h3 class="mt-4">第 5 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>阿努拉德普勒古城之旅</strong> – 历史探险</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在西吉里亚、努瓦勒埃利亚和康提住宿（豪华酒店）</h3>`
                },
                '21': {
                    title: '亚拉/埃勒/努瓦勒埃利亚/康提/西吉里亚/波隆纳鲁沃/科伦坡文化',
                    duration: '5 天',
                    category: '文化和风景',
                    description: '从雾蒙高地到神圣寺庙——穿过斯里兰卡心脏的灵魂之旅。',
                    itinerary: `<h3>第 1 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>亚拉国家公园野生动物园</strong> – 早晨吉普车之旅</li>
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>小亚当峰</strong> – 全景远足</li>
                <li><strong>火车之旅</strong> – 豪华火车之旅</li>
            </ul>
            <h3 class="mt-4">第 2 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>茶园</strong> – 山丘景色</li>
                <li><strong>印度教寺庙</strong> – 文化参观</li>
                <li><strong>安布卢瓦瓦塔</strong> – 宁静漫步</li>
                <li><strong>皇家植物园</strong> – 热带天堂</li>
                <li><strong>茶厂</strong> – 锡兰茶体验</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 3 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>内利加拉</strong> – 神圣参访</li>
                <li><strong>珠宝和宝石工厂</strong> – 闪闪发光的工艺</li>
                <li><strong>象骑行</strong> – 伦理互动</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 4 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>西吉里亚狮岩</strong> – 联合国教科文组织世界遗产</li>
                <li><strong>波隆纳鲁沃古城之旅</strong> – 文化城市</li>
            </ul>
            <h3 class="mt-4">第 5 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>科伦坡城市之旅</strong> – 城市探险</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在努瓦勒埃利亚、西吉里亚、波隆纳鲁沃和康提住宿（豪华酒店）</h3>`
                },
                '22': {
                    title: '亚拉/埃勒/努瓦勒埃利亚/康提/西吉里亚/波隆纳鲁沃/加勒文化',
                    duration: '5 天',
                    category: '文化和风景',
                    description: '从雾蒙高地到神圣寺庙——穿过斯里兰卡心脏的灵魂之旅。',
                    itinerary: `<h3>第 1 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>亚拉国家公园野生动物园</strong> – 早晨吉普车之旅</li>
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>小亚当峰</strong> – 全景远足</li>
                <li><strong>火车之旅</strong> – 豪华火车之旅</li>
            </ul>
            <h3 class="mt-4">第 2 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>茶园</strong> – 山丘景色</li>
                <li><strong>印度教寺庙</strong> – 文化参观</li>
                <li><strong>安布卢瓦瓦塔</strong> – 宁静漫步</li>
                <li><strong>皇家植物园</strong> – 热带天堂</li>
                <li><strong>茶厂</strong> – 锡兰茶体验</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 3 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>内利加拉</strong> – 神圣参访</li>
                <li><strong>珠宝和宝石工厂</strong> – 闪闪发光的工艺</li>
                <li><strong>象骑行</strong> – 伦理互动</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 4 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>西吉里亚狮岩</strong> – 联合国教科文组织世界遗产</li>
                <li><strong>波隆纳鲁沃古城之旅</strong> – 文化城市</li>
            </ul>
            <h3 class="mt-4">第 5 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>加勒城市</strong> – 殖民探险</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在努瓦勒埃利亚、西吉里亚、波隆纳鲁沃和加勒住宿（豪华酒店）</h3>`
                },
                '23': {
                    title: '埃勒/努瓦勒埃利亚/康提/西吉里亚/波隆纳鲁沃/阿努拉德普勒/科伦坡',
                    duration: '6 天',
                    category: '文化和风景',
                    description: '从雾蒙高地到神圣寺庙——穿过斯里兰卡心脏的灵魂之旅。',
                    itinerary: `<h3>第 1 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>小亚当峰</strong> – 全景远足</li>
                <li><strong>火车之旅</strong> – 豪华火车之旅</li>
            </ul>
            <h3 class="mt-4">第 2 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>茶园</strong> – 山丘景色</li>
                <li><strong>印度教寺庙</strong> – 文化参观</li>
                <li><strong>安布卢瓦瓦塔</strong> – 宁静漫步</li>
                <li><strong>皇家植物园</strong> – 热带天堂</li>
                <li><strong>茶厂</strong> – 锡兰茶体验</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 3 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>内利加拉</strong> – 神圣参访</li>
                <li><strong>珠宝和宝石工厂</strong> – 闪闪发光的工艺</li>
                <li><strong>象骑行</strong> – 伦理互动</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 4 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>西吉里亚狮岩</strong> – 联合国教科文组织世界遗产</li>
                <li><strong>波隆纳鲁沃古城之旅</strong> – 文化城市</li>
            </ul>
            <h3 class="mt-4">第 5 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>阿努拉德普勒古城之旅</strong> – 历史探险</li>
            </ul>
            <h3 class="mt-4">第 6 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>科伦坡城市之旅</strong> – 城市探险</li>
                <li><strong>加勒城市</strong> – 殖民探险</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在埃勒、努瓦勒埃利亚、西吉里亚住宿（豪华酒店）</h3>`
                },
                '24': {
                    title: '埃勒/努瓦勒埃利亚/康提/西吉里亚/波隆纳鲁沃/阿努拉德普勒/科伦坡',
                    duration: '6 天',
                    category: '文化和风景',
                    description: '从雾蒙高地到神圣寺庙——穿过斯里兰卡心脏的灵魂之旅。',
                    itinerary: `<h3>第 1 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>小亚当峰</strong> – 全景远足</li>
                <li><strong>火车之旅</strong> – 豪华火车之旅</li>
            </ul>
            <h3 class="mt-4">第 2 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>茶园</strong> – 山丘景色</li>
                <li><strong>印度教寺庙</strong> – 文化参观</li>
                <li><strong>安布卢瓦瓦塔</strong> – 宁静漫步</li>
                <li><strong>皇家植物园</strong> – 热带天堂</li>
                <li><strong>茶厂</strong> – 锡兰茶体验</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 3 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>内利加拉</strong> – 神圣参访</li>
                <li><strong>珠宝和宝石工厂</strong> – 闪闪发光的工艺</li>
                <li><strong>象骑行</strong> – 伦理互动</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 4 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>西吉里亚狮岩</strong> – 联合国教科文组织世界遗产</li>
                <li><strong>波隆纳鲁沃古城之旅</strong> – 文化城市</li>
            </ul>
            <h3 class="mt-4">第 5 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>阿努拉德普勒古城之旅</strong> – 历史探险</li>
            </ul>
            <h3 class="mt-4">第 6 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>科伦坡城市之旅</strong> – 城市探险</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在埃勒、努瓦勒埃利亚、康提、西吉里亚和科伦坡住宿（豪华酒店）</h3>`
                },
                '25': {
                    title: '埃勒/努瓦勒埃利亚/康提/西吉里亚/波隆纳鲁沃/阿努拉德普勒/加勒',
                    duration: '6 天',
                    category: '文化和风景',
                    description: '从雾蒙高地到神圣寺庙——穿过斯里兰卡心脏的灵魂之旅。',
                    itinerary: `<h3>第 1 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>拉瓦纳瀑布</strong> – 快速沐浴</li>
                <li><strong>九拱桥</strong> – 火车穿越</li>
                <li><strong>小亚当峰</strong> – 全景远足</li>
                <li><strong>火车之旅</strong> – 豪华火车之旅</li>
            </ul>
            <h3 class="mt-4">第 2 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>茶园</strong> – 山丘景色</li>
                <li><strong>印度教寺庙</strong> – 文化参观</li>
                <li><strong>安布卢瓦瓦塔</strong> – 宁静漫步</li>
                <li><strong>皇家植物园</strong> – 热带天堂</li>
                <li><strong>茶厂</strong> – 锡兰茶体验</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 3 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>内利加拉</strong> – 神圣参访</li>
                <li><strong>珠宝和宝石工厂</strong> – 闪闪发光的工艺</li>
                <li><strong>象骑行</strong> – 伦理互动</li>
                <li><strong>黄金寺庙</strong> – 文化参观</li>
            </ul>
            <h3 class="mt-4">第 4 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>西吉里亚狮岩</strong> – 联合国教科文组织世界遗产</li>
                <li><strong>波隆纳鲁沃古城之旅</strong> – 文化城市</li>
            </ul>
            <h3 class="mt-4">第 5 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>阿努拉德普勒古城之旅</strong> – 历史探险</li>
            </ul>
            <h3 class="mt-4">第 6 天:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>加勒城市</strong> – 殖民探险</li>
            </ul>
            <h3 class="mt-4" style="color:red;">在埃勒、努瓦勒埃利亚、康提、西吉里亚和加勒住宿（豪华酒店）</h3>`
                },
            },

        },
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;